/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b2b71f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b2b71f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"d4017e9f-67b3-4cb6-bc8c-336b2fb8e877","title":"Informace o tiskárně","link":"finding-information-about-printer-topic.html","desc":"Vyhledání informací o tiskárně Zdroje","descFull":"Vyhledání informací o tiskárně Zdroje a jejich umístění Co hledáte? Kde to najdete Úvodní pokyny k instalaci Podívejte se do dokumentace k nastavení dodané s tiskárnou. Software tiskárny Ovladač pro tisk nebo faxování Firmware tiskárny Nástroj Přejděte na stránku  www.lexmark.com/downloads . Interaktivní  Uživatelská příručka . Přejděte na  https://support.lexmark.com . Instruktážní videa Otevřete stránku  https://infoserve.lexmark.com/idv/ . Informace nápovědy k používání softwaru tiskárny Nápověda pro operační systémy Microsoft Windows nebo Macintosh – otevřete softwarový program tiskárny nebo aplikaci a poté klepněte na možnost  Nápověda . Klepnutím na tlačítko   zobrazíte kontextové informace. Nápověda se nainstaluje automaticky se softwarem tiskárny. V závislosti na operačním systému se software tiskárny nachází ve složce programů tiskárny nebo na ploše. Dokumentace Podpora prostřednictvím chatu E-mailová podpora Telefonická podpora Přejděte na  https://support.lexmark.com . Pro zobrazení příslušných internetových stránek podpory zvolte svou zemi nebo oblast a poté produkt. Kontaktní informace podpory ve vaší zemi či oblasti naleznete na internetových stránkách nebo na záručním listu, který byl dodán společně s vaší tiskárnou. Až budete kontaktovat zákaznickou podporu, mějte připravené následující informace: Místo a datum nákupu Typ zařízení a sériové číslo Další informace najdete v tématu  . Informace o bezpečnosti Informace o regulačních předpisech Informace o záruce Informace o životním prostředí Informace o záruce se mohou lišit podle země nebo regionu: V USA  – Podívejte se do prohlášení o omezené záruce, které je začleněno do tiskárny, nebo se podívejte na adresu  https://support.lexmark.com . Ostatní země nebo oblasti  – Přečtěte si tištěné prohlášení o záruce dodané s tiskárnou. Informační příručka o produktu  – Nahlédněte do dokumentace dodané s tiskárnou nebo na adresu  https://support.lexmark.com . Informace o digitálním pasu společnosti Lexmark Otevřete stránku  https://csr.lexmark.com/digital-passport.php . vyhledání informací o tiskárně"},{"UUID":"67297580-69c3-4f48-9a49-0a88f815fa99","title":"Informace o tiskárně","link":"finding-printer-serial-number-topic.html","desc":"Zjištění sériového čísla tiskárny Otevřete","descFull":"Zjištění sériového čísla tiskárny Otevřete zásobník. Vyhledejte sériové číslo na pravé straně tiskárny. sériové číslo tiskárny sériové číslo"},{"UUID":"80664bdd-b8b8-4dc3-b38f-117db7fa07e4","title":"Informace o tiskárně","link":"printer-configurations-topic.html","desc":"Konfigurace tiskárny Dbejte, aby tiskárna","descFull":"Konfigurace tiskárny Dbejte, aby tiskárna byla konfigurována na rovném, pevném a stabilním povrchu. Základní model Součásti základního modelu tiskárny 1 Podavač ADF (automatický podavač dokumentů) 2 Ovládací panel 3 port USB 4 Univerzální podavač 5 Standardní zásobník na 550 listů 6 Standardní zásobník Konfigurovaný model Při instalaci jednoho nebo více doplňků tiskárny nebo multifunkční tiskárny budete možná muset použít kolečkový podstavec, nábytek nebo jiný prvek, abyste předešli nestabilitě a možnému zranění. Další informace o podporovaných konfiguracích naleznete na  www.lexmark.com/multifunctionprinters . Při instalaci jednoho nebo více doplňků tiskárny nebo multifunkční tiskárny budete možná muset použít kolečkový podstavec, nábytek nebo jiný prvek, abyste předešli nestabilitě a možnému zranění. Další informace o podporovaných konfiguracích získáte u svého prodejce. Chcete-li snížit riziko nestability zařízení, vkládejte papír do jednotlivých zásobníků samostatně. Všechny ostatní zásobníky udržujte zavřené až do chvíle, kdy je budete potřebovat. Součásti konfigurovaného modelu tiskárny # Hardwarový doplněk Alternativní hardwarový doplněk 1  Nelze nainstalovat společně s dokončovací schránkou – vazačem knih nebo sešívacím děrovacím finišerem. 2  Musí být vždy nainstalován společně s volitelným zásobníkem na 550 listů a buď 2x zásobníkem na 550 listů, nebo dvojitým zásobníkem na 2000 listů. 3  Musí být vždy instalován společně s volitelným zásobníkem na 550 listů. 4  Musí být vždy nainstalován společně s volitelným zásobníkem na 550 listů a jedním z následujících zařízení: 2x zásobník na 550 listů, dvojitý zásobník na 2000 listů nebo skříňka. 1 Sešívací finišer 1 Odsazovací odkládací zásobník 1 Podávací jednotka Podávací jednotka s možností skládání 2 Zásobník na 1500 listů 2 Žádný 3 Dvojitý zásobník na 2000 listů 3 2x zásobník na 550 listů 3 Skříňka 3 4 Volitelný zásobník na 550 listů Žádný 5 Brožovací finišer – vazač knih 4 Sešívací, děrovací finišer 4 Některé možnosti nemusí být dostupné. Další informace získáte u prodejce tiskárny. konfigurace tiskárny"},{"UUID":"c9dd9773-066e-4cfb-8ac0-28f4f1c85ee1","title":"Informace o tiskárně","link":"using-control-panel-topic.html","desc":"Použití ovládacího panelu Části ovládacího","descFull":"Použití ovládacího panelu Části ovládacího panelu a jejich funkce Část ovládacího panelu Funkce 1 Tlačítko napájení Zapnutí nebo vypnutí tiskárny Chcete-li tiskárnu vypnout, stiskněte a podržte tlačítko napájení na pět sekund. Nastavení tiskárny do režimu spánku. Probuzení tiskárny z režimu spánku nebo hibernace. 2 Displej Zobrazuje hlášení tiskárny a stav spotřebního materiálu. Nastavení a ovládání tiskárny. 3 Kontrolka Kontrola stavu tiskárny ovládací panel použití pomocí ovládacího panelu"},{"UUID":"8feb5b37-8332-4af6-9253-a76075a2ddff","title":"Informace o tiskárně","link":"using-home-screen-topic.html","desc":"Ikony domovské obrazovky Domovská obrazovka","descFull":"Ikony domovské obrazovky Domovská obrazovka se může lišit v závislosti na přizpůsobení nastavení vaší domovské obrazovky, nastavení správy a aktivních vestavěných řešeních. Ikony na domovské obrazovce a jejich funkce # Název ikony Funkce 1 Uživatel  Zobrazuje, zda je uživatel přihlášen k tiskárně. 2 Zobrazené informace Zobrazí nastavitelné informace o tiskárně, například IP adresu tiskárny nebo datum a čas. 3 Spotřební materiál Zobrazuje stav spotřebního materiálu. 4 Upozornění Zobrazuje varovné nebo chybové zprávy tiskárny, kdykoli je třeba zásah obsluhy, aby mohla tiskárna pokračovat v práci. Zobrazuje podrobnější informace o varování či hlášení tiskárny včetně pokynů, jak je odstranit. 5 Tisk Tisk fotografií a dokumentů. 6 Kopírování Kopírování fotografií a dokumentů. 7 Skenování Skenování dokumentů. 8 Faxování Odesílání faxových zpráv. použití domovské obrazovky ikony domovské obrazovky"},{"UUID":"b7b2b2c9-395b-47cc-9438-97fcabf74246","title":"Informace o tiskárně","link":"colors-of-indicator-light-topic.html","desc":"Barvy kontrolky Barva indikátoru a","descFull":"Barvy kontrolky Barva indikátoru a odpovídající stav tiskárny Barva kontrolky Stav tiskárny Vypnuto Tiskárna je vypnuta. Svítí modře Tiskárna je připravena. Bliká modře Tiskárna tiskne nebo zpracovává data. Bliká červeně Tiskárna vyžaduje zásah uživatele. Svítí žlutě Tiskárna je v režimu spánku. Bliká žlutě Tiskárna je v režimu hlubokého spánku nebo hibernace. kontrolka stav tiskárny stav tiskárny"},{"UUID":"d3503476-862d-4469-8db1-47959b10993b","title":"Informace o tiskárně","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Používání automatického podavače dokumentů a skleněné","descFull":"Používání automatického podavače dokumentů a skleněné plochy skeneru Vložení papíru do podavače ADF a na skleněnou plochu skeneru Podavač ADF (automatický podavač dokumentů) Skleněná plocha skeneru Pro vícestránkové nebo oboustranné dokumenty použijte podavač ADF. Vložte originální dokument lícem nahoru. U vícestránkových dokumentů nezapomeňte před vložením vyrovnat přední hrany. Ujistěte se, že upravení vodicích lišt podavače ADF odpovídá formátu vkládaného papíru. Skleněnou plochu skeneru použijte pro jednostránkové dokumenty, stránky knih, malé položky (např. dopisnice nebo fotografie), průhledné fólie, fotografický papír nebo tenká média (např. výstřižky z časopisů). Položte dokument lícem dolů do rohu se šipkou. kopírování pomocí podavače ADF (automatický podavač dokumentů) kopírování použití skleněné plochy skeneru"},{"UUID":"aa92f315-5105-470c-9da4-a7119beabde8","title":"Informace o tiskárně","link":"locating-security-slot-topic.html","desc":"Vyhledání slotu zabezpečení Tiskárna je","descFull":"Vyhledání slotu zabezpečení Tiskárna je vybavena funkcí bezpečnostního zámku. Připevněte bezpečnostní zámek kompatibilní s většinou přenosných počítačů ve vyznačeném místě, abyste zajistili tiskárnu na místě. otvor pro zabezpečení vyhledání vyhledání slotu zabezpečení"},{"UUID":"b6735654-449b-4e2e-b80e-1a72ca269e98","title":"Výběr papíru","link":"paper-guidelines-topic.html","desc":"Pokyny ohledně použitého papíru Použitím","descFull":"Pokyny ohledně použitého papíru Použitím vhodného papíru zabráníte jeho uvíznutí a pomůžete zajistit bezproblémový tisk. Vždy používejte nový, nepoškozený papír. Před vložením papíru si zjistěte, která strana je doporučena pro tisk. Tyto informace jsou obvykle uvedeny na balení papíru. Nepoužívejte papír, který je nastříhaný nebo nařezaný ručně. Nevkládejte do stejného zásobníku papíry různého formátu, typu nebo gramáže. Směšování různých papírů povede k jejich uvíznutí. Nepoužívejte potahované papíry, pokud nejsou výslovně určené pro elektrofotografický tisk. Další informace naleznete v příručce  Průvodce papírem a speciálními médii . papír výběr pokyny pro papír"},{"UUID":"f5a7650e-ad11-49b0-81da-a429694dda9e","title":"Výběr papíru","link":"paper-guidelines-topic.html","desc":"Charakteristiky papíru Následující charakteristiky papíru","descFull":"Charakteristiky papíru Následující charakteristiky papíru mají vliv na kvalitu a spolehlivost tisku. Při tisku vezměte v úvahu následující faktory. Gramáž Zásobníky mohou podávat papír různých gramáží. Papír lehčí než 60 g/m 2  (16 lb) nemusí být dostatečně tuhý pro správné podávání, a může tak docházet k jeho uvíznutí. Další informace naleznete v části „Podporované gramáže papíru“. Prohýbání Prohýbání je tendence papíru ohýbat se na okrajích. Přílišné vlnění může způsobit problémy s podáváním papíru. Zvlnění může nastat poté, co papír projde tiskárnou, kde je vystaven vysokým teplotám. Uložení rozbaleného papíru v příliš teplém, vlhkém, chladném nebo suchém prostředí může vést ke zvlnění papíru a v důsledku toho k problémům při podávání. Hladkost Hladkost papíru má přímý vliv na kvalitu tisku. Je-li papír příliš hrubý, toner se do něj nemůže řádně zapéct. Je-li papír příliš hladký, může to způsobit problémy s podáváním a kvalitou tisku. Doporučujeme používat papír s hladkostí 50 Sheffieldových bodů. Obsah vlhkosti Množství vlhkosti v papíru ovlivňuje jak kvalitu tisku, tak schopnost tiskárny papír správně podávat. Než papír použijete, ponechejte ho v originálním obalu. Vystavení papíru změnám vlhkosti může vést ke zhoršení vlastností papíru. Před tiskem uchovávejte papír v původním obalu po dobu 24 až 48 hodin. Prostředí, ve kterém je papír uložen, musí být stejné jako tiskárna. Prodlužte tuto dobu o několik dní v případě, kdy prostředí skladování nebo dopravy je velmi odlišné od prostředí tiskárny. Silný papír může také vyžadovat delší dobu pro přizpůsobení podmínkám. Směr vláken Vláknem se rozumí směr papírových vláken v listu papíru. Vlákna mohou být  podélná : uložená po délce papíru, nebo  příčná : uložená na šířku papíru. Doporučený směr vláken naleznete v tématu „Podporované gramáže papíru“. Obsah vláken Většina vysoce kvalitních xerografických papírů je vyrobena ze 100% chemicky ošetřeného rozmělněného dřeva. To dává papíru vysoký stupeň stability s menším množstvím problémů při podávání papíru a s lepší kvalitou tisku. Papír obsahující vlákna jako bavlna negativně ovlivňuje manipulaci s papírem. charakteristiky papíru"},{"UUID":"cb481898-f710-497e-b639-6a6014fb8d48","title":"Výběr papíru","link":"paper-guidelines-topic.html","desc":"Nepřijatelný papír Při použití s tiskárnou","descFull":"Nepřijatelný papír Při použití s tiskárnou se nedoporučují následující typy papíru: Chemicky ošetřené papíry, které se používají k vytváření kopií bez uhlového papíru. Jsou také známé jako samopropisovací, samokopírovací (CCP) nebo bezuhlíkové papíry (NCR). Předtištěné papíry obsahující chemické látky, které mohou znečistit tiskárnu Předtištěné papíry, na které může nepříznivě působit teplota zapékače tiskárny. Předtištěné papíry vyžadující soutisk (přesné umístění tisku na stránce) větší než cca 2,3 mm. Například formuláře rozpoznávání písma (OCR). Někdy je možné soutisk nastavit pomocí softwarové aplikace a tisknout bez problémů i na tyto formuláře. Potahované papíry (smazatelné bankovní), syntetické papíry nebo papíry pro tepelný tisk Papíry s hrubým okrajem, hrubým či výrazným povrchem nebo zprohýbané papíry. Papíry, které nesplňují normu EN12281:2002 (Evropskou). Papíry s gramáží nižší než 60g/m 2 . Vícedílné formuláře nebo dokumenty. nepřijatelný papír"},{"UUID":"a206cbbb-9259-4dcf-9cc2-cb8a10934631","title":"Výběr papíru","link":"paper-guidelines-topic.html","desc":"Skladování papíru Dodržujte následující pravidla","descFull":"Skladování papíru Dodržujte následující pravidla pro skladování papíru, abyste zabránili uvíznutí papíru a nerovnoměrné kvalitě tisku: Před tiskem připravte papír tak, že jej na 24 až 48 hodin uložíte do původního obalu ve stejném prostředí, kde je umístěna tiskárna. Prodlužte tuto dobu o několik dní v případě, kdy prostředí skladování nebo dopravy je velmi odlišné od prostředí tiskárny. Silný papír může také vyžadovat delší dobu pro přizpůsobení podmínkám. K dosažení co nejlepších výsledků skladujte papír v prostředí s teplotou přibližně 21 °﻿C (70 °﻿F) a relativní vlhkostí vzduchu 40 %. Většina výrobců štítků doporučuje tisknout při teplotě v rozsahu 18 až 24 °﻿C (65 až 75 °﻿F) a relativní vlhkosti vzduchu 40 až 60 %. Papír skladujte v krabicích a spíše na paletě nebo na polici než přímo na zemi. Jednotlivá balení skladujte položená na rovném povrchu. Na jednotlivá balení papíru nic nepokládejte. Papír vyndávejte z krabice nebo z obalu až tehdy, když ho budete vkládat do tiskárny. Papír uložený v krabici a v obalu zůstane čistý, suchý a rovný. skladování papíru"},{"UUID":"96e1ff0c-c3dd-4120-aceb-86a8d4be1530","title":"Výběr papíru","link":"paper-guidelines-topic.html","desc":"Výběr předtištěných formulářů a hlavičkových","descFull":"Výběr předtištěných formulářů a hlavičkových papírů Používejte papír s dlouhými vlákny. Použijte pouze předtištěné formuláře a hlavičkové papíry tištěné offsetem nebo z rytiny. Nepoužívejte papíry s hrubým nebo výrazně strukturovaným povrchem. Použijte inkousty, které nejsou ovlivněny pryskyřicí v toneru. Inkousty, které jsou založeny na oxidaci nebo olejovém základě, obecně splňují tyto požadavky. Latexové inkousty tyto požadavky splňovat nemusí. Před zakoupením většího množství předtištěných formulářů a hlavičkových papírů vytiskněte několik zkušebních výtisků na zvažované předtištěné formuláře a hlavičkové papíry. Tím zjistíte, zda inkoust předtištěného formuláře nebo hlavičkového papíru ovlivňuje kvalitu tisku. Pokud máte pochybnosti, kontaktujte svého dodavatele papíru. Při tisku na hlavičkový papír vložte papír ve správné orientaci pro vaši tiskárnu. Další informace naleznete v příručce  Průvodce papírem a speciálními médii . Při tisku na hlavičkový papír vložte papír ve správné orientaci pro vaši tiskárnu. papír předtištěné formuláře předtištěné formuláře výběr papír hlavičkový papír hlavičkový papír výběr"},{"UUID":"6af08332-e15c-435d-a1ac-c1a6bd882d11","title":"Podporované formáty papíru","link":"paper-guidelines-topic.html","desc":"Formáty papíru podporované základní konfigurací","descFull":"Formáty papíru podporované základní konfigurací Formáty papíru podporované základní konfigurací Formát papíru Orientace Standardní zásobník na 550 listů Univerzální podavač Oboustranný tisk Automatický podavač dokumentů 1  Podporováno pouze u některých modelů tiskáren. 2  Podporováno pouze při konfiguraci z nabídky Univerzální nastavení. 3  Podporované formáty papíru od 95 x 139,7 mm (3,74 x 5,5 palce) do 297 x 355,6 mm (11,69 x 14 palců). 4  Maximální dílka univerzálního formátu papíru je v případě nekonečného papíru 1320,8 mm/52 palců. Vkládejte pouze jeden list nekonečného papíru současně. 5  Podporované formáty papíru od 95 x 139,7 mm (3,74 x 5,5 palce) do 320 x 457,2 mm (12,6 x 18 palců). 6  Podporované formáty papíru od 105 x 139,7 mm (4,13 x 5,5 palce) do 320 x 457,2 mm (12,59 x 18 palců). 7  Podporované formáty papíru od 76,2 x 128 mm (3 x 5,04 palce) do 297 x 432 mm (11,69 x 17,01 palců). Karta 4x6 Podávání krátkým okrajem X ✓ X X Podávání dlouhým okrajem X X X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Podávání dlouhým okrajem X X X X 1/3 A4 Podávání krátkým okrajem ✓ ✓ X ✓ Podávání dlouhým okrajem X X X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem ✓ X ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ X ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem X ✓ ✓ 1 ✓ 1 JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ X ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem ✓ X ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ X ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ X ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem X ✓ ✓ ✓ 12 x 18 304,8 x 457,2 mm (12,0 x 18,0 palců) Podávání krátkým okrajem X ✓ ✓ X SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X ✓ ✓ X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem ✓ ✓ X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem ✓ ✓ X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem ✓ ✓ X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem ✓ ✓ X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem ✓ ✓ X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem ✓ ✓ X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem ✓ ✓ X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X ✓ 2 X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem ✓ ✓ X X Univerzální – ✓ 3 ✓ 4, 5 ✓ 6 ✓ 7 podporované formáty papíru formáty papíru podporované"},{"UUID":"95f04eed-5792-4e21-b2bd-78a860e6ce90","title":"Podporované formáty papíru","link":"paper-guidelines-topic.html","desc":"Formáty papíru podporované volitelnými zásobníky","descFull":"Formáty papíru podporované volitelnými zásobníky Formát papíru Orientace Volitelný zásobník na 550 listů Zásobník na 2 x 550 listů dvojitý zásobník na 2000 listů Zásobník na 1500 listů 1  Podporováno pouze při konfiguraci z nabídky Univerzální nastavení. 2  Podporované formáty papíru od 139,7 x 215,9 mm (5,5 x 8,5 palce) do 304,8 x 457,2 mm (12 x 18 palců). Karta 4x6 Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem ✓ ✓ X X Podávání dlouhým okrajem X X X X 1/3 A4 Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ X X A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ X X JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ X X Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem ✓ ✓ X X Podávání dlouhým okrajem X X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ X X Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ X X Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ X X Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ X X Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ X X 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem ✓ ✓ X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem ✓ ✓ X X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem ✓ 1 ✓ 1 X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem ✓ 1 ✓ 1 X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem ✓ ✓ X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem ✓ ✓ X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem ✓ ✓ X X Univerzální – ✓ 2 ✓ 2 ✓ ✓ podporované formáty papíru formáty papíru podporované"},{"UUID":"9d1d507c-350b-4f68-b6cf-5a63a60c6b13","title":"Podporované formáty papíru","link":"paper-guidelines-topic.html","desc":"Formáty papíru podporované odkladači V tiskárně","descFull":"Formáty papíru podporované odkladači V tiskárně je nainstalována podávací jednotka a buď sešívací děrovací finišer, nebo dokončovací schránka – vazač knih. Formát papíru Orientace Podávací jednotka +sešívací děrovací finišer Podávací jednotka + dokončovací schránka – vazač knih Standardní zásobník (horní přihrádka dokončovací schránky) Přihrádka 1 (sešívací děrovací finišer, přihrádka posouvání) Přihrádka 2 (přihrádka podávací jednotky) Standardní zásobník (horní přihrádka dokončovací schránky) Přihrádka 1 (sešívací děrovací finišer, přihrádka posouvání) Přihrádka 2 (přihrádka dokončovací schránky – vazače knih) Přihrádka 3 (přihrádka podávací jednotky) 1  Podporované formáty papíru od 90 x 148 mm (3,55 x 5,83 palce) do 320 x 600 mm (12,59 x 23,62 palců). 2  Podporované formáty papíru od 90 x 148 mm (3,55 x 5,83 palce) do 320 x 1260 mm (12,59 x 49,6 palců). 3  Podporované formáty papíru od 182 x 257 mm (7,17 x 10,12 palce) do 304,8 x 457,2 mm (12 x 18 palců). Karta 4x6 Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem X X X X X X ✓ A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem X X X X X X X 1/3 A4 Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem X X X X X X ✓ A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem ✓ ✓ X ✓ ✓ X ✓ Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X ✓ X X X ✓ Univerzální – ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 V tiskárně je nainstalována podávací jednotka s možností skládání a buď sešívací děrovací finišer, nebo dokončovací schránka – vazač knih. Podávací jednotka s možností skládání + sešívací děrovací finišer Podávací jednotka s možností skládání + dokončovací schránka – vazač knih Formát papíru Orientace Standardní zásobník (horní přihrádka dokončovací schránky) Přihrádka 1 (sešívací děrovací finišer, přihrádka posouvání) Přihrádka 2 (přihrádka podávací jednotky) Standardní zásobník (horní přihrádka dokončovací schránky) Přihrádka 1 (sešívací děrovací finišer, přihrádka posouvání) Přihrádka 2 (přihrádka dokončovací schránky – vazače knih) Přihrádka 3 (přihrádka podávací jednotky) 1  Podporované formáty papíru od 90 x 148 mm (3,55 x 5,83 palce) do 320 x 600 mm (12,59 x 23,62 palců). 2  Podporované formáty papíru od 90 x 148 mm (3,55 x 5,83 palce) do 297 x 1260 mm (11,69 x 49,6 palců). 3  Podporované formáty papíru od 182 x 257 mm (7,17 x 10,12 palce) do 304,8 x 457,2 mm (12 x 18 palců). Karta 4x6 Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem X X X X X X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem X X X X X X X 1/3 A4 Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem X X X X X X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem ✓ ✓ X ✓ ✓ ✓ X SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem ✓ ✓ X ✓ ✓ X X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X ✓ X X X ✓ Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X ✓ X X X ✓ Univerzální – ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 podporované formáty papíru formáty papíru podporované"},{"UUID":"403f03c1-00e6-49bf-afd7-a69269d3fe6c","title":"Podporované formáty papíru","link":"paper-guidelines-topic.html","desc":"Podporované formáty papíru pro úlohy","descFull":"Podporované formáty papíru pro úlohy se sešíváním a děrováním Formáty papíru podporované sešívacím finišerem Formát papíru Orientace Sešívání Jednoduché Dvojité Dvojitě vlevo Karta 4x6 Podávání krátkým okrajem X X X Podávání dlouhým okrajem X X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X X Podávání dlouhým okrajem X X X 1/3 A4 Podávání krátkým okrajem X X X Podávání dlouhým okrajem X X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem X X X Podávání dlouhým okrajem X X X A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ ✓ Podávání dlouhým okrajem ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem X X X Podávání dlouhým okrajem X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ X Podávání dlouhým okrajem ✓ ✓ X Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ X Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ X Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem X X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X X X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X X Formáty papíru podporované sešívacím děrovacím finišerem Formát papíru Orientace Sešívání Děrování Jednoduché Dvojité Dvojitě vlevo Dva otvory Tři otvory Čtyři otvory Karta 4x6 Podávání krátkým okrajem X X X X X X Podávání dlouhým okrajem X X X X X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X X X X X Podávání dlouhým okrajem X X X X X X 1/3 A4 Podávání krátkým okrajem X X X X X X Podávání dlouhým okrajem X X X X X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem X X X ✓ X X Podávání dlouhým okrajem X X X ✓ X X A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem X X X ✓ X X Podávání dlouhým okrajem X X X ✓ X X Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem X X X X X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X X X X X X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X X X X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X X X X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X X X X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X X X X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X X X X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X X X X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X X X X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X X X X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X X X X X Formáty papíru podporované dokončovací schránkou – vazačem knih Formát papíru Orientace Sešívání Děrování Jednoduché Dvojité Dvojitě vlevo Dva otvory Tři otvory Čtyři otvory Karta 4x6 Podávání krátkým okrajem X X X X X X Podávání dlouhým okrajem X X X X X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X X X X X Podávání dlouhým okrajem X X X X X X 1/3 A4 Podávání krátkým okrajem X X X X X X Podávání dlouhým okrajem X X X X X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem X X X ✓ X X Podávání dlouhým okrajem X X X ✓ X X A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ ✓ X X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ X X JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem X X X ✓ X X Podávání dlouhým okrajem X X X ✓ X X Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Podávání dlouhým okrajem ✓ ✓ ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ X X Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem X X X X X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X X X X X X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X X X X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X X X X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X X X X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X X X X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X X X X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X X X X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X X X X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X X X X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X X X X X podporované formáty papíru formáty papíru podporované"},{"UUID":"486bcca6-659d-4a24-b9ca-b28d6bc35aae","title":"Podporované formáty papíru","link":"paper-guidelines-topic.html","desc":"Podporované formáty papíru pro úloh","descFull":"Podporované formáty papíru pro úloh se skládáním Formáty papíru podporované podávací jednotkou s možností skládání Formát papíru Orientace Pouze podávací jednotka s možností skládání Skládání typu C Skládání typu Z Skládání typu Z, poloviční list Skládání typu V Standardní zásobník Standardní zásobník Standardní zásobník Standardní zásobník Karta 4x6 Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X 1/3 A4 Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Podávání dlouhým okrajem X X X X A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem X X ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Podávání dlouhým okrajem X X X X Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem X X X X Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem X X X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X X X X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X X X Formáty papíru podporované podávací jednotkou a dokončovací schránkou – vazačem knih Formát papíru Orientace Podávací jednotka + dokončovací schránka – vazač knih Skládání typu V, vícenásobné Skládání typu V Zásobník 2 Standardní zásobník, zásobník 1, zásobník 2 Karta 4x6 Podávání krátkým okrajem X X Podávání dlouhým okrajem X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X Podávání dlouhým okrajem X X 1/3 A4 Podávání krátkým okrajem X X Podávání dlouhým okrajem X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem X X Podávání dlouhým okrajem X X A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem X X A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem X X JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem X X Podávání dlouhým okrajem X X Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem X X Podávání dlouhým okrajem X X Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem X X Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem ✓ ✓ Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X Formáty papíru podporované podávací jednotkou s možností skládání a sešívacím děrovacím finišerem Formát papíru Orientace Podávací jednotka s možností skládání + sešívací děrovací finišer Skládání typu C Skládání typu Z Skládání typu Z, poloviční list Skládání typu V Zásobník 2 Zásobník 2 Standardní zásobník, zásobník 2 Standardní zásobník, zásobník 2 Karta 4x6 Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X 1/3 A4 Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Podávání dlouhým okrajem X X X X A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem X X ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem X X X X Podávání dlouhým okrajem X X X X Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Podávání dlouhým okrajem X X X X Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem X X X X Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem X X X ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X X X ✓ Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X X X Formáty papíru podporované podávací jednotkou s možností skládání a dokončovací schránkou – vazačem knih Formát papíru Orientace Podávací jednotka s možností skládání + dokončovací schránka – vazač knih Skládání typu C Skládání typu Z Skládání typu Z, poloviční list Skládání typu V, vícenásobné Skládání typu V Zásobník 3 Zásobník 3 Standardní zásobník, zásobník 1, zásobník 3 Zásobník 2 Standardní zásobník, zásobník 1, zásobník 2, zásobník 3 Karta 4x6 Podávání krátkým okrajem X X X X X Podávání dlouhým okrajem X X X X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X X X X Podávání dlouhým okrajem X X X X X 1/3 A4 Podávání krátkým okrajem X X X X X Podávání dlouhým okrajem X X X X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem X X X X X Podávání dlouhým okrajem X X X X X A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ Podávání dlouhým okrajem X X X X X A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem X X X ✓ ✓ Podávání dlouhým okrajem X X X X X JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem X X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem X X X X X Podávání dlouhým okrajem X X X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem X X X X X Podávání dlouhým okrajem X X X X X Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ Podávání dlouhým okrajem X X X X X Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem X X X ✓ ✓ Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ ✓ ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem X X X X ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X X X X ✓ Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X X X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X X X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X X X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X X X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X X X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X X X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X X X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X X X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X X X X podporované formáty papíru formáty papíru podporované"},{"UUID":"cd8f97d6-66b7-4d31-be16-fd5e9af91cde","title":"Podporované formáty papíru","link":"paper-guidelines-topic.html","desc":"Podporované formáty papíru pro stohovací","descFull":"Podporované formáty papíru pro stohovací úlohy s posunutím Formáty papíru podporované odsazovacím odkládacím zásobníkem nebo sešívacím finišerem Formát papíru Orientace Odsazovací odkládací zásobník Sešívací finišer 1  Podporované formáty papíru od 90 x 148 mm (3,55 x 5,83 palce) do 320 x 600 mm (12,59 x 23,62 palců). 2  Podporované formáty papíru od 148 x 148 mm (5,83 x 5,83 palce) do 297 x 431,8 mm (11,69 x 17 palců). Karta 4x6 Podávání krátkým okrajem X X Podávání dlouhým okrajem X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X Podávání dlouhým okrajem X X 1/3 A4 Podávání krátkým okrajem X X Podávání dlouhým okrajem X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem ✓ X Podávání dlouhým okrajem ✓ X Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem ✓ X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem ✓ X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem ✓ X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem ✓ X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem ✓ X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem ✓ X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem ✓ X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem ✓ X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem ✓ X Univerzální – ✓ 1 ✓ 2 Formáty papíru podporované odkladači Formát papíru Orientace Podávací jednotka +sešívací děrovací finišer Podávací jednotka + dokončovací schránka – vazač knih Zásobník 1 Zásobník 1 1  Podporované formáty papíru od 139,7 x 148 mm (5,5 x 5,83 palce) do 304,8 x 600 mm (12 x 23,62 palců). 2  Podporované formáty papíru od 125 x 148 mm (4,93 x 5,83 palce) do 304,8 x 457,2 mm (12 x 18 palců). Karta 4x6 Podávání krátkým okrajem X X Podávání dlouhým okrajem X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X Podávání dlouhým okrajem X X 1/3 A4 Podávání krátkým okrajem X X Podávání dlouhým okrajem X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X Univerzální – ✓ 1 ✓ 2 Formáty papíru podporované výstupními zásobníky (s podávací jednotkou s možností skládání) Formát papíru Orientace Podávací jednotka s možností skládání + sešívací děrovací finišer Podávací jednotka s možností skládání + dokončovací schránka – vazač knih Zásobník 1 Zásobník 1 1  Podporované formáty papíru od 139,7 x 148 mm (5,5 x 5,83 palce) do 304,8 x 600 mm (12 x 23,62 palců). 2  Podporované formáty papíru od 125 x 148 mm (4,93 x 5,83 palce) do 304,8 x 457,2 mm (12 x 18 palců). Karta 4x6 Podávání krátkým okrajem X X Podávání dlouhým okrajem X X A6 105 x 148 mm (4,13 x 5,83 palce) Podávání krátkým okrajem X X Podávání dlouhým okrajem X X 1/3 A4 Podávání krátkým okrajem X X Podávání dlouhým okrajem X X A5 148 x 210 mm (5,83 x 8,27 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 palce) Podávání krátkým okrajem ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 palce) Podávání krátkým okrajem ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 palce) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 palců) Podávání krátkým okrajem ✓ ✓ Podávání dlouhým okrajem ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 palců) Podávání krátkým okrajem ✓ ✓ Oficio (Mexiko) 215,9 x 340,4 mm (8,5 x 13,4 palce) Podávání krátkým okrajem ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 palců) Podávání krátkým okrajem ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 palců) Podávání krátkým okrajem ✓ ✓ 12 x 18 304,8 x 457,2 mm (12 x 18 palců) Podávání krátkým okrajem ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 palce) Podávání krátkým okrajem X X Obálka (Choukei 3) 120 x 235 mm (4,75 x 9,25 palce) Podávání krátkým okrajem X X Hagaki 100 x 148 mm (3,94 x 5,83 palce) Podávání krátkým okrajem X X Obálka B5 176 x 250 mm (6,93 x 9,84 palce) Podávání krátkým okrajem X X Obálka (komerční 9) 98,4 x 225,4 mm (3,875 x 8,9 palce) Podávání krátkým okrajem X X Obálka (komerční 10) 104,8 x 241,3 mm (4,12 x 9,5 palce) Podávání krátkým okrajem X X Obálka (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 palce) Podávání krátkým okrajem X X Obálka (DL) 110 x 220 mm (4,33 x 8,66 palce) Podávání krátkým okrajem X X Obálka (ISO C4) 229 x 324 mm (9 x 12,8 palce) Podávání krátkým okrajem X X Obálka (ISO C5) 162 x 229 mm (6,38 x 9 palců) Podávání krátkým okrajem X X Univerzální – ✓ 1 ✓ 2 podporované formáty papíru formáty papíru podporované"},{"UUID":"e2c84a03-faf0-49b6-85b4-2b7aeff4def7","title":"Výběr papíru","link":"paper-guidelines-topic.html","desc":"Podporované gramáže papíru Podporované gramáže","descFull":"Podporované gramáže papíru Podporované gramáže papíru Gramáže papíru podporované tiskárnou Standardní nebo volitelný zásobník na 550 listů, 2x zásobník na 550 listů, zásobník na 1500 listů a dvojitý zásobník na 2000 listů Univerzální podavač Oboustranný tisk Automatický podavač dokumentů 60 – 300 g/m 2 (dokumentový papír 16–80 lb) 60 – 300 g/m 2 (dokumentový papír 16–80 lb) 60 – 220 g/m 2 (dokumentový papír 16–59 lb) 50 – 150 g/m 2 (dokumentový papír 14–40 lb) podporované gramáže papíru gramáže papíru podporované"},{"UUID":"0a896dd1-0a70-42f2-bf67-9228a1b7fd19","title":"Výběr papíru","link":"paper-guidelines-topic.html","desc":"Podporované typy papíru Podporované typy","descFull":"Podporované typy papíru Podporované typy papíru Typy papíru podporované základní konfigurací Formát papíru Standardní zásobník na 550 listů Univerzální podavač Oboustranný tisk Automatický podavač dokumentů Obyčejný papír ✓ ✓ ✓ ✓ Štítkový karton ✓ ✓ ✓ X Recyklovaný ✓ ✓ ✓ ✓ Lesklý ✓ ✓ ✓ X Těžký lesklý ✓ ✓ ✓ X Štítky ✓ ✓ X X Vinylové štítky ✓ ✓ X X Kancelářský ✓ ✓ ✓ ✓ Obálka ✓ ✓ X X Hrubá obálka ✓ ✓ X X Hlavičkový papír ✓ ✓ ✓ ✓ Předtištěný ✓ ✓ ✓ ✓ Barevný papír ✓ ✓ ✓ ✓ Lehký papír ✓ ✓ ✓ ✓ Těžký papír ✓ ✓ ✓ ✓ Drsný bavlněný ✓ ✓ ✓ X Vlastní typ ✓ ✓ ✓ ✓ Typy papíru podporované volitelnými zásobníky Formát papíru Volitelný zásobník na 550 listů Zásobník na 2 x 550 listů dvojitý zásobník na 2000 listů Zásobník na 1500 listů Obyčejný papír ✓ ✓ ✓ ✓ Štítkový karton ✓ ✓ ✓ ✓ Průhledné fólie X X X X Recyklovaný ✓ ✓ ✓ ✓ Lesklý ✓ ✓ ✓ ✓ Těžký lesklý ✓ ✓ ✓ ✓ Štítky ✓ ✓ X X Vinylové štítky ✓ ✓ X X Kancelářský ✓ ✓ ✓ ✓ Obálka ✓ ✓ X X Hrubá obálka ✓ ✓ X X Hlavičkový papír ✓ ✓ ✓ ✓ Předtištěný ✓ ✓ ✓ ✓ Barevný papír ✓ ✓ ✓ ✓ Lehký papír ✓ ✓ ✓ ✓ Těžký papír ✓ ✓ ✓ ✓ Drsný bavlněný ✓ ✓ ✓ ✓ Vlastní typ ✓ ✓ ✓ ✓ Typy papíru podporované výstupním odkladačem Formát papíru Podávací jednotka +sešívací děrovací finišer Podávací jednotka + dokončovací schránka – vazač knih Standardní zásobník (horní přihrádka dokončovací schránky) Přihrádka 1 (sešívací děrovací finišer, přihrádka posouvání) Přihrádka 2 (přihrádka podávací jednotky) Standardní zásobník (horní přihrádka dokončovací schránky) Přihrádka 1 (sešívací děrovací finišer, přihrádka posouvání) Přihrádka 2 (přihrádka dokončovací schránky – vazače knih) Přihrádka 3 (přihrádka podávací jednotky) *  Maximální dílka univerzálního formátu papíru je v případě nekonečného papíru 1320,8 mm/52 palců. Vkládejte pouze jeden list nekonečného papíru současně. Obyčejný papír ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Štítkový karton ✓ ✓ ✓ ✓ ✓ X ✓ Recyklovaný ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Lesklý ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Těžký lesklý ✓ ✓ ✓ ✓ ✓ X ✓ Štítky ✓ ✓ ✓ ✓ ✓ X X Vinylové štítky ✓ ✓ ✓ ✓ ✓ X X Kancelářský ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Obálka X X ✓ X X X ✓ Hrubá obálka X X ✓ X X X ✓ Hlavičkový papír ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Předtištěný ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Barevný papír ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Lehký papír ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Těžký papír ✓ ✓ ✓ ✓ ✓ X X Drsný bavlněný ✓ ✓ ✓ ✓ ✓ X X Vlastní typ ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Typy papíru podporované výstupním zásobníkem (s podávací jednotkou s možností skládání) Formát papíru Podávací jednotka s možností skládání + sešívací děrovací finišer Podávací jednotka s možností skládání + dokončovací schránka – vazač knih Standardní zásobník (horní přihrádka dokončovací schránky) Přihrádka 1 (sešívací děrovací finišer, přihrádka posouvání) Přihrádka 2 (přihrádka podávací jednotky) Standardní zásobník (horní přihrádka dokončovací schránky) Přihrádka 1 (sešívací děrovací finišer, přihrádka posouvání) Přihrádka 2 (přihrádka dokončovací schránky – vazače knih) Přihrádka 3 (přihrádka podávací jednotky) *  Maximální dílka univerzálního formátu papíru je v případě nekonečného papíru 1320,8 mm/52 palců. Vkládejte pouze jeden list nekonečného papíru současně. Obyčejný papír ✓ ✓ ✓ ✓ ✓ ✓ ✓ Štítkový karton ✓ ✓ ✓ ✓ ✓ X ✓ Recyklovaný ✓ ✓ ✓ ✓ ✓ ✓ ✓ Lesklý ✓ ✓ ✓ ✓ ✓ ✓ ✓ Těžký lesklý ✓ ✓ ✓ ✓ ✓ X ✓ Štítky ✓ ✓ ✓ ✓ ✓ X ✓ Vinylové štítky ✓ ✓ ✓ ✓ ✓ X ✓ Kancelářský ✓ ✓ ✓ ✓ ✓ ✓ ✓ Obálka X X ✓ X X X ✓ Hrubá obálka X X ✓ X X X ✓ Hlavičkový papír ✓ ✓ ✓ ✓ ✓ X ✓ Předtištěný ✓ ✓ ✓ ✓ ✓ X ✓ Barevný papír ✓ ✓ ✓ ✓ ✓ ✓ ✓ Lehký papír ✓ ✓ ✓ ✓ ✓ ✓ ✓ Těžký papír ✓ ✓ ✓ ✓ ✓ X X Drsný bavlněný ✓ ✓ ✓ ✓ ✓ X X Vlastní typ ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Typy papíru podporované podávací jednotkou s možností skládání, odsazovacím odkládacím zásobníkem, sešívacím finišerem Formát papíru Pouze podávací jednotka s možností skládání Odsazovací odkládací zásobník Sešívací finišer Obyčejný papír ✓ ✓ ✓ Štítkový karton ✓ ✓ ✓ Recyklovaný ✓ ✓ ✓ Lesklý ✓ ✓ ✓ Těžký lesklý ✓ ✓ ✓ Štítky ✓ ✓ ✓ Vinylové štítky ✓ ✓ ✓ Kancelářský ✓ ✓ ✓ Obálka ✓ ✓ ✓ Hrubá obálka ✓ ✓ ✓ Hlavičkový papír ✓ ✓ ✓ Předtištěný ✓ ✓ ✓ Barevný papír ✓ ✓ ✓ Lehký papír ✓ ✓ ✓ Těžký papír ✓ ✓ ✓ Drsný bavlněný ✓ ✓ ✓ Vlastní typ ✓ ✓ ✓ Typy papíru podporované sešívacím děrovacím finišerem a dokončovací schránkou – vazačem knih Formát papíru Horní přihrádka dokončovací schránky (standardní zásobník) Přihrádka sešívacího finišeru (přihrádka 1) Posunutí Děrování Sešívání 1 ohyb Posunutí Děrování Sešívání 1 ohyb Obyčejný papír X ✓ X ✓ ✓ ✓ ✓ ✓ Štítkový karton X X X X ✓ X X X Recyklovaný X ✓ X ✓ ✓ ✓ ✓ ✓ Lesklý X ✓ X ✓ ✓ ✓ ✓ ✓ Těžký lesklý X X X X ✓ X X X Štítky X X X X ✓ X X X Vinylové štítky X X X X ✓ X X X Kancelářský X ✓ X ✓ ✓ ✓ ✓ ✓ Hlavičkový papír X ✓ X ✓ ✓ ✓ ✓ ✓ Předtištěný X ✓ X ✓ ✓ ✓ ✓ ✓ Barevný papír X ✓ X ✓ ✓ ✓ ✓ ✓ Lehký papír X ✓ X ✓ ✓ ✓ ✓ ✓ Těžký papír X X X X ✓ X X X Drsný bavlněný X ✓ X X ✓ ✓ X X Vlastní typ X ✓ X ✓ ✓ ✓ ✓ ✓ podporované typy papíru typ papíru podporované"},{"UUID":"37ae004a-41de-4283-8ab9-fea7ed782965","title":"Další funkce a podpora tiskárny","link":"supported-applications-topic.html","desc":"Podporované aplikace Aplikací a podporované modely","descFull":"Podporované aplikace Aplikací a podporované modely tiskáren Aplikace Modely tiskárny Scan Center CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Přizpůsobení displeje CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Zákaznická podpora XC8355, XC9635, XC9645, XC9655 Kvóty zařízení XC8355, XC9635, XC9645, XC9655 aplikace tiskárny předinstalované aplikace"},{"UUID":"357f8a24-62ad-4ba7-aca2-f1782dd05945","title":"Další funkce a podpora tiskárny","link":"supported-applications-topic.html","desc":"Podporované jednotky flash a typy souborů","descFull":"Podporované jednotky flash a typy souborů Jednotky paměti flash Jednotky paměti flash, které podporují rozhraní USB 2.0 nebo nižší. Jednotky paměti flash, které podporují systém souborů NFTS (New Technology File System) nebo souborový systém FAT32 (File Allocation Table). Typy souborů Podporované typy souborů Dokumenty Obrázky PDF (verze 1.7 nebo starší) Formáty souborů Microsoft (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG nebo JPG TIFF nebo TIF GIF BMP PNG PCX DCX podporované jednotky flash podporované typy souborů"},{"UUID":"4b63718a-8c2b-4459-a033-4c3542480443","title":"Další funkce a podpora tiskárny","link":"supported-applications-topic.html","desc":"Dostupné interní možnosti Pevný disk","descFull":"Dostupné interní možnosti Pevný disk Licencované funkce IPDS Čárový kód Lexmark  – port ISP (Internal Solutions Port) Sériová karta RS‑232C MarkNet  N8230 Fiber Ethernet 100BASE-FX(LC), 1000BASE-SX(LC) Port Internal Solutions Port (ISP) interní doplňky firmwarová karta pevný disk"},{"UUID":"cd58aecf-f194-4343-846d-4f057e28f372","title":"Nastavení, instalace a konfigurace","link":"selecting-location-printer-topic.html","desc":"Výběr umístění tiskárny Ponechejte dostatek","descFull":"Výběr umístění tiskárny Ponechejte dostatek prostoru pro otevírání zásobníků, krytů a dvířek a pro instalaci hardwarových doplňků. Nastavte tiskárnu blízko elektrické zásuvky. Abyste zabránili nebezpečí požáru nebo úrazu elektrickým proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Abyste zabránili riziku úrazu elektrickým proudem, neumísťujte produkt blízko vody nebo vlhkých míst. Ujistěte se, že proudění vzduchu v místnosti odpovídá nejnovější revizi normy ASHRAE 62 nebo normě 156 technického výboru CEN. Umístěte tiskárnu na rovný, pevný a stabilní povrch. Udržujte tiskárnu: Čistou, suchou a nezaprášenou. Stranou od volně položených svorek a kancelářských spon. Stranou přímého vzdušného proudění klimatizací, ohřívačů a ventilátorů. Stranou přímého slunečního záření a prostředí s extrémní vlhkostí. Dodržujte doporučené teploty a zabraňte výkyvům hodnot: Doporučené teploty Okolní teplota Skladovací teplota Pro vhodné odvětrávání doporučujeme zachovat v okolí tiskány volný prostor o rozměrech: Doporučený volný prostor kolem tiskárny 1 Nahoře 2 Zadní strana 3 Pravá strana 4 Vepředu 5 Levá strana tiskárna volba umístění pro volba umístění pro tiskárnu tiskárna minimální volné prostory přemístění tiskárny"},{"UUID":"0f6ce424-661c-4700-a981-839c554e02d0","title":"Nastavení, instalace a konfigurace","link":"printer-ports-topic.html","desc":"Porty tiskárny Abyste zabránili riziku","descFull":"Porty tiskárny Abyste zabránili riziku úrazu el. proudem, nenastavujte produkt během bouřky a nepropojujte jej s jinými zařízeními, jako je napájecí kabel, fax nebo telefon. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Abyste zabránili riziku požáru nebo úrazu elektrickým proudem, používejte výhradně napájecí kabel dodávaný spolu s produktem nebo odpovídající náhradní kabel schválený výrobcem. Pokud připojujete tento výrobek k veřejné telefonní síti, používejte pouze telefonní kabel 26 AWG nebo robustnější telefonní kabel (RJ-11), abyste snížili riziko vzniku požáru. V případě uživatelů z Austrálie musí být kabel schválen úřadem Australian Communications and Media Authority. Aby nedošlo ke ztrátě dat nebo závadě tiskárny, nedotýkejte se během tisku kabelu USB, žádného adaptéru bezdrátové sítě nebo tiskárny v zobrazené oblasti. Zásuvka a porty tiskárny a jejich funkce Port tiskárny Funkce 1 Dokončovací schránka nebo volitelný port Připojte tiskárnu k dokončovací schránce nebo volitelnému zařízení. 2 port USB Připojte klávesnici nebo jakýkoli kompatibilní volitelný doplněk. 3 port LINE K dispozici pouze v případě, že je nainstalována faxová karta. Po připojení tiskárny k aktivní telefonní lince prostřednictvím standardní zásuvky na stěně (RJ-11), filtru DSL nebo adaptéru VoIP či jiného adaptéru, který umožňuje přístup k telefonní lince, bude možné odesílat a přijímat faxy. 4 port EXT K dispozici pouze v případě, že je nainstalována faxová karta. Slouží k připojení více zařízení (telefonu nebo záznamníku) k tiskárně a k telefonní lince. Tento port použijte, pokud nemáte pro tiskárnu samostatnou faxovou linku a pokud je tato metoda připojení podporována v dané zemi nebo oblasti. 5 Port USB tiskárny Připojte tiskárnu k počítači. 6 port Ethernet Připojte tiskárnu k síti. 7 Konektor napájecího kabelu Tiskárnu připojte k řádně uzemněné elektrické zásuvce. porty tiskárny port USB port Ethernet zásuvka napájecího kabelu"},{"UUID":"de54ebaf-a0bf-4fb6-b9ce-5a55047da6bf","title":"Konfigurace aplikací a řešení","link":"setting-up-scan-center-topic.html","desc":"Nastavení centra Scan Center Na","descFull":"Nastavení centra Scan Center Na ovládacím panelu vyberte možnost  Scan Center . Vyberte a vytvořte cíl a poté nakonfigurujte nastavení. Ukládají se pouze cíle vytvořené z prostředí serveru Embedded Web Server. Další informace vyhledejte v dokumentaci dodané společně s řešením. Naskenujte dokument. Scan Center nastavení"},{"UUID":"ef2335fd-5a62-47d3-99d2-a48dda0642c1","title":"Konfigurace aplikací a řešení","link":"setting-up-scan-center-topic.html","desc":"Použití přizpůsobení displeje Použití přizpůsobení","descFull":"Použití přizpůsobení displeje Použití přizpůsobení displeje Zkontrolujte, že jsou v serveru Embedded Web Server zapnuta nastavení Spořič obrazovky, Prezentace a Tapeta. Přejděte k položkám  Aplikace Přizpůsobení displeje Konfigurovat . Správa spořiče displeje a obrázků pro prezentace V oblasti Spořič displeje a obrázky prezentace přidejte, upravte nebo odstraňte obrázek. Můžete přidat až 10 obrázků. Když je povoleno, ikony stavu se na spořiči displeje zobrazí pouze v případě, že existují chyby, varování nebo cloudová oznámení. Použijte změny. Změna obrázku tapety Na ovládacím panelu zvolte položku  Změnit tapetu . Vyberte obrázek, který se má použít. Použijte změny. Spuštění prezentace z jednotky paměti flash Vložte jednotku flash do portu USB. Na ovládacím panelu vyberte možnost  Prezentace . Jednotku paměti flash lze po zahájení prezentace vyjmout, ale obrázky se do tiskárny neuloží. Pokud se prezentace zastaví, zobrazíte obrázky opětovným zasunutím jednotky paměti flash. Přizpůsobení displeje použití přizpůsobení displeje změna tapety spuštění prezentace správa spořiče obrazovky"},{"UUID":"8de0f47c-e4a3-4249-9ec3-feff746a57dc","title":"Konfigurace aplikací a řešení","link":"setting-up-scan-center-topic.html","desc":"Konfigurace záložek Vytváření záložek Otevřete","descFull":"Konfigurace záložek Vytváření záložek Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na položku  Záložky Přidat záložku  a poté zadejte název záložky. Vyberte typ protokolu  adresy  a poté proveďte jeden z následujících postupů: Pro možnosti HTTP nebo HTTPS zadejte adresu URL, pro kterou chcete vytvořit záložku. V případě protokolu HTTPS musíte používat název hostitele namísto IP adresy. Zadejte například  myWebsite.com/sample.pdf  namísto zadání  123.﻿123.123.123/sample.pdf . Zkontrolujte také, zda název hostitele odpovídá hodnotě Obvyklý název (CN) v certifikátu serveru. Více informací o získání hodnoty CN v certifikátu serveru naleznete v nápovědě k webovému prohlížeči. Pro možnost FTP zadejte adresu serveru FTP. Například  myServer/myDirectory . Zadejte číslo portu FTP. Výchozím portem pro odesílání příkazů je port 21. Pro možnost SMB zadejte adresu síťové složky. Například  myServer/myShare/myFile.pdf . Zadejte název síťové domény. V případě potřeby zvolte typ  ověření  pro FTP a SMB. Pokud chcete k záložce omezit přístup, zadejte kód PIN. Aplikace podporuje následující typy souborů: PDF, JPEG a TIFF. Jiné typy souborů, jako DOCX a XLSX, jsou podporovány pouze u některých modelů tiskáren. Klepněte na tlačítko  Uložit . Vytváření složek Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na položku  Záložky Přidat složku  a poté zadejte název složky. Pokud chcete ke složce omezit přístup, zadejte kód PIN. Klepněte na tlačítko  Uložit . záložky vytvoření vytváření záložek"},{"UUID":"f7eac2d3-54f6-48f2-aa10-2fa1da31d0ec","title":"Konfigurace aplikací a řešení","link":"setting-up-scan-center-topic.html","desc":"Konfigurace adresáře Přidání kontaktů Otevřete","descFull":"Konfigurace adresáře Přidání kontaktů Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnost  Adresář  a poté klepněte na možnost  Přidat kontakt . V případě potřeby zadejte přihlašovací metodou pro umožnění přístupu k aplikaci. Klepněte na tlačítko  Uložit . Přidání skupin Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnost  Adresář  a poté klepněte na možnost  Přidat kontakt . Můžete přiřadit jeden nebo více kontaktů ke skupině. Klepněte na tlačítko  Uložit . přidání kontaktů přidání skupin Adresář"},{"UUID":"28566ebb-f459-44d3-956f-5edd63b657ad","title":"Instalace a používání funkcí usnadnění","link":"activating-voice-guidance-topic.html","desc":"Aktivace funkce Hlasové pokyny Na","descFull":"Aktivace funkce Hlasové pokyny Na domovské obrazovce Jedním pohybem pomalu jeďte jedním prstem doleva a poté nahoru na displeji, dokud neuslyšíte hlasovou zprávu. Dvěma prsty stiskněte tlačítko  OK . Pokud gesto nefunguje, více zatlačte. Z klávesnice Stiskněte a podržte klávesu s číslem  5 , dokud se neozve hlasová zpráva. Stisknutím klávesy  Tab  navigujte kurzor na tlačítko OK a poté stiskněte klávesu  Enter . Pokud je aktivována funkce Hlasové pokyny, vždy vyberte libovolnou položku na displeji dvěma prsty. Hlasové pokyny mají omezenou jazykovou podporu. Hlasové pokyny aktivace aktivace funkce Hlasové pokyny"},{"UUID":"1a8196cc-f71d-4f52-a451-d92a71a12f6f","title":"Instalace a používání funkcí usnadnění","link":"activating-voice-guidance-topic.html","desc":"Deaktivace funkce Hlasové pokyny Jedním","descFull":"Deaktivace funkce Hlasové pokyny Jedním pohybem pomalu jeďte jedním prstem doleva a poté nahoru na displeji, dokud neuslyšíte hlasovou zprávu. Dvěma prsty proveďte jeden z následujících úkonů: Vyberte možnost  Hlasové pokyny  a poté vyberte možnost  OK . Vyberte položku  Zrušit . Pokud gesto nefunguje, více zatlačte. Stisknutím vypínače nebo přepnutím tiskárny do režimu spánku či hibernace deaktivujete také hlasové pokyny. Hlasové pokyny deaktivace deaktivace funkce Hlasové pokyny"},{"UUID":"5ca854fa-84d0-4c95-904e-f0c6745903c7","title":"Instalace a používání funkcí usnadnění","link":"activating-voice-guidance-topic.html","desc":"Navigace na obrazovce pomocí gest","descFull":"Navigace na obrazovce pomocí gest Většinu gest lze použít, pouze když je aktivována funkce Hlasové pokyny. K zadávání znaků a upravení určitých nastavení použijte fyzickou klávesnici. Gesta a jejich funkce Gesto Funkce Přejetí jedním prstem doleva a poté nahoru Spustí nebo ukončí režim usnadnění. Toto gesto lze použít také v případě, že je tiskárna v normálním režimu. Poklepání jedním prstem Výběr možnosti nebo položky na obrazovce. Poklepání dvěma prsty na ikonu domovské obrazovky Deaktivuje režim usnadnění. Trojité klepnutí jedním prstem Přiblížení nebo oddálení textu a obrázků. Chcete-li používat funkci zvětšení, povolte režim zvětšení. Přejetí jedním prstem doprava nebo dolů Přechod na další položku na obrazovce. Přejetí jedním prstem doleva nebo nahoru Přechod na předchozí položku na obrazovce. Přejetí jedním prstem nahoru a poté dolů Přechod na první položku na obrazovce. Posun Přístup k částem zvětšeného obrázku, které přesahují za hranice obrazovky. Pomocí dvou prstů přetáhněte zvětšený snímek. Chcete-li používat gesto posunu, povolte režim zvětšení. Přejetí jedním prstem nahoru a poté doprava Zvýší hlasitost. Toto gesto lze použít také v případě, že je tiskárna v normálním režimu. Přejetí jedním prstem dolů a poté doprava Sníží hlasitost. Toto gesto lze použít také v případě, že je tiskárna v normálním režimu. Přejetí jedním prstem nahoru a poté doleva Ukončení aplikace a návrat na domovskou obrazovku. Přejetí jedním prstem dolů a poté doleva Návrat na předchozí nastavení. navigace na obrazovce pomocí gest gesta na dotykové obrazovce gesta na obrazovce"},{"UUID":"53ff25cc-b953-413e-8b79-e9e671ce25b2","title":"Instalace a používání funkcí usnadnění","link":"activating-voice-guidance-topic.html","desc":"Používání klávesnice na obrazovce Když","descFull":"Používání klávesnice na obrazovce Když se zobrazí klávesnice na obrazovce, proveďte nejméně jeden z následujících kroků: Stisknutí klávesy umožňuje oznámit znak nebo jej zadat do pole. Přetažení prstu přes různé znaky umožňuje oznámit znak nebo jej zadat do pole. Stisknutí textového pole dvěma prsty oznámí znaky v poli. Použitím klávesy  Backspace  můžete znaky mazat. klávesnice na obrazovce použití"},{"UUID":"9068a569-8217-448e-95fa-7abbdffcc08b","title":"Instalace a používání funkcí usnadnění","link":"activating-voice-guidance-topic.html","desc":"Povolení režimu zvětšení Jedním pohybem","descFull":"Povolení režimu zvětšení Jedním pohybem pomalu jeďte jedním prstem doleva a poté nahoru na displeji, dokud neuslyšíte hlasovou zprávu. U modelů tiskáren bez vestavěných reproduktorů si zprávu poslechněte pomocí sluchátek. Dvěma prsty proveďte následující: Stiskněte  režim Zvětšení . Stiskněte tlačítko  OK . Pokud gesto nefunguje, více zatlačte. Podrobnější informace o navigaci na zvětšené obrazovce viz  . režim zvětšení povolení Povolení režimu zvětšení"},{"UUID":"6fae9620-981e-4231-b825-4ce4c77de084","title":"Instalace a používání funkcí usnadnění","link":"activating-voice-guidance-topic.html","desc":"Nastavení rychlosti mluvení funkce Hlasové","descFull":"Nastavení rychlosti mluvení funkce Hlasové pokyny Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Usnadnění Rychlost mluvení . Vyberte rychlost mluvení. Hlasové pokyny nastavení rychlosti mluvení nastavení rychlosti mluvení Hlasové pokyny nastavení rychlosti mluvení Hlasové pokyny"},{"UUID":"5c51220c-89d8-4656-8c58-ced2bfa9613b","title":"Instalace a používání funkcí usnadnění","link":"activating-voice-guidance-topic.html","desc":"Nastavení výchozí hlasitosti sluchátek Na","descFull":"Nastavení výchozí hlasitosti sluchátek Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Usnadnění . Nastaví hlasitost sluchátek. Poté, co uživatel ukončí režim usnadnění, nebo po probuzení tiskárny z režimu spánku či hibernace se hlasitost resetuje na výchozí hodnotu. hlasitost sluchátek, nastavení nastavení hlasitosti sluchátek"},{"UUID":"305ebbf8-150a-4780-9950-9ffe4dcf5a0a","title":"Instalace a používání funkcí usnadnění","link":"activating-voice-guidance-topic.html","desc":"Nastavení výchozí hlasitosti vnitřního reproduktoru","descFull":"Nastavení výchozí hlasitosti vnitřního reproduktoru Na ovládacím panelu posunutím prstu doprava přejděte do řídicího centra. Upravte hlasitost. Pokud je aktivován tichý režim, zvuková upozornění jsou vypnutá. Toto nastavení také zpomaluje výkon tiskárny. Poté ukončení režimu usnadnění uživatelem nebo po probuzení tiskárny z režimu spánku či hibernace se hlasitost obnoví na výchozí hodnotu. hlasitost reproduktoru nastavení nastavení hlasitosti reproduktoru"},{"UUID":"78ca2963-cd03-40cc-b415-b05883480e27","title":"Instalace a používání funkcí usnadnění","link":"activating-voice-guidance-topic.html","desc":"Povolení mluvených hesel nebo osobních","descFull":"Povolení mluvených hesel nebo osobních identifikačních čísel Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Usnadnění Mluvená hesla/kódy PIN . Povolte nastavení. mluvená hesla povolení osobní identifikační čísla povolení"},{"UUID":"a56d434c-7a0e-4ffa-aee1-a9a5ab7e3734","title":"Nastavení tiskárny pro faxování","link":"setting-up-printer-to-fax-group.html","desc":"Nastavení funkce faxu pomocí analogového","descFull":"Nastavení funkce faxu pomocí analogového faxu Nastavení funkce faxu pomocí analogového faxu K použití analogového faxu musí být nainstalována faxová karta. Některé způsoby připojení platí pouze pro některé země a oblasti. Je-li funkce faxu povolena, ale není plně nastavena, indikátor může červeně blikat. Pokud nemáte prostředí TCP/IP, pak k nastavení faxu použijte ovládací panel. Během odesílání nebo přijímání faxu se nedotýkejte kabelů ani tiskárny ve vyznačené oblasti, aby nedošlo ke ztrátě dat nebo poruše tiskárny. Pomocí ovládacího panelu Na ovládacím panelu přejděte k položkám  Nastavení Faxování Nastavení faxu Obecná nastavení faxu . Nakonfigurujte nastavení. Použití serveru Embedded Web Server Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Na ovládacím panelu zobrazte IP adresu tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnosti  Nastavení Fax Nastavení faxu Obecná nastavení faxu . Nakonfigurujte nastavení. Použijte změny. analogový fax nastavení nastavení analogového faxování"},{"UUID":"a4230d2b-8daa-4377-b41f-455fe97cdd93","title":"Nastavení tiskárny pro faxování","link":"setting-up-printer-to-fax-group.html","desc":"Nastavení funkce faxu pomocí služby","descFull":"Nastavení funkce faxu pomocí služby etherFAX Nastavení funkce faxu pomocí služby etherFAX Firmware tiskárny musí být aktualizován na nejnovější verzi. Podrobnější informace najdete v části „Aktualizace firmwaru“. V tiskárně musí být nainstalován příslušný licenční balíček. Chcete-li získat další informace, obraťte se na společnost etherFAX. Ujistěte se, že jste svou tiskárnu zaregistrovali na portálu etherFAX. Další informace naleznete na adrese  https://www.etherfax.net/lexmark . Při registraci je vyžadováno sériové číslo tiskárny. Další informace najdete v tématu  . Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Na ovládacím panelu zobrazte IP adresu tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnosti  Nastavení Fax Nastavení faxu Obecná nastavení faxu . Položka  Nastavení faxu  se zobrazí pouze v případě, že je položka  Režim Faxování  nastavena na možnost  Faxování . Do pole Název faxu zadejte jedinečný název. Do pole Faxové číslo zadejte faxové číslo poskytnuté službou etherFAX. V nabídce  Přenos faxu  vyberte možnost  etherFAX . Tato nabídka se zobrazí pouze v případě, že je k dispozici více než jeden přenos faxu. Pokud je v tiskárně nainstalována pouze služba etherFAX, pak je automaticky nakonfigurována. Použijte změny. etherFAX nastavení funkce faxu nastavení funkce faxu používání služby etherFAX"},{"UUID":"0c78b5bd-5e96-4852-a553-c45c350bc355","title":"Nastavení tiskárny pro faxování","link":"setting-up-printer-to-fax-group.html","desc":"Nastavení funkce faxu pomocí faxového","descFull":"Nastavení funkce faxu pomocí faxového serveru Tato funkce umožňuje odesílat faxové zprávy poskytovateli faxových služeb, který podporuje příjem e -mailů. Tato funkce podporuje pouze odchozí faxové zprávy. Chcete-li podporovat příjem faxů, ujistěte se, že máte v tiskárně nakonfigurován fax založený na zařízení, jako je analogový fax, etherFAX nebo Fax over IP (FoIP). Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Na ovládacím panelu zobrazte IP adresu tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnosti  Nastavení Faxování . V nabídce  Režim faxování  vyberte položku  Faxový server  a klepněte na tlačítko  Uložit . Klepněte na tlačítko  Nastavení faxového serveru . Do pole  Do formátu  zadejte  [#]@myfax.com , kde  [#]  je faxové číslo a  myfax.com  je doména poskytovatele faxu. V případě potřeby nakonfigurujte pole Adresa pro odpověď, Předmět nebo Zpráva. Chcete-li, aby tiskárna přijímala faxové zprávy, povolte nastavení příjmu faxu na základě zařízení. Ujistěte se, že máte nakonfigurován fax založený na zařízení. Klepněte na tlačítko  Uložit . Klepněte na možnost  Nastavení e-mailu faxového serveru  a aktivujte možnost  Použít e-mailový server SMTP . Pokud nejsou nastavení nakonfigurována, podívejte se do části  . Použijte změny. faxový server, použití nastavení funkce faxu nastavení funkce faxu pomocí faxového serveru"},{"UUID":"6215b499-de4b-470c-b7ba-7801058b60bc","title":"Nastavení tiskárny pro faxování","link":"setting-up-printer-to-fax-group.html","desc":"Nastavení faxu pomocí standardní telefonní","descFull":"Nastavení faxu pomocí standardní telefonní linky Nastavení faxu pomocí standardní telefonní linky Tyto pokyny platí pouze pro tiskárny s nainstalovanou faxovou kartou. Abyste zabránili riziku úrazu el. proudem, nenastavujte produkt během bouřky a nepropojujte jej s jinými zařízeními, jako je napájecí kabel, fax nebo telefon. Abyste zabránili riziku úrazu elektrickým proudem, nepoužívejte faxové funkce za bouřky. Pokud připojujete tento výrobek k veřejné telefonní síti, používejte pouze telefonní kabel 26 AWG nebo robustnější telefonní kabel (RJ-11), abyste snížili riziko vzniku požáru. V případě uživatelů z Austrálie musí být kabel schválen úřadem Australian Communications and Media Authority. Nastavení 1: Tiskárna je připojena k samostatné faxové lince Zapojte jeden konec telefonního kabelu do portu Line tiskárny. Druhý konec kabelu připojte do aktivní analogové telefonní zásuvky na stěně. Můžete nastavit tiskárnu tak, aby přijímala faxy automaticky (nastavení  Automatického příjmu  na  Zapnuto ) nebo ručně (nastavení  Automatického příjmu  na  Vypnuto ). Pokud chcete přijímat faxy automaticky, nastavte tiskárnu na přijetí volání při určitém počtu zazvonění. Nastavení 2: Tiskárna sdílí linku se záznamníkem Pokud si předplatíte službu rozlišujícího vyzvánění, musíte nastavit správný typ vyzvánění pro tiskárnu. V opačném případě nebude tiskárna přijímat faxy, ani když ji nastavíte na automatický příjem faxů. Zapojení do stejné telefonní zásuvky ve zdi Zapojte jeden konec telefonního kabelu do portu Line tiskárny. Druhý konec kabelu připojte do aktivní analogové telefonní zásuvky na stěně. Připojte záznamník do portu telefonu tiskárny. Zapojení do různých telefonních zásuvek ve zdi Zapojte jeden konec telefonního kabelu do portu Line tiskárny. Druhý konec kabelu připojte do aktivní analogové telefonní zásuvky na stěně. Pokud máte k lince pouze jedno telefonní číslo, nastavte tiskárnu na automatický příjem faxů. Nastavte tiskárnu tak, aby přijímala volání dvě zazvonění po záznamníku. Jestliže například nastavíte záznamník tak, aby přijímal volání po čtyřech zazvoněních, nastavte možnost  Počet zvonění před přijetím  na tiskárně na hodnotu  6 . nastavení faxování pomocí standardní telefonní linky nastavení faxování pomocí standardní telefonní linky záznamník nastavení"},{"UUID":"4fa26937-195a-4597-9123-f4f32684efaa","title":"Nastavení tiskárny pro faxování","link":"setting-up-printer-to-fax-group.html","desc":"Nastavení faxu v zemích nebo oblastech","descFull":"Nastavení faxu v zemích nebo oblastech s odlišnými telefonními zásuvkami a zástrčkami Nastavení faxu v zemích nebo oblastech s odlišnými telefonními zásuvkami a zástrčkami Tyto pokyny platí pouze pro tiskárny s nainstalovanou faxovou kartou. Abyste zabránili riziku úrazu el. proudem, nenastavujte produkt během bouřky a nepropojujte jej s jinými zařízeními, jako je napájecí kabel, fax nebo telefon. Abyste zabránili riziku úrazu elektrickým proudem, nepoužívejte faxové funkce za bouřky. Pokud připojujete tento výrobek k veřejné telefonní síti, používejte pouze telefonní kabel 26 AWG nebo robustnější telefonní kabel (RJ-11), abyste snížili riziko vzniku požáru. V případě uživatelů z Austrálie musí být kabel schválen úřadem Australian Communications and Media Authority. Standardní zásuvkou na stěně používanou ve většině zemí a oblastí je zásuvka RJ-11. Pokud nejsou telefonní zástrčky na stěnách nebo zařízení v budově kompatibilní s tímto typem konektoru, použijte telefonní adaptér. Adaptér pro vaši zemi nebo oblast nemusí být s tiskárnou dodáván a může být potřebné jej zakoupit samostatně. V portu telefonu tiskárny může být nainstalována zástrčka adaptéru. Při připojování tiskárny k sériovému nebo kaskádovému telefonnímu systému nevyjímejte zástrčku adaptéru z portu tiskárny. Číslo dílu zástrčky adaptéru Název součásti Obj. č. Zástrčka adaptéru Lexmark 40X8519 Připojení tiskárny:k telefonní zásuvce jiného typu než RJ‑11 Zapojte jeden konec telefonního kabelu do portu Line tiskárny. Zapojte druhý konec kabelu do adaptéru RJ‑11 a potom zapojte adaptér do zásuvky na zdi. Chcete-li připojit další zařízení pomocí jiného konektoru než RJ-11 ke stejné zásuvce na stěně, připojte je přímo k telefonnímu adaptéru. nastavení faxování nastavení faxování"},{"UUID":"f16f2863-975a-405c-b03d-109f46b6ad67","title":"Nastavení tiskárny pro faxování","link":"setting-up-printer-to-fax-group.html","desc":"Připojování ke službě charakteristického vyzvánění","descFull":"Připojování ke službě charakteristického vyzvánění Služba charakteristického vyzvánění umožňuje mít více telefonních čísel na jedné telefonní lince. Každé telefonní číslo má jiný vzor vyzvánění. Na ovládacím panelu přejděte k položkám  Nastavení Fax Nastavení faxu  Nastavení příjmu faxů Ovládací prvky správy Přijmout po . Vyberte typ vyzvánění. služba charakteristického vyzvánění připojení tiskárny ke službě charakteristických vyzváněcích tónů přiřazení vyzvánění k tiskárně"},{"UUID":"0e243759-5bb9-471f-ada1-d93698cf6839","title":"Nastavení tiskárny pro faxování","link":"setting-up-printer-to-fax-group.html","desc":"Nastavení data a času Nastavení","descFull":"Nastavení data a času Nastavení data a času Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Předvolby Datum a čas Konfigurovat . Nakonfigurujte nastavení. faxování nastavení data a času datum a čas nastavení faxování"},{"UUID":"0bd1378e-ea25-4cf4-a388-93a707030a1f","title":"Nastavení tiskárny pro faxování","link":"setting-up-printer-to-fax-group.html","desc":"Konfigurace letního času Na ovládacím","descFull":"Konfigurace letního času Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Předvolby Datum a čas Konfigurovat . V nabídce  Časové pásmo  vyberte možnost  (UTC+uživatelský) Vlastní . V nabídce  Konfigurovat  vyberte možnost  Posunutí UTC . Nakonfigurujte nastavení. konfigurace letního času letní čas konfigurace"},{"UUID":"24313f62-679e-4297-a090-6523b35fa4a2","title":"Nastavení tiskárny pro faxování","link":"setting-up-printer-to-fax-group.html","desc":"Konfigurace nastavení reproduktoru faxu Na","descFull":"Konfigurace nastavení reproduktoru faxu Na ovládacím panelu přejděte k položkám  Nastavení Faxování Nastavení faxu Nastavení reproduktoru . Proveďte jednu z následujících akcí: Režim reproduktoru  nastavte na hodnotu  Vždy zapnuto . Hlasitost reproduktoru  nastavte na hodnotu  Vysoká . Aktivujte možnost  Hlasitost vyzvánění . konfigurace nastavení reproduktor faxu reproduktor faxu konfigurace nastavení"},{"UUID":"39dc5e99-849a-4d0f-ae37-3f254f04d605","title":"Založení papíru a speciálních médií","link":"loading-trays-group.html","desc":"Nastavení formátu a typu speciálních","descFull":"Nastavení formátu a typu speciálních médií Nastavení formátu a typu speciálních médií U speciálních médií, jako jsou štítky, tvrdý papír nebo obálky, postupujte následovně: Na ovládacím panelu přejděte do nabídky  Nastavení Papír Konfigurace zásobníku Formát/Typ papíru . Vyberte zdroj papíru a poté nastavte formát a typ speciálního média. nastavení formátu papíru nastavení typu papíru"},{"UUID":"010e126d-95c5-47be-ac30-9e076f4d029a","title":"Založení papíru a speciálních médií","link":"loading-trays-group.html","desc":"Nastavení univerzálního papíru Nastavení univerzálního","descFull":"Nastavení univerzálního papíru Nastavení univerzálního papíru V nabídce  Univerzální nastavení  lze nastavit šířku a výšku papíru, která není v tiskárně přednastavena. Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Papír Konfigurace médií Univerzální nastavení . Vyberte možnost  Všechny vstupní zásobníky  a upravte nastavení formátu papíru, který chcete přizpůsobit. nastavení formátu papíru přizpůsobení formátu papíru"},{"UUID":"d7535c08-c0f0-485e-9f01-e48efb8fd6ca","title":"Založení papíru a speciálních médií","link":"loading-trays-group.html","desc":"Zakládání do zásobníku na 550 listů","descFull":"Zakládání do zásobníku na 550 listů Chcete-li snížit riziko nestability zařízení, vkládejte papír do jednotlivých zásobníků samostatně. Všechny ostatní zásobníky udržujte zavřené až do chvíle, kdy je budete potřebovat. Otevřete zásobník. Při probíhajícím tisku neotevírejte zásobníky, aby nedošlo k uvíznutí papíru. Nastavte vodicí lištu na formát vkládaného papíru. K nastavení vodicích lišt použijte ukazatele na spodní straně zásobníku. Perforovaný papír je podporován pouze ve standardním zásobníku na 550 listů. Papír formátu A3 je podporován pouze u volitelného zásobníku na 550 listů. Papír před vložením ohněte, promněte a vyrovnejte hrany. Vložte stoh papíru potiskovanou stranou nahoru. Nezasouvejte papír do zásobníku. Ujistěte se, že boční vodicí lišty přiléhají k papíru. Ujistěte se, že výška stohu papíru nepřesahuje indikátor značky maximálního množství papíru. Přeplnění může způsobit uvíznutí papíru. Vložte zásobník. V případě potřeby, nastavte formát a typ papíru tak, aby odpovídal papíru vloženému do zásobníku. Po instalaci dokončovací schránky se stránky při tisku otočí o 180°. Při vkládání hlavičkového papíru postupujte jedním z následujících způsobů: Bez dokončovací schránky S dokončovací schránkou Jednostranný tisk, dlouhá strana Jednostranný tisk, dlouhá strana Jednostranný tisk, krátká strana Jednostranný tisk, krátká strana Oboustranný tisk, dlouhá strana Oboustranný tisk, dlouhá strana Oboustranný tisk, krátká strana Oboustranný tisk, krátká strana Při vkládání perforovaného papíru postupujte jedním z následujících způsobů: Bez volitelné dokončovací schránky S volitelnou dokončovací schránkou Jednostranný tisk, dlouhá strana Jednostranný tisk, dlouhá strana Jednostranný tisk, krátká strana Jednostranný tisk, krátká strana Oboustranný tisk, dlouhá strana Oboustranný tisk, dlouhá strana Oboustranný tisk, krátká strana Oboustranný tisk, krátká strana Zásobník na 550 listů vložení plnění zásobníku na 550 listů vkládání do zásobníků"},{"UUID":"bd3e6eb6-65cf-4257-a687-41c70b70c018","title":"Založení papíru a speciálních médií","link":"loading-trays-group.html","desc":"Vkládání do dvojitého zásobníku na","descFull":"Vkládání do dvojitého zásobníku na 2000 listů Chcete-li snížit riziko nestability zařízení, vkládejte papír do jednotlivých zásobníků samostatně. Všechny ostatní zásobníky udržujte zavřené až do chvíle, kdy je budete potřebovat. Otevřete zásobník. Pokud chcete předejít uvíznutí papíru, nevytahujte při probíhajícím tisku zásobníky. Papír před vložením ohněte, promněte a vyrovnejte hrany. Stoh papíru založte do pravé vložky zásobníku tak, aby se listy nacházely potiskovanou stranou nahoru. Nezasouvejte papír do zásobníku. Ujistěte se, že výška stohu papíru nepřesahuje indikátor značky maximálního množství papíru. Přeplnění může způsobit uvíznutí papíru. Vložte pravou vložku zásobníku do tiskárny. Stoh papíru založte do levé vložky zásobníku tak, aby se listy nacházely potiskovanou stranou nahoru. Vložte zásobník. V případě potřeby, nastavte formát a typ papíru tak, aby odpovídal papíru vloženému do zásobníku. Po instalaci dokončovací schránky se stránky při tisku otočí o 180°. Při zakládání hlavičkového papíru pro jednostranný tisk umístěte papír lícem nahoru a hlavičkou směrem k přední části zásobníku. Při zakládání hlavičkového papíru pro oboustranný tisk umístěte papír lícem dolů a hlavičkou směrem k přední části zásobníku. dvojitý zásobník na 2000 listů vložení plnění dvojitého zásobníku na 2000 listů vkládání do zásobníků"},{"UUID":"c9a47a32-30b1-43c8-8576-3fc1d441923b","title":"Založení papíru a speciálních médií","link":"loading-trays-group.html","desc":"Zakládání do zásobníku na 1500 listů","descFull":"Zakládání do zásobníku na 1500 listů Chcete-li snížit riziko nestability zařízení, vkládejte papír do jednotlivých zásobníků samostatně. Všechny ostatní zásobníky udržujte zavřené až do chvíle, kdy je budete potřebovat. Otevřete dvířka K. Při probíhajícím tisku neotevírejte zásobníky, aby nedošlo k uvíznutí papíru. Papír před vložením ohněte, promněte a vyrovnejte hrany. Vložte stoh papíru potiskovanou stranou dolů. Nezasouvejte papír do zásobníku. Ujistěte se, že výška stohu papíru nepřesahuje indikátor značky maximálního množství papíru. Přeplnění může způsobit uvíznutí papíru. Zavřete dvířka K. V případě potřeby, nastavte formát a typ papíru tak, aby odpovídal papíru vloženému do zásobníku. Pro jednostranný tisk vkládejte hlavičkový papír lícem dolů a záhlavím k zadní straně tiskárny. Pro oboustranný tisk vkládejte hlavičkový papír lícem nahoru a záhlavím k zadní straně tiskárny. Při zakládání papíru jiného formátu nezapomeňte upravit vodítka. Proveďte jednu z následujících akcí: Plochým šroubovákem demontujte šrouby z vodicích lišt. Vyjměte vodicí lišty. Zarovnejte vodicí lišty podle formátu vkládaného papíru. Namontujte šrouby na vodicí lišty. Zásobník na 1500 listů vložení vkládání do zásobníku"},{"UUID":"b40138c5-be96-4760-b1f2-1024ab1c0679","title":"Založení papíru a speciálních médií","link":"loading-trays-group.html","desc":"Vkládání do univerzálního podavače Otevřete","descFull":"Vkládání do univerzálního podavače Otevřete univerzální podavač. Nastavte boční vodicí lištu na formát vkládaného papíru. Papír před vložením ohněte, promněte a vyrovnejte hrany. Vložte papír. Ujistěte se, že boční vodicí lišty přiléhají k papíru. Při vkládání hlavičkového papíru postupujte jedním z následujících způsobů: Bez dokončovací schránky S dokončovací schránkou Jednostranný tisk, dlouhá strana Jednostranný tisk, dlouhá strana Oboustranný tisk, dlouhá strana Oboustranný tisk, dlouhá strana Při vkládání perforovaného papíru postupujte jedním z následujících způsobů: Bez dokončovací schránky S dokončovací schránkou Jednostranný tisk, dlouhá strana Jednostranný tisk, dlouhá strana Oboustranný tisk, dlouhá strana Oboustranný tisk, dlouhá strana Pro obálky: Obálku vložte tak, aby chlopeň směřovala nahoru a k zadní straně tiskárny. Evropskou obálku vložte tak, aby chlopeň směřovala nahoru a vstupovala do univerzálního podavače jako první. Po instalaci dokončovací schránky tiskárna otočí stránky o 180°. vložení papíru do univerzálního podavače vkládání hlavičkového papíru vkládání děrovaného papíru"},{"UUID":"c27eadfd-8d63-47eb-9581-5ab7758f59f8","title":"Založení papíru a speciálních médií","link":"loading-trays-group.html","desc":"Spojování zásobníků Otevřete webový prohlížeč","descFull":"Spojování zásobníků Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na  Nastavení Papír Konfigurace zásobníku . Nastavte shodný formát a typ papíru se zásobníky, které připojujete. Do propojených zásobníků vkládejte papír se stejnou orientací. Uložte nastavení. Klepněte na položky  Nastavení Zařízení Údržba Nabídka konfigurace Konfigurace zásobníku . Nastavte  Spojování zásobníků  na možnost  Automaticky . Uložte nastavení. Chcete-li zásobníky odpojit, dbejte na to, aby žádné zásobníky neměly shodný formát a typ papíru. Teplota zapékače se liší podle vybraného typu papíru. Chcete-li předejít problémům s tiskem, dbejte na shodu nastavení typu papíru v tiskárně s papírem vloženým do zásobníku. rozpojování zásobníků spojování zásobníků spojování zásobníků rozpojování zásobníků"},{"UUID":"302a0c76-ac57-430c-b05a-a02f4a489894","title":"Instalace a aktualizace softwaru, ovladačů a firmwaru","link":"installing-printer-software-topic.html","desc":"Instalace softwaru tiskárny Tiskový ovladač","descFull":"Instalace softwaru tiskárny Tiskový ovladač je součástí softwarového instalačního balíčku. Pro počítače Macintosh se systémem macOS verze 10.7 nebo novější není nutné instalovat ovladač pro tisk na tiskárně certifikované pro technologii AirPrint. Pokud chcete vlastní tiskové funkce, stáhněte si tiskový ovladač. Opatřete si kopii softwarového instalačního balíčku. Ze softwarového disku CD dodaného s tiskárnou. Přejděte na stránku  www.lexmark.com/downloads . Přejděte na  www.dell.com/support/printers . Z našich webových stránek nebo u prodejce, u něhož jste zakoupili tiskárnu. Spusťte znovu instalační program a poté postupujte podle pokynů na obrazovce počítače. instalace softwaru tiskárny software tiskárny instalace instalace ovladače tiskárny ovladač tisku instalace"},{"UUID":"b3e3a3a3-4320-4136-902e-a3d41a696876","title":"Instalace a aktualizace softwaru, ovladačů a firmwaru","link":"installing-printer-software-topic.html","desc":"Instalace ovladače faxu Přejděte na","descFull":"Instalace ovladače faxu Přejděte na adresu  www.lexmark.com/downloads , vyhledejte model tiskárny a stáhněte si příslušný instalační balíček. Přejděte na naše webové stránky nebo na místo, kde jste tiskárnu zakoupili, a stáhněte si instalační balíček. Přejděte na adresu  www.dell.com/support a stáhněte si příslušný instalační balíček. V počítači klikněte na možnost  Vlastnosti tiskárny a poté přejděte na kartu  Konfigurace . Spusťte znovu instalační program a poté postupujte podle pokynů na obrazovce počítače. Zvolte možnost  Faxování  a klepněte na tlačítko  Použít . ovladač faxu instalace Instalace ovladače faxu"},{"UUID":"789ba608-098e-46cb-8e87-8c8cc1abdfbe","title":"Instalace a aktualizace softwaru, ovladačů a firmwaru","link":"installing-printer-software-topic.html","desc":"Přidání tiskáren do počítače Než","descFull":"Přidání tiskáren do počítače Než začnete, proveďte jeden z následujících úkonů: Připojte tiskárnu a počítač ke stejné síti. Další informace o připojení tiskárny k síti naleznete v části  . Připojte počítač k tiskárně. Další informace najdete v tématu  . Připojte tiskárnu k počítači pomocí kabelu USB. Další informace najdete v tématu  . Kabel USB je prodáván samostatně. Uživatelé se systémem Windows Nainstalujte ovladač tiskárny do počítače. Další informace najdete v tématu  . Otevřete složku  Tiskárny a skenery  a klepněte na  Přidat tiskárnu nebo skener . V závislosti na připojení tiskárny proveďte jeden z následujících postupů: Vyberte ze seznamu tiskárnu a klikněte na tlačítko  Přidat zařízení . Klikněte na tlačítko  Zobrazit tiskárny Wi-Fi Direct , vyberte tiskárnu a klikněte na tlačítko  Přidat zařízení . Klikněte na položku  Požadovaná tiskárna není v seznamu  a poté v okně  Přidat tiskárnu  postupujte takto: Zvolte možnost  Přidat tiskárnu pomocí IP adresy nebo názvu hostitele  a poté klepněte na tlačítko  Další . V poli Typ zařízení vyberte možnost  Zařízení TCP/IP . Do pole Název hostitele nebo IP adresa zadejte IP adresu tiskárny a klepněte na tlačítko  Další . Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Vyberte tiskový ovladač a klepněte na tlačítko  Další . Vyberte možnost  Použít aktuálně nainstalovaný ovladač (doporučeno) a klepněte na tlačítko  Další . Zadejte název tiskárny a klikněte na tlačítko  Další . Klikněte na tlačítko  Dokončit . Uživatelé se systémem Macintosh Otevřete okno  Tiskárny a skenery . Klepněte na tlačítko  Přidat tiskárnu, skener nebo fax  a vyberte tiskárnu. V nabídce  Přidat tiskárnu  vyberete ovladač tiskárny. Chcete-li použít tiskový ovladač pro systém Macintosh, vyberte možnost  AirPrint  nebo  Zabezpečený AirPrint . Pokud chcete vlastní tiskové funkce, vyberte tiskový ovladač Lexmark. Postup instalace ovladače naleznete v části  . Pokud chcete vlastní tiskové funkce, vyberte tiskový ovladač výrobce. Postup instalace ovladače naleznete v části  . Přidejte tiskárnu. přidání tiskáren do počítače"},{"UUID":"56b6142a-afcc-4b9d-a74e-5cf6312a3e5d","title":"Instalace a aktualizace softwaru, ovladačů a firmwaru","link":"installing-printer-software-topic.html","desc":"Export konfiguračního souboru Otevřete webový","descFull":"Export konfiguračního souboru Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Na serveru Embedded Web Server klepněte na možnost  Exportovat konfiguraci . Vyberte konfiguraci, kterou chcete exportovat. V závislosti na vybrané konfiguraci se soubory exportují ve formátu ZIP nebo CSV. export konfiguračního souboru konfigurační soubor export"},{"UUID":"c1e35dd0-d830-4f0d-824a-7c6a5fbc251e","title":"Instalace a aktualizace softwaru, ovladačů a firmwaru","link":"installing-printer-software-topic.html","desc":"Import konfiguračního souboru Otevřete webový","descFull":"Import konfiguračního souboru Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Na serveru Embedded Web Server klepněte na možnost  Importovat konfiguraci . Přejděte do umístění, v němž je soubor uložen. Soubory jsou uloženy ve formátu ZIP nebo CSV. Klepněte na tlačítko  Import . import konfiguračního souboru konfigurační soubor import"},{"UUID":"9416c536-4d4f-4982-840b-777be7ca564d","title":"Instalace a aktualizace softwaru, ovladačů a firmwaru","link":"installing-printer-software-topic.html","desc":"Přidání dostupných volitelných doplňků do","descFull":"Přidání dostupných volitelných doplňků do ovladače tiskárny Uživatelé se systémem Windows Otevřete složku Tiskárny. Vyberte tiskárnu, kterou chcete aktualizovat, a poté proveďte některou z následujících akcí: V systému Windows 7 nebo novějším vyberte možnost  Vlastnosti tiskárny . U předchozích verzí vyberte možnost  Vlastnosti . Přejděte na kartu  Konfigurace  a poté vyberte možnost  Aktualizovat – Požádat tiskárnu . Použijte změny. Uživatelé se systémem Macintosh Otevřete okno  Tiskárny a skenery . Klepněte na tlačítko  Přidat tiskárnu, skener nebo fax  a vyberte tiskárnu. Vyberte ovladač tiskárny. Použijte změny. přidání hardwarových součástí v ovladači tiskárny ovladač tisku přidání hardwarových součástí"},{"UUID":"0511bdea-77d7-4995-a097-ecf82fa54b3f","title":"Aktualizace firmwaru","link":"installing-printer-software-topic.html","desc":"Aktualizace firmwaru pomocí ovládacího panelu","descFull":"Aktualizace firmwaru pomocí ovládacího panelu Použití centra oznámení Tento způsob lze použít jen u vybraných modelů tiskáren. Na ovládacím panelu přejděte do centra oznámení a vyberte možnost  Je dostupná aktualizace firmwaru . Vyberte položku  Instalovat . Tiskárna se po aktualizaci automaticky restartuje. Použití nabídky Nastavení Na ovládacím panelu přejděte na položku  Nastavení Zařízení Aktualizovat firmware . V závislosti na modelu tiskárny vyberte možnost  Zkontrolovat aktualizace  nebo  Zkontrolovat aktualizace nyní . Pokud je dostupná nová aktualizace, vyberte možnost  Instalovat . Tiskárna se po aktualizaci automaticky restartuje. aktualizace firmwaru pomocí ovládacího panelu firmware, aktualizace pomocí ovládacího panelu"},{"UUID":"1cdf6464-eb9f-4d7e-b1f9-71f144ea2373","title":"Aktualizace firmwaru","link":"installing-printer-software-topic.html","desc":"Aktualizace firmwaru pomocí serveru Embedded","descFull":"Aktualizace firmwaru pomocí serveru Embedded Web Server Než začnete, zkontrolujte následující body: Ze stránky  https://support.lexmark.com  jste si stáhli nejnovější firmware tiskárny a uložili jej na jednotku paměti flash nebo do počítače. K nasazení firmwaru do tiskárny je třeba rozbalit soubor s firmwarem FLS z balíčku ZIP. Stáhli jste nejnovější software tiskárny a uložili jej na jednotku paměti flash nebo do počítače. Další informace získáte na místě, kde jste tiskárnu zakoupili. Stáhli jste nejnovější software tiskárny a uložili jej na jednotku paměti flash nebo do počítače. Další informace získáte od prodejce. V tiskárně nepoužíváte speciální kód, abyste nedošlo ke ztrátě této funkce. Zajistěte, aby všechny tiskárny, pro něž je aktualizace firmwaru určena, byly v průběhu celého procesu aktualizace firmwaru zapnuté. Při vypnutí tiskárny v průběhu aktualizace firmwaru může dojít k vážnému poškození tiskárny. Pokud je tiskárna při kontrole aktualizací připojena k síti, není firmware nutné stahovat. Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnost  Zařízení . Posuňte zobrazení dolů a klepněte na možnost  Aktualizovat firmware . V závislosti na modelu tiskárny klepněte na možnost  Zkontrolovat aktualizace  nebo  Zkontrolovat aktualizace nyní . Pokud je k dispozici nová aktualizace, klepněte na možnost  Souhlasím, spustit aktualizaci . Tiskárna se po aktualizaci automaticky restartuje. aktualizace firmwaru použití serveru Embedded Web Server firmware, aktualizace použití serveru Embedded Web Server"},{"UUID":"bb0a752b-b617-44f9-bf04-f17408bc9c92","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace volitelného zásobníku na 550 listů","descFull":"Instalace volitelného zásobníku na 550 listů Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte volitelný zásobník na 550 listů. Při zvedání je nutné držet přední a zadní stranu, aby nedošlo k poškození zásobníku. Nasaďte pravý kryt zásobníku. Vytáhněte vložku zásobníku na 550 listů. Sejměte horní kryt zásobníku. Vyšroubujte šrouby. Nasaďte dolní kryt zásobníku. Namontujte šrouby. Nasaďte horní kryt zásobníku. Vložte vložku zásobníku na 550 listů. Demontujte kryt pod pravou stranou tiskárny. Tiskárnu zarovnejte se zásobníkem na 550 listů a poté ji spusťte na místo. Přesahuje-li hmotnost tiskárny 20 kg (44 liber), může být k jejímu bezpečnému zdvižení třeba nejméně dvou osob. Vytáhněte vložku standardního zásobníku ven. Zajistěte zásobník na 550 listů k tiskárně. Zasuňte vložku standardního zásobníku. Zajistěte zadní část zásobníku na 550 listů k tiskárně. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. Přidejte zásobník do ovladače tiskárny, aby byl k dispozici pro tiskové úlohy. Další informace najdete v tématu  . instalace zásobníku na 550 listů Zásobník na 550 listů instalace hardwarové doplňky Zásobník na 550 listů"},{"UUID":"3a273477-520c-4a05-9716-fb5e68bff9dd","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace zásobníku na 2x 550","descFull":"Instalace zásobníku na 2x 550 listů Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento volitelný doplněk musí být instalován společně s volitelným zásobníkem na 550 listů. Tento volitelný doplněk umístěte do dolní části konfigurace. Pokud je zásobník na 550 listů již nainstalován, odinstalujte jej, sejměte boční kryt zásobníku, sejměte dolní kryt zásobníku a položte zásobník na tento volitelný doplněk. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte zásobník na 2x 550 listů a poté odstraňte veškerý balicí materiál. Zajistěte kolečko, aby se zásobník na 2x 550 listů nehýbal. Zásobník na 550 listů zarovnejte se zásobníkem na 2x 550 listů a spusťte jej na místo. Při zvedání zásobníku je nutné držet přední a zadní stranu, aby nedošlo k poškození zásobníku. Vytáhněte vložku zásobníku na 550 listů. Zajistěte zásobník na 550 listů k zásobníku na 2x 550 listů. Vložte vložku zásobníku na 550 listů. Zajistěte zadní část zásobníku na 550 listů k zásobníku na 2x550 listů. Demontujte kryt pod pravou stranou tiskárny. Vyrovnejte tiskárnu s volitelnými zásobníky a usaďte ji na místo. Přesahuje-li hmotnost tiskárny 20 kg (44 liber), může být k jejímu bezpečnému zdvižení třeba nejméně dvou osob. Vytáhněte vložku standardního zásobníku ven. Zajistěte zásobník na 550 listů k tiskárně. Zasuňte vložku standardního zásobníku. Zajistěte zadní část zásobníku na 550 listů k tiskárně. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. Přidejte zásobník do ovladače tiskárny, aby byl k dispozici pro tiskové úlohy. Další informace najdete v tématu  . Zásobník na 2 x 550 listů instalace hardwarové doplňky Zásobník na 2 x 550 listů instalace zásobníku na 2x 550 listů"},{"UUID":"185780b6-b50a-47d2-ab26-4b87819b22ce","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace dvojitého zásobníku na 2000 listů","descFull":"Instalace dvojitého zásobníku na 2000 listů Instalace dvojitého zásobníku na 2000 listů Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento volitelný doplněk musí být instalován společně s volitelným zásobníkem na 550 listů. Tento volitelný doplněk se umisťuje do dolní části konfigurace. Pokud je zásobník na 550 listů již nainstalován, odinstalujte jej, sejměte boční kryt zásobníku, sejměte dolní kryt zásobníku a položte zásobník na tento volitelný doplněk. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte dvojitý zásobník a poté odstraňte veškerý balicí materiál. Zajistěte kolečko, aby se dvojitý zásobník nehýbal. D Zásobník na 550 listů zarovnejte s dvojitým zásobníkem a usaďte jej na místě. Při zvedání zásobníku je nutné držet přední a zadní stranu, aby nedošlo k poškození zásobníku. Vytáhněte vložku zásobníku na 550 listů. Zajistěte dvojitý zásobník na 550 listů k tiskárně. Vložte vložku zásobník. Zajistěte zadní část zásobníku na 550 listů k dvojitému zásobníku. Demontujte kryt pod pravou stranou tiskárny. Vyrovnejte tiskárnu s volitelnými zásobníky a usaďte ji na místo. Přesahuje-li hmotnost tiskárny 20 kg (44 liber), může být k jejímu bezpečnému zdvižení třeba nejméně dvou osob. Vytáhněte standardní zásobník. Zajistěte zásobník na 550 listů k tiskárně. Vložte zásobník. Zajistěte zadní část zásobníku na 550 listů k tiskárně. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. Přidejte zásobník do ovladače tiskárny, aby byl k dispozici pro tiskové úlohy. Další informace najdete v tématu  . dvojitý zásobník na 2000 listů instalace hardwarové doplňky dvojitý zásobník na 2000 listů instalace dvojitého zásobníku na 2000 listů"},{"UUID":"39d16f49-a60d-4ce2-87ce-c26d72314e1a","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace skříňky Jestliže potřebujete získat","descFull":"Instalace skříňky Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento volitelný doplněk musí být instalován společně se zásobníkem na 550 listů. Tento volitelný doplněk umístěte do dolní části konfigurace. Pokud je zásobník na 550 listů již nainstalován, odinstalujte jej, sejměte spodní kryt zásobníku a položte jej na tento volitelný doplněk. Tento úkon vyžaduje plochý šroubovák. Rozbalte a poté sestavte skříňku. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Zajistěte kolečko, aby se skříňka nehýbala. Nasaďte boční kryt zásobníku na 550 listů. Vyrovnejte zásobník se skříňkou a usaďte jej na místo. Při zvedání je nutné držet přední a zadní stranu, aby nedošlo k poškození zásobníku. Vytáhněte vložku zásobníku. Zajistěte zásobník ke skříňce. Vložte vložku zásobník. Zajistěte zadní část zásobníku ke skříňce. Demontujte kryt pod pravou stranou tiskárny. Vyrovnejte tiskárnu se skříňkou a zásobníkem a pomalu ji usaďte na místo. Přesahuje-li hmotnost tiskárny 20 kg (44 liber), může být k jejímu bezpečnému zdvižení třeba nejméně dvou osob. Vytáhněte vložku standardního zásobníku ven. Zajistěte zásobník na 550 listů k tiskárně. Zasuňte vložku standardního zásobníku. Zajistěte zadní část zásobníku na 550 listů k tiskárně. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. skříňka instalace hardwarové doplňky skříňka instalace skříňky"},{"UUID":"c82825e6-1267-4b3e-b74b-5e828f7e334e","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace zásobníku na 1500 listů Jestliže","descFull":"Instalace zásobníku na 1500 listů Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Před instalací tohoto volitelného doplňku se ujistěte, že je již nainstalován volitelný zásobník na 550 listů a buď 2x zásobník na 500 listů, nebo zásobník na 2000 listů. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Sejměte kryt přípojek. Kryt nevyhazujte. Sejměte kryt portu. Kryt nevyhazujte. Demontujte šroubovací krytky z tiskárny. Šroubovací krytky nevyhazujte. Vybalte zásobník na 1500 listů a poté odstraňte veškerý balicí materiál. Namontujte šrouby pro montážní držák. Připevněte montážní držák na tiskárnu. Použijte montážní držák a šrouby dodané se zásobníkem na 1500 listů. Namontujte zbývající šrouby. Nainstalujte zásobník na 1500 listů. Připojte kabel zásobníku k tiskárně. Nasaďte kryt kabelu zásobníku. Zásobník na 1500 listů posuňte směrem k tiskárně. Zapojte jeden konec napájecího kabelu tiskárny do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. Přidejte zásobník do ovladače tiskárny, aby byl k dispozici pro tiskové úlohy. Další informace najdete v tématu  . instalace zásobníku na 1500 listů Zásobník na 1500 listů instalace hardwarové doplňky Zásobník na 1500 listů"},{"UUID":"6dbb4a8b-bae0-4e47-b63c-9fb2505bc965","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace sešívacího finišeru Instalace sešívacího","descFull":"Instalace sešívacího finišeru Instalace sešívacího finišeru Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte sešívací finišer a poté odstraňte veškerý balicí materiál. Nainstalujte podávací vodítka. Vyjměte standardní zásobník. Nevyhazujte přihrádku. Před instalací volitelného doplňku umístěte páčku výstupní přihrádky do zavřené polohy. Když je volitelný doplněk odebrán, umístěte páčku výstupní přihrádky do otevřené polohy. Demontujte záložní válec. Válec nevyhazujte. Zasuňte podávací válec dodaný se sešívacím finišerem tak, aby se  zajistil  na svém místě. Dbejte na to, aby se kovová pružina nacházela před podávacím válcem. Vložte kryt válce tak, aby se  zajistil  na svém místě. Otevřete přední dvířka a sejměte kryt na levé straně tiskárny. Šroub a kryt nevyhazujte. Sejměte levý zadní kryt. Šroub a kryt nevyhazujte. Vyjměte kryt vnitřní přihrádky. Kryt nevyhazujte. Zarovnejte a vložte vnitřní kryt přihrádky, který byl dodán se sešívacím finišerem. Namontujte šrouby na vnitřní kryt přihrádky. Připevněte jezdec sešívacího finišeru. Vložte sešívací finišer. Nainstalujte montážní držák a zajistěte finišer k tiskárně. Použijte šroub dodaný s dokončovací schránku. Nasaďte levý zadní kryt a posuňte sešívací finišer doleva. Nasaďte levý horní kryt, který byl dodán s finišerem. Vložte kazetu se svorkami dovnitř tak, až  zaklapne  na místo. Zavřete přední dvířka a posuňte finišer směrem k tiskárně. Připojte kabel volitelného doplňku k tiskárně. Zapojte jeden konec napájecího kabelu tiskárny do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. Přidejte finišer do ovladače tiskárny ručně, aby byl k dispozici pro tiskové úlohy. Další informace najdete v tématu  . instalace sešívacího finišeru sešívací finišer instalace hardwarové doplňky sešívací finišer"},{"UUID":"381a281c-296d-4662-ac62-32694de4ffd2","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace odsazovacího odkládacího zásobníku Instalace","descFull":"Instalace odsazovacího odkládacího zásobníku Instalace odsazovacího odkládacího zásobníku Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte odsazovací odkládací zásobník a poté odstraňte veškerý balicí materiál. Připevněte vnitřní zadní kryt k odsazovacímu odkládacímu zásobníku. Vyjměte standardní zásobník. Nevyhazujte přihrádku. Vyjměte kryt konektoru podávací jednotky. Kryt nevyhazujte. Před instalací volitelného doplňku umístěte páčku výstupní přihrádky do zavřené polohy. Zarovnejte a nainstalujte odsazovací odkládací zásobník do tiskárny.  Zkontrolujte, zda jsou součásti řádně přichyceny a zarovnány k tiskárně. Přichyťte ochranné proužky odsazovacího odkládacího zásobníku k tiskárně. Umístěte páčku výstupní přihrádky do otevřené polohy. Připevněte kryt páčky tak, aby se  zajistil  na svém místě. Zapojte jeden konec napájecího kabelu tiskárny do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. Přidejte odsazovací odkládací zásobník do ovladače tiskárny ručně, aby byl k dispozici pro tiskové úlohy. Další informace najdete v tématu  . odsazovací odkládací zásobník instalace instalace odsazovacího odkládacího zásobníku hardwarové doplňky instalace"},{"UUID":"4ec2f59d-ae15-4f4b-ac2e-c99cca2ba419","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace podávací jednotky s možností","descFull":"Instalace podávací jednotky s možností skládání Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento volitelný doplněk lze nainstalovat společně se sešívacím děrovacím finišerem nebo dokončovací schránkou – vazačem knih. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte podávací jednotku s možností skládání a poté odstraňte veškerý balicí materiál. Vyjměte standardní zásobník. Nevyhazujte přihrádku. Před instalací volitelného doplňku umístěte páčku výstupní přihrádky do zavřené polohy. Když je volitelný doplněk odebrán, umístěte páčku výstupní přihrádky do otevřené polohy. Demontujte záložní válec. Válec nevyhazujte. Zasuňte podávací válec dodaný s volitelným doplňkem tak, aby se  zajistil  na svém místě. Dbejte na to, aby se kovová pružina nacházela před podávacím válcem. Vložte kryt válce tak, aby se  zajistil  na svém místě. Otevřete přední dvířka a sejměte kryt na levé straně tiskárny. Šroub a kryt nevyhazujte. Zavřete přední dvířka. Vyjměte kryt konektoru podávací jednotky. Kryt nevyhazujte. Sejměte levý zadní kryt. Šroub a kryt nevyhazujte. Vyjměte kryt vnitřní přihrádky. Šroub a kryt nevyhazujte. Zarovnejte a vložte vnitřní kryt přihrádky, který byl dodán s volitelným doplňkem. Namontujte šrouby na vnitřní kryt přihrádky. K volitelnému doplňku přichyťte kousky pěnové pásky. Otevřete dvířka F a poté utáhněte šrouby. Zavřete dvířka F. Kovový držák připevněte k volitelnému doplňku. Vložte volitelný doplněk. Dbejte na to, aby se kovový držák nacházel před tiskárnou. Otevřete dvířka F a šroubovákem, který byl dodán s volitelným doplňkem, namontujte šroub. Zavřete dvířka F. Namontujte šrouby do volitelného doplňku. Připevněte levý zadní kryt. Otevřete přední dvířka a připevněte kryt na levou stranu tiskárny. Zavřete přední dvířka. Zvedněte víko přihrádky a poté zarovnejte a připojte přihrádku volitelného doplňku. Namontujte šrouby do přihrádky volitelného doplňku. Připojte kryt obložení. Připojte kabel volitelného doplňku k tiskárně. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. hardwarové doplňky podávací jednotka s možností skládání podávací jednotka s možností skládání instalace"},{"UUID":"663900f2-76c3-4f16-b81a-87bb9d7526af","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace volitelného sešívacího děrovacího finišeru","descFull":"Instalace volitelného sešívacího děrovacího finišeru a podávací jednotky Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte podávací jednotku. Vyjměte standardní zásobník. Nevyhazujte přihrádku. Před instalací volitelného doplňku umístěte páčku výstupní přihrádky do zavřené polohy. Když je volitelný doplněk odebrán, umístěte páčku výstupní přihrádky do otevřené polohy. Demontujte záložní válec. Válec nevyhazujte. Zasuňte podávací válec dodaný s podávací jednotkou tak, aby se  zajistil  na svém místě. Dbejte na to, aby se kovová pružina nacházela před podávacím válcem. Připevněte kryt tak, aby se  zajistil  na svém místě. Otevřete přední dvířka a sejměte kryt na levé straně tiskárny. Šroub a kryt nevyhazujte. Zavřete přední dvířka. Vyjměte kryt konektoru podávací jednotky. Kryt nevyhazujte. Sejměte kryt. Kryt nevyhazujte. Připevněte kovový držák. Zasuňte podávací jednotku. Otevřete držadlo G a poté namontujte šroub do přední části podávací jednotky. Zavřete držadlo G. Namontujte šroub do zadní části podávací jednotky. Otevřete přední dvířka a na levou stranu tiskárny připevněte kryt dodaný s podávací jednotkou. Zavřete přední dvířka. Vybalte sešívací děrovací finišer. Namontujte stabilizátor. Odstraňte kousky pásky kolem dokončovací schránky. Připevněte držák k dokončovací schránce. Připevněte pěnovou pásku k dokončovací schránce. Připevněte podávací vodítko k dokončovací schránce. Připevněte přihrádku k dokončovací schránce. Otevřete dvířka dokončovací schránky a poté vložte nádobku děrovače. Umístěte nástavec přihrádky do přihrádky dokončovací schránky. Nástavec přihrádky se používá pro papír formátu A3 nebo delší a v prostředí s vysokou vlhkostí, aby pomohl při skládání papíru. Kapacita přihrádky se při použití nástavce sníží. Zavřete dvířka dokončovací schránky. Připevněte montážní držák na tiskárnu. Zajistěte, aby byly šrouby zarovnány se značkami na montážním držáku. Připevněte kovový držák dodaný s podávací jednotkou k tiskárně. Otevřete dvířka dokončovací schránky, demontujte šroub a poté zatáhněte za pojistný mechanismus dokončovací schránky. Připojte dokončovací schránku k tiskárně. Zajistěte dokončovací schránku k tiskárně a namontujte šroub. Připojte kabel dokončovací schránky k tiskárně. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. hardwarové doplňky podávací jednotka hardwarové doplňky sešívací, děrovací finišer podávací jednotka instalace sešívací, děrovací finišer instalace"},{"UUID":"47cb6c3b-5f03-48d5-bef7-8c242444f31f","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace volitelného sešívacího děrovacího finišeru","descFull":"Instalace volitelného sešívacího děrovacího finišeru a podávací jednotky s možností skládání Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte podávací jednotku s možností skládání a poté odstraňte veškerý balicí materiál. Vyjměte standardní zásobník. Nevyhazujte přihrádku. Před instalací volitelného doplňku umístěte páčku výstupní přihrádky do zavřené polohy. Když je volitelný doplněk odebrán, umístěte páčku výstupní přihrádky do otevřené polohy. Demontujte záložní válec. Válec nevyhazujte. Zasuňte podávací válec dodaný s volitelným doplňkem tak, aby se  zajistil  na svém místě. Dbejte na to, aby se kovová pružina nacházela před podávacím válcem. Připevněte kryt tak, aby se  zajistil  na svém místě. Otevřete přední dvířka a sejměte kryt na levé straně tiskárny. Šroub a kryt nevyhazujte. Zavřete přední dvířka. Vyjměte kryt konektoru podávací jednotky. Kryt nevyhazujte. Sejměte levý zadní kryt. Šroub a kryt nevyhazujte. Vyjměte kryt vnitřní přihrádky. Šroub a kryt nevyhazujte. Zarovnejte a vložte vnitřní kryt přihrádky, který byl dodán s podávací jednotkou s možností skládání. Namontujte šrouby na vnitřní kryt přihrádky. K volitelnému doplňku přichyťte kousky pěnové pásky. Otevřete dvířka F a poté utáhněte šrouby. Zavřete dvířka F. Držák připevněte k volitelnému doplňku. Vložte volitelný doplněk. Dbejte na to, aby se kovový držák nacházel před tiskárnou. Otevřete dvířka F a šroubovákem, který byl dodán s volitelným doplňkem, namontujte šroub. Zavřete dvířka F. Namontujte šrouby do volitelného doplňku. Připevněte levý zadní kryt. Vybalte sešívací děrovací finišer. Namontujte stabilizátor. Odstraňte kousky pásky kolem dokončovací schránky. Připevněte držák k dokončovací schránce. Připevněte pěnovou pásku k dokončovací schránce. Odstraňte malý kousek pěny na pravé straně dokončovací schránky. Připevněte podávací vodítko k dokončovací schránce. Připevněte přihrádku k dokončovací schránce. Otevřete dvířka dokončovací schránky a poté vložte nádobku děrovače. Umístěte nástavec přihrádky do přihrádky dokončovací schránky. Nástavec přihrádky se používá pro papír formátu A3 nebo delší a v prostředí s vysokou vlhkostí, aby pomohl při skládání papíru. Kapacita přihrádky se při použití nástavce sníží. Zavřete dvířka dokončovací schránky. Zvedněte víko přihrádky a poté zarovnejte a připevněte kryt k volitelnému doplňku. Namontujte šrouby. Otevřete přední dvířka a poté připevněte kryt obložení, který byl dodán s volitelným doplňkem. Připevněte montážní držák na tiskárnu. Zajistěte, aby byly šrouby zarovnány se značkami na montážním držáku. Otevřete dvířka dokončovací schránky, demontujte šroub a poté zatáhněte za pojistný mechanismus dokončovací schránky. Připojte kabel volitelného doplňku k tiskárně. Připojte kabel dokončovací schránky k volitelnému doplňku. Připojte dokončovací schránku k tiskárně. Zajistěte dokončovací schránku k tiskárně a namontujte šroub. Zavřete dvířka dokončovací schránky. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. hardwarové doplňky podávací jednotka s možností skládání hardwarové doplňky sešívací, děrovací finišer podávací jednotka s možností skládání instalace sešívací, děrovací finišer instalace"},{"UUID":"277cf9eb-8795-45b3-b4c8-8662c50ca290","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace volitelné dokončovací schránky –","descFull":"Instalace volitelné dokončovací schránky – vazače knih a podávací jednotky Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte podávací jednotku. Vyjměte standardní zásobník. Nevyhazujte přihrádku. Před instalací volitelného doplňku umístěte páčku výstupní přihrádky do zavřené polohy. Když je volitelný doplněk odebrán, umístěte páčku výstupní přihrádky do otevřené polohy. Demontujte záložní válec. Válec nevyhazujte. Zasuňte podávací válec dodaný s podávací jednotkou tak, aby se  zajistil  na svém místě. Dbejte na to, aby se kovová pružina nacházela před podávacím válcem. Vložte kryt válce tak, aby se  zajistil  na svém místě. Otevřete přední dvířka a sejměte kryt na levé straně tiskárny. Šroub a kryt nevyhazujte. Zavřete přední dvířka. Vyjměte kryt konektoru podávací jednotky. Kryt nevyhazujte. Sejměte kryt. Kryt nevyhazujte. Připevněte kovový držák. Zasuňte podávací jednotku. Otevřete držadlo G a poté namontujte šroub do přední části podávací jednotky. Zavřete držadlo G. Namontujte šroub do zadní části podávací jednotky. Otevřete přední dvířka a na levou stranu tiskárny připevněte kryt dodaný s podávací jednotkou. Zavřete přední dvířka. Vybalte brožovací finišer a poté odstraňte veškerý balicí materiál. Připevněte držák k dokončovací schránce. Připevněte pěnovou pásku k dokončovací schránce. Připevněte podávací vodítko k dokončovací schránce. Připevněte horní přihrádku k dokončovací schránce. Zvedněte víko přihrádky a poté připevněte dolní přihrádku k dokončovací schránce. Otevřete dvířka finišeru. Z nádoby děrovače vyjměte balicí materiál a vložte ji do dokončovací schránky. Umístěte nástavec přihrádky na přihrádku dokončovací schránky. Nástavec přihrádky se používá pro papír formátu A3 nebo delší a v prostředí s vysokou vlhkostí, aby pomohl při skládání papíru. Kapacita přihrádky se při použití nástavce sníží. Připevněte koš k zadní části dokončovací schránky. Zavřete dvířka dokončovací schránky. Připevněte montážní držák na tiskárnu. Zajistěte, aby byly šrouby zarovnány se značkami na montážním držáku. Připevněte držák dodaný s podávací jednotkou k tiskárně. Otevřete dvířka dokončovací schránky, demontujte šroub a poté zatáhněte za pojistný mechanismus dokončovací schránky. Připojte dokončovací schránku k tiskárně. Zajistěte dokončovací schránku k tiskárně a namontujte šroub. Zavřete dvířka dokončovací schránky. Připojte kabel dokončovací schránky k tiskárně. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. instalace podávací jednotky instalace podávací jednotka instalace dokončovací schránky – vazače knih instalace brožovací finišer"},{"UUID":"0787283a-75b1-460c-9f0a-fe02620c5102","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace dokončovací schránky – vazače","descFull":"Instalace dokončovací schránky – vazače knih a podávací jednotky s možností skládání Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Vybalte podávací jednotku s možností skládání. Vyjměte standardní zásobník. Nevyhazujte přihrádku. Před instalací volitelného doplňku umístěte páčku výstupní přihrádky do zavřené polohy. Když je volitelný doplněk odebrán, umístěte páčku výstupní přihrádky do otevřené polohy. Demontujte záložní válec. Válec nevyhazujte. Zasuňte podávací válec dodaný s volitelným doplňkem tak, aby se  zajistil  na svém místě. Dbejte na to, aby se kovová pružina nacházela před podávacím válcem. Vložte kryt válce tak, aby se  zajistil  na svém místě. Otevřete přední dvířka a sejměte kryt na levé straně tiskárny. Šroub a kryt nevyhazujte. Zavřete přední dvířka. Vyjměte kryt konektoru podávací jednotky. Kryt nevyhazujte. Sejměte levý zadní kryt. Šroub a kryt nevyhazujte. Vyjměte kryt vnitřní přihrádky. Šroub a kryt nevyhazujte. Zarovnejte a vložte vnitřní kryt přihrádky, který byl dodán s volitelným doplňkem. Namontujte šrouby na vnitřní kryt přihrádky. K volitelnému doplňku přichyťte kousky pěnové pásky. Otevřete dvířka F a poté utáhněte šrouby. Zavřete dvířka F. Držák připevněte k volitelnému doplňku. Vložte volitelný doplněk. Dbejte na to, aby se kovový držák nacházel před tiskárnou. Otevřete dvířka F a šroubovákem, který byl dodán s volitelným doplňkem, namontujte šroub. Zavřete dvířka F. Namontujte šrouby do volitelného doplňku. Připevněte levý zadní kryt. Vybalte brožovací finišer a poté odstraňte veškerý balicí materiál. Připevněte držák k dokončovací schránce. Připevněte pěnovou pásku k dokončovací schránce. Připevněte podávací vodítko k dokončovací schránce. Připevněte horní přihrádku k dokončovací schránce. Zvedněte víko přihrádky a poté připevněte dolní přihrádku k dokončovací schránce. Otevřete dvířka finišeru. Z nádoby děrovače vyjměte balicí materiál a vložte ji do dokončovací schránky. Umístěte nástavec přihrádky na přihrádku dokončovací schránky. Nástavec přihrádky se používá pro papír formátu A3 nebo delší a v prostředí s vysokou vlhkostí, aby pomohl při skládání papíru. Kapacita přihrádky se při použití nástavce sníží. Připevněte koš k zadní části dokončovací schránky. Zavřete dvířka dokončovací schránky. Zvedněte víko přihrádky a poté zarovnejte a připevněte kryt k volitelnému doplňku. Namontujte šrouby. Otevřete přední dvířka a poté připevněte kryt obložení, který byl dodán s volitelným doplňkem. Připevněte montážní držák na tiskárnu. Zajistěte, aby byly šrouby zarovnány se značkami na montážním držáku. Otevřete dvířka dokončovací schránky, demontujte šroub a poté zatáhněte za pojistný mechanismus dokončovací schránky. Připojte kabel volitelného doplňku k tiskárně. Připojte kabel dokončovací schránky k volitelnému doplňku. Připojte dokončovací schránku k tiskárně. Zajistěte dokončovací schránku k tiskárně a namontujte šroub. Zavřete dvířka dokončovací schránky. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. hardwarové doplňky podávací jednotka s možností skládání hardwarové doplňky brožovací finišer podávací jednotka s možností skládání instalace brožovací finišer instalace"},{"UUID":"ab25e24b-d97e-4d8d-906f-3771818f2207","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace police s klávesnicí Vypněte","descFull":"Instalace police s klávesnicí Vypněte tiskárnu. Otevřete dvířka B. Sejměte přední kryt a zavřete dvířka B. Vybalte polici s klávesnicí. Vložte kabel klávesnice do police. Kabel uvnitř police smotejte. Sejměte přilnavý kryt. Zarovnejte a přichyťte klávesnici k základně. Zarovnejte polici, připojte kabel klávesnice k tiskárně, vložte polici a připevněte ji k tiskárně. Zapněte tiskárnu. hardwarové doplňky police s klávesnicí police s klávesnicí instalace instalace police s klávesnicí"},{"UUID":"274b5837-230e-4978-b1c7-ee9780499c38","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace faxové karty Jestliže potřebujete","descFull":"Instalace faxové karty Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Otevřete přístupový kryt desky řadiče. Elektronické součásti desky řadiče mohou být snadno poškozeny statickou elektřinou. Než se dotknete některé elektronické součásti na řídicí desce nebo konektoru, dotkněte se kovového povrchu tiskárny. Sejměte kryt portu faxu. Šroub a kryt nevyhazujte. Vybalte faxovou kartu. Připojte kabel faxu k desce řadiče. Zarovnejte a nainstalujte kartu faxu do tiskárny. Zavřete přístupový kryt desky řadiče tak, aby se  zajistil  na svém místě, a poté vložte šroub. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. faxová karta instalace instalace interních součástí faxová karta"},{"UUID":"e42c1a25-1d5b-4580-8e53-300b1efd0c58","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace čtečky karet Jestliže potřebujete","descFull":"Instalace čtečky karet Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Vypněte tiskárnu. Otevřete dvířka B. Otevřete kryt předního portu USB. Sejměte kryt dolního portu USB. Pokud tiskárna není vybavena touto součástí, pokračujte dalším krokem. Sejměte ochranný kryt ze čtečky karet. Vložte čtečku karet. Připevněte kryt dolního portu tak, aby se  zajistil  na svém místě. Připevněte vodítko štítků. Připevněte kryt předního portu USB tak, aby se  zajistil  na svém místě. Zavřete dvířka B tak, aby se  zajistila  na svém místě. Zapněte tiskárnu. čtečka karet instalace interní doplňky čtečka karet"},{"UUID":"b05a5309-c599-4944-a954-fa4f1f9abadc","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Instalace portu Internal Solutions Port","descFull":"Instalace portu Internal Solutions Port Instalace portu Internal Solutions Port Jestliže potřebujete získat přístup k desce řadiče nebo chcete doplnit volitelný hardware a paměťová zařízení poté, co jste tiskárnu nastavili, tiskárnu nejprve vypněte a odpojte napájecí kabel z elektrické zásuvky a až poté pokračujte v činnosti. Tím zabráníte riziku úrazu elektrickým proudem. Máte-li k tiskárně připojena další zařízení, pak je rovněž vypněte a odpojte jakékoliv kabely vedoucí k tiskárně. Tento úkon vyžaduje plochý šroubovák. Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny.  Otevřete přístupový kryt desky řadiče. Elektronické součásti desky řadiče mohou být snadno poškozeny statickou elektřinou. Než se dotknete některé elektronické součásti na řídicí desce nebo konektoru, dotkněte se kovového povrchu tiskárny. Sejměte kryt portu Internal Solutions Port (ISP). Šroub a kryt nevyhazujte. Vybalte sadu ISP. Obsah sady ISP 1 ISP 2 Prodloužený kabel ISP 3 Montážní držák 4 Křídlaté matice Montážní držák připevněte k desce řadiče tak, aby se  zajistil  na svém místě. Sadu ISP přichyťte k montážnímu držáku a poté připojte prodlužovací kabel sady ISP ke konektoru na desce řadiče. Připojte ISP k tiskárně. Zavřete přístupový kryt řídicí desky. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. internal solutions port instalace instalace doplňků internal solutions port"},{"UUID":"b7d24d95-f8d9-4067-8fce-2d3627484a5e","title":"Instalace hardwarových doplňků","link":"installing-optional-550-sheet-tray-topic.html","desc":"Změna nastavení portů tiskárny po","descFull":"Změna nastavení portů tiskárny po instalaci nového portu Internal Solutions Má-li tiskárna statickou adresu IP, neměňte její konfiguraci. Jsou-li počítače nakonfigurovány na použití názvu sítě a nikoli na použití adresy IP, neměňte konfiguraci. Pokud přidáváte bezdrátový port Internal Solutions (ISP) do tiskárny dříve konfigurované pro připojení Ethernet, odpojte tiskárnu od sítě Ethernet. Uživatelé se systémem Windows Otevřete složku Tiskárny. Z místní nabídky tiskárny s novým portem ISP otevřete okno Vlastnosti tiskárny. Konfigurujte port ze seznamu. Aktualizujte adresu IP. Použijte změny. Uživatelé se systémem Macintosh Pomocí ikony Předvolby systému v nabídce Menu přejděte do seznamu tiskáren a poté vyberte možnost  + IP . Zadejte do pole adresy adresu IP tiskárny. Použijte změny. nastavení portu tiskárny změna změna nastavení portu tiskárny po instalaci ISP"},{"UUID":"392a6788-c097-4fc9-aa77-cf7a236b4859","title":"Práce v síti","link":"connecting-printer-to-wireless-network-topic.html","desc":"Připojení tiskárny k síti Wi-Fi Než","descFull":"Připojení tiskárny k síti Wi-Fi Než začnete, zkontrolujte následující body: Možnost  Aktivní adaptér  je nastavena na hodnotu  Automaticky . Na ovládacím panelu přejděte na možnosti  Nastavení Síť/porty Přehled sítě Aktivní adaptér . Kabel Ethernet není připojen k tiskárně. Pomocí ovládacího panelu Na ovládacím panelu přejděte k položkám  Nastavení Sítě/porty Bezdrátové Nastavit na panelu tiskárny Vybrat síť . Vyberte síť Wi-Fi a poté zadejte heslo sítě. U tiskáren s vestavěným rozhraním Wi-Fi se v průběhu počátečního nastavení zobrazí výzva k nastavení sítě Wi-Fi. připojení tiskárny k síti Wi-Fi připojení tiskárny k bezdrátové síti používání bezdrátové síti"},{"UUID":"207291c4-a801-4eba-b27c-e4bd5a13832f","title":"Práce v síti","link":"connecting-printer-to-wireless-network-topic.html","desc":"Připojení tiskárny k bezdrátové síti","descFull":"Připojení tiskárny k bezdrátové síti pomocí Wi‑Fi Protected Setup (WPS) Než začnete, zkontrolujte následující body: Přístupový bod (bezdrátový směrovač) je certifikován pro metodu WPS nebo je WPS kompatibilní. Další informace naleznete v dokumentaci dodané s přístupovým bodem. V tiskárně je nainstalován adaptér bezdrátové sítě. Další informace najdete v návodu, který byl dodán s adaptérem. Možnost  Aktivní adaptér  je nastavena na hodnotu  Automaticky . Na ovládacím panelu přejděte na možnosti  Nastavení Síť/porty Přehled sítě Aktivní adaptér . Pomocí metody tlačítek Na ovládacím panelu přejděte k položkám  Nastavení Síť/Porty Bezdrátová Wi‑Fi Protected Setup Spustit metodu připojení tlačítkem . Postupujte podle pokynů na displeji. Pomocí metody s využitím PIN (Personal Identification Number) kódu Na ovládacím panelu přejděte k položkám  Nastavení Síť/Porty Bezdrátová Wi‑Fi Protected Setup Spustit metodu kódem PIN . Zkopírujte osmimístný kód PIN služby WPS. Otevřete webový prohlížeč a zadejte do pole adresy IP adresu přístupového bodu. IP adresu zjistíte v dokumentaci dodané s přístupovým bodem. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Otevřete nastavení WPS. Další informace naleznete v dokumentaci dodané s přístupovým bodem. Zadejte osmimístný PIN a uložte změny. Wi‑Fi Protected Setup bezdrátová síť bezdrátová síť Wi‑Fi Protected Setup připojení k bezdrátové síti metoda pomocí kódu PIN připojení k bezdrátové síti metoda pomocí tlačítka"},{"UUID":"060a1e06-fa33-4e8b-b8d9-2978f683bf6a","title":"Práce v síti","link":"connecting-printer-to-wireless-network-topic.html","desc":"Konfigurace funkce Wi-Fi Direct Wi‑Fi","descFull":"Konfigurace funkce Wi-Fi Direct Wi‑Fi Direct  umožňuje zařízením Wi-Fi přímé vzájemné připojení bez použití přístupového bodu (bezdrátového směrovače). Na ovládacím panelu přejděte k položkám  Nastavení Síť/porty Wi-Fi Direct . Nakonfigurujte nastavení. Povolit síť Wi-Fi Direct  – umožňuje tiskárně vysílat vlastní síť Wi-Fi Direct. Název sítě Wi-Fi Direct  – přiřadí název síti Wi-Fi Direct. Heslo sítě Wi-Fi Direct  – přiřadí heslo pro vyjednávání zabezpečení bezdrátové sítě při použití připojení peer-to-peer. Zobrazit heslo na stránce nastavení  – zobrazí heslo na stránce nastavení sítě. Číslo preferovaného kanálu  – přiřadí upřednostňovaný kanál sítě Wi-Fi Direct. Adresa IP vlastníka skupiny  – přiřadí IP adresu vlastníka skupiny. Automatické přijetí požadavků na připojení  – umožňuje tiskárně automaticky přijímat požadavky na připojení. Automatické přijímání požadavků stisknutím tlačítka není zabezpečeno. Při výchozím nastavení se heslo sítě Wi-Fi Direct nezobrazuje na displeji tiskárny. Chcete-li zobrazit heslo, aktivujte ikonu prohlížení hesla. Na ovládacím panelu přejděte do nabídky  Nastavení zabezpečení Různé Povolit odkrytí hesla/kódu PIN . Chcete-li zjistit heslo sítě Wi-Fi Direct, aniž by se zobrazilo na displeji tiskárny, vytiskněte  stránku nastavení sítě . Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zprávy Síť Stránka nastavení sítě . Wi‑Fi Direct konfigurace konfigurace funkce Wi-Fi Direct"},{"UUID":"86bfb026-2457-458c-a97c-3c99292e99b0","title":"Práce v síti","link":"connecting-printer-to-wireless-network-topic.html","desc":"Připojení mobilního zařízení k tiskárně Před","descFull":"Připojení mobilního zařízení k tiskárně Před připojením mobilního zařízení se ujistěte, že je nakonfigurována funkce Wi-Fi Direct. Další informace najdete v tématu  . Pomocí služby Wi-Fi Direct Tyto pokyny platí pouze pro mobilní zařízení založené na platformě  Android . V mobilním zařízení přejděte do nabídky  Nastavení . Povolte funkci  Wi-Fi  a poté klepněte na položku  Wi-Fi Direct . Vyberte název Wi-Fi Direct tiskárny. Potvrďte připojení na ovládacím panelu tiskárny. Používání sítě Wi-Fi V mobilním zařízení přejděte do nabídky  Nastavení . Klepněte na  Wi-Fi  a vyberte název sítě Wi-Fi Direct tiskárny. Před název Wi-Fi Direct je přidán řetězec DIRECT-xy (kde xy jsou dva náhodné znaky). Zadejte heslo sítě Wi-Fi Direct. připojení mobilního zařízení k tiskárně připojení k tiskárně pomocí služby Wi-Fi Direct"},{"UUID":"05b0061b-9a2a-4307-9aac-7d8a0c7f44d4","title":"Práce v síti","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi-Fi Direct Připojení počítače k tiskárně","descFull":"Wi-Fi Direct Připojení počítače k tiskárně Před připojením počítače se ujistěte, že je nakonfigurována funkce Wi-Fi Direct. Další informace najdete v tématu  . Uživatelé se systémem Windows Otevřete složku  Tiskárny a skenery  a klepněte na  Přidat tiskárnu nebo skener . Klikněte na tlačítko  Zobrazit tiskárny s funkcí Wi-Fi Direct  a vyberte název tiskárny s funkcí Wi-Fi Direct. Z displeje tiskárny si poznamenejte osmimístný kód PIN tiskárny. Zadejte kód PIN v počítači. Pokud ještě není nainstalován tiskový ovladač, systém Windows stáhne příslušný ovladač. Uživatelé se systémem Macintosh Klikněte na ikonu bezdrátového připojení a poté vyberte název tiskárny s funkcí Wi-Fi Direct. Před název Wi-Fi Direct je přidán řetězec DIRECT-xy (kde xy jsou dva náhodné znaky). Zadejte heslo sítě Wi-Fi Direct. Po odpojení od sítě Wi-Fi Direct přepněte počítač zpět do předchozí sítě. připojení tiskárny k počítači"},{"UUID":"11d89922-52ba-4910-b90f-7baa3d74c1fb","title":"Práce v síti","link":"connecting-printer-to-wireless-network-topic.html","desc":"Deaktivace sítě Wi-Fi Na ovládacím","descFull":"Deaktivace sítě Wi-Fi Na ovládacím panelu přejděte na možnosti  Nastavení Síť/porty Přehled sítě Aktivní adaptér Standardní síť . Výběrem možnosti  Ano  restartujte tiskárnu. síť Wi-Fi, deaktivace deaktivace sítě Wi-Fi"},{"UUID":"39abd22b-ff28-4a0e-8327-385ba9fbd468","title":"Práce v síti","link":"connecting-printer-to-wireless-network-topic.html","desc":"Kontrola připojení tiskárny Kontrola připojení","descFull":"Kontrola připojení tiskárny Kontrola připojení tiskárny Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zprávy Síť Stránka nastavení sítě . Zkontrolujte první část stránky a ověřte, že stav je Připojeno. Pokud je stav Nepřipojeno, je možné, že síť LAN není aktivní nebo je vadný síťový kabel. Požádejte o pomoc správce. kontrola síťového připojení připojení tiskárny k síti kontrola"},{"UUID":"dfda4ccf-966b-4e9b-8911-86586bf259e4","title":"Práce v síti","link":"connecting-printer-to-wireless-network-topic.html","desc":"Nastavení sériového tisku (pouze systém","descFull":"Nastavení sériového tisku (pouze systém Windows) Nastavte parametry v tiskárně. Na ovládacím panelu přejděte do nabídky s nastaveními portu. Vyhledejte nabídku pro nastavení sériového portu a pak v případě potřeby upravte nastavení. Použijte změny. V počítači otevřete složku tiskárny a poté vyberte vaší tiskárnu. Otevřete okno Vlastnosti tiskárny a poté ze seznamu vyberte možnost Místní port. Nastavte parametry portu COM ve Správci zařízení. Sériový tisk snižuje rychlost tisku. Zkontrolujte, zda je sériový kabel připojen ke správnému portu tiskárny. nastavení sériového tisku sériový tisk nastavení"},{"UUID":"c7e1ee16-8acd-4a96-a334-dd49f973de95","title":"Zabezpečení tiskárny","link":"erasing-printer-memory-topic.html","desc":"Vymazání paměti tiskárny Chcete-li vymazat","descFull":"Vymazání paměti tiskárny Chcete-li vymazat nestálou paměť nebo data z vyrovnávací paměti tiskárny, vypněte tiskárnu. Chcete-li vymazat energeticky nezávislou paměť, nastavení zařízení a sítě, nastavení zabezpečení a integrovaná řešení, postupujte následovně: Na ovládacím panelu přejděte do části  Nastavení Zařízení Údržba Vymazání při vyřazení z provozu . Vyberte možnost  Ošetřit všechny informace v energeticky nezávislé paměti  a poté vyberte možnost  VYMAZAT . Vyberte možnost  Spustit průvodce poč. nastav.  nebo  Nechat tiskárnu offline  a poté vyberte možnost  Další . Spusťte proces. Tento proces také zničí šifrovací klíč, který se používá k ochraně uživatelských dat. Zničení šifrovacího klíče způsobí, že data nelze obnovit. energeticky závislá paměť mazání energeticky nezávislá paměť mazání paměť tiskárny mazání mazání paměť tiskárny mazání energeticky závislá paměť mazání energeticky nezávislá paměť"},{"UUID":"3f4993df-6821-460a-8b2d-abf50573a7e7","title":"Zabezpečení tiskárny","link":"erasing-printer-storage-drive-topic.html","desc":"Mazání paměťové jednotky tiskárny Mazání","descFull":"Mazání paměťové jednotky tiskárny Mazání paměťové jednotky tiskárny Na ovládacím panelu přejděte do části  Nastavení Zařízení Údržba Vymazání při vyřazení z provozu . V závislosti na úložné jednotce nainstalované v tiskárně proveďte jeden z následujících úkonů: V případě pevného disku vyberte možnost  Ošetřit všechny informace na pevném disku , vyberte možnost  VYMAZAT  a poté vyberte způsob vymazání dat. Proces ošetření pevného disku může trvat od několika minut až po více než hodinu a během této doby nebude tiskárna dostupná pro jiné úlohy. V případě inteligentní paměťové jednotky vyberte možnost  Kryptograficky vymazat všechna uživatelská data na inteligentní paměťové jednotce (ISD)  a poté vyberte možnost  VYMAZAT . paměťová jednotka mazání pevný disk mazání inteligentní paměťová jednotka mazání mazání paměťová jednotka mazání pevný disk mazání inteligentní paměťová jednotka"},{"UUID":"f4ecfc39-41cc-43b1-ac7e-c396b7f946cf","title":"Zabezpečení tiskárny","link":"restoring-factory-default-settings-topic.html","desc":"Obnovení výchozích továrních nastavení NA","descFull":"Obnovení výchozích továrních nastavení NA ovládacího panelu přejděte na položku Nastavení Zařízení Obnovit tovární nastavení . Vyberte možnost  Obnovit nastavení . Vyberte nastavení, která chcete obnovit, a poté vyberte možnost  OBNOVIT . výchozí tovární nastavení obnovení nastavení tiskárny obnovení výchozích továrních nastavení"},{"UUID":"b216b36e-a609-4225-b063-6dbbeddf9493","title":"Zabezpečení tiskárny","link":"statement-of-volatility-topic.html","desc":"Prohlášení o nestálosti Prohlášení o","descFull":"Prohlášení o nestálosti Prohlášení o nestálosti Typy pamětí a jejich popisy Typ paměti Popis Energeticky závislá paměť Tiskárna využívá standardní paměť RAM (Random Access Memory) k dočasnému ukládání uživatelských dat během jednoduchých úloh tisku a kopírování. energeticky nezávislá paměť Tiskárna může používat dva druhy energeticky nezávislé paměti: EEPROM a NAND (flash paměť). Oba typy ukládají operační systém, nastavení tiskárny a síťové informace. Ukládají také nastavení skeneru a záložek a integrovaná řešení. Jednotka pevného disku V některých tiskárnách může být nainstalován pevný disk. Pevný disk tiskárny je určen pro specifické funkce tiskárny. Na pevném disku může tiskárna uchovávat uživatelská data z komplexních tiskových úloh, formuláře a písma. Inteligentní paměťová jednotka (ISD) U některých tiskáren může být nainstalována jednotka ISD. Jednotka ISD využívá trvalou paměť flash k ukládání uživatelských dat ze složitých tiskových úloh, dat formulářů a dat písem. Obsah všech instalovaných pamětí tiskárny vymažte za následujících okolností: Tiskárna je vyřazena z provozu. Jednotka ISD nebo pevný disk tiskárny je vyměněn. Tiskárna je přemístěna do jiného oddělení nebo na jiné místo. Servis tiskárny je prováděn mimo vaši organizaci. Tiskárna je kvůli servisu přemístěna z vašich prostor. Tiskárna je prodána jiné organizaci. Chcete-li zlikvidovat paměťovou jednotku, postupujte podle zásad a postupů vaší organizace. prohlášení o nestálosti energeticky závislá paměť energeticky nezávislá paměť jednotka pevného disku inteligentní paměťová jednotka vymazání paměti tiskárny ochrana dat tiskárny"},{"UUID":"6f3cd437-1585-4513-a19c-2e164f296237","title":"Tisk","link":"printing-from-computer-topic.html","desc":"Tisk z počítače Uživatelé se systémem","descFull":"Tisk z počítače Uživatelé se systémem Windows Otevřete dokument, klepněte na možnost  Soubor Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . V případě potřeby upravte nastavení. Klepněte na tlačítko  OK  a potom na tlačítko  Tisk . Uživatelé se systémem Macintosh Otevřete dokument a vyberte možnost  Soubor Tisk . Vyberte tiskárnu a poté vyberte nastavení v nabídce  Předvolby . V případě potřeby upravte nastavení. Klepněte na tlačítko  Tisk . tisk z počítače dokumenty, tisk z počítače"},{"UUID":"d9a30816-a2f8-41bd-91ba-442445a0dda1","title":"Tisk pomocí mobilního zařízení","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Tisk pomocí mobilního zařízení pomocí","descFull":"Tisk pomocí mobilního zařízení pomocí Lexmark Print Lexmark  Print je služba pro mobilní tisk ze zařízení se systémem  Android  verze 6.0 nebo novější. Umožňuje odesílat dokumenty a obrázky na tiskárny připojené k síti a servery pro správu tisku. Nezapomeňte si z obchodu  Google Play  stáhnout aplikaci Lexmark Print a aktivovat ji v mobilním zařízení. Ujistěte se, že jsou tiskárna i mobilní zařízení připojeny ke stejné síti. Z mobilního zařízení vyberte dokument ze správce souborů. Odešlete nebo sdílejte dokument do aplikace Lexmark Print. Některé aplikace třetích stran nemusí podporovat funkci odesílání či sdílení. Další informace naleznete v dokumentaci dodané s aplikací. Výběr tiskárny V případě potřeby upravte nastavení. Vytiskněte dokument. Tisk Lexmark použití tisk dokumentů pomocí mobilního zařízení mobilní zařízení tisk z..."},{"UUID":"42a51355-d574-4925-8d86-da18823712a2","title":"Tisk pomocí mobilního zařízení","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Tisk pomocí mobilního zařízení pomocí","descFull":"Tisk pomocí mobilního zařízení pomocí tiskové služby Mopria™ Print Service Mopria Print Service je služba pro mobilní tisk ze zařízení se systémem  Android  verze 5.0 nebo novější. Díky ní můžete odesílat úlohy přímo do tiskáren certifikovaných pro technologii Mopria™. Nezapomeňte si z obchodu  Google Play  stáhnout aplikaci Mopria Print Service a aktivovat ji v mobilním zařízení. Z mobilního zařízení spusťte kompatibilní aplikaci nebo vyberte dokument ze správce souborů. Klepněte na tlačítko  Tisk . Vyberte tiskárnu a poté dle potřeby upravte nastavení. Klepněte na  . Tisková služba Mopria tisk pomocí mobilního zařízení mobilní zařízení tisk z... tisk pomocí aplikace Mopria Print Service"},{"UUID":"7c0694f9-72f5-446a-9bdd-ef1d9b898003","title":"Tisk pomocí mobilního zařízení","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Tisk z mobilního zařízení pomocí","descFull":"Tisk z mobilního zařízení pomocí AirPrint Funkce softwaru AirPrint je služba pro mobilní tisk, která umožňuje odesílat tiskovou úlohu přímo ze zařízení Apple do tiskáren certifikovaných pro technologii AirPrint. Ujistěte se, zda jsou zařízení Apple i tiskárna připojeny ke stejné síti. Pokud má síť více bezdrátových rozbočovačů, ujistěte se, že jsou obě zařízení připojena ke stejné podsíti. Aplikace je podporována pouze u některých zařízení Apple. V mobilním zařízení zvolte ve správci souborů dokument nebo spusťte kompatibilní aplikaci. Klepněte na tlačítko  Tisk . Vyberte tiskárnu a poté dle potřeby upravte nastavení. Vytiskněte dokument. použití funkce AirPrint tisk pomocí mobilního zařízení mobilní zařízení tisk z..."},{"UUID":"028f8939-8c6d-44a4-a571-bafc83af36be","title":"Tisk pomocí mobilního zařízení","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Tisk z mobilního zařízení pomocí služby","descFull":"Tisk z mobilního zařízení pomocí služby Wi‑Fi Direct® Wi‑Fi Direct  je tisková služba, která umožňuje odesílat tisk do tiskáren podporujících službu Wi‑Fi Direct. Zkontrolujte, že je mobilní zařízení připojeno k bezdrátové síti tiskárny. Další informace najdete v tématu  . Z mobilního zařízení spusťte kompatibilní aplikaci nebo vyberte dokument ze správce souborů. V závislosti na mobilním zařízení proveďte jeden z následujících postupů: Klepněte na tlačítko  Tisk . Klepněte na tlačítko  Tisk . Klepněte na tlačítko  Tisk . Vyberte tiskárnu a poté dle potřeby upravte nastavení. Vytiskněte dokument. Wi‑Fi Direct tisk z mobilního zařízení tisk z mobilního zařízení mobilní zařízení tisk z tisk pomocí služby Wi-Fi Direct"},{"UUID":"e71366a5-01ef-489d-88f9-6fdc731e1a5a","title":"Tisk","link":"printing-from-flash-drive-topic.html","desc":"Tisk z jednotky flash Vložte jednotku","descFull":"Tisk z jednotky flash Vložte jednotku paměti flash. Další informace o podporovaných jednotkách paměti flash naleznete v části  . Vložíte-li jednotku flash, když se zobrazí chybová zpráva, tiskárna jednotku flash ignoruje. Pokud vložíte jednotku paměti flash během zpracování jiných tiskových úloh tiskárnou, zobrazí se na displeji zpráva  Zaneprázdněna . Na ovládacím panelu vyberte možnost  Tisk . Vyberte  jednotku USB  a poté dokument, který chcete vytisknout. V případě potřeby nakonfigurujte nastavení. Vytiskněte dokument. Během aktivního tisku, čtení nebo zápisu na paměťové zařízení se nedotýkejte tiskárny ani jednotky flash ve vyznačené oblasti, aby nedošlo ke ztrátě dat nebo poruše tiskárny. tisk z jednotky flash jednotka flash, tisk z"},{"UUID":"8e9f2dfc-71e7-4238-a0d8-9fd673aad3c1","title":"Tisk","link":"configuring-confidential-jobs-topic.html","desc":"Konfigurace důvěrných úloh Na ovládacím","descFull":"Konfigurace důvěrných úloh Na ovládacím panelu přejděte na položku  Nastavení Zabezpečení Nastavení důvěrného tisku . Nakonfigurujte nastavení. Položky nabídky  Nastavení důvěrného tisku  a jejich popisy Nastavení Popis Max. počet neplatných kódů PIN Nastaví limit pro zadání neplatného kódu PIN. Po dosažení tohoto limitu se odstraní tiskové úlohy s tímto uživatelským jménem. Doba platnosti důvěrné úlohy U každé pozdržené úlohy nastaví individuální dobu vypršení platnosti, než se automaticky odstraní z paměti tiskárny, pevného disku nebo inteligentní paměťové jednotky. Pozdržená úloha je buď  důvěrná ,  opakovaná ,  vyhrazená  nebo  ověřovací . Doba platnosti opakované úlohy Nastaví dobu platnosti tiskových úloh, které chcete opakovat. Doba platnosti ověřené úlohy Nastaví dobu vypršení platnosti pro tisk kopie úlohy, abyste mohli zkontrolovat její kvalitu před tiskem zbývajících kopií. Doba platnosti vyhrazené úlohy Nastaví dobu vypršení pro úlohy, které chcete uložit do tiskárny pro pozdější tisk. Vyžadovat pozdržení všech úloh Nastaví tiskárnu pro pozdržení všech tiskových úloh. Zachovat duplicitní dokumenty Nastaví tiskárnu, aby uchovávala všechny dokumenty se stejným názvem souboru. důvěrné tiskové úlohy konfigurace pozdržené úlohy konfigurace ukládání tiskových úloh přidržení tiskových úloh"},{"UUID":"e47a067e-5369-4923-8080-eb9f04d6f5c5","title":"Tisk","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Tisk důvěrných a jiných pozdržených úloh","descFull":"Tisk důvěrných a jiných pozdržených úloh Uživatelé se systémem Windows Otevřete dokument, klepněte na možnost  Soubor Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . Klepněte na položku  Vytisknout a pozdržet . Klepněte na možnost  Použít režim Tisk a podržení úlohy  a zadejte uživatelské jméno. Vyberte některý z těchto typů tiskových úloh: Důvěrný tisk  – tiskárna vás před tiskem úlohy požádá o osobní identifikační číslo. Pokud vyberete tento typ úlohy, zadejte čtyřmístné osobní identifikační číslo (PIN). Ověřit tisk  – Tiskárna vytiskne jednu kopii a pozdrží zbývající kopie, které jste vyžádali od ovladače v paměti tiskárny. Rezervovat tisk  – tiskárna uloží úlohu do paměti, abyste ji mohli později vytisknout. Opakovat tisk  – Tiskárna vytiskne všechny požadované kopie úlohy a zároveň uloží úlohu do paměti, abyste později mohli vytisknout další kopie. Klikněte na možnost  OK . Klepněte na tlačítko  Tisk . Uvolněte tiskovou úlohu k tisku pomocí ovládacího panelu tiskárny. Vyberte možnost  Tisk . Vyberte možnost  Pozdržené úlohy  a poté vyberte své uživatelské jméno. V případě důvěrných tiskových úloh vyberte možnost  Důvěrné , zadejte kód PIN a poté vyberte  OK . Vyberte tiskovou úlohu a poté vyberte možnost  Tisk . Uživatelé se systémem Macintosh Otevřete dokument a vyberte možnost  Soubor Tisk . Výběr tiskárny V rozevírací nabídce  Zabezpečení tiskové úlohy  povolte možnost  Tisk s kódem PIN  a zadejte čtyřmístný kód PIN. Klepněte na tlačítko  Tisk . Uvolněte tiskovou úlohu k tisku pomocí ovládacího panelu tiskárny. Vyberte možnost  Pozdržené úlohy  a poté vyberte název počítače. Vyberte možnost  Důvěrné  a zadejte kód PIN. Vyberte tiskovou úlohu a poté vyberte možnost  Tisk . tisk pozdržené úlohy tisk důvěrné tiskové úlohy důvěrné tiskové úlohy tisk pozdržené úlohy tisk"},{"UUID":"60f5f02e-5227-4064-942e-51112ed79948","title":"Tisk","link":"printing-font-sample-list-topic.html","desc":"Tisk seznamu ukázek písma Na","descFull":"Tisk seznamu ukázek písma Na ovládacím panelu přejděte k položkám  Nastavení  Zprávy Tisk Tisk typů písma . Vyberte typ písma. tisk seznam ukázek typů písma seznam ukázek typů písma tisk"},{"UUID":"996d6401-3607-42ad-a5b6-2743fb484c48","title":"Tisk","link":"printing-directory-list-topic.html","desc":"Tisk seznamu adresářů Na ovládacím","descFull":"Tisk seznamu adresářů Na ovládacím panelu přejděte na položku  Nastavení  Zprávy Tisk . Vyberte možnost  Tisk adresáře . tisk seznam adresářů seznam adresářů tisk"},{"UUID":"2dc4eb94-6ca4-4102-9c1f-8429a34c5895","title":"Tisk","link":"placing-separator-sheets-in-print-jobs-topic.html","desc":"Umístění oddělovacích listů do tiskových","descFull":"Umístění oddělovacích listů do tiskových úloh Otevřete dokument, klepněte na možnost  Soubor Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . Klepněte na položku  Papír/Dokončování . V nabídce  Oddělovací listy  vyberte nastavení. Klepněte na tlačítko  OK  a potom na tlačítko  Tisk . oddělovací listy umístění vkládání oddělovacích listů"},{"UUID":"6b7d6964-2c88-4fb9-b2fc-e29ce6647d06","title":"Tisk","link":"canceling-print-job-topic.html","desc":"Rušení tiskové úlohy Na ovládacím","descFull":"Rušení tiskové úlohy Na ovládacím panelu vyberte možnost  Fronta úloh . Vyberte možnost  Tisk  a poté vyberte úlohu, kterou chcete zrušit. Pokud se dokument již tiskne, zastavíte tisk výběrem možnosti  Zrušit úlohu  v pravém dolním rohu displeje. tisková úloha rušení rušení tiskové úlohy"},{"UUID":"6ddf34c8-9913-4916-948e-a8a4c8ffde59","title":"Tisk","link":"adjusting-toner-darkness-topic.html","desc":"Úprava sytosti toneru Na ovládacím","descFull":"Úprava sytosti toneru Na ovládacím panelu přejděte na položku  Nastavení Tisk Kvalita . Upravte nastavení pro  Sytost toneru . sytost toneru nastavení úprava sytosti toneru"},{"UUID":"1b385881-d9cb-4fc9-b0d5-e1c23d22e7b2","title":"Kopírování","link":"making-copies-topic.html","desc":"Kopírování Položte originální dokument do","descFull":"Kopírování Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Chcete-li předejít oříznutí obrázku, ujistěte se, že originální dokument a výstup mají stejnou velikost papíru. Z ovládacího panelu, vyberte možnost  Kopírovat  a potom zadejte počet kopií. V případě potřeby upravte nastavení kopírování. Zkopírujte dokument. kopírování kopírování dokumenty kopírování použití podavače ADF kopírování pomocí skleněné plochy skeneru"},{"UUID":"1558a5a3-fe39-4312-9b85-31c8026b6dd9","title":"Kopírování","link":"copying-photos-topic.html","desc":"Kopírování fotografií Kopírování fotografií Položte","descFull":"Kopírování fotografií Kopírování fotografií Položte fotografii na skleněnou plochu skeneru. Na ovládacím panelu přejděte na položky  Kopírování Další nastavení Obsah Typu obsahu Fotografie . Vyberte možnost  Zdroj obsahu  a poté vyberte nastavení, které nejlépe odpovídá předlohové fotografii. Kopírovat fotografii. kopírování fotografie fotografie, kopírování"},{"UUID":"d4b651d5-3b63-4295-993c-4a4394ef9c65","title":"Kopírování","link":"copying-on-letterhead-topic.html","desc":"Kopírování na hlavičkový papír Kopírování na hlavičkový","descFull":"Kopírování na hlavičkový papír Kopírování na hlavičkový papír Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu tiskárny přejděte k položkám  Kopírování Kopírovat z . Výběr velikosti originálního dokumentu Vyberte možnost  Kopírovat do  a zvolte zdroj papíru, který obsahuje hlavičkový papír. Pokud jste vložili hlavičkový papír do univerzálního podavače, vyberte možnost  Univerzální podavač , vyberte formát papíru a poté vyberte možnost  Hlavičkový papír . Zkopírujte dokument. kopírování na hlavičkový papír hlavičkový papír kopírování na"},{"UUID":"a990a924-4cf9-4230-9001-fc0c3538a9a7","title":"Kopírování","link":"copying-on-both-sides-of-paper-topic.html","desc":"Kopírování na obě strany papíru","descFull":"Kopírování na obě strany papíru Kopírování na obě strany papíru Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu skeneru přejděte k položkám  Kopírování Další nastavení Strany . Vyberte nastavení. Zkopírujte dokument. kopírování tisk na obě strany papíru oboustranné kopírování Oboustranné kopírování"},{"UUID":"0c97dd58-e9ec-4b5d-a2e1-2a764316123d","title":"Kopírování","link":"reducing-or-enlarging-copies-topic.html","desc":"Zmenšení nebo zvětšení kopií Zmenšení","descFull":"Zmenšení nebo zvětšení kopií Zmenšení nebo zvětšení kopií Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu skeneru přejděte k položkám  Kopírování Další nastavení Měřítko . Vyberte nastavení. Změna velikosti originálního dokumentu nebo výstupu po nastavení položky  Měřítko  způsobí obnovení hodnoty měřítka  Automaticky . Zkopírujte dokument. zmenšení velikosti kopie zvětšení velikosti kopie velikost kopie nastavení"},{"UUID":"f6943b2a-3abc-40f5-b633-12ca0771c50d","title":"Kopírování","link":"collating-copies-topic.html","desc":"Skládání kopií Skládání kopií Položte","descFull":"Skládání kopií Skládání kopií Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu skeneru přejděte k položkám  Kopírování Další nastavení Skládání Zap. [1,2,1,2,1,2] . Zkopírujte dokument. skládání kopií třídění více kopií"},{"UUID":"f67f0dce-2fc5-4b05-9a14-8b09f7aaecf1","title":"Kopírování","link":"placing-separator-sheets-between-copies-topic.html","desc":"Umístění oddělovacích listů mezi kopie","descFull":"Umístění oddělovacích listů mezi kopie Umístění oddělovacích listů mezi kopie Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu skeneru přejděte k položkám  Kopírování Další nastavení Oddělovací listy . Povolte nabídku a vyberte nastavení. Zkopírujte dokument. oddělovací listy přidání vkládání oddělovacích listů"},{"UUID":"64aa72b1-cdd3-4542-b4fa-c738478c33f1","title":"Kopírování","link":"copying-multiple-pages-onto-single-sheet-topic.html","desc":"Kopírování více stránek na jeden","descFull":"Kopírování více stránek na jeden list Kopírování více stránek na jeden list Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu skeneru přejděte k položkám  Kopírování Další nastavení Více stránek na list . Povolte nabídku a vyberte nastavení. Zkopírujte dokument. kopírování vícestránkových dokumentů na jeden list papíru úspora papíru"},{"UUID":"2585a3ae-b581-41c4-8505-6bf05e0f760d","title":"Kopírování","link":"copying-cards-topic.html","desc":"Kopírování karet Kopírování karet Položte","descFull":"Kopírování karet Kopírování karet Položte kartu na skleněnou plochu skeneru. Na ovládacím panelu tiskárny přejděte k položkám  Kopírování Kopírovat z ID karta . Zkopírujte kartu. kopírování karty karty, kopírování"},{"UUID":"3c54abd3-7c43-4e20-af00-22847a698baa","title":"Kopírování","link":"creating-copy-shortcut-topic.html","desc":"Vytvoření zkratky pro kopírování Vytvoření","descFull":"Vytvoření zkratky pro kopírování Vytvoření zkratky pro kopírování Na ovládacím panelu vyberte možnost  Kopírování . Nakonfigurujte nastavení a poté vyberte možnost  . Vytvořte zástupce. vytvoření zástupce kopírování přidávání zástupců kopírování"},{"UUID":"8f7eb0f7-f6d1-4688-973b-7e1effbb07a1","title":"E-mail","link":"configuring-smtp-settings-topic.html","desc":"Konfigurace nastavení protokolu SMTP Konfigurace","descFull":"Konfigurace nastavení protokolu SMTP Konfigurace nastavení protokolu SMTP Nakonfigurujte nastavení protokolu SMTP (Simple Mail Transfer Protocol) pro odesílání naskenovaných dokumentů e -mailem. Nastavení se liší podle jednotlivých poskytovatelů e -mailových služeb. Než začnete, ujistěte se, že je tiskárna připojena k síti a síť je připojena k internetu. Pomocí ovládacího panelu Na ovládacím panelu tiskárny přejděte na položku  Nastavení E-mail Nastavení e-mailu . Nakonfigurujte nastavení.  Použití serveru Embedded Web Server Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnost  Nastavení E-mail . V nabídce  Nastavení e-mailu  upravte nastavení.  Klepněte na tlačítko  Uložit . Poskytovatelé e -mailových služeb AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live nebo Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Pokud se při použití uvedených nastavení vyskytnou chyby, obraťte se na poskytovatele služeb. Pokud váš poskytovatel služeb není v seznamu uveden, obraťte se na něj. AOL Mail Nastavení pro službu AOL Mail Nastavení Hodnota Primární brána SMTP smtp.aol.com Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Heslo aplikace  Chcete-li vytvořit heslo aplikace, přejděte na stránku  zabezpečení účtu AOL , přihlaste se ke svému účtu a klepněte na možnost  Vygenerovat a spravovat hesla aplikace . Comcast Mail Nastavení pro službu Comcast Mail Nastavení Hodnota Primární brána SMTP smtp.comcast.net Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Heslo účtu Zkontrolujte, zda je v účtu povoleno nastavení Zabezpečení přístupu třetích stran. Další informace naleznete na  stránce nápovědy Comcast Xfinity Connect . Gmail Zkontrolujte, že je ve vašem účtu povoleno dvoufázové ověření. Chcete-li povolit dvoufázové ověření, přejděte na stránku  zabezpečení účtu Google , přihlaste se ke svému účtu a poté v části  Postup přihlášení ke službě Google  klepněte na položku  Dvoufázové ověření . Nastavení serveru SMTP pro službu Gmail Nastavení Hodnota Primární brána SMTP smtp.gmail.com Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Heslo aplikace Chcete-li vytvořit heslo aplikace, přejděte na stránku  zabezpečení účtu Google , přihlaste se ke svému účtu a poté v části  Postup přihlášení ke službě Google , klepněte na položku  Dvoufázové ověření Hesla aplikace . Text „ Hesla aplikace “ se zobrazí pouze v případě, že je povoleno dvoufázové ověření. iCloud Mail Zkontrolujte, že je ve vašem účtu povoleno dvoufázové ověření. Nastavení pro službu iCloud Mail Nastavení Hodnota Primární brána SMTP smtp.mail.me.com Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Heslo aplikace Chcete-li vytvořit heslo aplikace, přejděte na stránku  Správa účtu iCloud , přihlaste se ke svému účtu a potom v části  Přihlášení a zabezpečení  klepněte na položku  Hesla pro konkrétní aplikace Vygenerovat heslo pro konkrétní aplikaci . Mail.com Nastavení pro službu Mail.com Nastavení Hodnota Primární brána SMTP smtp.mail.com Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Heslo účtu NetEase Mail (mail.126.com) Zkontrolujte, že je ve vašem účtu povolena služba SMTP. Chcete-li službu povolit, na domovské stránce NetEase Mail klepněte na možnost  Nastavení POP3/SMTP/IMAP  a povolte službu  IMAP/SMTP  nebo  POP3/SMTP . Nastavení pro službu NetEase Mail (mail.126.com) Nastavení Hodnota Primární brána SMTP smtp.126.com Port primární brány SMTP 465 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Autorizační heslo Autorizační heslo je poskytováno, pokud je povolena  služba IMAP/SMTP  nebo  služba POP3/SMTP . NetEase Mail (mail.163.com) Zkontrolujte, že je ve vašem účtu povolena služba SMTP. Chcete-li službu povolit, na domovské stránce NetEase Mail klepněte na možnost  Nastavení POP3/SMTP/IMAP  a povolte službu  IMAP/SMTP  nebo  POP3/SMTP . Nastavení pro službu NetEase Mail (mail.163.com) Nastavení Hodnota Primární brána SMTP smtp.163.com Port primární brány SMTP 465 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Autorizační heslo Autorizační heslo je poskytováno, pokud je povolena  služba IMAP/SMTP  nebo  služba POP3/SMTP . NetEase Mail (mail.yeah.net) Zkontrolujte, že je ve vašem účtu povolena služba SMTP. Chcete-li službu povolit, na domovské stránce NetEase Mail klepněte na možnost  Nastavení POP3/SMTP/IMAP  a povolte službu  IMAP/SMTP  nebo  POP3/SMTP . Nastavení pro službu NetEase Mail (mail.yeah.net) Nastavení Hodnota Primární brána SMTP smtp.yeah.net Port primární brány SMTP 465 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Autorizační heslo Autorizační heslo je poskytováno, pokud je povolena  služba IMAP/SMTP  nebo  služba POP3/SMTP . Outlook Live nebo Microsoft 365 Tato nastavení se vztahují na e-mailové domény outlook.com a hotmail.com a na účty Microsoft 365. Nastavení aplikace Outlook Live nebo Microsoftu 365 Nastavení Hodnota Primární brána SMTP smtp.office365.com Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Heslo účtu nebo heslo aplikace U účtů se zakázaným dvoufázovým ověřováním použijte své heslo účtu. Pro účty e-mailové domény outlook.com nebo hotmail.com s povoleným dvoufázovým ověřováním použijte heslo aplikace. Chcete-li vytvořit heslo aplikace, přejděte na stránku  správ účtu Outlook Live , přihlaste se ke svému účtu a klepněte na možnost  Vytvořit nové heslo aplikace . Další možnosti nastavení pro firmy používající Microsoft 365 naleznete na  stránce nápovědy Microsoft 365 . QQ Mail Zkontrolujte, že je ve vašem účtu povolena služba SMTP. Chcete-li tuto službu povolit, klepněte na domovské stránce QQ Mail na možnost  Nastavení Účet . V části  Služba POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV  povolte  službu POP3/SMTP  nebo  službu IMAP/SMTP . Nastavení pro službu QQ Mail Nastavení Hodnota Primární brána SMTP smtp.qq.com Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Autorizační kód Chcete-li vytvořit autorizační kód, na domovské stránce služby QQ Mail klepněte na možnost  Nastavení Účet  a poté v části  Služba POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV  klepněte na možnost  Vytvořit autorizační kód . Sina Mail Zkontrolujte, zda je ve vašem účtu povolena služba POP3/SMTP. Chcete-li službu povolit, klepněte na domovské stránce služby Sina Mail na položku  Nastavení Další nastavení POP/IMAP/SMTP koncového uživatele  a poté povolte  službu POP3/SMTP . Nastavení pro službu Sina Mail Nastavení Hodnota Primární brána SMTP smtp.sina.com Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Autorizační kód Chcete-li vytvořit autorizační kód, klepněte na domovské stránce e-mailu na položku  Nastavení Další nastavení POP/IMAP/SMTP koncového uživatele  a poté povolte  stav autorizačního kódu . Sohu Mail Zkontrolujte, že je ve vašem účtu povolena služba SMTP. Chcete-li službu povolit, klepněte na domovské stránce služby Sohu Mail na položku  Možnosti Nastavení POP3/SMTP/IMAP  a povolte  službu IMAP/SMTP  nebo  službu POP3/SMTP . Nastavení pro službu Sohu Mail Nastavení Hodnota Primární brána SMTP smtp.sohu.com Port primární brány SMTP 465 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Nezávislé heslo Nezávislé heslo je poskytováno, pokud je povolena  služba IMAP/SMTP  nebo  služba POP3/SMTP . Yahoo! Mail Nastavení pro službu Yahoo! Mail Nastavení Hodnota Primární brána SMTP smtp.mail.yahoo.com Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Heslo aplikace  Chcete-li vytvořit heslo aplikace, přejděte na stránku  zabezpečení účtu Yahoo , přihlaste se ke svému účtu a poté v části  Heslo aplikace  klepněte na položku  Vygenerovat heslo aplikace . Zoho Mail Nastavení pro službu Zoho Mail Nastavení Hodnota Primární brána SMTP smtp.zoho.com Port primární brány SMTP 587 Použít protokol SSL/TLS Požadované Vyžadovat důvěryhodný certifikát Vypnuto Zpáteční adresa Vaše e-mailová adresa Ověření serveru SMTP Přihlášení/obyčejné E-mail započatý zařízením Použít ověřovací soubory SMTP zařízení ID uživatele zařízení Vaše e-mailová adresa Heslo zařízení Heslo účtu nebo heslo aplikace U účtů se zakázaným dvoufázovým ověřováním použijte své heslo účtu. Pro účty s povoleným dvoufázovým ověřováním použijte heslo aplikace. Chcete-li vytvořit heslo aplikace, přejděte na stránku  správy účtu Zoho Mail , přihlaste se ke svému účtu a poté v části  Hesla pro konkrétní aplikace  klepněte na položku  Vytvořit nové heslo . poskytovatelé e -mailových služeb konfigurace nastavení e-mailového serveru nastavení SMTP konfigurace funkce e-mailu nastavení nastavení e-mailového serveru konfigurace"},{"UUID":"0db9bc35-f299-40d3-99d3-768b20b204a9","title":"E-mail","link":"sending-email-topic.html","desc":"zasílání emailem Než začnete, ujistěte","descFull":"zasílání emailem Než začnete, ujistěte se, že jsou nakonfigurována nastavení SMTP. Další informace najdete v tématu  . Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu přejděte na položky  Skenování E-mail . Zadejte potřebné informace a vyberte možnost  Další . V případě potřeby nakonfigurujte nastavení. Vyberte možnost  Skenování  a odešlete e-mail. e-mail odeslání odeslání e-mailu"},{"UUID":"56259437-5359-42f5-9233-114430807510","title":"E-mail","link":"creating-email-shortcut-topic.html","desc":"Vytvoření zástupce e-mailu Pomocí ovládacího","descFull":"Vytvoření zástupce e-mailu Pomocí ovládacího panelu Na ovládacím panelu přejděte na položky  Skenování E-mail . Zadejte potřebné informace a vyberte možnost  . Vytvořte zástupce. Použití serveru Embedded Web Server Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnost  Zástupci Přidat zástupce . Nakonfigurujte nastavení. Klepněte na tlačítko  Uložit . vytvoření zástupce e-mail přidávání zástupců e-mail zástupce pro e-mail vytvoření"},{"UUID":"1a0ba73e-0c85-458f-a090-33f9ba2e9094","title":"Faxování","link":"sending-fax-topic.html","desc":"Odeslání Faxování Odeslání Faxování Pomocí","descFull":"Odeslání Faxování Odeslání Faxování Pomocí ovládacího panelu Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu vyberte možnost  Faxování . Vyberte možnost  Přidat příjemce  nebo  Adresář . V případě potřeby upravte nastavení. Odešlete fax. Pomocí počítače Než začnete, ujistěte se, že je nainstalován faxový ovladač. Další informace najdete v tématu  . Uživatelé se systémem Windows Otevřete dokument, klepněte na možnost  Soubor Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . Klepněte na tlačítko  Fax Povolit fax Vždy zobrazit nastavení před faxováním  a zadejte číslo příjemce. V případě potřeby nakonfigurujte nastavení. Odešlete fax. Uživatelé se systémem Macintosh Otevřete dokument a vyberte možnost  Soubor Tisk . Vyberte tiskárnu, která má za názvem příponu  - Fax . Do pole Komu zadejte číslo příjemce. V případě potřeby nakonfigurujte nastavení. Odešlete fax. odeslání Faxování fax, odeslání"},{"UUID":"14a5c12e-8b11-4dfe-b6a4-b15b6028b80b","title":"Faxování","link":"scheduling-fax-topic.html","desc":"Naplánování faxu Naplánování faxu Položte","descFull":"Naplánování faxu Naplánování faxu Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu vyberte možnost  Faxování . Vyberte možnost  Přidat příjemce  nebo  Adresář  a zadejte potřebné informace. Vyberte možnost  Čas odeslání , nakonfigurujte datum a čas a poté vyberte možnost  Hotovo . V případě potřeby nakonfigurujte další nastavení faxu. Odešlete fax. plánovaní faxu fax, plánování"},{"UUID":"b6aa32f0-38d4-4f07-8f18-ddae63f8e8ba","title":"Faxování","link":"creating-fax-destination-shortcut-topic.html","desc":"Vytvoření zástupce cíle faxování Vytvoření","descFull":"Vytvoření zástupce cíle faxování Vytvoření zástupce cíle faxování Na ovládacím panelu vyberte možnost  Faxování . Vyberte možnost  Přidat příjemce  nebo  Adresář  a zadejte potřebné informace. V případě potřeby upravte nastavení. Vyberte možnost  . Vytvořte zástupce. vytvoření zástupce cíl Faxování cíl Faxování vytvoření zástupce přidávání zástupců cíl Faxování zástupce, vytvoření cíl Faxování"},{"UUID":"5f21483b-a172-43af-8afd-f148463b0872","title":"Faxování","link":"changing-fax-resolution-topic.html","desc":"Změna rozlišení faxu Změna rozlišení","descFull":"Změna rozlišení faxu Změna rozlišení faxu Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu vyberte možnost  Faxování . Vyberte možnost  Přidat příjemce  nebo  Adresář  a zadejte potřebné informace. Vyberte možnost  Rozlišení  a poté zvolte nastavení. Odešlete fax. rozlišení faxu změna změna rozlišení faxu"},{"UUID":"fe69ad9a-fe77-4724-8733-2cc24cc72ca2","title":"Faxování","link":"adjusting-fax-darkness-topic.html","desc":"Úprava sytosti faxu Úprava sytosti","descFull":"Úprava sytosti faxu Úprava sytosti faxu Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu vyberte možnost  Faxování . Vyberte možnost  Přidat příjemce  nebo  Adresář  a zadejte potřebné informace. Vyberte možnost  Další nastavení Tmavost  a poté upravte nastavení. Odešlete fax. úprava sytosti faxu sytost faxu nastavení"},{"UUID":"85f4f932-fc5e-4375-9ddc-c29957ee00d6","title":"Faxování","link":"printing-fax-log-topic.html","desc":"Tisk faxového protokolu Tisk faxového","descFull":"Tisk faxového protokolu Tisk faxového protokolu Na ovládacím panelu přejděte k položkám  Nastavení Zprávy Fax . Vyberte protokol faxování. protokol faxování tisk tisk protokolu faxování"},{"UUID":"1c559880-929c-41b8-a2c5-22586d225e14","title":"Faxování","link":"blocking-junk-faxes-topic.html","desc":"Blokování nevyžádaných faxů Na ovládacím","descFull":"Blokování nevyžádaných faxů Na ovládacím panelu přejděte k položkám  Nastavení Fax Nastavení faxu  Nastavení příjmu faxů Ovládací prvky správy . Povolte nabídku  Blokovat fax bez názvu . nežádoucí faxy blokování blokování nevyžádaných faxů"},{"UUID":"b8c243dc-016b-4697-a561-8c3d91c1c525","title":"Faxování","link":"holding-faxes-topic.html","desc":"Pozdržení faxů Pozdržení faxů Na","descFull":"Pozdržení faxů Pozdržení faxů Na ovládacím panelu přejděte k položkám  Nastavení Fax Nastavení faxu Nastavení příjmu faxů Pozdržení faxů . Vyberte nastavení. pozdržení faxů přijaté faxy pozdržení faxování pozdržení"},{"UUID":"aa3b494f-7a26-4873-822b-52ba1a0c4fda","title":"Faxování","link":"forwarding-fax-topic.html","desc":"Přeposlání faxu Přeposlání faxu Na","descFull":"Přeposlání faxu Přeposlání faxu Na ovládacím panelu přejděte k položkám  Nastavení Fax Nastavení faxu  Nastavení příjmu faxů Ovládací prvky správy . Vyberte možnost  Přeposílání faxu  a poté vyberte možnost  Vytisknout a přeposlat  nebo  Přeposlat . V nabídce  Přeposlat  vyberte cíl a nakonfigurujte nastavení. přeposlání faxu faxování přeposlání"},{"UUID":"f8d5ca03-661b-4644-8c9b-b3a386ce70e4","title":"Skenování","link":"scanning-to-computer-topic.html","desc":"Skenování do počítače Než začnete,","descFull":"Skenování do počítače Než začnete, ujistěte se, zda jsou počítač i tiskárna připojeny ke stejné síti. Uživatelé se systémem Windows Použití nástroje Lexmark ScanBack V počítači spusťte  nástroj Lexmark ScanBack  a klepněte na možnost  Vytvořit profil . Nástroj si můžete stáhnout na stránce  www.lexmark.com/downloads . Pokud chcete raději použít stávající profil skenování, klepněte na možnost  Stávající profil . Klepněte na možnost  Nastavení  a přidejte IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Klepněte na možnost  OK  a poté na  Zavřít . Vyberte formát a velikost skenovaného dokumentu. Vyberte formát souboru a rozlišení skenování a klikněte na tlačítko  Další . Zadejte jedinečný název profilu skenování. Přejděte do umístění, do kterého chcete uložit naskenovaný dokument, a vytvořte název souboru. Chcete-li znovu použít profil skenování, povolte možnost  Vytvořit zástupce  a vytvořte jedinečný název zástupce. Klikněte na tlačítko  Dokončit . Položte originál dokumentu do automatického podavače nebo na skleněnou plochu skeneru. Na ovládacím panelu tiskárny přejděte k položkám  Profily skenování Skenovat do počítače  a poté vyberte profil skenování. V počítači klepněte na možnost  Skenování dokončeno . Uživatelé se systémem Windows Použití aplikace Windows Fax a skener Ujistěte se, že je tiskárna v počítači přidána. Další informace najdete v tématu  . Položte originál dokumentu do automatického podavače nebo na skleněnou plochu skeneru. V počítači otevřete aplikaci  Windows Fax a skener . Klepněte na možnost  Nové skenování  a vyberte zdroj skenování. V případě potřeby změňte tisková nastavení. Naskenujte dokument. Klepněte na možnost  Uložit jako , zadejte název souboru a klepněte na  možnost Uložit . Uživatelé se systémem Macintosh Ujistěte se, že je tiskárna v počítači přidána. Další informace najdete v tématu  . Položte originál dokumentu do automatického podavače nebo na skleněnou plochu skeneru. Na ovládacím panelu proveďte jednu z následujících akcí: Otevřete aplikaci  Image Capture . Otevřete složku  Tiskárny a skenery  a vyberte tiskárnu. Klikněte na tlačítko  Skenovat Otevřít skener . Na obrazovce skeneru proveďte některé z následujících kroků: Vyberte umístění, do kterého chcete naskenovaný dokument uložit. Výběr velikosti originálního dokumentu Chcete-li skenovat z automatického podavače dokumentů, vyberte možnost  Podavač dokumentů  v  Nabídce skenování  nebo povolte možnost  Použít podavač dokumentů . V případě potřeby nakonfigurujte nastavení skenování. Klepněte na možnost  Skenování . skenování do počítače počítač, skenování do Nástroj Lexmark ScanBack"},{"UUID":"f7f92697-2107-458f-9553-8814f8cd41fb","title":"Skenování","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Skenování na server FTP Skenování","descFull":"Skenování na server FTP Skenování na server FTP Než začnete, zkontrolujte, zda je tiskárna připojena k serveru FTP. Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu tiskárny přejděte k položce  Skenování FTP . Zadejte potřebné informace a vyberte možnost  Další . V případě potřeby nakonfigurujte nastavení FTP. Naskenujte dokument. server FTP skenování do skenování na server FTP"},{"UUID":"e8428778-9e64-4bc4-b900-98ee11805333","title":"Skenování","link":"creating-FTP-shortcut-topic.html","desc":"Vytvoření zástupce serveru FTP Vytvoření","descFull":"Vytvoření zástupce serveru FTP Vytvoření zástupce serveru FTP Na ovládacím panelu vyberte možnost  Skenování FTP . Zadejte adresu serveru FTP a stiskněte možnost  . Vytvořte zástupce. vytvoření zástupce adresa FTP přidávání zástupců adresa FTP"},{"UUID":"55e27138-3f22-4f0b-94b4-d353832d26e2","title":"Skenování","link":"scanning-to-network-folder-topic.html","desc":"Skenování do síťové složky Než","descFull":"Skenování do síťové složky Než začnete, ověřte, že je již nakonfigurována síťová složka, do které chcete dokument skenovat. Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Na ovládacím panelu přejděte k položkám  Scan Center Síťová složka . Vyberte příslušnou síťovou složku. Přidání do síťové složky je popsáno v části  . Naskenujte dokument. skenování do síťové složky síťová složka skenování do"},{"UUID":"c704a01e-d080-4c8d-8e38-b567e4dfb2ed","title":"Skenování","link":"configuring-network-folder-destination-topic.html","desc":"Konfigurace cílové síťové složky Konfigurace","descFull":"Konfigurace cílové síťové složky Konfigurace cílové síťové složky Na ovládacím panelu přejděte k položkám  Scan Center Síťová složka Vytvořit síťovou složku . Nakonfigurujte potřebná nastavení. Přihlaste se k síti a vyberte možnost  Další . Nakonfigurujte nastavení síťové složky a poté vyberte možnost  Hotovo . Informace o skenování dokumentu do síťové složky naleznete v části  . cílová síťová složka konfigurace vytvoření síťové složky"},{"UUID":"95c805f4-802d-45db-8523-582a05129117","title":"Skenování","link":"creating-network-folder-shortcut-topic.html","desc":"Přidání zástupce síťové složky Otevřete","descFull":"Přidání zástupce síťové složky Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnost  Zástupci Přidat zástupce . Z nabídky  Typ zástupce  vyberte položku  Síťová složka  a poté nakonfigurujte nastavení. Použijte změny. zástupce síťové složky vytvoření zástupce"},{"UUID":"a0983f70-a45f-4d6a-b0da-6ddd0e792205","title":"Skenování","link":"scanning-to-flash-drive-topic.html","desc":"Skenování na jednotku paměti flash","descFull":"Skenování na jednotku paměti flash Skenování na jednotku paměti flash Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Vložte jednotku paměti flash. Na ovládacím panelu vyberte možnost  Skenování  a poté vyberte možnost  Jednotka USB . Vyberte umístění, kam se má soubor uložit, vytvořte název souboru a poté vyberte možnost  Další . Nakonfigurujte nastavení skenování. Naskenujte dokument. Během aktivního tisku, čtení nebo zápisu na paměťové zařízení se nedotýkejte tiskárny ani jednotky flash ve vyznačené oblasti, aby nedošlo ke ztrátě dat nebo poruše tiskárny. skenování na jednotku paměti flash jednotka paměti flash skenování do"},{"UUID":"d411dbc6-7858-4157-ace1-fc09e2fe80c4","title":"Nabídky tiskárny","link":"menu-map-topic.html","desc":"Schéma nabídek 1  Zobrazuje","descFull":"Schéma nabídek 1  Zobrazuje se pouze v případě, že je nainstalována dokončovací schránka. 2  Zobrazuje se pouze v případě, že je nainstalována paměťová jednotka. Zařízení Předvolby Ekologický režim Vzdálený ovládací panel Upozornění Správa napájení Sdílet data se společností Lexmark Usnadnění Obnovit výchozí výrobní nastavení Údržba Aktualizovat firmware O této tiskárně Zařízení Předvolby Ekologický režim Vzdálený ovládací panel Upozornění Správa napájení Usnadnění Obnovit výchozí výrobní nastavení Údržba Aktualizovat firmware O této tiskárně Tisk Rozložení Dokončování 1 Nastavení Kvalita Evidence úloh PDF PostScript PCL Obrázek Papír Konfigurace zásobníku Konfigurace médií Konfigurace přihrádky 1 Kopírování Výchozí nastavení kopírování Faxování Výchozí nastavení faxu E-mail Nastavení e-mailu Výchozí nastavení e-mailu Nastavení internetového odkazu FTP Výchozí nastavení FTP Jednotka USB Skenování na jednotku paměti flash Tisk z jednotky paměti flash Síť/Porty Přehled sítí Bezdrátové Wi‑Fi Direct Správa mobilních služeb Ethernet TCP/IP SNMP IPSec 802.1x Konfigurace LPD Nastavení HTTP/FTP ThinPrint USB Zakázat přístup k externím sítím Zabezpečení Metody přihlášení Naplánovat USB zařízení Protokol auditu zabezpečení Omezení přihlášení Nastavení důvěrného tisku Šifrování Vymazat dočasné soubory Nastavení LDAP řešení Různé Cloudové služby Registrace do cloudových služeb Zprávy Stránka nastavení nabídek Zařízení Tisk Zástupci Faxování Síť Řešení problémů Vytisknout zkušební stránku Čištění skeneru Forms Merge 2 Forms Merge schéma nabídek nabídky tiskárny"},{"UUID":"7c345175-842b-4f3b-8ebc-47fa51bcdb2e","title":"Zařízení","link":"preferences-topic.html","desc":"Předvolby Položky nabídky Předvolby a","descFull":"Předvolby Položky nabídky Předvolby a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Jazyk výpisů – [Seznam jazyků] Nastaví jazyk zobrazovaného textu na displeji. Země/oblast – [Seznam zemí nebo regionů] Určete zemi nebo region, kde je tiskárna nakonfigurována k používání. Spustit prvotní nastavení – Vypnuto * Zapnuto Spustí průvodce instalací. Klávesnice Typ klávesnice [Seznam jazyků] Vyberte jazyk jako typ klávesnice. Je možné, že se nezobrazí všechny hodnoty pro  typ klávesnice  nebo tyto hodnoty mohou vyžadovat speciální hardware. Datum a čas Konfigurovat Aktuální datum a čas Ručně nastavit datum a čas Formát data  ( MM‑DD‑RRRR *) Formát času  ( 12hodinový dop./odp. *) Časové pásmo Rozdíl DST (GMT) Počátek letního času Konec letního času Posunutí letního času Konfigurovat datum a čas tiskárny a protokol NTP. Výchozí tovární nastavení v USA je  MM‑DD‑RRRR . Mezinárodní výchozí tovární nastavení je  DD‑MM‑RRRR . Položky  Rozdíl UTC (GMT) ,  Počátek DST ,  Konec DST  a  Posunutí letního času  se zobrazí pouze v případě, že je  Časové pásmo  nastaveno na možnost  (UTC+uživatelský) Vlastní . Položky  ID klíče  a  Heslo  se zobrazují pouze v případě, že je položka  Povolit ověření  nastavena na hodnotu  Klíč MD5 . Časový protokol sítě Povolit NTP  ( Zapnuto *) Server NTP Povolit ověření  ( Žádné  *) ID klíče Heslo Formáty papíru – U.S. * Metrický Určuje měrné jednotky pro formáty papíru. Země nebo oblast vybraná během počátečního nastavení určuje počáteční nastavení formátu papíru. Jas obrazovky – 20–100%  (100*) Upraví jas displeje. Přístup k jednotce flash – Vypnuto Zapnuto * Povolte přístup k funkci paměti flash v tiskárně. Povolit odstranění pozadí – Vypnuto Zapnuto * Určuje, zda je povoleno odstranit pozadí. Povolit skenování vlastních úloh – Vypnuto Zapnuto * Určete, zda se položka  Skenování vlastní úlohy  zobrazí pro kopírování, skenování a faxování. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Ploché skenování jedné stránky – Vypnuto * Zapnuto Nastaví tiskárnu na skenování jakéhokoli typu úlohy zahrnujícího skleněnou plochu skeneru jako jednu stránku. Tiskárna se po provedení jediného skenování z plochy místo zobrazení výzvy vrací na domovskou obrazovku. Zvuky zařízení Vypnout všechny zvuky Vypnuto * Zapnuto Konfiguruje nastavení zvuku tiskárny. Odezva tlačítek Vypnuto Zapnuto * Hlasitost 0–10  (5*) Pípnutí – papír v ADF založen Vypnuto Zapnuto * Řízení alarmů Vypnuto Jednou * Nepřetržitě Alarm kazety Vypnuto Jednou * Nepřetržitě Režim reproduktoru Vždy vypnuto * Vždy zapnuto Zapnuto do připojení Hlasitost zvonění Vypnuto * Zapnuto Časový limit obrazovky – 5–300 sekund  (60*) Nastavit dobu prodlevy v sekundách předtím, než displej zobrazí domovskou obrazovku, nebo než tiskárna automaticky odhlásí uživatelský účet. nabídka Předvolby"},{"UUID":"cffd5459-e302-4c98-8a57-29f17341ca2a","title":"Zařízení","link":"preferences-topic.html","desc":"Ekologický režim Položky nabídky Ekologický","descFull":"Ekologický režim Položky nabídky Ekologický režim a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Tisk Strany Jednostranný Oboustranný * Určuje, zda tisknout na jednu stranu nebo na obě strany papíru. Počet stránek na stránku Vypnuto * 2 stránky na stranu 3 stránky na stranu 4 stránky na stranu 6 stránek na stranu 9 stránek na stranu 12 stránek na stranu 16 stránek na stranu Určuje, kolik stránek se má vytisknout na jednu stranu listu papíru. Sytost toneru 1–5  (4*) Určuje, zda mají textové obrázky malou nebo velkou sytost. Šetřič barev Vypnuto * Zapnuto Sníží množství toneru používaného tiskárnou pro tisk grafiky a obrázků. Kopírování Strany Jednostranný na jednostranný * Jednostranný na oboustranný Oboustranná na jednostranný Oboustranný na oboustranný Určuje chování při skenování podle originálního dokumentu. Počet stránek na stránku Vypnuto * 2 stránky orientované na výšku 4 stránky orientované na výšku 2 stránky orientované na šířku 4 stránky orientované na šířku Určuje, kolik stránek se má zkopírovat na jednu stranu listu papíru. Tmavost 1–9  (5*) Určuje tmavost naskenovaných textových obrázků. nabídka Ekologický režim"},{"UUID":"d6a297ad-823c-40b1-a41e-a0cdf29a312f","title":"Zařízení","link":"preferences-topic.html","desc":"Vzdálený ovládací panel Položky nabídky","descFull":"Vzdálený ovládací panel Položky nabídky Vzdálený ovládací panel a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Externí připojení VNC Nepovolit * Povolit Připojte externí klientský program VNC (Virtual Network Computing) k dálkovému ovládacímu panelu. Typ ověření Žádná * Standardní ověření Nastaví typ ověření při přístupu ke klientskému serveru VNC. Heslo VNC Nastavení je definováno uživatelem. Určí heslo pro připojení ke klientskému serveru VNC. Tato položka nabídky se zobrazuje pouze v případě, že je možnost  Typ ověření  nastavena na hodnotu  Standardní ověření . nabídka Vzdálený ovládací panel"},{"UUID":"955f6387-c5d8-4e28-bbb2-2910725212ef","title":"Zařízení","link":"preferences-topic.html","desc":"Upozornění Položky nabídky Upozornění a jejich","descFull":"Upozornění Položky nabídky Upozornění a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Pípnutí – papír v ADF založen – Vypnuto Zapnuto * Určete, zda má tiskárna pípnout při vložení originálního dokumentu do automatického podavače dokumentů. Řízení alarmů – Vypnuto Jednou * Nepřetržitě Nastavuje počet zaznění alarmu tehdy, když bude tiskárna vyžadovat zásah uživatele. Spotřební materiál Zobrazit odhady spotřebního materiálu Zobrazit odhady * Nezobrazovat odhady Zobrazuje odhadovaný stav spotřebního materiálu. Alarm kazety Vypnuto Jednou * Nepřetržitě Nastavuje počet zaznění alarmu při nízkém stavu zásobníku toneru. Alarm sešívačky Vypnuto * Jednoduchý Nepřetržitě Nastavuje počet zaznění alarmu při vyprázdnění kazety se svorkami. Tato položka nabídky se zobrazí jen v případě, že je instalován sešívací finišer. Alarm děrovače Vypnuto * Jednoduchý Nepřetržitě Nastavte, kolikrát má zaznít alarm, když je krabice děrovačky plná nebo není vložena. Tato položka nabídky se zobrazí jen v případě, že je instalován sešívací a děrovací finišer. Nastavení výstrah e-mailem Primární brána SMTP Nastavení je definováno uživatelem. Zadejte IP adresu nebo název hostitele primárního serveru SMTP. Port primární brány SMTP 1–65535  (25*) Zadá číslo portu primárního serveru SMTP. Sekundární brána SMTP Nastavení je definováno uživatelem. Zadejte IP adresu nebo název hostitele sekundárního serveru SMTP. Port sekundární brány SMTP 1–65535  (25*) Zadejte číslo portu sekundárního serveru SMTP. Časový limit pro SMTP 5–30 sekund  (30*) Určuje dobu, která musí uplynout, než se server SMTP přestane pokoušet odeslat e-mail. Zpáteční adresa Nastavení je definováno uživatelem. Určuje adresu pro odpověď v e-mailu. Vždy používat výchozí adresu pro odpověď SMTP Zapnuto Vypnuto * Vždy použije výchozí server pro odpověď v serveru SMTP. Použít protokol SSL/TLS Vypnuto * Vyjednávat Požadované Odešle e-mail pomocí šifrovaného odkazu. Vyžadovat důvěryhodný certifikát Zapnuto * Vypnuto Vyžaduje důvěryhodný certifikát při přístupu k serveru SMTP. Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Nastavení výstrah e-mailem Ověření serveru SMTP Žádné ověření není nutné * Přihlášení / obyčejné NTLM CRAM-MD5 Digest-MD5 Kerberos 5 Nastavuje typ ověření pro přístup k serveru SMTP. E-mail započatý zařízením Žádná * Použít ověřovací soubory SMTP zařízení Nastavte, zda u e‑mailů spuštěných ze zařízení mají být vyžadovány ověřovací údaje. E-mail započatý uživatelem Žádná * Použít ověřovací soubory SMTP zařízení Použít uživatelské jméno a heslo relace Použít e-mailovou adresu a heslo relace Vyzvat uživatele Nastavte, zda u e‑mailů spuštěných ze strany uživatele mají být vyžadovány ověřovací údaje. Použít ověřovací údaje zařízení Active Directory Zapnuto Vypnuto * Povoluje připojení ověřovacích údajů uživatelů a označení skupin k serveru SMTP. ID uživatele zařízení Nastavení je definováno uživatelem. Určete ID uživatele pro přihlášení k serveru SMTP. Heslo zařízení Nastavení je definováno uživatelem. Určete heslo uživatele pro přihlášení k serveru SMTP. SFÉRA Kerberos 5 Nastavení je definováno uživatelem. Určuje sféru ověřovacího protokolu Kerberos 5. Doména NTLM Nastavení je definováno uživatelem. Určuje název domény ověřovacího protokolu NTLM. Zakázat chybu „Není nastaven server SMTP“ Zapnuto Vypnuto * Deaktivuje chybovou zprávu o nastavení serveru SMTP. Nastavení seznamů e-mailových adres a výstrah e-mailem Nastavení je definováno uživatelem. Zadejte e-mailové adresy a povolte události výstrah e-mailem. Tato položka nabídky je dostupná pouze v prostředí Embedded Web Server. Prevence chyb Snímač podání více listů podavače ADF Vypnuto Zapnuto * Nastaví, aby tiskárna detekovala případy, kdy automatický podavač dokumentů zavede více než jeden list papíru najednou. Automatické pokračování Vypnuto Zapnuto * Nechá tiskárnu po odstranění zaseknuté stránky automaticky pokračovat ve zpracování nebo tisku úlohy tím. Je-li položka nastavena na hodnotu  Zapnuto , výchozí nastavení z výroby činí 5 sekund. Automatické restartování Restartovat při nečinnosti Restartovat vždy * Nikdy nerestartovat Nastaví restartování tiskárny při zjištění chyby. Maximální počet automatických restartování 1–20  (2*) Nastaví počet automatických restartování, která může tiskárna provést. Okno automatického restartování 1–525600  (720*) Nastavit počet sekund předtím, než tiskárna provede automatický restart. Počitadlo automatického restartování Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazí počet automatických restartování, která tiskárna provedla. Zobrazit chybu krátkého papíru Zapnuto Automaticky vymazat * Nastavuje tiskárnu pro zobrazení zprávy v případě výskytu chyby „krátký papír“. Chyba „krátký papír“ se vztahuje k formátu vloženého papíru. Ochrana stránky Vypnuto * Zapnuto Nastavit tiskárnu tak, aby před vytištěním úlohy zpracovala celou stránku do paměti. Obnova obsahu po uvíznutí Napravit uvíznutí Vypnuto Zapnuto Auto * Nastaví tiskárnu tak, aby znovu vytiskla uvíznuté stránky. Obnova po uvíznutí ve skeneru Úroveň úlohy Úroveň stránky * Určuje, jak restartovat úlohu skenování po vyřešení uvíznutí papíru. nabídka Upozornění"},{"UUID":"a4abdd34-058b-4c0e-8e67-1880894373cf","title":"Zařízení","link":"preferences-topic.html","desc":"Správa napájení Položky nabídky Správa","descFull":"Správa napájení Položky nabídky Správa napájení a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Profil režimu spánku Tisknout z režimu spánku Po tisku nepřecházet do režimu spánku Po tisku přejít do režimu spánku * Nastaví tiskárnu tak, aby zůstala aktivní, nebo se po tisku vrátila do  režimu spánku . Dotykem probudit z hlubokého spánku Vypnuto Zapnuto * Probudí tiskárnu z  režimu hlubokého spánku . Časové limity Režim spánku 1–114 minut  (15*) Nastaví dobu nečinnosti, po které tiskárna přejde do  režimu spánku . Doba hibernace Vypnuto 1 hodina 2 hodiny 3 hodiny 6 hodin 1 den 2 dny 3 dny * 1 týden 2 týdny 1 měsíc Nastaví dobu, po které se tiskárna vypne. Doba hibernace pro připojení Hibernace Neuvádět do rež. hibernace * Nastaví  Časový limit hibernace , aby bylo možné vypnout tiskárnu v době, kdy je aktivní připojení k síti Ethernet. Naplánovat úsporné režimy Plány Přidat nový plán Naplánuje, kdy má tiskárna přejít do  režimu spánku  nebo  hibernace . nabídka Správa napájení"},{"UUID":"bbdb632e-b992-43aa-8a9d-57634e8fdac0","title":"Zařízení","link":"preferences-topic.html","desc":"Sdílet data se společností Lexmark","descFull":"Sdílet data se společností Lexmark Sdílení dat s položkami nabídky Lexmark a jejich popisem Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Sdílet data se společností Lexmark Ano Ne * Odeslat společnosti Lexmark informace o využití a výkonu tiskárny. Sdílet čas odeslání dat Čas začátku Čas ukončení Vyberte časové okno pro shromažďování a přenos dat. Položka  Sdílet čas odeslání dat  se zobrazí pouze tehdy, když v nabídce  Sdílet data se společností Lexmark  vyberete možnost  Ano . nabídka Sdílet data se společností Lexmark"},{"UUID":"34b28923-789a-48e8-a99b-74e86b718331","title":"Zařízení","link":"preferences-topic.html","desc":"Usnadnění Položky nabídky dostupnosti a","descFull":"Usnadnění Položky nabídky dostupnosti a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Interval při duplicitním stisku kláves 0.00–5.00  (0.00*) Nastaví časový interval v sekundách, při kterém tiskárna ignoruje duplicitní stisk kláves na připojené klávesnici. Původní zpoždění pro opakovací efekt kláves 0.25–5.00  (1.00*) Nastaví počáteční délku zdržení v sekundách před zahájením opakování opakovací klávesy. Rychlost opakovacího efektu kláves 0.5–30.0  (30.0*) Nastaví počet opakovaných stisknutí klávesy za sekundu. Prodloužit čas. limit obrazovky Vypnuto * Zapnuto Nechá uživatele ve stejné obrazovce a místo návratu na domovskou obrazovku obnoví po vypršení  Časový limit obrazovky . Hlasitost sluchátek 1–10  (5*) Nastaví hlasitost sluchátek. Povolit hlasové pokyny, jsou-li připojena sluchátka Vypnuto * Zapnuto Povolí hlasové pokyny, když jsou sluchátka připojena ke konektoru sluchátek. Mluvená hesla/kódy PIN Vypnuto * Zapnuto Nastaví hlasité přečtení hesel nebo osobních identifikačních čísel tiskárnou. Rychlost mluvení Velmi pomalé Pomalu Normální * Rychle Rychlejší Velmi rychlé Extrémně rychlé Ultra rychlé Nejrychlejší Nastaví rychlost mluvení funkce Hlasové pokyny. nabídka Usnadnění"},{"UUID":"de8708d4-6d1e-4113-891c-a262381d4b7e","title":"Zařízení","link":"preferences-topic.html","desc":"Obnovit výchozí výrobní nastavení Položka","descFull":"Obnovit výchozí výrobní nastavení Položka nabídky Obnovit výchozí výrobní nastavení a její popis Položka nabídky Nastavení Popis Obnovit nastavení Obnovit všechna nastavení Obnovit nastavení tiskárny Obnovit nastavení sítě Obnovit nastavení faxu Obnovit nastav. aplikací Obnovení výchozí tovární nastavení tiskárny. nabídka Obnovit výchozí výrobní nastavení"},{"UUID":"7d9a854b-1ec0-483b-8aa7-84ed0515a73a","title":"Údržba","link":"preferences-topic.html","desc":"Nabídka konfigurace Položky nabídky Konfigurace","descFull":"Nabídka konfigurace Položky nabídky Konfigurace a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Konfigurace USB USB PnP 1 * 2 Změna režimu ovladače USB tiskárny k vylepšení jeho kompatibility s osobním počítačem. Skenování do místního USB Zapnuto * Vypnuto Nastaví, zda je ovladač USB zařízení vyjmenován jako jednoduché zařízení USB (jedno rozhraní), nebo jako složené zařízení USB (více rozhraní). Rychlost USB Plná Auto * Nastavit port USB na chod při plné rychlosti a deaktivovat jeho vysokorychlostní schopnosti. Konfigurace zásobníku Detekce formátu Detekce zásobníku  [x] ( Zapnuto *) Nastavení zásobníku na automatické rozpoznání velikosti vloženého papíru. Spojování zásobníků Automaticky * Vypnuto Nastaví tiskárnu tak, aby propojila zásobníky, které mají stejná nastavení typu a formátu papíru. Zobrazit zprávu vložení zásobníku Vypnuto Pouze pro neznámé velikosti * Vždy Zobrazí zprávu, která uživateli umožňuje změnit nastavení formátu a typu papíru po vložení zásobníku. Papír – výzvy Auto * Univerzální podavač Papír ručně Nastaví zdroj papíru, který uživatel vloží, jakmile se zobrazí výzva k vložení papíru. Aby se zobrazil  Univerzální podavač , nastavte v nabídce  Papír  položku  Konfigurace univerzálního podavače  na hodnotu  Kazeta . Obálky – výzvy Auto * Univerzální podavač Obálka ručně Nastaví zdroj papíru, který uživatel vloží, jakmile se zobrazí výzva k vložení obálky. Aby se zobrazil  Univerzální podavač , nastavte v nabídce  Papír  položku  Konfigurace univerzálního podavače  na hodnotu  Kazeta . Akce na výzvy Vyzvat uživatele * Pokračovat Použít aktuální Nastaví tiskárnu tak, aby vyřešila výzvy související se změnami papíru nebo obálek. Více univerzálních formátů Vypnuto * Zapnuto Nastavte zásobník tak, aby podporoval více univerzálních formátů papíru. Zprávy – Stránka nastavení nabídek Protokol událostí Souhrn protokolu událostí Hlášení tiskárny týkající se nastavení tiskárny, stavu a protokolů událostí. Počitadla a využ. spotř. mat. Vymazat historii použití spotřebního materiálu Start Resetuje historii využití spotřebního materiálu na výrobní úroveň při dodání. Reset ITM Start Po instalaci nového spotřebního materiálu nebo sady údržby je nutné vynulovat počítadlo. Reset počitadla černé kazety Start Reset počitadla azurové kazety Start Reset počitadla purpurové kazety Start Reset počitadla žluté kazety Start Reset počitadla černé obrazové jednotky Start Reset počitadla barevné obrazové sady Start Reset počitadla sady válečků v univerzálním podavači Start Reset počitadla sady válečků na 1 500 listů Start Reset počitadla sady válců Start Rozsahy vrstveného pokrytí Metriky vrstveného pokrytí  ( Zobrazit *) Ve zprávě se statistikami zařízení zobrazí část Počet podle úrovně pokrytí. Rozsahy vrstveného pokrytí Úpravy velkých médií Vypnuto * Zapnuto Umožňuje úpravy při tisku na velký nebo silný papír. Emulace tiskárny Emulace PPDS Vypnuto * Zapnuto Nastavit tiskárnu tak, aby rozpoznávala a používala datový proud PPDS. Emulace PS Vypnuto Zapnuto * Nastavit tiskárnu tak, aby rozpoznávala a používala datový proud PS. Povolit Formsmerge Vypnuto * Zapnuto Aktivuje sloučení formulářů. Musí být nainstalována licence k funkci Formsmerge. Musí být nainstalována uživatelská paměť flash. Povolit Prescribe Vypnuto * Zapnuto Aktivujte jazyk tiskárny PRESCRIBE. Musí být nainstalována licence PRESCRIBE. Zabezpečení emulátoru Časový limit stránky  (60*) Nastavit časový limit stránky během emulace. Po úloze resetovat emulátor  ( Vypnuto *) Resetovat emulátor po dokončení tiskové úlohy. Zakázat přístup ke zprávě tiskárny  ( Zapnuto *) Určuje, zda má emulátor přístup k počátečnímu nastavení tiskárny, nebo ne. Konfigurace faxu Podpora nízké spotřeby faxu Zakázat režim spánku Povolit režim spánku Auto * Určete, zda má tiskárna podporovat faxovou část architektury s nízkou spotřebou energie. Umístění úložiště faxů Disk * NAND Nastaví umístění, kam se mají uložit stažené zdroje. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Konfigurace tisku Režim Pouze černá Vypnuto * Zapnuto Tisk jiných úloh než kopírování ve stupních šedé. Zachycování barev Vypnuto 1 2 * 3 4 5 Vylepší tiskový výstup za účelem kompenzace nesprávné registrace v tiskárně. Zaostření písma 0–150  (24*) Nastavit hodnotu bodové velikosti textu, pod kterou budou při tisku dat písem používány vysokofrekvenční obrazovky. Jestliže například bude tato hodnota rovna 24, pak všechna písma o velikostech 24 bodů a méně budou využívat vysokofrekvenční obrazovky. Použít nativní písma ISD Zapnuto * Vypnuto Nechá uživatele, aby vybral, zda se mají použít bezplatná písma, která jsou uložena v inteligentní paměťové jednotce (ISD). Tato položka nabídky se zobrazí jen v případě, že je nainstalována jednotka ISD. Činnosti zařízení Tichý režim Vypnuto * Zapnuto Upraví hladinu šumu, který tiskárna vytváří. Povolením tohoto nastavení se sníží celkový výkon tiskárny. Povolit režim dávky Zapnuto * Vypnuto Nastavte tiskárnu tak, aby zrychlila tisk jedné stránky a případně první stránky z vícestránkové úlohy, takže úloha bude dokončena rychleji. Tato položka nabídky se zobrazí pouze u některých modelů tiskáren. Nouzový režim Vypnuto * Zapnuto Nastaví tiskárnu tak, aby pracovala ve zvláštním režimu, v němž nabízí co nejvíce funkcí, přestože jsou známy nějaké problémy. Je-li například tento parametr nastaven na hodnotu  Zapnuto  a duplexní motor není funkční, bude tiskárna tisknout dokumenty jednostranně, i když obdrží oboustrannou tiskovou úlohu. Zapnutím tohoto nastavení povolíte tisk pouze z univerzálního podavače. Minim. paměť kopírování 20 MB 30 MB 50 MB 80 MB * 100 MB Nastaví minimální přidělení paměti pro ukládání úloh kopírování. Vymazat vlastní stav Start Vymazat uživatelem definované řetězce pro  Implicitní  nebo  Alternativní  uživatelsky přizpůsobené zprávy. Vymazat všechny vzdáleně nainstalované zprávy Start Vymaže zprávy, které byly nainstalovány dálkově. Automaticky zobrazit chybová hlášení Vypnuto Zapnuto * Zobrazí na displeji stávající chybová hlášení poté, co tiskárna setrvá v neaktivním stavu na domovské obrazovce po určitou dobu. Dodržet orientaci při kopírování rychlou cestou Vypnuto * Zapnuto Umožní, aby tiskárna použila nastavení orientace z nabídky  Kopírování , pokud odesílá rychlé úlohy kopírování. Šifrovat energeticky nezávislou paměť služby Stav šifrování Zobrazuje stav šifrování paměťové jednotky. Šifrovat energeticky nezávislou paměť služby Povolte ruční šifrování zrcadlení. Nastavení snímače tonerové vrstvy Předvolba frekvence kalibrace Vypnuto Nejméně úprav barev Méně úprav barev Normální * Větší věrnost barev Největší věrnost barev Nastaví tiskárnu tak, aby používala správné množství toneru pro zachování barevné konzistence. Celková kalibrace Start Spustí kalibraci barev. Tisk informační stránky TPS Start Vytiskne stránku diagnostiky obsahující informaci o kalibraci snímače tonerové vrstvy. Konfigurace aplikace Aplikace LES Vypnuto Zapnuto * Povolí používání aplikací Lexmark Embedded Solutions (LES). Konfigurace skeneru Ruční registrace skeneru Rychlý test tisku Registrace předního ADF Registrace zadního ADF Registrace ploch. skeneru Po výměně automatického podavače dokumentů (ADF), skleněné plochy skeneru nebo desky ovladače vytiskněte cílovou stránku rychlého testu nebo ručně zaregistrujte plochý a automatický podavač dokumentů. Při tisku cílové stránky rychlého testu ověřte, že jsou okraje na cílové stránce rovnoměrné po celém obvodu cílové stránky. V opačném případě je třeba resetovat okraje tiskárny. Reset počítadla údržby Nulování počítadla údržby podavače ADF  ( Spustit ) Po výměně sady pro údržbu podavače ADF resetujte počitadlo údržby podavače ADF. Vymazání okraje Vymazání okraje plochého skeneru  (3*) Vymazání okraje ADF  (3*) Nastaví v milimetrech velikost netištěné oblasti kolem úlohy ADF nebo plochého skeneru. Odstranění zkosení ADF Elektronické odstranění zkosení ADF  ( Zapnuto *) Sníží míru zkosení dokumentů skenovaných z podavače ADF. Deaktivovat skener Ne * Ano Pouze ADF Deaktivuje skener, pokud nepracuje správně. Pořadí bajtů TIFF Endianita procesoru Hodnota Little Endian Hodnota Big Endian Nastaví pořadí bajtů ve výstupu skenování ve formátu TIFF. Přesný počet řádků TIFF na pruh Zapnuto * Vypnuto Nastaví hodnotu značky RowsPerStrip (počet řádků na pruh) ve výstupu skenování ve formátu TIFF. Práh čištění skleněné plochy skeneru 1000–30000  (10000*) Nastaví počet naskenovaných stran před tím, než bude uživatel vyzván k vyčištění skleněné plochy skeneru. nabídka Nabídka konfigurace"},{"UUID":"f98de4ad-2c0b-43ad-8eb9-3cb6749ada04","title":"Údržba","link":"preferences-topic.html","desc":"Vymazání při vyřazení z provozu Položky","descFull":"Vymazání při vyřazení z provozu Položky nabídky Vymazání při vyřazení z provozu a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Vymazání při vyřazení z provozu Poslední ošetření paměti Nastavení je údaj, který je k dispozici jen pro čtení. Udává, kdy byla paměť tiskárny naposledy vymazána. Posl. ošetření pevného disku Nastavení je údaj, který je k dispozici jen pro čtení. Udává, kdy byl pevný disk naposledy vymazán. Tato položka nabídky se zobrazí pouze v případě, že je nainstalován pevný disk. Jednotka ISD naposledy vymazána Nastavení je údaj, který je k dispozici jen pro čtení. Udává, kdy byla inteligentní paměťová jednotka (ISD) naposledy vymazána. Tato položka nabídky se zobrazí jen v případě, že je nainstalována jednotka ISD. Ošetřit všechny informace v energeticky nezávislé paměti Vymazat všechna nastavení tiskárny a sítě Vymazat všechny aplikace i s nastavením Vymazat všechny zástupce a nastavení zástupců? Vymaže všechny informace v energeticky nezávislé paměti. Ošetřit všechny informace na pevném disku Vymazat staž. soubory (tzn. všechna makra, písma, PFO atd.) Vymazat úlohy z vyrovnávací paměti Vymaz. pozdrž. úlohy Vymaže všechny informace na pevném disku. Tato položka nabídky se zobrazí pouze v případě, že je nainstalován pevný disk. Vymazat inteligentní paměťovou jednotku Vymazat Vymažte všechny informace na jednotce ISD. Tato položka nabídky se zobrazí jen v případě, že je nainstalována jednotka ISD. nabídka Vymazání při vyřazení z provozu"},{"UUID":"a2b7619e-50db-494a-b1d5-2c134a30f93b","title":"Zařízení","link":"preferences-topic.html","desc":"Aktualizovat firmware  Položky nabídky","descFull":"Aktualizovat firmware  Položky nabídky Aktualizovat firmware a jejich popisy Položka nabídky Nastavení Popis Současná verze Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazí aktuální verzi firmwaru nainstalovanou v tiskárně. Vyhledat aktualizace nyní Instalovat nyní Instalovat později Kontrola aktualizací firmwaru. Automatická kontrola aktualizací Zapnuto Vypnuto * Nastaví tiskárnu na automatickou kontrolu aktualizací firmwaru. nabídka Aktualizovat firmware"},{"UUID":"9c77a7bd-7d59-4ea1-bfb1-237bf3a6b98b","title":"Zařízení","link":"preferences-topic.html","desc":"O této tiskárně Položky nabídky Tiskárna","descFull":"O této tiskárně Položky nabídky Tiskárna a jejich popisy Položka nabídky Popis Položka Zadání totožnosti tiskárny. Umístění tiskárny Slouží k zadání umístění tiskárny. Kontakt Zadání kontaktních údajů pro tiskárnu. Verze firmwaru Zobrazí verzi firmwaru nainstalovanou v tiskárně. Základní deska Zobrazí výrobní číslo tiskárny. Sériové číslo Zobrazit výrobní číslo tiskárny. Exportovat konfigurační soubor na jednotku USB Exportuje konfigurační soubor na jednotku paměti flash. Exportovat komprim. prot. na USB Exportuje komprimovaný soubor protokolu na jednotku paměti flash. Posílat protokoly Odesílá údaje o využití tiskárny společnosti Lexmark. nabídka O této tiskárně"},{"UUID":"cadb0755-6f90-4ad6-9690-d875dda27fbc","title":"Tisk","link":"layout-topic.html","desc":"Rozložení Položky nabídky Rozložení a","descFull":"Rozložení Položky nabídky Rozložení a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Strany Jednostranný Oboustranný * Určuje, zda tisknout na jednu stranu nebo na obě strany papíru. Styl otočení Dlouhý okraj * Krátký okraj Určuje, která strana papíru je při oboustranném tisku svázána. Prázdné strany Tisk Netisknout * Vytiskne prázdné stránky, které jsou zařazeny do tiskové úlohy. Skládání kopií Vypnuto (1,1,1,2,2,2) Zapnuto (1,2,1,2,1,2) * Skládá stránky tiskové úlohy v pořadí, především při tisku více kopií. Oddělovací listy Žádná * Mezi kopiemi Mezi úlohami Mezi listy Při tisku vkládá prázdné oddělovací listy. Zdroj oddělovacích listů Zásobník  [x] (1*) Univerzální podavač Zadejte zdroj papíru pro oddělovací list. Počet stránek na stránku Vypnuto * 2 stránky na stranu 3 stránky na stranu 4 stránky na stranu 6 stránek na stranu 9 stránek na stranu 12 stránek na stranu 16 stránek na stranu Na jednu stranu listu papíru se vytisknou obrazy více stránek. Více str. na stranu – řazení Horizontální * Opačné horizontální Vertikální Opačné vertikální Určuje polohu obrázků na více stránek při použití nastavení  Více stránek na stranu . Více str. na stranu – orientace Auto * Na šířku Na výšku Určuje orientaci obrázků na více stránek při použití nastavení  Více stránek na stranu . Více str. na str. – okraj Žádná * Pevný Při použití nastavení  Více stránek na stranu  vytiskne rámeček okolo každého obrázku na stránce. Počet kopií 1–9999  (1*) Určuje počet kopií pro každou tiskovou úlohu. Oblast tisku Normální * Přizpůsobit na stránku Celá stránka Nastaví tisknutelnou oblast listu papíru. nabídka Rozložení"},{"UUID":"f2cb319a-a169-47e1-a391-b3351438aa11","title":"Tisk","link":"layout-topic.html","desc":"Dokončování Položky nabídky Dokončování a","descFull":"Dokončování Položky nabídky Dokončování a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Sešít výtisk Vypnuto * 1 svorka, levý horní roh 2 svorky, nalevo 1 svorka, pravý horní roh 2 svorky, nahoře 1 svorka, levý dolní roh 2 svorky, dole 1 svorka, pravý dolní roh 2 svorky, napravo Určuje polohu svorky pro všechny tiskové úlohy. Tato položka nabídky se zobrazí jen v případě, že je instalován sešívací finišer. Test sešívačky Start Určuje, zda sešívací finišer funguje správně. Tato položka nabídky se zobrazí jen v případě, že je instalován sešívací finišer. Děrování Vypnuto * Zapnuto Vytváří otvory podél okraje vytištěného výstupu. Tato položka nabídky se zobrazí jen v případě, že je instalován sešívací a děrovací finišer. Režim děrování 2 otvory 3 otvory 4 otvory Nastaví režim děrování vytištěného výstupu. 3 otvory  jsou americkým výchozím továrním nastavením. Mezinárodní výchozí tovární nastavení jsou  4 otvory . Tato položka nabídky se zobrazí jen v případě, že je instalován podporovaná sešívačka a děrovačka nebo dokončovací schránka – vazač knih. Posunout listy Žádná * Mezi kopiemi Mezi úlohami Posune výstup jednotlivých tiskových úloh nebo jednotlivých kopií tiskové úlohy. Možnost  Mezi kopiemi  zajistí posunutí každé kopie tiskové úlohy, pokud je položka  Skládání  nastavena na hodnotu  Zapnuto [1,2,1,2,1,2] . Je-li funkce  Skládání  nastavena na hodnotu  Vypnuto [1,1,1,2,2,2] , vytisknou se pohromadě jednotlivé stránky, například všechny stránky označené jako 1 a všechny stránky označené jako 2. Při nastavení hodnoty  Mezi úlohy  se posune celá tisková úloha stejně bez ohledu na počet vytištěných kopií. nabídka Dokončování"},{"UUID":"5c2d4783-58dd-4e75-bc50-83c5ff0aa684","title":"Tisk","link":"layout-topic.html","desc":"Nastavení Položky nabídky Nastavení a","descFull":"Nastavení Položky nabídky Nastavení a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Jazyk tiskárny Emulace PCL Emulace PS * Nastaví jazyk tiskárny. Nastavení výchozího jazyka tiskárny nebrání odesílání tiskové úlohy softwarovým programům, které používají jiný jazyk tiskárny. Čekání úloh Vypnuto * Zapnuto Uchová tiskové úlohy vyžadující spotřební materiál, aby se mohly vytisknout úlohy nevyžadující spotřební materiál. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Limit čekání na pozdrženou úlohu 0–255  (30*) Nastaví dobu (v sekundách), po kterou tiskárna čeká na zásah uživatele předtím, než pozdrží úlohy vyžadující nedostupné zdroje. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Cíl stahování RAM * Paměť flash Disk Zadejte, kam se mají ukládat všechny trvalé zdroje, které byly do tiskárny staženy. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Použ. tiskárny Maximální rychlost Max. výtěžnost * Určete, zda zadržovací hardware v průběhu tisku odpojí nebo připojí barevné vývojové jednotky. Je-li tento parametr nastaven na hodnotu  Maximální výtěžnost , hardware zůstane připojen k barevným vývojovým jednotkám, i když je tiskárna nečinná. Když je nastaven na hodnotu  Maximální rychlost , zůstane hardware připojen k barevným vývojovým jednotkám bez ohledu na to, zda úloha obsahuje černobílý nebo barevný obsah. Použití tiskárny s nízkou rychlostí Max. výtěžnost * Maximální rychlost Nechte tiskárnu přepínat mezi vysokou výtěžností (pouze černobílý režim) a vysokou rychlostí (barevný režim) při nízké rychlosti. Toto nastavení mění chování tiskárny pouze v případě, že tiskový modul zpracovává 25 stránek za minutu. Nemá žádný vliv na provoz tiskového modulu při vyšších rychlostech zpracování. Šetření zdroji Vypnuto * Zapnuto Zadejte, co má tiskárna dělat se staženými zdroji, když obdrží úlohu vyžadující více paměti, než kolik je k dispozici. Když je nastavena hodnota  Vypnuto , tiskárna uchová stažené zdroje, pouze pokud není vyžadována paměť. Zdroje přiřazené k neaktivnímu jazyku tiskárny se vymažou. Když je nastavena hodnota  Zapnuto , tiskárna uchová všechny trvalé stažené zdroje ve všech jazycích. V případě nutnosti tiskárna místo odstranění trvalých zdrojů zobrazuje zprávy o nedostatku paměti. Pořadí tisku Vytisknout vše Abecedně * Od nejnovějších Od nejstarších Upřesní pořadí tisku, rozhodnete-li se vytisknout všechny pozdržené a důvěrné úlohy. Automatické odstranění pozastavených tiskových úloh Vypnuto * Zapnuto Nastavte tiskárnu, aby automaticky zrušila všechny tiskové úlohy ve frontě, které byly přerušeny chybami, jako např. zaseknutím papíru nebo nedostatkem materiálů. nabídka Nastavení"},{"UUID":"1355c0bb-3081-4ccd-9e25-b603c334584b","title":"Tisk","link":"layout-topic.html","desc":"Kvalita Položky nabídky Kvalita a","descFull":"Kvalita Položky nabídky Kvalita a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Režim tisku – Černobíle Barevně * Nastavuje, jak tiskárna generuje barevné obsah. Rozlišení tisku – 4800 CQ * 1200 dpi Nastaví rozlišení pro tištěný výstup. 4800 CQ  poskytuje vysoce kvalitní výstup při maximální rychlosti. Sytost toneru – 1 až 5  (4*) Určuje, zda mají textové obrázky malou nebo velkou sytost. Půltón – Normální * Detail Zdokonalí tiskový výstup, aby měl hladší linie a ostřejší okraje. Šetřič barev – Vypnuto * Zapnuto Sníží množství toneru používaného pro tisk grafiky a obrázků. Když nastavíte hodnotu  Zapnuto , toto nastavení potlačí hodnotu nastavení  Sytost toneru . Jas RGB – –6 až +6  (0*) Upraví jas všech objektů v odstínech šedi a RGB na stránce. Toto nastavení nemá vliv na soubory, kde se používají specifikace barev CMYK. Kontrast RGB – 0 až 5  (0*) Upraví kontrast všech objektů v odstínech šedi a RGB na stránce. Toto nastavení nemá vliv na soubory, kde se používají specifikace barev CMYK. Sytost RGB – 0 až 5  (0*) Zachová hodnoty černé a bílé a současně upraví hodnoty barev každého objektu na stránce. Toto nastavení nemá vliv na soubory, kde se používají specifikace barev CMYK. Rozšířené zobrazování Vyvážení barev Azurová  (0*) Purpurová  (0*) Žlutá  (0*) Černá  (0*) Upraví množství toneru použitého pro každou barvu. Obnovit výchozí nastavení Obnoví všechna nastavení barev na výchozí hodnoty. Korekce barev Vypnuto Auto * Ručně Upraví nastavení barev, které jsou používány k tisku dokumentů. Vypnuto  – nastaví tiskárnu tak, aby přijímala korekci barev ze softwaru. Auto  – nastaví tiskárnu tak, aby používala různé profily barev pro jednotlivé objekty na stránce. Ruční  – umožňuje přizpůsobit konverze barev RGB nebo CMYK používané pro jednotlivé objekty na tištěné stránce. Ukázka barev Tisk barevných vzorků Vytiskne zkušební stránky pro každou barevnou konverzní tabulku RGB a CMYK použitou v tiskárně. Úprava barev Úprava barev Kalibruje tiskárnu k úpravě barevných odchylek v tiskovém výstupu. Náhrada přímých barev Nast. vlastní CMYK Umožňuje přiřadit hodnoty CMYK 20 přímým barvám. nabídka Kvalita"},{"UUID":"ee7e42df-7dc6-48bc-993e-0a5ba3a89891","title":"Tisk","link":"layout-topic.html","desc":"Evidence úloh Položky nabídky Evidence","descFull":"Evidence úloh Položky nabídky Evidence úloh a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Evidence úloh Vypnuto * Zapnuto Nastaví tiskárnu tak, aby vytvořila protokol přijatých tiskových úloh. Četnost evidence úloh Každý den Každý týden Každý měsíc * Určuje, jak často tiskárna vytváří soubor protokolu. Akce protokolu na konci četnosti Žádná * Odeslat e-mailem aktuální protokol Odeslat e-mailem aktuální protokol a odstranit ho Vystavit aktuální protokol Vystavit a odstranit aktuální protokol Určuje, jak tiskárna reaguje při vypršení prahu četnosti. Hodnota definovaná v položce  Četnost protokolování evidence  určuje, kdy bude tato akce spuštěna. Protokol při téměř plném disku Zapnuto * (5 MB) Vypnuto Určuje maximální velikost souboru protokolu předtím, než tiskárna spustí funkci  Akce protokolu při téměř plném disku . Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Akce protokolu při téměř plném disku Žádná * Odeslat e-mailem aktuální protokol Odeslat e-mailem aktuální protokol a odstranit ho Odeslat e-mailem nejstarší protokol a odstranit ho Vystavit aktuální protokol Vystavit a odstranit aktuální protokol Vystavit a odstranit nejstarší protokol Odstranit aktuální protokol Odstranit nejstarší protokol Odstranit všechny protokoly kromě aktuálního Odstranit všechny protokoly Určuje, jak tiskárna reaguje na téměř plnou paměťovou jednotku. Hodnota definovaná v poli  Protokol při téměř plném disku  určuje, kdy bude akce spuštěna. Akce protokolu při plném disku Žádná * Odeslat e-mailem aktuální protokol a odstranit ho Odeslat e-mailem nejstarší protokol a odstranit ho Vystavit a odstranit aktuální protokol Vystavit a odstranit nejstarší protokol Odstranit aktuální protokol Odstranit nejstarší protokol Odstranit všechny protokoly kromě aktuálního Odstranit všechny protokoly Určuje, jak tiskárna reaguje, když využití paměťové jednotky dosáhne maximální mezní hodnoty (100 MB). URL pro vystavení protokolu Nastavení je definováno uživatelem. Určuje, kam tiskárna vystavuje protokoly evidence úloh. E-mailová adresa pro zasílání protokolů Nastavení je definováno uživatelem. Určuje e-mailovou adresu, na kterou bude zařízení zasílat protokoly evidence úloh. Předpona souboru protokolu Nastavení je definováno uživatelem. Určuje předponu souborů protokolu. Jako výchozí předpona souboru protokolu se používá aktuální název hostitele definovaný v nabídce TCP/IP. nabídka Evidence úloh"},{"UUID":"70978d4d-fb3e-4d70-9f93-313089101613","title":"Tisk","link":"layout-topic.html","desc":"PDF Položky nabídky PDF a","descFull":"PDF Položky nabídky PDF a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Na celou stránku Vypnuto * Zapnuto Přizpůsobí obsah stránky formátu vybraného papíru. Anotace Tisk Netisknout * Určuje, zda tisknout anotace v souboru PDF. Vytisknout hlášení o chybě v PDF Vypnuto Zapnuto * Povoluje tisk chyby PDF. nabídka PDF"},{"UUID":"87a2614c-f10b-4de3-bb50-4b321a39393f","title":"Tisk","link":"layout-topic.html","desc":"PostScript PostScript Položky nabídky PostScript","descFull":"PostScript PostScript Položky nabídky PostScript a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Tisk PS chyb Vypnuto * Zapnuto Vytiskne zkušební stránku popisující chybu emulace jazyku PostScript®. Když dojde k chybě, zpracování úlohy se zastaví, tiskárna vytiskne chybovou zprávu a zbytek tiskové úlohy bude vyprázdněn. Minimální šířka linky 1–30  (2*) Nastaví minimální šířku záběru. Úlohy vytištěné v rozlišení 1200 dpi používají tuto hodnotu přímo. Režim spuštění se zamknutým PS Vypnuto Zapnuto * Zakáže soubor SysStart. Povolením souboru SysStart vystavíte tiskárnu nebo síť bezpečnostnímu riziku. Vyhlazení obrazu Vypnuto * Zapnuto Zvýší kontrast a ostrost pro obrázky s nízkým rozlišením. Toto nastavení nijak neovlivní obrázky s rozlišením 300 dpi nebo vyšším. Priorita písma Rezidentní * Paměť flash / Disk Stanovení pořadí hledání písem. Rezidentní  – nastaví tiskárnu tak, aby při hledání požadovaného písma nejprve prohledala svou paměť a teprve poté paměťovou jednotku. Paměť flash / Disk  – nastaví tiskárnu tak, aby při hledání požadovaného písma nejprve prohledala paměťovou jednotku a teprve poté prohledala paměť tiskárny. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Limit pro čekání Vypnuto Zapnuto * Povolí tiskárně, aby před zrušením tiskové úlohy počkala na další data. Je-li položka nastavena na hodnotu  Zapnuto , je výchozí nastavení z výroby 40 sekund. nabídka PostScript"},{"UUID":"1ba97c7c-034c-458b-a6bc-40714c4da170","title":"Tisk","link":"layout-topic.html","desc":"PCL Položky nabídky PCL a","descFull":"PCL Položky nabídky PCL a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Zdroj písem Rezidentní * Disk Stáhnout Paměť flash Karta s písmy Vše Zvolte zdroj, který obsahuje výchozí nastavení písma. Disk  – zobrazí se pouze v případě, že je nainstalován funkční pevný disk, který obsahuje písma a není chráněn proti čtení/zápisu. Stáhnout  – zobrazí se pouze v případě, že stažená písma jsou v paměti tiskárny. Paměť flash  – zobrazí se pouze v případě, že je nainstalována funkční paměť flash, která obsahuje písma a není chráněna proti čtení/zápisu. Karta s písmy  – zobrazí se pouze v případě, že je nainstalována funkční karta s písmy nebo je nakonfigurována inteligentní paměťová jednotka. Název písma [Seznam dostupných písem] ( Courier *) Zvolí písmo z určeného zdroje písem. Sada symbolů [Seznam dostupných sad symbolů] ( 10U PC-8 *) Určení sady symbolů pro jednotlivé názvy písem. Sada symbolů je sada písmen a číselných znaků, interpunkčních znamének a speciálních symbolů. Sady symbolů podporují různé jazyky nebo specifické programy, například matematické symboly pro vědecké texty. Rozteč 0.08–100.00  (10.00*) Určete rozteč pro pevná písma nebo písma s konstantní roztečí. Tato položka nabídky se odvíjí od počtu znaků pevné mezery na jeden horizontální palec. Orientace Na výšku * Na šířku Převrátit na výšku Převrátit na šířku Určení orientace textu a grafiky na stránce. Řádků na stránku 1–255 Určuje počet řádků na každé stránce vytištěné přes datový tok PCL®. Tato položka nabídky aktivuje vertikální únik, který způsobí, že se vybraný počet požadovaných řádků vytiskne mezi výchozí okraje stránky. V USA je výchozí tovární nastavení 60. Mezinárodní tovární nastavení je 64. Minimální šířka linky PCL5 1–30  (2*) Nastavuje počáteční minimální hodnotu čáry pro libovolnou úlohu vytištěnou v rozlišení 1200 dpi pomocí příslušného emulátoru. Minimální šířka linky PCLXL 1–30  (2*) Šířka A4 198 mm * 203 mm Nastaví šířku logické stránky při tisku na papír formátu A4. Logická stránka je prostor na stránce, kde jsou data vytištěna. Vkládat CR za LF Zapnuto Vypnuto * Nastaví tiskárnu k provedení konce řádku po příkazu posunu na další řádek. Znak pro konec řádku je mechanismus, který tiskárně přikazuje přesunout pozici kurzoru na první pozici stejného řádku. Vkládat LF za CR Zapnuto Vypnuto * Nastaví tiskárnu k provedení posunu na další řádek za příkazem konce řádku. Přečíslování zásobníků Přiřadit univerzální podavač Přiřadit zásobník  [x] Přiřadit ruční podavač papíru Přiřadit ruč. podavač obálek Nakonfiguruje tiskárnu pro práci s odlišným ovladačem tisku nebo s vlastní aplikací, které pro žádost o daný zdroj papíru používají jinou sadu označení zdrojů. Vyberte z následujících možností: Vypnuto * – Tiskárna použije výchozí tovární označení zdrojů papíru. Žádný  – Zdroj papíru ignoruje příkaz Vybrat podávání papíru. 0–199  – výběrem číselné hodnoty přiřadíte zdroji papíru vlastní hodnotu. Zobrazit výchozí nastavení Zobrazení výchozí hodnoty přiřazené k jednotlivým zdrojům papíru. Obnovit výchozí nastavení Obnovit výchozí tovární nastavení pro číslování zásobníků. Časový limit tisku Vypnuto Zapnuto * (90) Nastaví konkrétní dobu nečinnosti, po které tiskárna ukončí tiskovou úlohu. nabídka PCL"},{"UUID":"4e64c083-3ea7-4ff6-b429-e1b85ef5d3f5","title":"Tisk","link":"layout-topic.html","desc":"Obrázek Položky nabídky Obrázek a","descFull":"Obrázek Položky nabídky Obrázek a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Automatické přizpůsobení Zapnuto Vypnuto * Vybere nejlepší dostupné nastavení formátu a orientace papíru pro daný obrázek. Je-li tato položka nabídky nastavena na hodnotu  Zapnuto , přepíše nastavení přizpůsobení a orientace pro daný obrázek. Invertovat Vypnuto * Zapnuto Invertuje dvoubarevné monochromatické obrázky. Tato položka nabídky se nevztahuje na formáty obrazu GIF a JPEG. Přizpůsobení Přizpůsobení výšky/šířky * Ukotvit vlevo nahoře Ukotvit ve středu Přizpůsobit výšku/šířku Přizpůsobit výšku Přizpůsobit šířku Upraví obrázek tak, aby vyhovoval tisknutelné oblasti. Když je  zapnuto Automatické přizpůsobení , je  Měřítko  automaticky nastaveno na  Přizpůsobení výšky/šířky . Orientace Na výšku * Na šířku Převrátit na výšku Převrátit na šířku Určení orientace textu a grafiky na stránce. nabídka Obrázek"},{"UUID":"36f8537b-9cf6-4108-85db-fc10ace6b427","title":"Papír","link":"tray-configuration-topic.html","desc":"Konfigurace zásobníku Položky nabídky Konfigurace","descFull":"Konfigurace zásobníku Položky nabídky Konfigurace zásobníku a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Výchozí zdroj – Zásobník  [x] (1*) Univerzální podavač Papír ručně Obálka ručně Nastavení výchozího zdroje papíru pro všechny tiskové úlohy. Formát/typ papíru Zásobník  [x] Univerzální podavač Papír ručně Obálka ručně Velikost Typ Určuje formát nebo typ papíru vkládaného do jednotlivých zdrojů papíru. Náhradní formát – Vypnuto Statement/A5 Letter/A4 11 x 17/A3 Všechny uvedené * Nastaví tiskárnu tak, aby nahradila zadaný formát papíru v případě, že v žádném zdroji papíru není vložen požadovaný formát. Vypnuto  – uživateli se zobrazí výzva k vložení požadovaného formátu papíru. Všechny uvedené  – umožňuje všechny dostupné náhrady. Konfigurace univerzálního podavače – Kazeta * Ručně První Určuje chování univerzálního podavače. Kazeta  – nakonfiguruje univerzální podavač jako automatický zdroj papíru. Ruční  – univerzální podavač lze použít pouze pro tiskové úlohy s ručním podáváním. První  – nakonfiguruje univerzální podavač jako primární zdroj papíru. nabídka Konfigurace zásobníku"},{"UUID":"f61f0ebb-340c-4b97-a4b7-53392d40703a","title":"Papír","link":"tray-configuration-topic.html","desc":"Konfigurace médií Položky nabídky Konfigurace","descFull":"Konfigurace médií Položky nabídky Konfigurace médií a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Jednotky míry – Palce Milimetry Určuje měrné jednotky pro papír Universal. Palce  jsou americkým výchozím továrním nastavením. Mezinárodním výchozím továrním nastavením jsou  milimetry . Univerzální nastavení Všechny vstupní zásobníky Na výšku – šířka Nastaví šířku papíru Universal při orientaci na výšku. Na výšku - výška Nastaví výšku papíru Universal při orientaci na výšku. Směr podávání  ( krátký okraj *) Nastaví tiskárnu tak, aby zaváděla papír ze směru krátkého nebo dlouhého okraje papíru. Dlouhý okraj  se zobrazuje pouze tehdy, když je delší strana kratší než maximální podporovaná šířka. Vlastní formáty skenování Název formátu skenu Nastavení je definováno uživatelem. Přiřaďte název pro vlastní skenování. Šířka 1–8,5 palce  (8,5*) 25–215,9 mm  (215,9*) Určete šířku originálního dokumentu. Výška 1–25 palců  (11*) 25–635 mm  (279,4*) Určete výšku originálního dokumentu. Orientace Na výšku * Na šířku Určete orientaci obsahu na originálním dokumentu. 2 skeny na stranu Vypnuto * Zapnuto Nastavte výchozí počet skenů na každé straně tiskárny. Nastavení typu média [Seznam typů papíru] Povrch Gramáž Orientace vložení Odeslat do odkl. Specifikuje texturu, gramáž a orientaci papíru. nabídka Konfigurace médií"},{"UUID":"eaa38687-c3ba-4d0a-887d-cc494c875536","title":"Papír","link":"tray-configuration-topic.html","desc":"Konfigurace přihrádky Položky nabídky Konfigurace","descFull":"Konfigurace přihrádky Položky nabídky Konfigurace přihrádky a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Výstupní zásobník Standardní zásobník * Odkladač  [x] Určuje výstupní přihrádku pro tiskové úlohy. Konfigurace odkladačů Schránka * Propojit Propojit volitelné Přiřazení typu Slouží ke konfiguraci provozního režimu výstupních odkladačů. Schránka  – umožňuje samostatně zvolit standardní zásobník a jakoukoli volitelnou přihrádku. Propojit  – umožňuje propojit výstupní přihrádky, jako kdyby se jednalo o jednu výstupní přihrádku. Propojit volitelné  – považuje všechny volitelné přihrádky za jednu velkou výstupní přihrádku. Přiřazení typu  – každému typu papíru je přiřazena přihrádka nebo propojená sada přihrádek. Vlastní názvy zásobníků Standardní zásobník Odkladač  [x] Přiřadí každé přihrádce název. nabídka konfigurace přihrádky"},{"UUID":"cbe6e3b8-af6c-42ab-ac3f-70935ce9a972","title":"Kopírování","link":"copy-defaults-topic.html","desc":"Výchozí nastavení kopírování  Položky","descFull":"Výchozí nastavení kopírování  Položky nabídky Výchozí nastavení kopírování a jejich popisy Položka nabídky Položky podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Typ obsahu – Text Text/fotografie * Foto Grafika Umožňuje vylepšit výsledný výstup podle obsahu originálního dokumentu. Zdroj obsahu – Černobílá laserová Barevná laserová * Inkoustová Fotografie/Film Časopis Noviny Tiskovina Jiné Umožňuje vylepšit výsledný výstup podle zdroje originálního dokumentu. Strany – Jednostranný na jednostranný * Jednostranný na oboustranný Oboustranná na jednostranný Oboustranný na oboustranný Určuje chování při skenování podle originálního dokumentu. Oddělovací listy – Žádná * Mezi kopiemi Mezi úlohami Mezi listy Určuje, zda se mají při tisku vkládat prázdné oddělovací listy. Zdroj oddělovacích listů – Zásobník  [x] (1*) Univerzální podavač Zadejte zdroj papíru pro oddělovací list. Barevně – Vypnuto Zapnuto * Auto Nastavení tiskárny na generování barevného výstupu z úlohy skenování. Počet stránek na stránku – Vypnuto * 2 stránky orientované na výšku 4 stránky orientované na výšku 2 stránky orientované na šířku 4 stránky orientované na šířku Určuje, kolik stránek se má vytisknout na jednu stranu listu papíru. Tisknout okraje stránek – Vypnuto * Zapnuto Při tisku více stránek na jednu stranu umístí okraj kolem každého obrázku. Skládání kopií – Vypnuto [1,1,1,2,2,2] Zapnuto [1,2,1,2,1,2] * Vytiskne více kopií za sebou. Posunout listy – Žádná * Mezi kopiemi Mezi úlohami Posune výstup jednotlivých tiskových úloh nebo jednotlivých kopií tiskové úlohy. Mezi kopiemi  – zajistí posunutí každé kopie tiskové úlohy, pokud je položka  Skládání  nastavena na hodnotu  Zapnuto [1,2,1,2,1,2] . Je-li funkce  Skládání  nastavena na hodnotu  Vypnuto [1,1,1,2,2,2] , vytisknou se pohromadě jednotlivé stránky, například všechny první stránky, všechny druhé stránky atd. Mezi úlohy  – celá tisková úloha se posune stejně bez ohledu na počet vytištěných kopií. Tato položka nabídky se zobrazí jen v případě, že je instalován odsazovací odkládací zásobník nebo sešívací děrovací finišer. Sešívání – Vypnuto * 1 svorka, levý horní roh 2 svorky, nalevo 1 svorka, pravý horní roh 2 svorky, nahoře 1 svorka, levý dolní roh 2 svorky, dole 1 svorka, pravý dolní roh 2 svorky, napravo 4 svorky Určuje polohu svorky pro všechny tiskové úlohy. Tato položka nabídky se zobrazí jen v případě, že je instalován sešívací finišer. Děrovat – Vypnuto * 2 otvory 3 otvory 4 otvory Provést děrování na výstupu tisku. Tato položka nabídky se zobrazí jen v případě, že je instalován podporovaná sešívačka a děrovačka nebo dokončovací schránka – vazač knih. Velikost „Kopírovat z“ [Seznam formátů papíru] Nastavuje formát papíru originálního dokumentu. V USA je výchozím nastavením formát  Letter .  Mezinárodní výchozí tovární nastavení je A4. Zdroj „Kopírovat do“ – Zásobník  [x] (1*) Univerzální podavač Automatické přizpůsobení formátu Určuje zdroj papíru pro úlohu kopírování. Teplota – –4 až +4  (0*) Zadejte, zda vytvářet chladnější nebo teplejší výstup. Tmavost – 1 až 9  (5*) Nastavení sytosti skenovaného obrazu. Počet kopií – 1–9999  (1*) Zadejte počet kopií. Záhlaví/zápatí – Levé záhlaví Střední záhlaví Pravé záhlaví Levé zápatí Střední zápatí Pravé zápatí Zadání informací záhlaví nebo zápatí na naskenovaném obrazu. Překrytí – Důvěrné Kopírování Koncept Naléhavé Vlastní Vypnuto * Určuje tisk textu překrytí na každou kopii. Vlastní překrytí – Nastavení je definováno uživatelem. Zadání textu pro volbu  Vlastní  v nabídce  Překrytí . Rozšířené zobrazování Vyvážení barev Azurová až červená  (0*) Purpurová až zelená  (0*) Žlutá až modrá  (0*) Nastavení intenzity barev pro tyrkysovou, purpurovou a žlutou. Zeslabení barvy Zeslabení barvy  ( Žádné *) Výchozí prahová hodnota červené  (128*) Výchozí prahová hodnota zelené  (128*) Výchozí prahová hodnota modré  (128*) Určuje barvu, jejíž intenzita bude během skenování snížena, a umožňuje nastavit snížení této barvy. Aut. detekce barev Citlivost barev  (5*) Citlivost oblasti  (5*) Konfigurace nastavení automatické detekce barev. Kontrast Nejlepší pro obsah * 0–5 Určuje název souboru naskenovaného obrazu. Odstranění pozadí Detekce pozadí  ( Založeno na obsahu *) Úroveň  (0*) Odstranění barvy pozadí nebo vad tisku z originálního dokumentu. Na základě obsahu  – odstraní barvy pozadí z originálního dokumentu. Pevné  – odstraní vady obrazu z fotografie. Automatické centrování Vypnuto * Zapnuto Umožňuje vyrovnat obsah na střed stránky. Zrcadlový obraz Vypnuto * Zapnuto Vytvoří zrcadlový obraz předlohy. Obraz v negativu Vypnuto * Zapnuto Vytvoří negativní obraz předlohy. Detail stínu –4 až +4  (0*) Úprava detailů stínů v originálním dokumentu. Skenování od okraje k okraji Vypnuto * Zapnuto Skenování originálního dokumentu od kraje ke kraji. Ostrost 1–5  (3*) Nastavuje kontrast naskenovaného obrázku. Ovl. prvky správy Povolit barevné kopie Vypnuto Zapnuto * Tiskne barevné kopie. Povolit prioritní kopie Vypnuto Zapnuto * Přerušení tiskové úlohy pro pořízení kopií. Skenování vlastní úlohy Vypnuto * Zapnuto Nastavení tiskárnu na skenování první sady originálních dokumentů s použitím zadaných nastavení a poté na skenování další sady se stejným nebo odlišným nastavením. Povolit zkratku funkce Uložit jako Vypnuto Zapnuto * Uložení aktuálního nastavení skenování jako zástupce. Vzorek kopie Vypnuto * Zapnuto Vytištění ukázková kopie pro kontrolu kvality před vytištěním zbývajících kopií. nabídka Výchozí nastavení kopírování"},{"UUID":"4d19d65e-e815-499f-83c9-2dd6b2bfff85","title":"Výchozí nastavení faxu","link":"fax-defaults-subgroup.html","desc":"Režim faxování Položka nabídky ","descFull":"Režim faxování Položka nabídky  Režim faxování  a její popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Režim faxování Faxování * Faxový server Vypnuto Výběr režimu faxování. nabídka Režim faxování"},{"UUID":"6e3a3585-6310-4dd8-95f5-9a872677aa6c","title":"Výchozí nastavení faxu","link":"fax-defaults-subgroup.html","desc":"Nastavení faxování Položky nabídky Obecná","descFull":"Nastavení faxování Položky nabídky Obecná nastavení faxu a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Obecná nastavení faxu Název faxu Nastavení je definováno uživatelem. Zadejte své ID faxu. Faxové číslo Nastavení je definováno uživatelem. Zadejte své faxové číslo. ID faxu Název faxu Faxové číslo * Nastavte ID faxu, které se má použít při vyjednávání faxu. Povolit ruční skenování Vypnuto * Zapnuto Zapněte funkci ručního faxu v tiskárně. Tato nabídka vyžaduje rozdělovač telefonní linky a telefonní sluchátko. K přijetí příchozí faxové úlohy a volbě čísla faxu použijte běžnou telefonní linku. Chcete-li přejít přímo k funkci ručního faxování, stiskněte tlačítko  #  a  0  na klávesnici. Využitá paměť Všechny přijaté Většina pro příjem Stejné * Nejodesílanější Všechny odeslané Nastavuje množství interní paměti tiskárny přidělené pro faxování. Tato nabídka zabraňuje poruchám vyrovnávací paměti a výskytům neodeslaných faxů. Storno faxů Povolit * Nepovolit Zrušení odchozích nebo příchozích faxů Maskování faxového čísla Vypnuto * Zleva Zprava Zadává formát maskování odchozího faxového čísla. Obecná nastavení faxu Maskované číslice 0–58  (0*) Určuje počet maskovaných číslic v odchozím čísle faxu. Povolit detekci připojené linky Vypnuto Zapnuto * Určuje, zda je telefonní linka připojená k tiskárně. Události jsou detekovány okamžitě. Povolit detekci nespr. připojení linky Vypnuto Zapnuto * Určuje, zda je telefonní linka připojena ke správnému portu tiskárny. Události jsou detekovány okamžitě. Povoluje podporu pro používanou linku Vypnuto Zapnuto * Určuje, zda telefonní linku využívá jiné zařízení, například další telefon na stejné lince. Události jsou detekovány okamžitě. Optimalizovat kompatibilitu faxu Nastavení je definováno uživatelem. Slouží ke konfiguraci funkce faxu tiskárny pro zajištění optimální kompatibility s ostatními faxy. Podávací jednotka T.38 Analogové G.711 etherFAX Nastavte metodu přenosu faxů. Tato položka nabídky se zobrazí, pouze pokud je v tiskárně nainstalován licenční balíček etherFAX nebo Fax over IP (FoIP). Nastavení HTTPS faxu Tato nabídka se zobrazí pouze v případě, že je položka  Přenos faxu  nastavena na možnost  etherFAX . Adresa URL služby HTTPS Nastavení je definováno uživatelem. Zadejte adresu URL služby etherFAX. HTTPS proxy Nastavení je definováno uživatelem. Zadejte adresu URL serveru proxy. Uživatel HTTPS proxy Nastavení je definováno uživatelem. Zadejte uživatelské jméno a heslo pro server proxy. Heslo HTTPS proxy Šifrování odeslaných faxů Vypnuto Zapnuto * Požadované Povolte šifrování odchozích faxových zpráv. Šifrování přijatých faxů Vypnuto Zapnuto * Požadované Povolte šifrování příchozích faxových zpráv. Status HTTPS faxu Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazte stav komunikace pro etherFAX. Nastavení odesílání faxů Rozlišení Standardní * Vysoká Superjemné Ultrajemné Nastavení rozlišení skenovaného obrazu. Vyšší rozlišení prodlužuje dobu přenosu faxu a vyžaduje více paměti. Původní velikost [Seznam formátů papíru] ( Kombinované formáty *) Zadání velikosti původního dokumentu Orientace Na výšku * Na šířku Určuje orientaci originálního dokumentu. Strany Vypnuto * Krátký okraj Dlouhý okraj Určuje orientaci originálního dokumentu při skenování obou stran dokumentu. Typ obsahu Text * Text/Fotografie Foto Grafika Umožňuje vylepšit výsledný výstup podle obsahu originálního dokumentu. Zdroj obsahu Černobílá laserová Barevná laserová * Inkoustová Fotografie/Film Časopis Noviny Tiskovina Jiné Umožňuje vylepšit výsledný výstup podle zdroje originálního dokumentu. Tmavost 1–9  (5*) Nastavení sytosti skenovaného obrazu. Za systémem PABX Zapnuto Vypnuto * Nastavení tiskárny na vytáčení faxového čísla bez čekání na rozeznání oznamovacího tónu. Telefonní služba automatické pobočkové ústředny (PABX neboli Private Automated Branch Exchange) je telefonní síť, která umožňuje nabídnout volajícím více linek pomocí jednoho přístupového čísla. Režim vytáčení Tón * Pulsní volba Určuje režim vytáčení pro příchozí nebo odchozí faxy. Rozšířené zobrazování Vyvážení barev Azurová – červená  (0*) Purpurová – zelená  (0*) Žlutá – modrá  (0*) Nastavení intenzity barev během skenování. Zeslabení barvy Nejlepší pro obsah * 0 1 2 3 4 5 Nastavuje kontrast výstupu. Zrcadlový obraz Vypnuto * Zapnuto Vytvoří zrcadlový obraz předlohy. Detail stínu –4 až +4  (0*) Upraví viditelnost detailů ve stínech na naskenovaném obrázku. Skenování od okraje k okraji Vypnuto Zapnuto * Umožňuje skenování předlohy od okraje k okraji. Ostrost 1–5  (3*) Nastavuje kontrast naskenovaného obrázku. Teplota –4 až +4  (0*) Zadejte, zda vytvářet chladnější nebo teplejší výstup. Ovl. prvky správy Automatická opakovaná volba 0–9  (5*) Určuje počet pokusů, které tiskárna opakuje před tím, než zruší odeslání faxu na dané místo určení. Četnost opakovaného vytáčení 1–200  minut (3*) Prodlužuje dobu mezi pokusy o opakované vytáčení, aby se zvýšila pravděpodobnost úspěšného odeslání faxu. Povolit ECM Zapnuto * Vypnuto Aktivuje režim opravy chyb (ECM) pro faxové úlohy. Režim ECM detekuje a napravuje ty chyby během procesu faxového přenosu způsobené šumem na telefonní lince a slabým signálem. Zapnout skenování faxů Zapnuto * Vypnuto Vytvářejte faxy pomocí skeneru tiskárny. Ovladač na fax Zapnuto * Vypnuto Umožňuje tiskovému ovladači odesílat faxy. Povolit zkratku funkce Uložit jako Zapnuto * Vypnuto Umožňuje uložit v tiskárně faxová čísla jako zástupce. Maximální rychlost 33600 * 14400 9600 4800 2400 Nastavuje maximální rychlost odesílání faxu. Skenování vlastní úlohy Vypnuto * Zapnuto Umožňuje zapnout skenování vlastních úloh ve výchozím nastavení. Náhled skenování Vypnuto * Zapnuto Umožňuje zobrazit náhled skenu na displeji. Oprava šikmého posunu v podavači ADF Vypnuto Zapnuto * Opravuje jemné zešikmení naskenovaného obrazu. Zapnout skenování barevných faxů Ve výchozím nastavení vypnuto * Ve výchozím nastavení zapnuto Nikdy nepoužít Vždy použít Umožňuje používat pro faxování barevné naskenované dokumenty. Automatický převod barevných faxů do jednobarevných Zapnuto * Vypnuto Převádí všechny barevné odchozí faxy na černobílé. Potvrdit faxové číslo Vypnuto * Zapnuto Vyžádá si potvrzení faxového čísla od uživatele. Předvolba Nastavení je definováno uživatelem. Nastavuje předvolbu. Pravidla pro předvolbu Nastavení je definováno uživatelem. Umožňuje určit pravidlo pro předvolbu. Nastavení přijímání faxů Čekání faxových úloh Žádná * Toner Toner a spotřební materiál Odebere z tiskové fronty faxové úlohy, které požadují specifické nedostupné zdroje. Počet zvonění před přijetím 1–25  (3*) Nastavte počet zazvonění, po kterém tiskárna přijme příchozí volání: Automatická redukce Zapnuto * Vypnuto Přizpůsobí příchozí fax podle velikosti stránky. Zdroj papíru Zásobník  [x] Auto * Nastaví zdroj papíru pro tisk příchozího faxu. Strany Zapnuto Vypnuto * Tiskněte na obě strany papíru. Oddělovací listy Žádná * Před úlohou Po úloze Určuje, zda se mají při tisku vkládat prázdné oddělovací listy. Zdroj oddělovacích listů Zásobník  [x] (1*) Zadejte zdroj papíru pro oddělovací list. Výstupní zásobník Standardní zásobník Určuje výstupní zásobník přijatých faxů. Zápatí faxu Zapnuto Vypnuto * Tiskne informace o přenosu na spodní okraj každé stránky přijatého faxu. Časová značka zápatí faxu Přijmout * Tisk Tiskne časové razítko na spodní okraj každé stránky přijatého faxu. Pozdržení faxů Režim pozdrženého faxu  (Vypnuto*) Pozdrží tisk přijatých faxů, dokud nebudou uvolněny. Plán pozdržení faxů Přiřaďte plán na pozdržení faxů. Tato položka nabídky se zobrazí pouze tehdy, když bude možnost  Režim pozdržení faxů  nastavena na hodnotu  Naplánováno . Ovl. prvky správy Zapnout příjem faxů Zapnuto * Vypnuto Nastaví tiskárnu pro příjem faxů. Zapnout příjem barevných faxů Zapnuto * Vypnuto Nastaví tiskárnu pro příjem barevných faxů. Povolit ID volajícího Zapnuto Vypnuto * Informace o ID volajícího se při příchozím hovoru zobrazí na displeji tiskárny. Blokovat fax bez názvu Zapnuto Vypnuto * Blokuje příchozí faxy bez ID faxu. Seznam blokovaných faxů Přidat blok. fax Určuje telefonní čísla, která chcete blokovat. Přijmout po Všechna zvonění * Pouze jedno zazv. Pouze dvě zazv. Pouze tři zazv. Pouze po jednom nebo dvou zazvoněních Pouze po jednom nebo třech zazvoněních Pouze dvě nebo tři zazv. Nastaví odlišný typ vyzvánění pro příchozí fax. Automatický příjem Zapnuto * Vypnuto Nastaví tiskárnu pro automatický příjem faxů. Kód ručního příjmu 0–9  (9*) Umožňuje zadat ručně pomocí číselníku telefonu kód pro zahájení příjmu faxu. Tato položka nabídky se zobrazí pouze v případě, že tiskárna sdílí linku s telefonem. Tato položka nabídky se zobrazí pouze v případě, že nastavíte tiskárnu pro ruční příjem faxu. Přeposílání faxů Tisk * Vytisknout a přeposlat Přeposlat Určuje, zda přeposlat přijatý fax. Přeposlat komu Cíl 1 Cíl 2 Určuje, kam přeposlat přijatý fax. Tato položka nabídky se zobrazí pouze v případě, že je možnost  Přeposlání faxu  nastavena na hodnotu  Vytisknout a přeposlat  nebo  Přeposlat . Maximální rychlost 33600 * 14400 9600 4800 2400 Nastavuje maximální rychlost přenosu faxu. Úvodní stránka faxu Úvodní stránka faxu Ve výchozím nastavení vypnuto * Ve výchozím nastavení zapnuto Nikdy nepoužít Vždy použít Nakonfigurujte nastavení pro úvodní stránku faxu. Zahrnout pole Komu Vypnuto * Zapnuto Zahrnout pole Od Vypnuto * Zapnuto Od Nastavení je definováno uživatelem. Zahrnout pole Zpráva Vypnuto * Zapnuto Zpráva: Nastavení je definováno uživatelem. Zahrnout logo Vypnuto * Zapnuto Zahrnout zápatí [x] Vypnuto * Zapnuto Zápatí [x] Nastavení je definováno uživatelem. Nastavení faxových protokolů Četnost protokolování přenosu Vždy * Nikdy Pouze v případě chyby Určuje, jak často tiskárna vytváří protokol přenosů. Akce protokolování přenosu Tisk  ( Zapnuto *) E‑mail  ( Vypnuto *) Vytiskne nebo odešle e-mailem protokol úspěšného faxového přenosu nebo chyby při přenosu. Protokol chyb příjmu Nikdy netisknout * Tisk při chybě Vytiskne protokol pro selhání přijetí faxu. Automatický tisk protokolů Zapnuto * Vypnuto Vytiskne veškerou aktivitu faxu. Zdroj papíru pro protokol Zásobník  [x] (1*) Zadejte zdroj papíru pro tisk protokolů. Zobrazení protokolů Název vzdáleného faxu * Zvolené číslo Identifikuje odesílatele pomocí názvu vzdáleného faxu nebo faxového čísla. Umožnit protokolování úloh Zapnuto * Vypnuto Zobrazí shrnutí všech faxových úloh. Povolit záznam volání Zapnuto * Vypnuto Zobrazí shrnutí historie vytáčení faxů. Protokol výstupního odkladače Standardní zásobník * Odkladač  [x] Určuje výstupní odkladač pro tištěné protokoly. Nastavení reproduktoru Režim reproduktoru Vždy vypnuto * Vždy zapnuto Zapnuto do připojení Nastaví režim faxového reproduktoru. Hlasitost reproduktoru Nízká * Vysoká Upraví výchozí hlasitost reproduktoru. Hlasitost zvonění Vypnuto * Zapnuto Povolí hlasitost zvonění. Nastavení VoIP Protokol VoIP SIP * H.323 Nastavte protokol VoIP (Voice over Internet Protocol). Server STUN Nastavení je definováno uživatelem. Zadejte server STUN k přechodu přes bránu firewall. Vynutit rež. fax. Vypnuto Zapnuto * Na začátku faxového volání přepněte bránu VoIP z analogového režimu na T.38. Vynutit zpož. rež. fax. 0–15  (7*) Nastavte časovou prodlevu v sekundách při odesílání další pozvánky možnosti  Vynutit režim Faxování . Nastavení SIP Proxy Nastavení je definováno uživatelem. Zadejte IP adresu systému, který převede telefonní číslo na IP adresu, na kterou je fax odeslán. Registrátor Nastavení je definováno uživatelem. Zadejte název nebo IP adresu systému, který zpracovává registraci klientů protokolu SIP (Session Initiation Protocol). Uživatel Nastavení je definováno uživatelem. Zadejte jméno uživatele pro protokol SIP. Heslo Nastavení je definováno uživatelem. Zadejte heslo, které se použije při registraci do registrátoru SIP. Ověř. ID Nastavení je definováno uživatelem. Uživatelské jméno, které se používá při registraci. Pokud není nastavena možnost  Auth ID , použije nastavení místo toho uživatelské jméno v poli Uživatel. Přenos pro registraci UDP * TCP Nastavte typ přenosu SIP pro registraci. Přenos pro příchozí hovory UDP * TCP UDP a TCP Nastavte typ přenosu SIP pro příchozí hovory. Přenos pro odchozí hovory UDP * TCP Nastavte typ přenosu SIP pro odchozí hovory. Odchozí Proxy Nastavení je definováno uživatelem. Zadejte odchozí proxy k předávání veškeré komunikace SIP. Kontakt Nastavení je definováno uživatelem. Určuje kontaktní jméno pro protokol SIP. Sféra Nastavení je definováno uživatelem. Zadejte název sféry pro protokol SIP. Pokud není určeno nastavení Sféra, použije se místo toho název  kontaktu . Stav registrace SIP Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazí stav registrace SIP. Nastavení H.323 Brána Nastavení je definováno uživatelem. Zadejte IP adresu brány H.323. Zábrana Nastavení je definováno uživatelem. Určete správce brány H.323. Uživatel Nastavení je definováno uživatelem. Zadejte uživatelské jméno používané s bránou H.323. Heslo Nastavení je definováno uživatelem. Zadejte heslo brány H.323. Povolit rychlé spuštění Vypnuto * Zapnuto Povolí rychlé spuštění. Zakázat tunelování H.245 Vypnuto * Zapnuto Zakáže tunelování H.323. Zakázat zjištění zábrany Vypnuto Zapnuto * Zakáže zjištění zábrany H.323. Nastavení T.38 Redundance indikátoru 0–5  (3*) Nastavte počet opakování indikátoru faxu v komunikaci T.38. Pomalá redundance 0–5  (3*) Nastavte počet opakování pomalých dat v komunikaci T.38. Rychlá redundance 0–5  (1*) Nastavte počet opakování rychlých dat v komunikaci T.38. nabídka Nastavení faxování"},{"UUID":"a0c3588d-fec5-4a9e-bcbc-c27f387e7380","title":"Výchozí nastavení faxu","link":"fax-defaults-subgroup.html","desc":"Nastavení faxového serveru Obecná nastavení","descFull":"Nastavení faxového serveru Obecná nastavení faxu Položky nabídky Obecná nastavení faxu a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Na formát – Určuje příjemce faxu. Chcete-li použít faxové číslo, napište před číslo znak pro číslo (#). Zpáteční adresa – Určuje zpáteční adresu pro odeslání faxu. Předmět – Určuje předmět a sdělení faxu. Zpráva – Zapnout analogový příjem Vypnuto * Zapnuto Nastaví tiskárnu pro příjem analogových faxů. Nastavení faxového serveru pro e-mail Položky nabídky  Nastavení faxového serveru pro e-mail  a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Použít e-mailový server SMTP Zapnuto Vypnuto * Nastavení protokolu SMTP (Simple Mail Transfer Protocol) použijte pro e-mail při příjmu a odesílání faxů. Je-li nastavena možnost  Zapnuto , nezobrazí se všechna ostatní nastavení nabídky  Nastavení faxového serveru pro e-mail . Primární brána SMTP – Zadejte IP adresu nebo název hostitele primárního serveru SMTP. Port primární brány SMTP 1–65535 (25*) Zadá číslo portu primárního serveru SMTP. Sekundární brána SMTP – Zadá IP adresu serveru nebo název hostitele sekundárního nebo záložního serveru SMTP. Port sekundární brány SMTP 1–65535 (25*) Zadá číslo portu serveru sekundárního nebo záložního serveru SMTP. Časový limit pro SMTP 5–30 (30*) Nastaví čas před uplynutím časového limitu tiskárny v případě, že server SMTP nereaguje. Zpáteční adresa – Určuje zpáteční adresu pro odeslání faxu. Použít protokol SSL/TLS Vypnuto * Vyjednávat Požadované Určuje, zda odeslat fax pomocí šifrovaného odkazu. Vyžadovat důvěryhodný certifikát Vypnuto Zapnuto * Určuje důvěryhodný certifikát při přístupu k serveru SMTP. Ověření serveru SMTP Žádné ověření není nutné * Přihlášení/obyčejné NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Nastavuje typ ověření pro přístup k serveru SMTP. E-mail započatý zařízením Žádná * Použít ověřovací soubory SMTP zařízení Určuje, zda jsou pro e‑mail spuštěný ze zařízení vyžadovány ověřovací údaje. E-mail započatý uživatelem Žádná * Použít ověřovací soubory SMTP zařízení Použít uživatelské jméno relace a heslo Použít e-mailovou adresu a heslo relace Vyzvat uživatele Určuje, zda jsou pro e‑mail spuštěný uživatelem vyžadovány ověřovací údaje. Použít ověřovací údaje zařízení Active Directory Vypnuto * Zapnuto Povoluje připojení ověřovacích údajů uživatelů a skupinových cílů k serveru SMTP. ID uživatele zařízení – Určuje ID a heslo uživatele pro připojení k serveru SMTP. Heslo zařízení – SFÉRA Kerberos 5 – Určuje sféru ověřovacího protokolu Kerberos 5. Doména NTLM – Určuje název domény ověřovacího protokolu NTLM. Zakázat chybu „Není nastaven server SMTP“ Vypnuto * Zapnuto Skryje chybovou zprávu „Není nastaven server SMTP“. Nastavení faxového serveru pro skenování Položky nabídky  Nastavení faxového serveru pro skenování  a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Formát obrazu TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Určuje formát souboru naskenovaného obrazu. Typ obsahu Text * Text/Fotografie Foto Grafika Umožňuje vylepšit výsledný výstup podle obsahu originálního dokumentu. Zdroj obsahu Černobílá laserová Barevná laserová * Inkoustová Fotografie/Film Časopis Noviny Tiskovina Jiné Umožňuje vylepšit výsledný výstup podle zdroje originálního dokumentu. Rozlišení faxu Standardní * Vysoká Superjemné Ultrajemné Nastavte rozlišení faxu. Strany Vypnuto * Krátký okraj Dlouhý okraj Určuje orientaci originálního dokumentu při skenování obou stran dokumentu.   Tmavost 1–9 (5*) Upravuje sytost výstupu. Orientace Na výšku * Na šířku Určení orientace textu a grafiky na stránce. Původní velikost [Seznam formátů papíru] Nastavuje formát papíru originálního dokumentu. V USA je výchozím nastavením hodnota  Kombinované formáty . Mezinárodní výchozí tovární nastavení je  A4 . Toto nastavení se může u jednotlivých modelů tiskáren lišit. Použít vícestránkový TIFF Vypnuto Zapnuto * Umožňuje zvolit mezi jednostránkovými a vícestránkovými soubory formátu TIFF. nabídka Nastavení faxového serveru"},{"UUID":"550dd46f-f000-4a71-95a5-3b87d1d2c104","title":"E-mail","link":"email-setup-topic.html","desc":"Nastavení e-mailu  Položky nabídky","descFull":"Nastavení e-mailu  Položky nabídky Nastavení e-mailu a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Primární brána SMTP Nastavení je definováno uživatelem. Zadá IP adresu nebo název hostitele primárního serveru SMTP používaného k posílání e-mailů. Port primární brány SMTP 1–65535 (25*) Zadá číslo portu primárního serveru SMTP. Sekundární brána SMTP Nastavení je definováno uživatelem. Zadá IP adresu serveru nebo název hostitele sekundárního nebo záložního serveru SMTP. Port sekundární brány SMTP 1–65535  (25*) Zadá číslo portu serveru sekundárního nebo záložního serveru SMTP. Časový limit pro SMTP 5–30 sekund  (30*) Nastaví čas před uplynutím časového limitu tiskárny v případě, že server SMTP nereaguje. Zpáteční adresa Nastavení je definováno uživatelem. Určuje adresu pro odpověď v e-mailu. Vždy používat výchozí adresu pro odpověď SMTP Zapnuto Vypnuto * Vždy použije výchozí server pro odpověď v serveru SMTP. Použít protokol SSL/TLS Vypnuto * Vyjednávat Požadované Určuje, zda odeslat e-mail pomocí šifrovaného odkazu. Vyžadovat důvěryhodný certifikát Vypnuto Zapnuto * Vyžaduje důvěryhodný certifikát při přístupu k serveru SMTP. Ověření serveru SMTP Žádné ověření není nutné * Přihlášení/obyčejné NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Nastavuje typ ověření pro přístup k serveru SMTP. E-mail započatý zařízením Žádná * Žádná * Použít ověřovací soubory SMTP zařízení Určuje, zda jsou pro e‑mail spuštěný ze zařízení vyžadovány ověřovací údaje. E-mail započatý uživatelem Žádná * Použít ověřovací soubory SMTP zařízení Použít uživatelské jméno relace a heslo Použít e-mailovou adresu a heslo relace Vyzvat uživatele Určuje, zda jsou pro e‑mail spuštěný uživatelem vyžadovány ověřovací údaje. Použít ověřovací údaje zařízení Active Directory Vypnuto * Zapnuto Určuje, zda jsou pro e‑mail spuštěný uživatelem vyžadovány ověřovací údaje. ID uživatele zařízení Nastavení je definováno uživatelem. Určuje ID a heslo uživatele pro připojení k serveru SMTP. Heslo zařízení Nastavení je definováno uživatelem. SFÉRA Kerberos 5 Nastavení je definováno uživatelem. Určuje sféru ověřovacího protokolu Kerberos 5. Doména NTLM Nastavení je definováno uživatelem. Určuje název domény ověřovacího protokolu NTLM. Zakázat chybu „Není nastaven server SMTP“ Vypnuto * Zapnuto Skryje chybovou zprávu „Není nastaven server SMTP“. nabídka Nastavení e-mailu"},{"UUID":"b991a3fe-01e6-4d20-a013-95e4dc9aeaa3","title":"E-mail","link":"email-setup-topic.html","desc":"Výchozí nastavení e-mailu  Položky","descFull":"Výchozí nastavení e-mailu  Položky nabídky Výchozí nastavení e-mailu a jejich popisy Položka nabídky Položky podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Předmět: – Nastavení je definováno uživatelem. Určuje předmět a sdělení e‑mailu. Zpráva: – Nastavení je definováno uživatelem. Název souboru – Nastavení je definováno uživatelem. Určuje název souboru naskenovaného dokumentu. Formát – JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Určuje formát souboru naskenovaného dokumentu. Tyto položky nabídky se mohou u jednotlivých modelů tiskáren lišit. Globální nastavení OCR Rozpoznávané jazyky [Seznam jazyků] Nakonfiguruje nastavení optického rozpoznávání znaků (OCR). Tato položka nabídky se zobrazí, pouze pokud jste zakoupili a nainstalovali řešení OCR. Aut. otočit Vypnuto * Zapnuto Odstranit skvrny Vypnuto * Zapnuto Aut. zlepšení kontrastu Vypnuto * Zapnuto Nastavení PDF Verze ve formátu PDF 1.3 1.4 1.5 * 1.6 1.7 Nakonfigurujte nastavení formátu PDF naskenovaného obrazu. Položky  Verze archivu  a  Archivní (PDF/A)  jsou podporovány jen v případě, že je možnost  Verze PDF  nastavena na hodnotu 1.4 nebo 1.7. Možnost  Vysoce komprimované  se zobrazí pouze v případě, že je nainstalována paměťová jednotka. Možnost  Zabezpečené  je podporována pouze v případě, že je parametr  Verze PDF  nastaven na hodnotu 1.4 nebo vyšší. Archivní (PDF/A) Vypnuto * Zapnuto Verze archivu A–1a * A–1b A‑2u Vysoce komprimované Vypnuto * Zapnuto Zabezpečené Vypnuto * Zapnuto Prohledávatelné Vypnuto * Zapnuto Rozdělit úlohu podle stránek 0 * Typ obsahu – Text Text/fotografie * Foto Grafika Určuje obsah předlohy. Zdroj obsahu – Černobílá laserová * Barevná laserová Inkoustová Fotografie/Film Časopis Noviny Tiskovina Jiné Určete zdroj původního dokumentu. Barevně – Černobíle Šedá Barevně * Auto Určuje, jak je snímána předloha. Rozlišení – 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Nastavení rozlišení skenovaného obrazu. Tmavost – 1–9  (5*) Nastavení sytosti skenovaného obrazu. Orientace – Na výšku * Na šířku Určuje orientaci originálního dokumentu. Původní velikost – Kombinované formáty Nastavuje formát papíru originálního dokumentu. Strany – Vypnuto * Krátký okraj Dlouhý okraj Určuje orientaci originálního dokumentu při skenování obou stran dokumentu. Rozšířené zobrazování Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Vyvážení barev Azurová Purpurová Žlutá ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) Nastavení intenzity barev pro tyrkysovou, purpurovou a žlutou. Zeslabení barvy Zeslabení barvy Žádná * Červená Zelená Modrá Určuje barvu, jejíž intenzita bude během skenování snížena, a umožňuje nastavit snížení této barvy. Výchozí prahová hodnota červené 0–255  (128*) Výchozí prahová hodnota zelené 0–255  (128*) Výchozí prahová hodnota modré 0–255  (128*) Aut. detekce barev Citlivost barev 1–9  (5*) Konfigurace nastavení automatické detekce barev. Citlivost oblasti 1–9  (5*) Bitová hloubka e-mailu 1 bit * 8 bitů Minimální rozlišení skenování 75 dpi 150 dpi 200 dpi 300 dpi * Kvalita JPEG – Nejlepší pro obsah * 5–95 Nastavení kvality JPEG naskenovaného obrazu. Kontrast – Nejlepší pro obsah * 0–5 Určuje název souboru naskenovaného obrazu. Odstranění pozadí Detekce pozadí Založeno na obsahu * Pevná Úroveň  –4 až 4  (0*) Odstranění barvy pozadí nebo vad tisku z originálního dokumentu. Zrcadlový obraz – Vypnuto * Zapnuto Vytvoří zrcadlový obraz předlohy. Obraz v negativu – Vypnuto * Zapnuto Vytvoří negativní obraz předlohy. Detail stínu – –4 až +4  (0*) Nastavení detailu stínu ve skenovaném obrazu. Skenování od okraje k okraji – Vypnuto * Zapnuto Skenování originálního dokumentu od kraje ke kraji. Ostrost – 1–5  (3*) Nastavení ostrosti naskenovaného obrazu. Teplota – –4 až +4  (0*) Generování modřejšího nebo červenějšího výstupu originálního dokumentu. Prázdné strany Odstranění prázdné stránky Neodebrat * Odebrat Odebere prázdné stránky z originálního dokumentu. Citlivost prázdné stránky 1–9  (5*) Nastavení citlivosti skenování s ohledem na prázdné stránky v originálním dokumentu. Ovl. prvky správy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Maximální velikost e-mailu 0–65535  (0*) Nastaví přípustnou velikost souboru pro jednotlivé e‑maily. Zpráva o chybě velikosti Nastavení je definováno uživatelem. Určuje chybovou zprávu, kterou tiskárna odešle v případě, že e‑mail přesáhne přípustnou velikost souboru. Můžete zadat až 1024 znaků. Omezit cíle Nastavení je definováno uživatelem. Omezí odesílání e‑mailu pouze do názvů domén ze zadaného seznamu. Domény od sebe oddělujte čárkami. Odeslat kopii sobě Nikdy se nezobrazuje * Ve výchozím nastavení zapnuto Ve výchozím nastavení vypnuto Vždy zapnuto Odešle vám kopii e-mailu. Povolit pouze e-maily sobě Vypnuto * Zapnuto Nastavení tiskárny pro odesílání e‑mailů pouze sobě. Použít cc:/bcc: Vypnuto * Zapnuto Povolí kopii a slepou kopii v e‑mailu. Použít vícestránkový TIFF Vypnuto * Zapnuto Povolení skenování několika obrázků TIFF do jednoho souboru TIFF. Komprese TIFF JPEG LZW * Nastavení typu komprese souborů TIFF. Text – výchozí 5–95  (75*) Nastavení kvality textu ve skenovaném obsahu. Text/fotografie – výchozí 5–95  (75*) Nastavení kvality textu a fotografií ve skenovaném obsahu. Fotografie – výchozí 5–95  (50*) Nastavení kvality fotografií ve skenovaném obsahu. Oprava šikmého posunu v podavači ADF Vypnuto * Zapnuto Nastavení tiskárny, aby upravovala křivě naskenované obrazy z dokumentů, které se skenují z automatického podavače dokumentů. Protokol přenosu Tisk protokolu * Netisknout protokol Tisknout jen kvůli chybě Tisk protokolu přenosu pro skeny e-mailů. Zdroj papíru pro protokol Zásobník  [x] (1*) Univerzální podavač Zadejte zdroj papíru pro tisk protokolů. Skenování vlastní úlohy Vypnuto * Zapnuto Nastavení tiskárnu na skenování první sady originálních dokumentů s použitím zadaných nastavení a poté na skenování další sady se stejným nebo odlišným nastavením. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Náhled skenování Vypnuto Zapnuto * Zobrazení náhledu skenování originálního dokumentu. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Povolit zkratku funkce Uložit jako Vypnuto Zapnuto * Uložení e-mailové adresy jako zástupce. E-mail. obr. poslány jako Příloha * Webový odkaz Určení, jak odesílat obrázky, které jsou součástí e‑mailu. Resetovat informace e-mailu po odeslání Vypnuto Zapnuto * Reset polí Komu, Předmět, Zpráva a Název souboru na výchozí hodnoty po odeslání e-mailu. nabídka Výchozí nastavení e-mailu"},{"UUID":"301515e6-63c1-45c7-b206-2fca1fb09780","title":"E-mail","link":"email-setup-topic.html","desc":"Nastavení internetového odkazu Položky nabídky","descFull":"Nastavení internetového odkazu Položky nabídky Nastavení internetového odkazu a jejich popisy Položka nabídky Nastavení Popis Server Nastavení je definováno uživatelem. Zadejte přihlašovací údaje serveru, který je hostitelem snímků obsažených v emailu. Přihlašovací jméno Nastavení je definováno uživatelem. Heslo Nastavení je definováno uživatelem. Cesta Nastavení je definováno uživatelem. Název souboru Nastavení je definováno uživatelem. Webový odkaz Nastavení je definováno uživatelem. nabídka Nastavení internetového odkazu"},{"UUID":"28f817d2-c510-44a3-93e7-6348870d684d","title":"FTP","link":"ftp-defaults-topic.html","desc":"Výchozí nastavení FTP  Položky","descFull":"Výchozí nastavení FTP  Položky nabídky Výchozí nastavení FTP a jejich popisy Položka nabídky Položky podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Formát – JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Určuje formát souboru naskenovaného obrazu. Globální nastavení OCR Rozpoznávané jazyky [Seznam jazyků] Nakonfiguruje nastavení optického rozpoznávání znaků (OCR). Tato nabídka se zobrazí, pouze pokud jste zakoupili a nainstalovali řešení OCR. Aut. otočit Vypnuto * Zapnuto Odstranit skvrny Vypnuto * Zapnuto Aut. zlepšení kontrastu Vypnuto * Zapnuto Nastavení PDF Verze ve formátu PDF 1.3 1.4 1.5 * 1.6 1.7 Nastaví formát souboru PDF naskenovaného dokumentu. Položky  Verze archivu  a  Archivní (PDF/A)  jsou podporovány jen v případě, že je možnost  Verze PDF  nastavena na hodnotu 1.4 nebo 1.7. Možnost  Vysoce komprimované  se zobrazí pouze v případě, že je nainstalována paměťová jednotka. Možnost  Zabezpečené  je podporována pouze v případě, že je parametr  Verze PDF  nastaven na hodnotu 1.4 nebo vyšší. Archivní (PDF/A) Vypnuto * Zapnuto Verze archivu A–1a * A–1b A‑2u Vysoce komprimované Vypnuto * Zapnuto Zabezpečené Vypnuto * Zapnuto Prohledávatelné Vypnuto * Zapnuto Rozdělit úlohu podle stránek 0 * Typ obsahu – Text Text/fotografie * Grafika Foto Umožňuje vylepšit výsledný výstup podle typu obsahu originálního dokumentu. Zdroj obsahu – Černobílá laserová Barevná laserová * Inkoustová Fotografie/Film Časopis Noviny Tiskovina Jiné Umožňuje vylepšit výsledný výstup podle zdroje obsahu originálního dokumentu. Barevně – Černobíle Šedá Barevně * Auto Umožňuje nastavení tiskárny na snímání obsah souboru barevně nebo černobíle. Rozlišení – 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Nastavení rozlišení skenovaného obrazu. Tmavost – 1–9  (5*) Nastavení sytosti skenovaného obrazu. Orientace – Na výšku * Na šířku Určuje orientaci originálního dokumentu. Původní velikost – Kombinované formáty * Nastavuje formát papíru originálního dokumentu. Strany – Vypnuto * Dlouhý okraj Krátký okraj Určuje orientaci při skenování obou stran dokumentu. Název souboru – Nastavení je definováno uživatelem. Určuje název souboru naskenovaného obrazu. Rozšířené zobrazování Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Vyvážení barev Azurová Purpurová Žlutá ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) Nastavení intenzity barev pro tyrkysovou, purpurovou a žlutou. Zeslabení barvy Zeslabení barvy Žádná * Červená Zelená Modrá Určuje barvu, jejíž intenzita bude během skenování snížena, a umožňuje nastavit snížení této barvy. Výchozí prahová hodnota červené 0–255  (128*) Výchozí prahová hodnota zelené 0–255  (128*) Výchozí prahová hodnota modré 0–255  (128*) Aut. detekce barev Citlivost barev 1–9  (5*) Konfigurace nastavení automatické detekce barev. Citlivost oblasti 1–9  (5*) Bitová hloubka e-mailu 1 bit * 8 bitů Minimální rozlišení skenování 75 dpi 150 dpi 200 dpi 300 dpi * Kvalita JPEG – Nejlepší pro obsah * 5–95 Nastavení kvality JPEG naskenovaného obrazu. Kontrast – Nejlepší pro obsah * 0–5 Určuje název souboru naskenovaného obrazu. Odstranění pozadí Detekce pozadí Založeno na obsahu * Pevná Úroveň  –4 až 4  (0*) Odstranění barvy pozadí nebo vad tisku z originálního dokumentu. Zrcadlový obraz – Vypnuto * Zapnuto Vytvoří zrcadlový obraz předlohy. Obraz v negativu – Vypnuto * Zapnuto Vytvoří negativní obraz předlohy. Detail stínu – –4 až +4  (0*) Nastavení detailu stínu ve skenovaném obrazu. Skenování od okraje k okraji – Vypnuto * Zapnuto Skenování originálního dokumentu od kraje ke kraji. Ostrost – 1–5  (3*) Nastavení ostrosti naskenovaného obrazu. Teplota – –4 až +4  (0*) Generování modřejšího nebo červenějšího výstupu originálního dokumentu. Prázdné strany Odstranění prázdné stránky Neodebrat * Odebrat Odebere prázdné stránky z originálního dokumentu. Citlivost prázdné stránky 1–9  (5*) Nastavení citlivosti skenování s ohledem na prázdné stránky v originálním dokumentu. Ovl. prvky správy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Text – výchozí 5–95  (75*) Nastaví kvalitu textu skenovaného obrazu. Text/fotografie – výchozí 5–95  (75*) Nastaví kvalitu textu a fotografie skenovaného obrazu. Fotografie – výchozí 5–95  (50*) Nastaví kvalitu fotografie skenovaného obrazu. Použít vícestránkový TIFF Zapnuto * Vypnuto Povolení skenování několika obrázků TIFF do jednoho souboru TIFF. Komprese TIFF LZW * JPEG Nastavení typu komprese souborů TIFF. Protokol přenosu Tisk protokolu * Netisknout protokol Tisknout jen kvůli chybě Tisk protokolu přenosu pro skeny FTP. Zdroj papíru pro protokol Zásobník  [x] (1*) Univerzální podavač Určuje zdroj papíru pro tisk protokolů FTP. Skenování vlastní úlohy Vypnuto * Zapnuto Nastavení tiskárnu na skenování první sady originálních dokumentů s použitím zadaných nastavení a poté na skenování další sady se stejným nebo odlišným nastavením. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Náhled skenování Vypnuto Zapnuto * Tato položka nabídky se zobrazí pouze v případě, že je nainstalován pevný disk. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Povolit zkratku funkce Uložit jako Vypnuto Zapnuto * Uložení adresy FTP jako zástupce. nabídka Výchozí nastavení FTP"},{"UUID":"d25cf90e-e003-4cd9-a9e9-d4100236407e","title":"Jednotka USB","link":"flash-drive-scan-topic.html","desc":"Skenování na jednotku paměti flash","descFull":"Skenování na jednotku paměti flash Položky nabídky Skenování na jednotku paměti flash a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Formát – JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) * DOCX (.doc) XLSX (.xlsx) CSV (.csv) Určuje formát souboru naskenovaného obrazu. Soubory  TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx) a  CSV (.csv)  se zobrazí pouze v případě, že jste zakoupili a nainstalovali řešení pro optické rozpoznávání znaků (OCR). Globální nastavení OCR Rozpoznávané jazyky [Seznam jazyků] Nakonfigurujte nastavení pro OCR. Tato nabídka se zobrazí, pouze pokud jste zakoupili a nainstalovali řešení OCR. Aut. otočit Vypnuto * Zapnuto Odstranit skvrny Vypnuto * Zapnuto Aut. zlepšení kontrastu Vypnuto * Zapnuto Nastavení PDF Verze ve formátu PDF 1.3 1.4 1.5 * 1.6 1.7 Nakonfigurujte nastavení formátu PDF naskenovaného obrazu. Položky  Archivní (PDF/A)  a  Verze archivu  jsou podporovány jen v případě, že je možnost  Verze PDF  nastavena na hodnotu 1.4 nebo 1.7. Vysoce komprimované  – zobrazí se pouze v případě, že je nainstalován pevný disk. Zabezpečené  – je podporováno pouze v případě, že je parametr  Verze PDF  nastaven na hodnotu 1.4 nebo vyšší. Archivní (PDF/A) Vypnuto * Zapnuto Verze archivu A–1a * A–1b A‑2u Vysoce komprimované Vypnuto * Zapnuto Zabezpečené Vypnuto * Zapnuto Prohledávatelné Vypnuto * Zapnuto Typ obsahu – Text Text/fotografie * Foto Grafika Umožňuje vylepšit výsledný výstup podle typu obsahu originálního dokumentu. Zdroj obsahu – Černobílá laserová Barevná laserová * Inkoustová Fotografie/Film Časopis Noviny Tiskovina Jiné Umožňuje vylepšit výsledný výstup podle zdroje obsahu originálního dokumentu. Barevně – Černobíle Šedá Barevně * Auto Umožňuje nastavení tiskárny na snímání obsah souboru barevně nebo černobíle. Rozlišení – 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Nastavení rozlišení skenovaného obrazu. Tmavost – 1–9  (5*) Nastavení sytosti skenovaného obrazu. Orientace – Na výšku * Na šířku Určuje orientaci originálního dokumentu. Původní velikost – Kombinované formáty * Nastavuje formát papíru originálního dokumentu. Strany – Vypnuto * Krátký okraj Dlouhý okraj Určuje orientaci originálního dokumentu při skenování obou stran dokumentu. Název souboru – Nastavení je definováno uživatelem. Určuje název souboru naskenovaného obrazu. Rozšířené zobrazování Vyvážení barev Azurová  (0*) Purpurová  (0*) Žlutá  (0*) Nastavení intenzity barev pro tyrkysovou, purpurovou a žlutou. Zeslabení barvy Zeslabení barvy  ( Žádné *) Výchozí prahová hodnota červené  (128*) Výchozí prahová hodnota zelené  (128*) Výchozí prahová hodnota modré  (128*) Určuje barvu, jejíž intenzita bude během skenování snížena, a umožňuje nastavit snížení této barvy. Aut. detekce barev Citlivost barev  (5*) Citlivost oblasti  (5*) Bitová hloubka skenování  (1 bit*) Minimální rozlišení skenování  (300 dpi*) Konfigurace nastavení automatické detekce barev. Kvalita JPEG Nejlepší pro obsah * 5–95 Nastavení kvality JPEG naskenovaného obrazu. Kontrast Nejlepší pro obsah * 0–5 Určuje název souboru naskenovaného obrazu. Odstranění pozadí Detekce pozadí  ( Založeno na obsahu *) Úroveň  (0*) Odstranění barvy pozadí nebo vad tisku z originálního dokumentu. Zrcadlový obraz Vypnuto * Zapnuto Vytvoří zrcadlový obraz předlohy. Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Rozšířené zobrazování Obraz v negativu Vypnuto * Zapnuto Vytvoří negativní obraz předlohy. Detail stínu –4 až +4  (0*) Nastavení detailu stínu ve skenovaném obrazu. Skenování od okraje k okraji Vypnuto * Zapnuto Skenování originálního dokumentu od kraje ke kraji. Ostrost 1–5  (3*) Nastavení ostrosti naskenovaného obrazu. Teplota –4 až +4  (0*) Generování modřejšího nebo červenějšího výstupu originálního dokumentu. Prázdné strany Odstranění prázdné stránky  ( Neodstraňovat *) Citlivost prázdné stránky  (5*) Nastavení citlivosti skenování s ohledem na prázdné stránky v originálním dokumentu. Ovl. prvky správy Text – výchozí 5–95  (75*) Nastaví kvalitu textu skenovaného obrazu. Text/fotografie – výchozí 5–95  (75*) Nastaví kvalitu textu a fotografie skenovaného obrazu. Fotografie – výchozí 5–95  (50*) Nastaví kvalitu fotografie skenovaného obrazu. Použít vícestránkový TIFF Vypnuto Zapnuto * Povolení skenování několika obrázků TIFF do jednoho souboru TIFF. Komprese TIFF JPEG LZW * Nastavení typu komprese souborů TIFF. Skenování vlastní úlohy Vypnuto * Zapnuto Nastavení tiskárnu na skenování první sady originálních dokumentů s použitím zadaných nastavení a poté na skenování další sady se stejným nebo odlišným nastavením. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Náhled skenování Vypnuto * Zapnuto Zobrazení náhledu skenování originálního dokumentu. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Oprava šikmého posunu v podavači ADF Vypnuto Zapnuto * Nastavení tiskárny, aby upravovala křivě naskenované obrazy z dokumentů, které se skenují z automatického podavače dokumentů. nabídka Skenování na jednotku paměti flash"},{"UUID":"966dad37-a40b-4d51-8978-a442253d7dd4","title":"Jednotka USB","link":"flash-drive-scan-topic.html","desc":"Tisk z jednotky paměti flash Položky","descFull":"Tisk z jednotky paměti flash Položky nabídky Tisk z jednotky paměti flash a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Počet kopií 1–9999  (1*) Určuje počet kopií v tiskové úloze. Zdroj papíru Zásobník  [x] (1*) Univerzální podavač Papír ručně Obálka ručně Nastaví výchozí zdroj papíru pro tiskovou úlohu. Barevně Vypnuto Zapnuto * Vytiskne jednotku paměti flash barevně. Skládání kopií Vypnuto [1,1,1,2,2,2] Zapnuto [1,2,1,2,1,2] * Skládá stránky tiskové úlohy v pořadí, především při tisku více kopií. Strany Jednostranný tisk * Oboustranný tisk Určuje, zda tisknout na jednu stranu nebo na obě strany papíru. Sešívání Vypnuto * 1 svorka, levý horní roh 2 svorky, nalevo 1 svorka, pravý horní roh 2 svorky, nahoře 1 svorka, levý dolní roh 2 svorky, dole 1 svorka, pravý dolní roh 2 svorky, napravo Určuje polohu svorky pro všechny tiskové úlohy. Tato položka nabídky se zobrazí jen v případě, že je instalován sešívací finišer. Děrování Vypnuto * 2 otvory 3 otvory 4 otvory Nastaví režim děrování pro všechny tiskové úlohy. Tato položka nabídky se zobrazí jen v případě, že je instalován podporovaná sešívačka a děrovačka nebo dokončovací schránka – vazač knih. Posunout listy Žádná * Mezi kopiemi Mezi úlohami Posune výstup jednotlivých tiskových úloh nebo jednotlivých kopií tiskové úlohy. Mezi kopiemi  – zajistí posunutí každé kopie tiskové úlohy, pokud je položka  Skládání  nastavena na hodnotu  Zapnuto [1,2,1,2,1,2] . Je-li funkce  Skládání  nastavena na hodnotu  Vypnuto [1,1,1,2,2,2] , vytisknou se pohromadě jednotlivé stránky, například všechny stránky označené jako 1 a všechny stránky označené jako 2. Mezi úlohy  – celá tisková úloha se posune stejně bez ohledu na počet vytištěných kopií. Styl otočení Dlouhý okraj * Krátký okraj Určuje, která strana papíru je při oboustranném tisku svázána. Počet stránek na stránku Vypnuto * 2 stránky na stranu 3 stránky na stranu 4 stránky na stranu 6 stránek na stranu 9 stránek na stranu 12 stránek na stranu 16 stránek na stranu Na jednu stranu listu papíru se vytisknou obrazy více stránek. Více str. na stranu – řazení Horizontální * Opačné horizontální Opačné vertikální Vertikální Určuje polohu obrázků na více stránek při použití nastavení  Více stránek na stranu . Více str. na stranu – orientace Auto * Na šířku Na výšku Určuje orientaci obrázků na více stránek při použití nastavení  Více stránek na stranu . Více str. na str. – okraj Žádná * Pevný Při použití nastavení  Více stránek na stranu  vytiskne rámeček okolo každého obrázku na stránce. Oddělovací listy Vypnuto * Mezi kopiemi Mezi úlohami Mezi listy Při tisku vkládá prázdné oddělovací listy. Zdroj oddělovacích listů Zásobník  [x] (1*) Univerzální podavač Zadejte zdroj papíru pro oddělovací list. Prázdné strany Netisknout * Tisk Při tiskové úloze tiskne prázdné stránky. nabídka Tisk z jednotky paměti flash"},{"UUID":"da88c5e1-d360-4732-9b04-c91c9991b35f","title":"Síť/Porty","link":"network-overview-topic.html","desc":"Přehled sítí Položky nabídky Přehled","descFull":"Přehled sítí Položky nabídky Přehled sítí a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Aktivní adaptér Auto * Standardní síť Bezdrátové Zadat typ síťového připojení. Nabídka  Bezdrátové  je k dispozici jen u tiskáren připojených k bezdrátové síti. Stav sítě Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazit stav připojení sítě tiskárny. Zobrazení stavu sítě na tiskárně Vypnuto Zapnuto * Zobrazit stav sítě na displeji. Rychlost, oboustranný tisk Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazit rychlost aktuálně aktivní síťové karty. IPv4 Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazit adresu IPv4. Všechny adresy IPv6 Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazit všechny adresy IPv6. Resetovat tiskový server Start Resetuje všechna aktivní síťová připojení k tiskárně. Tímto nastavením se odeberou veškerá nastavení síťové konfigurace. Čas. limit síťové úlohy Vypnuto Zapnuto * (90 sekund) Nastaví dobu, po které tiskárna zruší síťovou tiskovou úlohu. Hlavičková stránka Vypnuto Zapnuto * Vytiskne hlavičkovou stránku. Skenovat do rozsahu portů počítače Nastavení je definováno uživatelem. Určuje platný rozsah portů pro tiskárny za branou firewall blokující porty. Povolit síťové připojení Vypnuto Zapnuto * Povolit připojení tiskárny k síti. Povolit LLDP Vypnuto * Zapnuto Zobrazit stav sítě na domovské obrazovce. nabídka Přehled sítí"},{"UUID":"6ecc6125-cda4-4599-b624-98dfac859d49","title":"Síť/Porty","link":"network-overview-topic.html","desc":"Bezdrátové Tato nabídka je k dispozici","descFull":"Bezdrátové Tato nabídka je k dispozici pouze u tiskáren připojených k síti Wi-Fi nebo u modelů tiskáren, které mají bezdrátový síťový adaptér.  Položky nabídky Bezdrátová a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Nastavit na panelu tiskárny Zvolit síť [seznam dostupných bezdrátových sítí] Určuje bezdrátovou síť, ke které se tiskárna připojuje. Přidat síť Wi-Fi Název sítě Režim sítě  ( Infrastruktura *) Režim zabezpečení bezdrátové sítě  ( Zakázáno *) Ručně zadejte název a typ sítě. Wi‑Fi Protected Setup – Spustit metodu pomocí tlačítka Metoda spuštění kódem PIN Nastaví síť Wi-Fi a zapne zabezpečení sítě. Metoda připojení tlačítkem  připojí tiskárnu k síti Wi-Fi stisknutím tlačítka na tiskárně a na přístupovém bodu (bezdrátovém směrovači) v daném čase. Metoda připojení kódem PIN  připojí tiskárnu k síti Wi-Fi zadáním kódu PIN na tiskárně a do nastavení bezdrátové sítě v přístupovém bodu. Síťový režim – Typ BSS Infrastruktura * Určuje režim sítě. Kompatibilita – 802.11b/g/n (2,4 GHz) * 802.11a/b/g/n/ac (2,4 GHz / 5 GHz) 802.11a/n/ac (5 GHz) Určuje standard pro síť Wi-Fi. Položky  802.11a/b/g/n/ac (2,4 GHz / 5 GHz)  a  802.11a/n/ac (5 GHz)  se zobrazí, pouze když je nainstalována možnost Wi-Fi. Režim zabezpečení bezdrátové sítě – Vypnuto * WPA2/WPA – Personal WPA2-Personal WPA3/WPA – Personal WPA3-Personal 802.1x – RADIUS Nastavte režim zabezpečení pro připojení tiskárny k síti Wi-Fi. WPA2/WPA Personal – AES Povolit zabezpečení sítě Wi-Fi prostřednictvím chráněného přístupu k síti Wi-Fi (WPA). Tato položka nabídky se zobrazí pouze tehdy, když bude možnost  Režim zabezpečení bezdrátové sítě  nastavena na hodnotu  WPA2/WPA-Osobní . Nastavit PSK – Nastavení je definováno uživatelem. Nastavit heslo pro zabezpečené připojení k síti Wi-Fi. WPA2-Personal – AES Povolení zabezpečení sítě Wi-Fi prostřednictvím WPA2. Tato položka nabídky se zobrazí pouze tehdy, když bude možnost  Režim zabezpečení bezdrátové sítě  nastavena na hodnotu  WPA2-Osobní . Režim šifrování 802.1x – WPA+ WPA2 * Povolit zabezpečení sítě Wi-Fi prostřednictvím standardu 802.1x. Tato položka nabídky se zobrazí pouze tehdy, když bude možnost  Režim zabezpečení bezdrátové sítě  nastavena na hodnotu  802.1x – RADIUS . Položku  802.1x – RADIUS  lze nakonfigurovat pouze z prostředí serveru Embedded Web Server. IPv4 Povolit DHCP Zapnuto * Vypnuto Povolení a konfigurace nastavení IPv4 na tiskárně. Nastavit statickou IP adresu IP adresa Síťová maska Brána IPv6 Povolit IPv6 Zapnuto * Vypnuto Povolení a konfigurace nastavení IPv6 na tiskárně. Povolit DHCPv6 Zapnuto Vypnuto * Bezstavová autokonfigurace adres Zapnuto * Vypnuto Adresa serveru DNS Nastavení je definováno uživatelem. Ručně přiřazená adresa IPv6 Nastavení je definováno uživatelem. Ručně přiřazený směrovač IPv6 Nastavení je definováno uživatelem. Předpona adresy Nastavení je definováno uživatelem. Všechny adresy IPv6 Nastavení je definováno uživatelem. Všechny adresy směrovače v síti IPv6 Nastavení je definováno uživatelem. Síťová adresa – UAA LAA Zobrazí síťové adresy. PCL SmartSwitch – Vypnuto Zapnuto * Nastavit tiskárnu tak, aby se přepínala na emulaci PCL pokaždé, když to bude vyžadovat tisková úloha, bez ohledu na výchozí jazyk tiskárny. Pokud je parametr  PCL SmartSwitch  nastaven na hodnotu  Vypnuto , tiskárna neprověřuje příchozí data a použije výchozí jazyk tiskárny zadaný v nabídce  Nastavení . PS SmartSwitch – Vypnuto Zapnuto * Nastavit tiskárnu tak, aby se přepínala na emulaci PS pokaždé, když to bude vyžadovat tisková úloha, bez ohledu na výchozí jazyk tiskárny. Pokud je parametr  PS SmartSwitch  nastaven na hodnotu  Vypnuto , tiskárna neprověřuje příchozí data a použije výchozí jazyk tiskárny zadaný v nabídce  Nastavení . Ukládání úloh do vyrovnávací paměti – Zapnuto Vypnuto * Před tiskem dočasně uložte tiskové úlohy na paměťovou jednotku. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Binární PostScript Mac – Auto * Zapnuto Vypnuto Nastavte tiskárnu ke zpracování binárních tiskových úloh Macintosh s emulací jazyka PostScript. Nastavení  Zapnuto  zpracovává tiskové úlohy v základním binárním jazyku emulace PostScript. Nastavení  Vypnuto  filtruje tiskové úlohy používající standardní protokol. nabídka Bezdrátové"},{"UUID":"a3f5542c-2a65-4cce-bbce-2453bc410bb7","title":"Síť/Porty","link":"network-overview-topic.html","desc":"Wi‑Fi Direct Položky nabídky Wi‑Fi","descFull":"Wi‑Fi Direct Položky nabídky Wi‑Fi Direct a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Povolit Wi-Fi Direct Zapnuto Vypnuto * Nastavit tiskárnu tak, aby se připojovala přímo k Wi-Fi zařízením. Název sítě Wi-Fi Direct Nastavení je definováno uživatelem. Určuje název sítě Wi-Fi Direct. Heslo pro Wi-Fi Direct Nastavení je definováno uživatelem. Nastavení hesla k ověření a validaci uživatelů Wi-Fi připojení. Zobrazit heslo na stránce Nastavení Vypnuto Zapnuto * Zobrazí  Heslo pro Wi‑Fi Direct  na  stránce Nastavení sítě . Číslo preferovaného kanálu 1–11 Auto * Nastavte preferovaný kanál sítě Wi-Fi. Adresa IP vlastníka skupiny Nastavení je definováno uživatelem. Určuje IP adresu vlastníka skupiny. Automaticky přijímat žádosti tlačítka Vypnuto * Zapnuto Automaticky přijímá požadavky na připojení k síti. Automatické přijímání klientů není zabezpečeno. nabídka Wi‑Fi Direct"},{"UUID":"33552de4-da90-4cd0-ae8e-032e54090b13","title":"Síť/Porty","link":"network-overview-topic.html","desc":"Správa mobilních služeb Položky nabídky","descFull":"Správa mobilních služeb Položky nabídky Správa mobilních služeb a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Povolit tisk IPP Zapnuto * Vypnuto Povolte síťové tiskárně tisk úloh pomocí protokolu IPP (Internet Printing Protocol). Povolit faxování IPP. Zapnuto * Vypnuto Povolte tiskárně USB odesílat faxové úlohy pomocí protokolu IPP. Povolit IPP přes USB Zapnuto * Vypnuto Povolte tiskárně USB odesílat tiskové úlohy pomocí protokolu IPP. Protokol IPP je obvykle určen pro síťové tiskárny. Povolit skenování Zapnuto * Vypnuto Povolte síťové tiskárně tisk úloh pomocí protokolu eSCL. Povolit vyhledávání Mopria Zapnuto * Vypnuto Povolte mobilním zařízením vyhledat tiskárnu s certifikací Mopria™. nabídka Správa mobilních služeb"},{"UUID":"f0920ed9-07de-4bed-9471-6a3cfe0ceb05","title":"Síť/Porty","link":"network-overview-topic.html","desc":"Ethernet Položky nabídky Síť Ethernet","descFull":"Ethernet Položky nabídky Síť Ethernet a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Rychlost sítě – Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazí rychlost aktivního síťového adaptéru. IPv4 Povolit DHCP Zapnuto * Vypnuto Konfiguruje nastavení IPv4. Nastavení jsou definována uživatelem. Nastavit statickou IP adresu IP adresa Síťová maska Brána IPv6 Povolit IPv6 Zapnuto * Vypnuto Konfiguruje nastavení IPv6. Povolit DHCPv6 Vypnuto * Zapnuto Bezstavová autokonfigurace adres Zapnuto * Vypnuto Adresa serveru DNS Nastavení je definováno uživatelem. Ručně přiřazená adresa IPv6 Nastavení je definováno uživatelem. Ručně přiřazený směrovač IPv6 Nastavení je definováno uživatelem. Předpona adresy (64*) 0–128  (64*) Všechny adresy IPv6 Nastavení je údaj, který je k dispozici jen pro čtení. Všechny adresy směrovače v síti IPv6 Nastavení je údaj, který je k dispozici jen pro čtení. Síťová adresa – UAA LAA Určuje adresu sítě. PCL SmartSwitch – Vypnuto Zapnuto * Nastavit tiskárnu tak, aby se přepínala na emulaci PCL pokaždé, když to bude vyžadovat tisková úloha, bez ohledu na výchozí jazyk tiskárny. Pokud je toto nastavení zakázáno, tiskárna neprověřuje příchozí data a použije výchozí jazyk tiskárny zadaný v nabídce  Nastavení . PS SmartSwitch – Vypnuto Zapnuto * Nastavit tiskárnu tak, aby se přepínala na emulaci PostScript pokaždé, když to bude vyžadovat tisková úloha, bez ohledu na výchozí jazyk tiskárny. Pokud je toto nastavení zakázáno, tiskárna neprověřuje příchozí data a použije výchozí jazyk tiskárny zadaný v nabídce  Nastavení . Ukládání úloh do vyrovnávací paměti – Vypnuto * Zapnuto Před tiskem dočasně uložte úlohy na paměťovou jednotku. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Binární PostScript Mac – Auto * Vypnuto Zapnuto Nastavte tiskárnu ke zpracování binárních tiskových úloh Macintosh s emulací jazyka PostScript. Automaticky  zpracovává tiskové úlohy z počítačů používajících operační systém Windows nebo Macintosh. Možnost  Vypnuto  filtruje tiskové úlohy využívající emulaci jazyka PostScript pomocí standardního protokolu. Energeticky úsporná síť Ethernet – Zapnuto Vypnuto Auto * Sníží spotřebu energie, pokud tiskárna nepřijímá žádná data ze sítě Ethernet. nabídka Ethernet"},{"UUID":"9f29dad0-8001-479d-96d9-8156de303e2a","title":"Síť/Porty","link":"network-overview-topic.html","desc":"TCP/IP Tato nabídka se zobrazuje","descFull":"TCP/IP Tato nabídka se zobrazuje pouze u síťových tiskáren nebo tiskáren připojených k tiskovým serverům. Položky nabídky TCP/IP a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Nastavit název hostitele Nastavení je definováno uživatelem. Nastavení aktuálního názvu hostitele protokolu TCP/IP Název domény Nastavení je definováno uživatelem. Nastavuje název domény. Umožňuje serveru DHCP/BOOTP aktualizovat server NTP Zapnuto * Vypnuto Povolte klientům protokolu DHCP (Dynamic Host Configuration Protocol) a protokolu BOOTP (BOOTstrap Protocol) aktualizovat nastavení NTP tiskárny. Název Nulové konfigurace Nastavení je definováno uživatelem. Určuje název služby pro síť nulové konfigurace. Povolit Auto IP Vypnuto Zapnuto * Přiřadí IP adresu automaticky. Adresa serveru DNS Nastavení je definováno uživatelem. Určuje aktuální adresu serveru DNS (Domain Name System). Záloha adresy serveru DNS Nastavení je definováno uživatelem. Určuje zálohové adresy serveru DNS. Záloha 2. adresy DNS serveru Záloha 3. adresy DNS serveru Pořadí hledání domény Nastavení je definováno uživatelem. Určuje seznam názvů domén, které slouží k vyhledání tiskárny a jejích zdrojů nacházejících se na různých místech v síti. Povolit DDNS Vypnuto * Zapnuto Aktualizuje dynamická nastavení serveru DNS. DDNS TTL Nastavení je definováno uživatelem. Určuje aktuální nastavení serveru DDNS. Výchozí hodnoty TTL Čas aktualizace DDNS Povolit mDNS Vypnuto Zapnuto * Aktualizuje vícesměrová nastavení serveru DNS. Adresa WINS serveru Nastavení je definováno uživatelem. Určuje adresu serveru pro službu WINS (Windows Internet Name Service). Povolit BOOTP Vypnuto * Zapnuto Umožňuje BOOTP přiřadit tiskárně IP adresu. Seznam omez. serverů Nastavení je definováno uživatelem. Určuje adresy IP, které mají povoleno komunikovat s tiskárnou přes TCP/IP. IP adresy od sebe oddělujte čárkami. Můžete přidat až 50 IP adres. Možnosti omez. seznamu serverů Blokovat všechny porty * Blokovat pouze tisk Blokovat pouze tisk a HTTP Určuje možnost přístupu pro adresy IP, které nejsou v seznamu. MTU 256–1500 Ethernet  (1500*) Určuje parametr maximální přenosové jednotky (MTU) pro připojení TCP. Port pro tisk typu Raw 1–65535  (9100*) Určuje číslo portu typu Raw pro tiskárny zapojené do sítě. Maximální rychlost odchozí komunikace Vypnuto * Zapnuto Nastavuje maximální přenosovou rychlost tiskárny. Pokud je volba povolena, hodnota pro toto nastavení je 100 – 1 000 000 kilobitů/sekundu. Podpora protokolu TLS Zapnout TLSv1.0  ( Vypnuto *) Zapnout TLSv1.1  ( Vypnuto *) Zapnout TLSv1.2  ( Zapnuto *) Povolí protokol Transport Layer Security. Seznam šifer SSL Nastavení je definováno uživatelem. Specifikuje použitelné šifrovací algoritmy pro připojení SSL nebo TLS. Seznam šifer TLSv1.3 SSL nabídka TCP/IP"},{"UUID":"481d1590-92b7-4332-b3a0-51f87edcbd8b","title":"Síť/Porty","link":"network-overview-topic.html","desc":"SNMP Tato nabídka se zobrazuje","descFull":"SNMP Tato nabídka se zobrazuje pouze u síťových tiskáren nebo tiskáren připojených k tiskovým serverům. Položky nabídky SNMP a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Verze SNMP 1 a 2c Zapnuto Vypnuto Zapnuto * Slouží ke konfiguraci protokolů SNMP (Simple Network Management Protocol) verze 1 a 2c, které se používají k instalaci tiskových ovladačů a aplikací. Povolit nastavení SNMP Vypnuto Zapnuto * Zapnout PPM MIB Vypnuto Zapnuto * Komunita SNMP Nastavení je definováno uživatelem. SNMP verze 3 Zapnuto Vypnuto Zapnuto * Slouží k povolení protokolu SNMP verze 3, který se používá k instalaci aktualizaci zabezpečení tiskárny. Název kontextu Nastavení je definováno uživatelem. Zadejte kontextový název. Nast. ověř. úd. pro čtení/zápis Uživatelské jméno Heslo pro ověření Heslo pro ochranu osobních údajů Zadejte přihlašovací údaje pro čtení a zápis pro protokol SNMP verze 3. Nast. ověř. úd. jen pro čtení Uživatelské jméno Heslo pro ověření Heslo pro ochranu osobních údajů Zadejte přihlašovací údaje pouze pro čtení pro protokol SNMP verze 3. Hash ověření MD5 SHA1 * Nastavte příslušnou hodnotu hash ověření. Minimální úroveň ověření Bez ověření, bez ochrany osobních údajů Ověření, bez ochrany osobních údajů Ověření, ochrana osobních údajů * Nastavte příslušnou minimální úroveň ověřování. Algoritmus ochrany osobních údajů DES AES‑128 * Nastavte příslušný algoritmus ochrany osobních údajů. nabídka SNMP"},{"UUID":"e26c563b-b032-4043-8400-958e64d6c137","title":"Síť/Porty","link":"network-overview-topic.html","desc":"IPSec Tato nabídka se zobrazuje","descFull":"IPSec Tato nabídka se zobrazuje pouze u síťových tiskáren nebo tiskáren připojených k tiskovým serverům. Položky nabídky IPSec a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Povolit IPSec Vypnuto * Zapnuto Povolí protokol IPSec (Internet Protocol Security). Základní konfigurace Výchozí nastavení * Kompatibilita Zabezpečené Nastaví základní konfiguraci IPSec. Tato položka nabídky se zobrazí pouze tehdy, když bude možnost  Povolit IPSec  nastavena na hodnotu  Zapnuto . Návrh skupiny DH (Diffie‑Hellman) modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Nastaví základní konfiguraci IPSec. Tato položka nabídky je k dispozici pouze tehdy, pokud je možnost  Základní konfigurace  nastavena na hodnotu  Kompatibilita . Navrhovaná metoda šifrování 3DES AES * Nastavuje metodu šifrování. Tato položka nabídky je k dispozici pouze tehdy, pokud je možnost  Základní konfigurace  nastavena na hodnotu  Kompatibilita . Navrhovaná metoda ověřování SHA1 SHA256 * SHA512 Nastavuje metodu ověřování. Tato položka nabídky je k dispozici pouze tehdy, pokud je možnost  Základní konfigurace  nastavena na hodnotu  Kompatibilita . Životnost přidružení zabezpečení pro výměnu klíčů po internetu (hodiny) 1 2 4 8 24 * Zadejte dobu platnosti Životnosti přidružení zabezpečení pro výměnu klíčů po internetu. Tato položka nabídky je k dispozici pouze tehdy, pokud je možnost  Základní konfigurace  nastavena na hodnotu  Zabezpečeno . Životnost protokolu IPSec SA (hodiny) 1 2 4 8 24 * Zadejte dobu platnosti Životnosti protokolu IPSec SA. Tato položka nabídky je k dispozici pouze tehdy, pokud je možnost  Základní konfigurace  nastavena na hodnotu  Zabezpečeno . Certifikát zařízení IPSec Výchozí nastavení * Určuje certifikát IPSec. Tato položka nabídky se zobrazí pouze tehdy, když bude možnost  Povolit IPSec  nastavena na hodnotu  Zapnuto . Připojení ověřovaná předsdíleným klíčem Hostitel  [x] Slouží ke konfiguraci ověřovaných připojení tiskárny. Tyto položky nabídky se zobrazují pouze tehdy, když je možnost  Povolit IPSec  nastavena na hodnotu  Zapnuto . Připojení ověřovaná certifikátem Adresa hostitele  [x]  [/podsíť] nabídka IPSec"},{"UUID":"81b7e8ba-108d-4b00-9cc1-2a9d2a43bfdb","title":"Síť/Porty","link":"network-overview-topic.html","desc":"802.1x 802.1x Tato nabídka se","descFull":"802.1x 802.1x Tato nabídka se zobrazuje pouze u síťových tiskáren nebo tiskáren připojených k tiskovým serverům. Položky nabídky 802.1x a jejich popisy Položka nabídky Položky podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Aktivní – Vypnuto * Zapnuto Umožní tiskárnu připojit k sítím, které před udělením přístupu vyžadují ověření. Ověření 802.1x Přihlašovací název zařízení Nastavení je definováno uživatelem. Zadejte jedinečné přihlašovací jméno. Přihlašovací heslo k zařízení Nastavení je definováno uživatelem. Určete jedinečné heslo. Ověřit certifikát serveru Zapnuto * Vypnuto Po zapnutí této možnosti bude vyžadováno ověření certifikátu zabezpečení na ověřovacím serveru. Zapnout protokolování událostí Zapnuto Vypnuto * Zapněte v tiskárně záznam protokolů připojení. Certifikát zařízení 802.1x Výchozí nastavení * Vyberte digitální certifikát, který chcete použít. Pokud je nainstalován pouze jeden certifikát, zobrazí se pouze možnost  výchozí . Ověřovací mechanismus EAP – MD5 Zapnuto * Vypnuto Povolte prostředí MD5 protokolu EAP (Extensible Authentication Protocol). EAP – MSCHAPv2 Zapnuto * Vypnuto Povolte metodu ověřování EAP MSCHAP (Microsoft Challenge Handshake Authentication Protocol) verze 2. LEAP Zapnuto * Vypnuto Povolte protokol LEAP (Lightweight Extensible Authentication Protocol), upravenou verzi protokolu MSCHAP. PEAP Zapnuto * Vypnuto Povolte protokol PEAP (Protected Extensible Authentication Protocol), tedy metodu, která poskytuje bezpečnější ověřování pro sítě WLAN 802.11. Protokol PEAP podporuje řízení přístupu k portům 802.1x. EAP – TLS Zapnuto * Vypnuto Povolte protokol EAP TLS (Transport Layer Security), ve kterém klient a server provádí vzájemní ověření pomocí digitálních certifikátů. EAP – TTLS Zapnuto * Vypnuto Povolte protokol TLS (Transport Layer Security) s tunelovým připojením EAP, což je protokol podobný protokolu EAP_TLS s tím rozdílem, že certifikát má pouze server, kterým se nejprve ověřuje u klienta. Metoda ověření TTLS CHAP MSCHAP MSCHAPv2 * PAP Vyberte, která metoda EAP TTLS se má v zařízení použít. nabídka 802.1x"},{"UUID":"6cf268af-ce42-45ac-86a0-c15f4cd890dc","title":"Síť/Porty","link":"network-overview-topic.html","desc":"Konfigurace LPD Tato nabídka se","descFull":"Konfigurace LPD Tato nabídka se zobrazuje pouze u síťových tiskáren nebo tiskáren připojených k tiskovým serverům. Položky nabídky Konfigurace LPD a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Časový limit pro LPD 0–65535 sekund  (90*) Nastaví hodnotu časového limitu, který serveru LPD (Line Printer Daemon) zabrání v nekonečném čekání na pozastavené nebo neplatné tiskové úlohy. Stránka se záhlavím LPD Vypnuto * Zapnuto Vytiskne stránku se záhlavím pro všechny tiskové úlohy LPD. Stránka se záhlavím je první stránka tiskové úlohy, která slouží jako oddělovač tiskových úloh a slouží také k identifikaci původce požadavku na tiskovou úlohu. Koncová stránka LPD Vypnuto * Zapnuto Vytiskne koncovou stránku pro všechny tiskové úlohy LPD. Koncová stránka je poslední stránka tiskové úlohy. Konverze znaku pro konec řádku pro LPD Vypnuto * Zapnuto Povolí konverze znaku pro konec řádku. Znak pro konec řádku je mechanismus, který tiskárně přikazuje přesunout pozici kurzoru na první pozici stejného řádku. nabídka Konfigurace LPD"},{"UUID":"96f94217-d756-473d-9f02-1b5957f5dabc","title":"Síť/Porty","link":"network-overview-topic.html","desc":"Nastavení HTTP/FTP Položky nabídky Nastavení","descFull":"Nastavení HTTP/FTP Položky nabídky Nastavení HTTP/FTP a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Proxy IP adresa HTPP Proxy Nastavení je definováno uživatelem. Nakonfigurujte nastavení serveru HTTP. Výchozí IP portu HTTP Nastavení je definováno uživatelem. Nakonfigurujte výchozí IP adresu portu pro protokol HTTP. Výchozí port pro protokol HTTP nastavený z výroby je 80. IP adresa proxy serveru FTP Nastavení je definováno uživatelem. Nakonfigurujte nastavení formátu FTP. Výchozí IP portu FTP Nastavení je definováno uživatelem. Nakonfigurujte výchozí IP adresu portu pro protokol FTP. Výchozí port pro protokol HTTP nastavený z výroby je 21. Ověření Žádná Auto * Základní Shrnutí NTLM Zadejte ověřovací údaje. Uživatelské jméno Nastavení je definováno uživatelem. Určete jedinečné uživatelské jméno. Heslo Nastavení je definováno uživatelem. Určete jedinečné heslo. Místní domény Nastavení je definováno uživatelem. Určuje názvy domén pro servery HTTP a FTP. Další nastavení Povolit server HTTP Zapnuto * Vypnuto Umožní serveru Embedded Web Server monitorovat a spravovat tiskárnu. Povolit HTTPS Zapnuto * Vypnuto Povolí protokol HTTPS (Hypertext Transfer Protocol Secure) k šifrování dat přenášených na tiskový server a z něj. Vynutit připojení pomocí protokolu HTTPS Zapnuto Vypnuto * Na tiskárně vynutit používání připojení pomocí protokolu HTTPS. Povolit FTP/TFTP Zapnuto * Vypnuto Odesílá soubory pomocí funkce FTP/TFTP. Certifikát zařízení HTTPS Výchozí nastavení * Zobrazí certifikát zařízení HTTP použitý na tiskárně. Časový limit pro požadavky HTTP/FTP 1–299 sekund  (30*) Určuje čas, který uplyne před zastavením připojení k serveru. Opakování pro požadavky HTTP/FTP 1–299 sekund  (3*) Nastaví počet opakovaných pokusů o připojení k serveru HTTP/FTP. nabídka Nastavení HTTP/FTP"},{"UUID":"35b8bdb4-54bc-48eb-aef0-51dcd006fbba","title":"Síť/Porty","link":"network-overview-topic.html","desc":"ThinPrint Položky nabídky ThinPrint a","descFull":"ThinPrint Položky nabídky ThinPrint a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Povolit ThinPrint Vypnuto * Zapnuto Bude tisknout pomocí funkce ThinPrint. Číslo portu 4000–4999  (4000*) Nastaví číslo portu pro přístup k serveru ThinPrint. Šířka pásma (bity/s) 100–1000000  (0*) Nastaví rychlost pro přenos dat v prostředí ThinPrint. Velikost paketu (kilobajty) 0–64000  (0*) Nastaví velikost paketu pro datový přenos. nabídka ThinPrint"},{"UUID":"c201376c-82b8-4ac4-8dac-d1e1c1d9d89e","title":"Síť/Porty","link":"network-overview-topic.html","desc":"USB Položky nabídky USB a","descFull":"USB Položky nabídky USB a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. PCL SmartSwitch Vypnuto Zapnuto * Nastavení tiskárny tak, aby se přepnula na emulaci PCL, pokud to vyžaduje tisková úloha přijatá přes port USB, bez ohledu na výchozí jazyk tiskárny. Pokud je toto nastavení zakázáno, tiskárna neprověřuje příchozí data a použije výchozí jazyk tiskárny zadaný v nabídce  Nastavení . PS SmartSwitch Vypnuto Zapnuto * Nastavení tiskárny tak, aby se přepnula na emulaci PostScript, pokud to vyžaduje tisková úloha přijatá přes port USB, bez ohledu na výchozí jazyk tiskárny. Pokud je toto nastavení zakázáno, tiskárna neprověřuje příchozí data a použije výchozí jazyk tiskárny zadaný v nabídce  Nastavení . Ukládání úloh do vyrovnávací paměti Vypnuto * Zapnuto Před tiskem dočasně uložte úlohy na paměťovou jednotku. Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Binární PostScript Mac Auto * Zapnuto Vypnuto Nastavte tiskárnu ke zpracování binárních tiskových úloh Macintosh s emulací jazyka PostScript. Automaticky  zpracovává tiskové úlohy z počítačů používajících operační systém Windows nebo Macintosh. Možnost  Vypnuto  filtruje tiskové úlohy využívající emulaci jazyka PostScript pomocí standardního protokolu. Povolit port USB Vypnuto Zapnuto * Povolte přední a zadní port jednotky USB. nabídka USB"},{"UUID":"4e87dd64-1d6e-45e4-8d98-c338b98c6f46","title":"Síť/Porty","link":"network-overview-topic.html","desc":"Zakázat přístup k externím sítím Položky","descFull":"Zakázat přístup k externím sítím Položky nabídky Zakázat externí přístup k síti a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Zakázat přístup k externím sítím Vypnuto * Zapnuto Omezí přístup k síťovým webům. Externí síťová adresa Nastavení je definováno uživatelem. Zadejte síťové adresy s omezeným přístupem. E-mailová adresa pro oznámení Nastavení je definováno uživatelem. Zadejte e-mailovou adresu používanou k odesílání upozornění na protokolované události. Frekvence příkazu ping 1–300  (10*) Zadejte interval dotazování sítě v sekundách. Předmět Nastavení je definováno uživatelem. Zadejte předmět a text e-mailu s oznámením. Zpráva nabídka Zakázat přístup k externím sítím"},{"UUID":"baa35910-e116-45b5-a91d-e96fe8c3cc06","title":"Metody přihlášení","link":"login-methods-subgroup.html","desc":"Správa oprávnění Položky nabídky Správa","descFull":"Správa oprávnění Položky nabídky Správa oprávnění a jejich popisy Položka nabídky Nastavení Popis Přístup k funkci Přístup k adresáři v aplikacích Změnit adresář Správa zástupců Vytvořit profily Správa záložek Tisk z jednotky paměti flash Barevný tisk z jednotky paměti flash Skenování na jednotku paměti flash Kopírovací funkce Barevný tisk kopírování Zeslabení barvy Funkce e-mailu Funkce faxu Funkce FTP Uvolnit pozdržené faxy Přístup k pozdrženým úlohám Použít profily Zrušte úlohy v zařízení Změnit jazyk Protokol IPP Spustit skenování vzdáleně ČB tisk Barevný tisk Síťová složka – Skenování Pevný disk – Tisk Pevný disk – Barevný tisk Pevný disk – Skenování Určete funkce tiskárny, ke kterým má mít uživatel přístup. Některé položky nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Nabídky správy Nabídka Bezpečnost Nabídka Síť/Porty Nabídka Papír Nabídka Sestavy Nabídky Konfigurace funkcí Nabídka Spotřební materiál Nabídka Doplňková karta Nabídka SE Nabídka Zařízení Určete nabídky tiskárny, ke kterým má mít uživatel přístup. Správa zařízení Vzdálená správa Aktualizace firmwaru Konfigurace aplikací Zámek ovládacího panelu Přístup k serveru Embedded Web Server Import / Export všech nastavení Vymazání při vyřazení z provozu Registrace do cloudových služeb Určete funkce  správy zařízení , ke kterým má mít uživatel přístup. Aplikace Nové aplikace Prezentace Změnit tapetu Spořič obrazovky Kopírování karet Scan Center Scan Center – Vlastní  [x] Umožňuje řízení přístupu k aplikacím tiskárny. nabídka Správa oprávnění"},{"UUID":"730fe255-05be-418c-9e8a-81f13141207b","title":"Metody přihlášení","link":"login-methods-subgroup.html","desc":"Místní účty Položky nabídky Místní","descFull":"Místní účty Položky nabídky Místní účty a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Správa skupin/oprávnění Přidat skupinu Nastavení je definováno uživatelem. Určete skupiny, které mají přístup k funkcím tiskárny, nabídkám správy, možnostem správy tiskárny a aplikacím. Všichni uživatelé Import ovl. prvků přístupu Import řízení přístupu z účtů zaregistrovaných v tiskárně. Přidat uživatele Uživatelské jméno/heslo Uživatelské jméno Heslo PIN Nastavení je definováno uživatelem. Přidejte uživatele a určete metodu přihlášení k tiskárně. nabídka Místní účty"},{"UUID":"53d15ca1-c0b2-4ea5-b554-f98758bc3eea","title":"Metody přihlášení","link":"login-methods-subgroup.html","desc":"Výchozí metody přihlášení Tato nabídka","descFull":"Výchozí metody přihlášení Tato nabídka se zobrazí, pouze když je nakonfigurována nabídka  Místní účty . Položky nabídky Výchozí metody přihlášení a jejich popisy Položka nabídky Nastavení Popis Ovládací panel Uživatelské jméno/heslo Uživatelské jméno Heslo PIN Určete výchozí metodu přihlášení pro přístup k ovládacímu panelu. Prohlížeč Uživatelské jméno/heslo Uživatelské jméno Heslo PIN Určete výchozí metodu přihlášení pro přístup k prohlížeči. nabídka Výchozí metody přihlášení"},{"UUID":"23a66945-057b-4196-bc3a-0add85f1e580","title":"Zabezpečení","link":"login-methods-subgroup.html","desc":"Naplánovat USB zařízení Položka nabídky","descFull":"Naplánovat USB zařízení Položka nabídky Naplánovat USB zařízení a její popis Položka nabídky Položky podnabídky Nastavení Popis Plány Přidat nový plán Uložit plán Akce Den (dny) Čas Naplánuje přístup k přednímu portu USB. nabídka Naplánovat USB zařízení"},{"UUID":"a3b8e223-d0b4-489a-ab69-fad73bfc5a18","title":"Zabezpečení","link":"login-methods-subgroup.html","desc":"Protokol auditu zabezpečení Položky nabídky","descFull":"Protokol auditu zabezpečení Položky nabídky Deník bezpečnostního auditu a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Zapnout audit Vypnuto * Zapnuto Nastavte tiskárnu tak, aby zaznamenávala události do zabezpečeného deníku auditu a vzdáleného protokolu syslog. Zapnout vzdálený syslog Vypnuto * Zapnuto Nastavte tiskárnu tak, aby odesílala deníky auditu na vzdálený server. Vzdálený syslog server Nastavení je definováno uživatelem. Uveďte vzdálený server syslog. Vzdálený syslog port 1–65535  (514*) Určete port, přes který tiskárna odesílá protokolované události na vzdálený server. Vzdálená metoda syslogu Normální UDP * Stunnel Určuje protokol, který tiskárna používá k přenosu protokolovaných událostí na vzdálený server. Vzdálené zařízení pro syslog 0 – Zprávy jádra 1 – Zprávy na úrovni uživatele 2 – Poštovní systém 3 – Démony systému 4 – Zprávy zabezpečení/autorizace * 5 – Zprávy vytvořené interně pomocí serverů Syslog 6 – Subsystém řádkové tiskárny 7 – Subsystém síťových zpráv 8 – Subsystém UUCP 9 – Démon hodin 10 – Zprávy zabezpečení/autorizace 11 – Démon FTP 12 – Subsystém NTP 13 – Audit protokolu 14 – Výstraha protokolu 15 – Démon hodin 16 – Místní použití 0 (local0) 17 – Místní použití 1 (local1) 18 – Místní použití 2 (local2) 19 – Místní použití 3 (local3) 20 – Místní použití 4 (local4) 21 – Místní použití 5 (local5) 22 – Místní použití 6 (local6) 23 – Místní použití 7 (local7) Určuje hodnotu zařízení, které tiskárna používá v případě, že odesílá události deníku na vzdálený server syslog. Závažnost událostí k protokolování 0 – Stav nouze 1 – Výstraha 2 – Kritický 3 – Chyba 4 – Varování * 5 – Oznámení 6 – Neformální 7 – Ladění Zadejte hodnotu závažnosti pro každou událost. Neprotokolované události pro vzdálený syslog Vypnuto * Zapnuto Nastavte tiskárnu tak, aby odesílala všechny příslušné události. E‑mailová adresa správce Nastavení je definováno uživatelem. Zadejte e-mailovou adresu správce tiskárny, který bude upozorněn na určité protokolované události. Upozornit e‑mailem při odstranění deníku Vypnuto * Zapnuto Nastavte tiskárnu tak, aby se při každém odstranění deníku odeslal e-mail správci. Upozornit e‑mailem při uložení deníku Vypnuto * Zapnuto Nastavte tiskárnu tak, aby při přenesení položek deníku odesílala e-mail správci. Chování při zaplnění deníku Zabalení nejstarších záznamů * Odeslat deník e‑mailem, poté odstranit všechny položky Určete, jak má tiskárna vyřešit problémy s úložištěm deníku, když deník zaplní přidělenou paměť. Upozornit e‑mailem na procento zaplnění Vypnuto * Zapnuto Nastavte tiskárnu tak, aby poslala správci e-mail, když deník zaplní přidělenou paměť. Úroveň výstrahy o % zaplnění 1–99  (90*) Určete, zda prostor, který zabírá deník, je roven nebo větší než hodnota úrovně upozornění na zaplnění paměti. Upozornit e‑mailem při exportu deníku Vypnuto * Zapnuto Odešle správci e‑mailové upozornění, pokud dojde k exportování deníku. Upozornit e‑mailem na změnu nastavení deníku Vypnuto * Zapnuto Nastavte tiskárnu tak, aby při změně hodnoty v nabídce  Povolit audit  odeslala správci e-mail. Ukonč. řádku protokolu LF (\\n) * CR (\\r) CRLF (\\r\\n) V závislosti na operačním systému, v němž je soubor analyzován nebo prohlížen, určete, jak má tiskárna zpracovávat konce řádků v souboru deníku. Dig. podepsat exporty Vypnuto * Zapnuto Nastavte tiskárnu tak, aby automaticky podepisovala exportované deníky zabezpečení. Vymaz. protok. Nastavení je definováno uživatelem. Odstraní všechny protokoly auditu. Exportovat deník Syslog (RFC 5424) Syslog (RFC 3164) CSV Exportujte deníky z tiskárny nebo jednotky paměti flash. nabídka Protokol auditu zabezpečení"},{"UUID":"bb892924-2fc0-44e9-be34-8aae1f2dad7e","title":"Zabezpečení","link":"login-methods-subgroup.html","desc":"Omezení přihlášení Položky nabídky Omezení","descFull":"Omezení přihlášení Položky nabídky Omezení přihlášení a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Chyby při přihlášení 1–10  (3*) Určuje počet neúspěšných pokusů o přihlášení, než dojde k uzamčení uživatele. Časový rámec pro neúspěšné pokusy 1–60 minut  (5*) Určuje časový rámec přípustných neúspěšných pokusů o přihlášení, než dojde k uzamčení uživatele. Doba uzamčení 1–60 minut  (5*) Určete dobu, po kterou není dovoleno přihlašování. Časový limit webového přihlášení 1–120 minut  (10*) Určete dobu, po kterou může vzdálené rozhraní, například webová stránka, zůstat nečinné, než bude uživatel automaticky odhlášen. nabídka Omezení přihlášení"},{"UUID":"ac1b8491-28dc-4d74-b3e4-d032448bc815","title":"Zabezpečení","link":"login-methods-subgroup.html","desc":"Nastavení důvěrného tisku Položky nabídky","descFull":"Nastavení důvěrného tisku Položky nabídky Nastavení důvěrného tisku a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Max. počet neplatných kódů PIN 2–10 Nastaví limit pro zadání neplatného kódu PIN. Po dosažení tohoto limitu se odstraní tiskové úlohy s tímto uživatelským jménem. Doba platnosti důvěrné úlohy Vypnuto * 1 hodina 4 hodiny 24 hodin 72 hodin 1 týden U každého typu pozdržené úlohy nastaví individuální dobu vypršení platnosti, než se automaticky odstraní z paměti tiskárny. Typy pozdržených úloh jsou  Důvěrné ,  Opakované ,  Vyhrazené  a  Ověřit . Pokud se změní doba vypršení platnosti, zatímco jsou v paměti tiskárny nebo na pevném disku tiskárny uloženy důvěrné tiskové úlohy, doba platnosti těchto tiskových úloh se na novou výchozí hodnotu nezmění. Po vypnutí tiskárny se odstraní všechny důvěrné úlohy uložené v paměti tiskárny. Doba platnosti opakované úlohy Vypnuto * 1 hodina 4 hodiny 24 hodin 72 hodin 1 týden Nastaví dobu platnosti tiskových úloh, které chcete opakovat. Doba platnosti ověřené úlohy Vypnuto * 1 hodina 4 hodiny 24 hodin 72 hodin 1 týden Nastaví dobu vypršení platnosti pro tisk kopie úlohy, abyste mohli zkontrolovat její kvalitu před tiskem zbývajících kopií. Doba platnosti vyhrazené úlohy Vypnuto * 1 hodina 4 hodiny 24 hodin 72 hodin 1 týden Nastaví dobu vypršení pro úlohy, které chcete uložit do tiskárny pro pozdější tisk. Vyžadovat pozdržení všech úloh Vypnuto * Zapnuto Nastaví tiskárnu pro pozdržení všech tiskových úloh. Zachovat duplicitní dokumenty Vypnuto * Zapnuto Nastaví tiskárnu, aby uchovávala všechny dokumenty se stejným názvem souboru. nabídka Nastavení důvěrného tisku"},{"UUID":"d366b997-43ee-4df1-a21f-9b6d048d9565","title":"Zabezpečení","link":"login-methods-subgroup.html","desc":"Šifrování Položky nabídky Šifrování a","descFull":"Šifrování Položky nabídky Šifrování a jejich popisy Položka nabídky Nastavení Popis Interní úložiště Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazuje stav šifrování vnitřní interního úložiště. Pevný disk Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazuje stav šifrování pevného disku. Tato položka nabídky se zobrazí pouze v případě, že je nainstalován pevný disk. Inteligentní paměťová jednotka Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazuje stav šifrování inteligentní paměťové jednotky (ISD). Tato položka nabídky se zobrazí jen v případě, že je nainstalována jednotka ISD. nabídka Šifrování"},{"UUID":"c38ca149-7c11-43c2-b383-54a2998ed748","title":"Zabezpečení","link":"login-methods-subgroup.html","desc":"Vymazat dočasné soubory Položky a popis","descFull":"Vymazat dočasné soubory Položky a popis nabídky Vymazat dočasné soubory Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Uloženo v integrované paměti Vypnuto * Zapnuto Nastaví tiskárnu tak, aby po dokončení úlohy vymazala všechna data úlohy z paměti. Uloženo na pevném disku Vym. 1 průchodem * Vym. 3 průchody Vym. 7 průchody Určete metodu, kterou tiskárna po dokončení úlohy použije k vymazání veškerých dat úlohy z pevného disku. Tato položka nabídky se zobrazí pouze v případě, že je nainstalován pevný disk tiskárny. nabídka Vymazat dočasné soubory"},{"UUID":"a337eaee-feb4-468f-9dbb-283aa1ec7faf","title":"Zabezpečení","link":"login-methods-subgroup.html","desc":"Nastavení LDAP řešení Položky nabídky","descFull":"Nastavení LDAP řešení Položky nabídky Nastavení LDAP řešení a jejich popisy Položka nabídky Nastavení Popis Sledovat doporučení LDAP Vypnuto * Zapnuto Vyhledává různé servery v doméně pro přihlášený uživatelský účet. Ověření LDAP certifikátu Ano Ne * Umožňuje ověření certifikátů LDAP. nabídka Nastavení LDAP řešení"},{"UUID":"789d5dd7-a949-497b-aea5-4e962c493e7b","title":"Zabezpečení","link":"login-methods-subgroup.html","desc":"Různé Položky nabídky Různé a","descFull":"Různé Položky nabídky Různé a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Chráněné funkce Zobrazit * Skrýt Zobrazí všechny funkce, které FAC (řízení přístupu k funkci) chrání bez ohledu na oprávnění zabezpečení uživatele. Možnost  Skrýt  zobrazí pouze funkce chráněné pomocí FAC, k nimž má uživatel přístup. Oprávnění k tisku Vypnuto * Zapnuto Vyžaduje, aby se uživatel před tiskem přihlásil. Výchozí přihlášení pro oprávnění k tisku Uživatelské jméno/heslo * Uživatelské jméno Nastaví výchozí přihlášení pro  Oprávnění k tisku . Bezpečnostní resetovací propojka Povolit přístup „hostovi“ * Bez účinku Určuje přístup uživatelů k tiskárně. Nastavení  Povolit přístup „hostovi“  poskytuje neomezený přístup ke všem aspektům tiskárny. Nastavení  Žádný vliv  může zabránit přístupu k tiskárně v případě, že nejsou k dispozici požadované informace o bezpečnosti. Pro uživatelská data použít inteligentní paměťovou jednotku Vypnuto Zapnuto * Povolte ukládání uživatelských dat na inteligentní paměťovou jednotku. Tato položka nabídky je zakázána v případě, že je nainstalován pevný disk. Minimální délka hesla 0–32  (0*) Určete minimální délku hesla, která se používá pro interní účty, jako jsou  Heslo  a  Uživatelské jméno / heslo . Povolit odhalení hesel / kódů PIN Vypnuto Zapnuto * Umožňuje zobrazit heslo nebo osobní identifikační číslo. Povolit šifrování energeticky nezávislé paměti služby Vypnuto * Zapnuto Povolte šifrování energeticky nezávislé paměti služby v zařízení. Toto nastavení je k dispozici, pokud je vypnuta funkce  Šifrovat energeticky nezávislou paměť služby . nabídka Různé"},{"UUID":"0fe148e9-0734-4da0-a38d-18d96c7fcf26","title":"Cloudové služby","link":"cloud-services-enrollment-topic.html","desc":"Registrace do cloudových služeb Položky","descFull":"Registrace do cloudových služeb Položky nabídky Registrace do cloudových služeb a jejich popisy Položka nabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Zobrazit další informace Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazí další informace o používání služeb Lexmark Cloud. Povolit komunikaci s cloudovými službami Lexmark Vypnuto * Zapnuto Povolte tiskárně komunikaci s Cloudovými službami Lexmark. Zobrazit aktuální stav Nastavení je údaj, který je k dispozici jen pro čtení. Zobrazí stav připojení mezi tiskárnou a Cloudovými službami Lexmark. nabídka Registrace do cloudových služeb"},{"UUID":"a9495300-3708-4777-b734-cd70285f2b30","title":"Zprávy","link":"menu-settings-page-topic.html","desc":"Stránka nastavení nabídek Položka nabídky","descFull":"Stránka nastavení nabídek Položka nabídky  Stránka nastavení nabídek  a její popis Položka nabídky Popis Stránka nastavení nabídek Vytiskne hlášení obsahující nabídky tiskárny. nabídka Stránka nastavení nabídek"},{"UUID":"be4b42db-dd15-4e9f-bfb0-a167b30eb8ad","title":"Zprávy","link":"menu-settings-page-topic.html","desc":"Zařízení Položky nabídky Zařízení a","descFull":"Zařízení Položky nabídky Zařízení a jejich popisy Položka nabídky Popis Informace o zařízení Vytiskne zprávu obsahující informace o tiskárně. Statistika zařízení Vytiskněte zprávu se stavem spotřebního materiálu, počtem papírů, informacemi o úloze a dalšími údaji. Seznam profilů Vytiskne seznam profilů uložených v tiskárně. Zpráva o aktivech Vytiskněte diagnostický nástroj při problémech s tiskem. Chcete-li zabránit oříznutí obsahu, vytiskněte zprávu na papír formátu Letter nebo A4. nabídka Zařízení"},{"UUID":"ed3c13fe-4513-4969-bbe9-5e4b9a4d4a87","title":"Zprávy","link":"menu-settings-page-topic.html","desc":"Tisk Položky nabídky Tisk a jejich","descFull":"Tisk Položky nabídky Tisk a jejich popis Položka nabídky Nastavení Popis Tisk typů písma Písma PCL Písma PS Tisk vzorků a informací o písmech, která jsou k dispozici v jednotlivých jazycích tiskárny. Tisk ukázky Ukázková stránka Vytiskněte diagnostický nástroj při problémech s tiskem. Chcete-li zabránit oříznutí obsahu, vytiskněte zprávu na papír formátu Letter nebo A4. Tato položka nabídky se zobrazí pouze v případě, že je nainstalována ukázková stránka. Tisk adresáře Nastavení je definováno uživatelem. Vytiskne zprávu se zdroji uloženými na jednotce paměti flash nebo pevném disku tiskárny. nabídka Tisk"},{"UUID":"c8f9bf1c-bf17-46bf-9a23-102ac45c7757","title":"Zprávy","link":"menu-settings-page-topic.html","desc":"Zástupci Položky nabídky Zástupci a jejich","descFull":"Zástupci Položky nabídky Zástupci a jejich popis Položka nabídky Popis Všichni zástupci Vytiskne zprávu, kde je uveden každý zástupce uložený v tiskárně. Položka  Zástupci pro fax  se zobrazí pouze v případě, že je nainstalován  fax . Zástupci pro fax Zástupci kopírování Zástupci pro e-mail Zástupci pro FTP Zástupci síťové složky nabídka Zástupci"},{"UUID":"41de8ca9-655c-444b-9a3a-1c47e1721674","title":"Zprávy","link":"menu-settings-page-topic.html","desc":"Faxování Tato nabídka se zobrazí","descFull":"Faxování Tato nabídka se zobrazí pouze v případě, že je nakonfigurován fax a položka  Povolit protokolování úloh  je nastavena na možnost  Zapnuto . Položky nabídky Faxování a jejich popisy Položka nabídky Popis Protokol faxových úloh Vytiskne hlášení o posledních 200 dokončených faxových úlohách. Protokol faxových volání Vytiskne zprávu o posledních 100 pokusech o volání, přijatých a zablokovaných voláních. nabídka Faxování"},{"UUID":"bd4d46f8-30b8-45eb-a4be-4a03c6e869b0","title":"Zprávy","link":"menu-settings-page-topic.html","desc":"Síť Položky nabídky Síť a","descFull":"Síť Položky nabídky Síť a jejich popisy Položka nabídky Popis Stránka nastavení sítě Vytiskne stránku, která zobrazuje nakonfigurovanou síť a bezdrátová nastavení tiskárny. Tato položka nabídky se zobrazuje pouze u síťových tiskáren nebo tiskáren připojených k tiskovým serverům. Připojení klienti – Wi-Fi Direct Vytiskne stránku, která zobrazuje seznam zařízení, která jsou k tiskárně připojena pomocí Wi-Fi Direct. Tato položka nabídky se zobrazí pouze tehdy, když bude možnost  Povolit Wi‑Fi Direct  nastavena na hodnotu  Zapnuto . nabídka Síť"},{"UUID":"3305d58f-cf78-49c4-9243-752f57143175","title":"Nabídky tiskárny","link":"troubleshooting-menu-topic.html","desc":"Řešení problémů Položky nabídky Řešení","descFull":"Řešení problémů Položky nabídky Řešení problémů a jejich popisy Položka nabídky Popis Vytisknout zkušební stránku Tisk vzorových stran za účelem identifikace a opravy vad kvality tisku. Čištění skeneru Tisk pokynů k čištění skeneru. nabídka Řešení problémů Vytisknout zkušební stránku Čištění skeneru"},{"UUID":"270f3089-ffc2-4939-9329-7b1d6577f89e","title":"Nabídky tiskárny","link":"forms-merge-topic.html","desc":"Forms Merge Tato položka nabídky","descFull":"Forms Merge Tato položka nabídky se zobrazí jen v případě, že je instalována paměťová jednotka. Položky nabídky funkce Forms Merge a jejich popisy Položka nabídky Položka podnabídky Nastavení Popis Hvězdička (*) vedle hodnoty označuje výchozí nastavení z výroby. Režim sloučení – Tisk * Záznam dat Vypnuto Určete režim činnosti funkce Forms Merge. Cíl záznamu dat – Paměť flash * Nastavte cílové umístění, kam se budou zaznamenaná data předávat. Tato položka nabídky se zobrazí pouze tehdy, když bude parametr  Režim sloučení  nastaven na  Záznam dat . Nastavení tiskového portu a filtru Síťový port Zapnuto * Vypnuto Chcete-li zpracovat všechna data odesílaná do síťového portu, povolte funkci Forms Merge. Síťový filtr Vypnuto * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF Zadejte síťový filtr pro všechna data odesílaná do tiskárny. Port USB Zapnuto * Vypnuto Chcete-li zpracovat všechna data odesílaná do portu USB, povolte funkci Forms Merge. Filtr USB Vypnuto * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF Zadejte filtr USB pro všechna data odesílaná do tiskárny. Časový limit místního portu 1–100  (10*) Zadejte hodnotu časového limitu pro úlohy funkce Forms Merge, které jsou odesílány do místního portu. Různé Tisk všech formulářů Start Tisk všech sad formulářů uložených na inteligentní paměťové jednotce nebo pevném disku. Tisk stránky s chybou Zapnuto * Vypnuto Povolit tisk stránky s chybou, pokud se v úloze funkce Forms Merge vyskytne chyba. nabídka Forms Merge"},{"UUID":"c4b2e34a-ae1d-435c-8b87-d222e3f920f4","title":"Nabídky tiskárny","link":"printing-menu-settings-page-topic.html","desc":"Tisk  stránky s nastavením Na","descFull":"Tisk  stránky s nastavením Na ovládacím panelu přejděte na položku  Nastavení Zprávy . Vyberte možnost  Stránka s nastavením nabídky . tisk Stránka nastavení nabídek Stránka nastavení nabídek tisk nabídky tiskárny"},{"UUID":"84ffb92c-9968-4fbe-942d-41ce1c7b0c9a","title":"Možnosti dokončovací schránky tiskárny","link":"using-staple-finisher-topic.html","desc":"Používání sešívacího finišeru Sešívání pomocí","descFull":"Používání sešívacího finišeru Sešívání pomocí tiskového ovladače Uživatelé se systémem Windows Otevřete dokument, klepněte na možnost  Soubor Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . Klepněte na možnost  Papír/Dokončování  a poté nakonfigurujte nastavení  Papír . V nabídce  Sešívání  vyberte nastavení. Klepněte na tlačítko  OK  a potom na tlačítko  Tisk . Uživatelé se systémem Macintosh Otevřete dokument a vyberte možnost  Soubor Tisk . Výběr tiskárny V nabídce  Možnosti dokončování  vyberte možnost  Použít dokončování  Možnosti tiskárny . Klepněte na možnost  Sešívání  a vyberte nastavení. Klepněte na tlačítko  Tisk . Sešívání pomocí ovládacího panelu Na ovládacím panelu vyberte možnost  Tisk  a poté vyberte zdroj tiskové úlohy. Vyberte dokument. Vyberte možnost  Další nastavení  a poté vyberte možnost  Možnosti dokončování . Vyberte možnost  Sešívání  a poté vyberte nastavení. Vytiskněte dokument. sešívací finišer použití sešívání vytištěné listy sešívání kopírované dokumenty"},{"UUID":"cc361d08-b946-4b9a-bf00-321ee2ba36ae","title":"Možnosti dokončovací schránky tiskárny","link":"using-staple-hole-punch-finisher-topic.html","desc":"Používání sešívacího děrovacího finišeru Používání","descFull":"Používání sešívacího děrovacího finišeru Používání sešívacího děrovacího finišeru Sešívání nebo děrování papíru pomocí tiskového ovladače Uživatelé se systémem Windows Otevřete dokument, klepněte na možnost  Soubor Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . Klepněte na možnost  Papír/Dokončování  a poté nakonfigurujte nastavení  Papír . V závislosti na požadovaném dokončení vyberte nastavení pro  sešívání  nebo  děrování . Pokud chcete tištěné materiály sešívat i děrovat, můžete vybrat nastavení pro obě činnosti. Klepněte na tlačítko  OK  a potom na tlačítko  Tisk . Uživatelé se systémem Macintosh Otevřete dokument, klepněte na možnost  Soubor Tisk . Výběr tiskárny V nabídce  Možnosti dokončování  vyberte možnost  Použít dokončování  Možnosti tiskárny . Klepněte na možnost  Sešívání  nebo  Děrování  a vyberte nastavení. Klepněte na tlačítko  Tisk . Sešívání nebo děrování papíru pomocí ovládacího panelu Na ovládacím panelu vyberte možnost  Tisk  a poté vyberte zdroj tiskové úlohy. Vyberte dokument. Vyberte možnost  Další nastavení  a poté vyberte možnost  Možnosti dokončování . V závislosti na požadovaném dokončení vyberte nastavení pro  sešívání  nebo  děrování . Pokud chcete tištěné materiály sešívat i děrovat, můžete vybrat nastavení pro obě činnosti. Vytiskněte dokument. sešívání vytištěných dokumentů děrování vytištěných listů sešívací děrovací finišer použití"},{"UUID":"155c95ad-9f31-447c-a92b-bf65cf77ff85","title":"Možnosti dokončovací schránky tiskárny","link":"using-offset-stacker-topic.html","desc":"Používání odsazovacího odkládacího zásobníku Stohování","descFull":"Používání odsazovacího odkládacího zásobníku Stohování s posunem pomocí tiskového ovladače Uživatelé se systémem Windows Otevřete dokument, klepněte na možnost  Soubor Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . Klepněte na možnost  Papír/Dokončování  a poté nakonfigurujte nastavení  Papír . V nabídce  Posunutí  vyberte nastavení. Klepněte na tlačítko  OK  a potom na tlačítko  Tisk . Uživatelé se systémem Macintosh Otevřete dokument, klepněte na možnost  Soubor Tisk . Výběr tiskárny V nabídce  Možnosti dokončování  vyberte možnost  Použít dokončování  Možnosti tiskárny . Klepněte na možnost  Ofset  a vyberte typ. Klepněte na tlačítko  Tisk . Stohování s posunem pomocí ovládacího panelu Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Chcete-li předejít oříznutí obrázku, ujistěte se, že originální dokument a výstup mají stejnou velikost papíru. Z ovládacího panelu, vyberte možnost  Kopírovat  a potom zadejte počet kopií. Vyberte možnost  Další nastavení  a poté vyberte možnost  Posun stránek . Povolte nabídku a vyberte nastavení. Vytiskněte dokument. odsazovací odkládací zásobník použití ofsetové stohování"},{"UUID":"a4b71a4d-f01b-43ee-ad21-1f57d9ac5ac9","title":"Možnosti dokončovací schránky tiskárny","link":"using-booklet-finisher-topic.html","desc":"Používání dokončovací schránky na knihy","descFull":"Používání dokončovací schránky na knihy Před vytvořením knihy vložte papír tak, aby krátký okraj směřoval k pravé straně zásobníku. Vytvoření knihy pomocí tiskového ovladače Uživatelé se systémem Windows Otevřete dokument, klepněte na možnost  Soubor Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . Vyberte možnost  Kniha . Klepněte na kartu  Papír/Dokončování  a poté nakonfigurujte nastavení papíru. V nabídce  Skládání  vyberte nastavení. Klepněte na tlačítko  OK  a potom na tlačítko  Tisk . Uživatelé se systémem Macintosh Otevřete dokument, klepněte na možnost  Soubor Tisk . Výběr tiskárny V nabídce  Možnosti dokončování  vyberte možnost  Použít dokončování  Možnosti tiskárny . Vyberte možnost  Kniha  a poté vyberte nastavení  Skládání . Klikněte na možnost  OK . Vytvoření knihy pomocí ovládacího panelu Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Chcete-li předejít oříznutí obrázku, ujistěte se, že originální dokument a výstup mají stejnou velikost papíru. Na ovládacím panelu vyberte možnost  Kopírování  a nakonfigurujte nastavení. Vyberte možnost  Další nastavení  a poté vyberte možnost  Vytvořit knihu . Povolte možnost  Brožovací dokončování  a vyberte nastavení. Zkopírujte dokument. vytváření brožury tvorba brožury brožovací finišer použití"},{"UUID":"1f4ea508-636b-4990-a73f-32c862249fce","title":"Možnosti dokončovací schránky tiskárny","link":"using-hptfu-topic.html","desc":"Používání podávací jednotky s možností","descFull":"Používání podávací jednotky s možností skládání Skládání papíru pomocí tiskového ovladače Uživatelé se systémem Windows Otevřete dokument, klepněte na možnost  Soubor Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . Klepněte na možnost  Papír/Dokončování  a poté nakonfigurujte nastavení Papír. V nabídce  Skládání  vyberte nastavení. Klepněte na tlačítko  OK  a potom na tlačítko  Tisk . Uživatelé se systémem Macintosh Otevřete dokument a vyberte možnost  Soubor Tisk . Výběr tiskárny V nabídce  Možnosti dokončování  vyberte možnost  Použít dokončování  Možnosti tiskárny . Klepněte na možnost  Skládání  a vyberte nastavení. Klepněte na tlačítko  Tisk . Skládání papíru pomocí ovládacího panelu Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Chcete-li předejít oříznutí obrázku, ujistěte se, že originální dokument a výstup mají stejnou velikost papíru. Z ovládacího panelu, vyberte možnost  Kopírovat  a potom zadejte počet kopií. Vyberte možnost  Další nastavení  a poté vyberte možnost  Možnosti dokončování . Vyberte možnost  Skládání  a poté vyberte nastavení. Zkopírujte dokument. podávací jednotka s možností skládání použití skládání vytištěných kopií skládání zkopírovaných dokumentů"},{"UUID":"4fef37ef-5991-453c-8e68-4c7238d5fe52","title":"Údržba tiskárny","link":"checking-supplies-status-topic.html","desc":"Kontrola stavu částí a spotřebního","descFull":"Kontrola stavu částí a spotřebního materiálu Kontrola stavu částí a spotřebního materiálu V pravém horním rohu ovládacího panelu vyberte možnost  . Prohlédněte si stav dílů a spotřebního materiálu tiskárny. Výběrem možnosti   můžete zkontrolovat také oznámení, která vyžadují zásah uživatele. kontrola, stav spotřebního materiálu stav spotřebního materiálu kontrola stav dílů tiskárny kontrola"},{"UUID":"27cc6187-7092-4358-a98a-a5e0e6f36acc","title":"Údržba tiskárny","link":"configuring-supply-notifications-topic.html","desc":"Konfigurace upozorňování na spotřební materiál","descFull":"Konfigurace upozorňování na spotřební materiál Konfigurace upozorňování na spotřební materiál Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na položku  Nastavení Zařízení Upozornění . Klepněte na možnost  Vlastní upozornění na spotřební materiál . Zvolte upozornění pro jednotlivou položku spotřebního materiálu. Použijte změny. oznámení o spotřebním materiálu konfigurace konfigurace upozorňování na spotřební materiál"},{"UUID":"6be20ce4-2b58-4f79-960f-e3fc640bcffe","title":"Údržba tiskárny","link":"setting-up-email-alert-topic.html","desc":"Nastavení e-mailových upozornění Nastavení e-mailových","descFull":"Nastavení e-mailových upozornění Nastavení e-mailových upozornění Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na položku  Nastavení Zařízení Upozornění . Klepněte na možnost  Nastavení e‑mailových upozornění  a nakonfigurujte nastavení. Další informace o nastavení SMTP zjistíte u svého poskytovatele e-mailových služeb. Použijte změny. Klepněte na možnost  Nastavení seznamů e-mailových adres a výstrah e-mailem  a poté nakonfigurujte nastavení. Použijte změny. e-mailová upozornění nastavení nastavení e-mailových upozornění"},{"UUID":"5f19edd1-1c6d-4063-9d49-32ddd567630e","title":"Údržba tiskárny","link":"generating-reports-and-logs-topic.html","desc":"Vytváření zpráv a protokolů Vytváření","descFull":"Vytváření zpráv a protokolů Vytváření zpráv a protokolů Na ovládacím panelu přejděte na položku  Nastavení Zprávy . Vyberte zprávu nebo protokol, které chcete vytisknout. Stránka s nastavením  – obsahuje aktuální předvolby, nastavení a konfigurace tiskárny. Zařízení Informace o zařízení  – obsahuje sériové číslo tiskárny, nainstalovaná řešení a fax. Statistiky zařízení  – obsahuje stav spotřebního materiálu, celkový počet vytištěných listů a informace o tiskových úlohách. Seznam profilů  – obsahuje seznam profilů nebo zástupců uložených v tiskárně. Zpráva o aktivech  – obsahuje zprávu s inventárními informacemi o tiskárně, např. sériové číslo a název modelu. Tisk Tisk písem  – obsahuje písma, která jsou k dispozici v jednotlivých jazycích tiskárny. Tisk ukázky  – obsahuje ukázkové soubory, které jsou k dispozici ve firmwaru, ve volitelné paměti flash a na volitelném disku. Tisk adresáře  – obsahuje zdroje uložené na jednotce paměti flash, pevném disku nebo inteligentní paměťové jednotce (ISD). Tato zpráva se zobrazuje pouze v případě, že je nainstalována jednotka paměti flash, pevný disk tiskárny nebo jednotka ISD. Zástupci Všichni zástupci  – obsahuje seznam všech zástupců uložených v tiskárně. Zástupci pro fax  – obsahuje seznam zástupců pro fax uložených v tiskárně. Zástupci pro kopírování  – obsahuje seznam zástupců pro kopírování uložených v tiskárně. Zástupci pro e-mail  – obsahuje seznam zástupců pro e-mail uložených v tiskárně. Zástupci FTP  – obsahuje seznam zástupců protokolu FTP (File Transfer Protocol) uložených v tiskárně. Zástupci síťových složek  – obsahuje seznam zástupců síťových složek uložených v tiskárně. Faxování Protokol faxových úloh  – seznam posledních 200 vykonaných faxových úloh. Zpráva se zobrazuje pouze v případě, že je aktivována možnost  Povolit protokol úloh . Protokol faxových hovorů  – obsahuje prostředky uložené na jednotce flash nebo na paměťové jednotce. Zpráva se zobrazuje pouze v případě, že je nainstalována jednotka flash nebo paměťová jednotka. Síť Stránka nastavení sítě  – obsahuje nakonfigurovanou síť a bezdrátová nastavení tiskárny. Tato zpráva se zobrazuje pouze u síťových tiskáren a tiskáren připojených k tiskovým serverům. Připojení klienti – Wi-Fi Direct  – obsahuje seznam zařízení připojených k tiskárně pomocí funkce Wi-Fi Direct. Tato zpráva se zobrazuje pouze tehdy, když je možnost  Povolit Wi‑Fi Direct  nastavena na hodnotu  Zapnuto . tisk sestav tisk protokolů zobrazení zpráv a protokolů odečet měřičů, zobrazení tištěné listy, zobrazení"},{"UUID":"11fcc1ef-842f-431c-ab30-07bbec64440d","title":"Objednání částí a spotřebního materiálu","link":"ordering-parts-and-supplies-group.html","desc":"V USA kontaktuje společnost Lexmark na","descFull":"V USA kontaktuje společnost Lexmark na čísle 1-800-539-6275, kde získáte kontakt na autorizované prodejce spotřebního materiálu ve své oblasti. V jiných zemích přejděte na webovou stránku  www.lexmark.com  nebo kontaktujte prodejce, u něhož jste tiskárnu zakoupili. Chcete-li si objednat spotřební materiál, kontaktujte prodejce tiskárny. Veškeré odhady životnosti spotřebního materiálu předpokládají tisk na obyčejný papír formátu letter nebo A4. Pokud nezajistíte optimální fungování tiskárny nebo nevyměníte příslušné části a spotřební materiál, může dojít k poškození tiskárny. originální části a spotřební materiál"},{"UUID":"5d9e1498-3cc4-43c9-9ac3-0fba0605794d","title":"Objednání částí a spotřebního materiálu","link":"ordering-parts-and-supplies-group.html","desc":"Používání originálních dílů a spotřebního","descFull":"Používání originálních dílů a spotřebního materiálu Lexmark Tiskárna Lexmark je navržena tak, aby fungovala nejlépe s originálními díly a spotřebním materiálem Lexmark. Použití spotřebních materiálů či dílů jiných výrobců můžete ovlivnit výkon, spolehlivost či životnost tiskárny a jejích zobrazovacích součástí. Rovněž to může ovlivnit krytí zárukou. Poškození způsobené použitím dílů či spotřebního materiálu jiného výrobce není kryto zárukou. Všechny ukazatele životnosti jsou navrženy pro používání dílů a spotřebního materiálu Lexmark a mohou přivodit nepředvídatelné důsledky, pokud se použijí díly či spotřební materiál jiného výrobce. Používání zobrazovacích součástí po uplynutí zamýšlené životnosti může tiskárnu Lexmark nebo související součásti poškodit. Resetovat a repasovat lze pouze spotřební materiál a díly, na které se nevztahují smluvní podmínky vratného programu. Záruka výrobce se ale nevztahuje na jakékoliv poškození způsobené neoriginálním spotřebním materiálem nebo neoriginálními díly. Resetování počitadel spotřebního materiálu nebo dílu bez řádného výrobního zpracování může poškodit tiskárnu. Po vyresetování počitadla spotřebního materiálu nebo dílu tiskárna může zobrazit chybu přítomnosti vyresetované součásti. používání originálních dílů a spotřebního materiálu Lexmark originální díly a spotřební materiál Lexmark"},{"UUID":"74a18bd6-f3cf-47cb-a7ce-7f45e8e83934","title":"Objednání částí a spotřebního materiálu","link":"ordering-parts-and-supplies-group.html","desc":"Objednání tonerové kazety Objednání tonerové","descFull":"Objednání tonerové kazety Objednání tonerové kazety Odhadovaný počet vytištěných stránek pomocí kazety je založen na normě ISO/IEC 19798. Extrémně nízké pokrytí může v delším období negativně ovlivnit skutečný počet vytištěných stránek. Chcete-li si objednat tonerové kazety, kontaktujte prodejce, u něhož jste zakoupili tiskárnu. Tonerové kazety zařazené do Vratného programu Lexmark CX833, CX961, CX962, CX963 Položka Spojené státy, Kanada, Austrálie a Nový Zéland Evropská unie, Evropský hospodářský prostor, Island, Lichtenštejnsko, Norsko, Švýcarsko Zbývající část Tichomořské Asie Latinská Amerika, Portoriko a Mexiko Zbylá část Evropy, Střední východ, Afrika, Střední a východní Evropa, Společenství nezávislých států (SNS) Další informace o zemích v jednotlivých regionech získáte na webové stránce  www.lexmark.com/regions . Azurová 77L10C0 77L20C0 77L30C0 77L40C0 77L50C0 Purpurová 77L10M0 77L20M0 77L30M0 77L40M0 77L50M0 Žlutá 77L10Y0 77L20Y0 77L30Y0 77L40Y0 77L50Y0 Černá 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 Vysokokapacitní tonerové kazety zařazené do Vratného programu Lexmark CX833 Položka Spojené státy, Kanada, Austrálie a Nový Zéland Evropská unie, Evropský hospodářský prostor, Island, Lichtenštejnsko, Norsko, Švýcarsko Zbývající část Tichomořské Asie Latinská Amerika, Portoriko a Mexiko Zbylá část Evropy, Střední východ, Afrika, Střední a východní Evropa, Společenství nezávislých států (SNS) Další informace o zemích v jednotlivých regionech získáte na webové stránce  www.lexmark.com/regions . Azurová 79L10K0 79L20K0 79L30K0 79L40K0 79L50K0 Purpurová 79L1HM0 79L2HM0 79L3HM0 79L4HM0 79L5HM0 Žlutá 79L1HY0 79L2HY0 79L3HY0 79L4HY0 79L5HY0 Černá 79L1HK0 79L2HK0 79L3HK0 79L4HK0 79L5HK0 Lexmark CX961, CX962, CX963 Položka Spojené státy, Kanada, Austrálie a Nový Zéland Evropská unie, Evropský hospodářský prostor, Island, Lichtenštejnsko, Norsko, Švýcarsko Zbývající část Tichomořské Asie Latinská Amerika, Portoriko a Mexiko Zbylá část Evropy, Střední východ, Afrika, Střední a východní Evropa, Společenství nezávislých států (SNS) Další informace o zemích v jednotlivých regionech získáte na webové stránce  www.lexmark.com/regions . Azurová 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 Purpurová 77L1HM0 77L2HM0 77L3HM0 77L4HM0 77L5HM0 Žlutá 77L1HY0 77L2HY0 77L3HY0 77L4HY0 77L5HY0 Černá 77L1HK0 77L2HK0 77L3HK0 77L4HK0 77L5HK0 Lexmark XC8355 Položka Spojené státy, Kanada, Austrálie, Nový Zéland Zbývající část Evropy, Střední východ, Afrika Další informace o zemích v jednotlivých regionech získáte na webové stránce  www.lexmark.com/regions . Azurová 24B7574 24B7582 Purpurová 24B7575 24B7583 Žlutá 24B7576 24B7584 Černá 24B7577 24B7585 Lexmark XC9635, XC9645, XC9655 Položka Spojené státy, Kanada, Austrálie a Nový Zéland Zbývající část Evropy, Střední východ, Afrika Další informace o zemích v jednotlivých regionech získáte na webové stránce  www.lexmark.com/regions . Azurová 24B7570 24B7578 Purpurová 24B7571 24B7579 Žlutá 24B7572 24B7580 Černá 24B7573 24B7581 Běžné vysokokapacitní tonerové kazety Lexmark CX833 Položka Celý svět Další informace o zemích v jednotlivých regionech získáte na webové stránce  www.lexmark.com/regions . Azurová 77L0H20 Purpurová 77L0H30 Žlutá 77L0H40 Černá 77L0H10 Lexmark CX961, CX962, CX963 Položka Celý svět Další informace o zemích v jednotlivých regionech získáte na webové stránce  www.lexmark.com/regions . Azurová 79L0H20 Purpurová 79L0H30 Žlutá 79L0H40 Černá 79L0H10 objednání spotřebního materiálu tonerová kazeta tonerová kazeta objednání"},{"UUID":"4bae3f1e-2e5a-4e71-b5ff-460ef61120d1","title":"Objednání částí a spotřebního materiálu","link":"ordering-parts-and-supplies-group.html","desc":"Objednání černé zobrazovací jednotky Objednání","descFull":"Objednání černé zobrazovací jednotky Objednání černé zobrazovací jednotky Chcete-li objednat černou zobrazovací jednotku, kontaktujte prodejce, u kterého jste zakoupili tiskárnu. Černá zobrazovací jednotka a příslušná objednací čísla Položka Obj. č. Černá zobrazovací jednotka zařazená do Vratného programu 77L0ZK0 Černá zobrazovací jednotka 77L0Z10 černá zobrazovací jednotka objednání objednání spotřebního materiálu černá zobrazovací jednotka"},{"UUID":"ac3bdc4e-0eb2-4c16-8460-f4c88e9e9413","title":"Objednání částí a spotřebního materiálu","link":"ordering-parts-and-supplies-group.html","desc":"Objednání barevné zobrazovací sady Chcete-li","descFull":"Objednání barevné zobrazovací sady Chcete-li objednat barevnou zobrazovací sadu, kontaktujte prodejce, u kterého jste zakoupili tiskárnu. Položka Obj. č. Barevná zobrazovací sada zařazená do Vratného programu 77L0ZV0 Běžná barevná zobrazovací sada 77L0Z50 barevná zobrazovací sada objednání objednání spotřebního materiálu barevná zobrazovací sada"},{"UUID":"46f9a848-2ffe-4e81-b003-1e77d724a605","title":"Objednání částí a spotřebního materiálu","link":"ordering-parts-and-supplies-group.html","desc":"Objednání nádobky na odpadní toner","descFull":"Objednání nádobky na odpadní toner Objednání nádobky na odpadní toner Chcete-li si objednat nádobku na odpadní toner, kontaktujte prodejce, u něhož jste zakoupili tiskárnu. Číslo dílu nádobky na odpadní toner Položka Obj. č. Nádobka na odpadní toner 77L0W00 objednání spotřebního materiálu nádobka na odpadní toner nádobka na odpadní toner objednání"},{"UUID":"a00a7a47-e63a-45c4-a55c-d8ff56a4ea93","title":"Objednání částí a spotřebního materiálu","link":"ordering-parts-and-supplies-group.html","desc":"Objednání kazety se svorkami Chcete-li","descFull":"Objednání kazety se svorkami Chcete-li si objednat kazetu se svorkami, kontaktujte prodejce, u něhož jste zakoupili tiskárnu. Kazeta se svorkami a objednací číslo Položka Obj. č. 1  K dispozici pouze pro vazač knih. 2  K dispozici pouze pro dokončovací schránku – vazač knih, sešívací finišer a sešívací děrovací finišer. Kazety se svorkami (balení se 4 kusy) 1 20L7500 Kazety se svorkami (balení se 3 kusy) 2 25A0013 kazeta se svorkami objednání objednání spotřebního materiálu kazeta se svorkami"},{"UUID":"902b449e-0aa0-43e8-9ce3-e5041cf5e4f1","title":"Objednání částí a spotřebního materiálu","link":"ordering-parts-and-supplies-group.html","desc":"Objednání sady pro údržbu Objednání","descFull":"Objednání sady pro údržbu Objednání sady pro údržbu Chcete-li si objednat sadu pro údržbu, kontaktujte prodejce, u něhož jste zakoupili tiskárnu. Sada pro údržbu musí odpovídat napětí tiskárny. Používání některých typů papíru si může vyžádat častější výměnu sady pro údržbu. Sada pro údržbu obsahuje zapékač a zaváděcí válečky. Tyto součásti lze rovněž objednat samostatně a vyměnit podle potřeby. Doporučené sady pro údržbu a číselná označení dílů Položka Obj. č. Sadu pro údržbu může vyměnit pouze autorizovaný servisní technik. Obraťte se na svého poskytovatele služeb. Sada pro údržbu 100V zapékače v rámci vratného programu, typ 02 41X5654 Sada pro údržbu 110–120V zapékače v rámci vratného programu, typ 00 41X5655 Sada pro údržbu 220–240V zapékače v rámci vratného programu, typ 01 41X5656 Běžná sada pro údržbu 100V zapékače, typ 12 41X6053 Běžná sada pro údržbu 110–120V zapékače, typ 10 41X6051 Běžná sada pro údržbu 220–240V zapékače, typ 11 41X6052 objednání spotřebního materiálu sada pro údržbu zapékače sada pro údržbu zapékače objednání"},{"UUID":"4cab0b74-b0b4-46e8-81cc-af03c20c9b94","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna tonerové kazety Výměna tonerové","descFull":"Výměna tonerové kazety Výměna tonerové kazety Otevřete přední dvířka.  Vyjměte použitou tonerovou kazetu. Rozbalte novou tonerovou kazetu. Vložte novou tonerovou kazetu tak, aby  zaklapnula  na místo. Zavřete dvířka. tonerová kazeta výměna výměna spotřebního materiálu tonerová kazeta"},{"UUID":"c2df986a-c6cf-4df6-822c-5272246d1ee7","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna nepodporované černé zobrazovací jednotky","descFull":"Výměna nepodporované černé zobrazovací jednotky Otevřete přední dvířka. Vyjměte tonerové kazety. Vyjměte nádobku na odpadní toner. Abyste zamezili vylití toneru, umístěte láhev do vzpřímené polohy. Vyjměte zobrazovací sadu. Nevystavujte zobrazovací sadu přímému světlu. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Zobrazovací sadu umístěte do svislé polohy na čistý a rovný povrch, aby nedošlo k poškrábání nebo poškození bubnu fotoválce.  Odjistěte použitou černou zobrazovací jednotku. Vyjměte použitou černou zobrazovací jednotku. Rozbalte novou černou zobrazovací jednotku. Vložte novou černou zobrazovací jednotku. Novou černou zobrazovací jednotku zajistěte na místě. Vložte zobrazovací sadu, aby zapadla na své místo. Vložte nádobku na odpadní toner tak, aby  zaklapla  na místo. Opatrně vytáhněte stěrače tiskové hlavy a poté očistěte čočky tiskové hlavy. Další informace o čištění čoček tiskové hlavy najdete v části  . Vložte tonerové kazety. Zavřete dvířka. černá zobrazovací jednotka výměna výměna spotřebního materiálu černá zobrazovací jednotka"},{"UUID":"29ff14e4-d382-43f8-a347-8f7f598573bb","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna barevné zobrazovací sady Otevřete","descFull":"Výměna barevné zobrazovací sady Otevřete přední dvířka. Vyjměte tonerové kazety. Vyjměte nádobku na odpadní toner. Abyste zamezili vylití toneru, umístěte láhev do vzpřímené polohy. Vyjměte použitou zobrazovací sadu. Zobrazovací sadu umístěte do svislé polohy na čistý a rovný povrch, aby nedošlo k poškrábání nebo poškození bubnu fotoválce.  Odjistěte černou zobrazovací jednotku. Vyjměte černou zobrazovací jednotku. Černou zobrazovací jednotku nevyhazujte. Je nutné ji nainstalovat na novou zobrazovací sadu. Rozbalte novou zobrazovací sadu. Zobrazovací sada obsahuje zobrazovací koš a azurovou, purpurovou a žlutou vývojovou jednotku. Nevystavujte zobrazovací sadu přímému světlu. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku do nové zobrazovací sady. Černou zobrazovací jednotku zajistěte na místě. Vložte novou zobrazovací sadu tak, aby se řádně usadila na svém místě. Vložte nádobku na odpadní toner tak, aby  zaklapla  na místo. Opatrně vytáhněte stěrače tiskové hlavy a poté očistěte čočky tiskové hlavy. Další informace o čištění čoček tiskové hlavy najdete v části  . Vložte tonerové kazety. Zavřete dvířka. barevná zobrazovací sada výměna výměna spotřebního materiálu barevná zobrazovací sada"},{"UUID":"a32346ae-d188-4cb5-90b6-927e3ec97013","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna nádobky na odpadní toner","descFull":"Výměna nádobky na odpadní toner Výměna nádobky na odpadní toner Otevřete přední dvířka. Vyjměte použitou nádobku na odpadní toner. Abyste zamezili vylití toneru, umístěte láhev do vzpřímené polohy. Vybalte novou nádobku na odpadní toner. Vložte novou nádobku na odpadní toner, dokud  nezaklapne  na místo, a zavřete dvířka. výměna spotřebního materiálu nádobka na odpadní toner nádobka na odpadní toner výměna"},{"UUID":"4a3a7ae9-4fe2-46f4-a7bc-d1ab8230d0a4","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna zapékače Výměna zapékače Vypněte","descFull":"Výměna zapékače Výměna zapékače Vypněte tiskárnu. Odpojte napájecí kabel z elektrické zásuvky a poté z tiskárny. Otevřete dvířka B. Vnitřek tiskárny může být horký. Abyste omezili riziko zranění způsobeného horkou součástí, nedotýkejte se povrchu, dokud nevychladne. Odjistěte a vyjměte použitý zapékač. Rozbalte nový zapékač. Vložte novou jednotku zapékače tak, aby  zaklapla  na místo, a poté ji zamkněte. Zavřete dvířka B. Zapojte jeden konec napájecího kabelu do tiskárny a druhý konec do elektrické zásuvky. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zapněte tiskárnu. zapékač výměna výměna součástí zapékač"},{"UUID":"204eed85-3cbf-471b-ba57-39e26ab8d558","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna vložky zásobníku Výměna vložky","descFull":"Výměna vložky zásobníku Výměna vložky zásobníku Vytáhněte použitou vložku zásobníku. Rozbalte novou vložku zásobníku. Vložte novou vložku zásobníku. vložka zásobníku výměna výměna součástí vložka zásobníku"},{"UUID":"e1536d8b-2e2a-44d7-ada7-e18a94511a5a","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna vodítek formátu ve volitelném","descFull":"Výměna vodítek formátu ve volitelném zásobníku na 550 listů Výměna vodítek formátu ve volitelném zásobníku na 550 listů Vytáhněte zásobník. Vyjměte použitá vodítka formátu. Vybalte nová vodítka formátu. Vložte nová vodítka formátu tak, aby se  zajistila  na svém místě. Vložte zásobník. vodítka formátu výměna výměna součástí vodítka formátu"},{"UUID":"4927155f-c632-49f0-a7b9-90a442baa984","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna krytu ve volitelném zásobníku","descFull":"Výměna krytu ve volitelném zásobníku na 550 listů Výměna krytu ve volitelném zásobníku na 550 listů Sejměte použitý kryt zásobníku. Rozbalte nový kryt zásobníku. Vložte nový kryt zásobníku tak, aby se zajistil na svém místě. výměna součástí kryt zásobníku kryt zásobníku výměna kryt zásobníku na 550 listů"},{"UUID":"d2238d79-bfee-4d0f-828a-439c5e7df27e","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna nástavce horní přihrádky dokončovací","descFull":"Výměna nástavce horní přihrádky dokončovací schránky – vazače knih Vyjměte použitý nástavec horní přihrádky. Rozbalte nový nástavec horní přihrádky. Vložte nový nástavec horní přihrádky. výměna součástí nástavec horní přihrádky dokončovací schránky – vazače knih nástavec horní přihrádky dokončovací schránky – vazače knih výměna"},{"UUID":"928ebcf2-c56f-43cb-a7ae-e627c88c2c3e","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna nádobky děrovače V závislosti","descFull":"Výměna nádobky děrovače V závislosti na nainstalované dokončovací schránce se může vzhled nádobky děrovačky lišit. Otevřete dvířka finišeru. Vyjměte použitou nádobku děrovače. Vybalte novou nádobku děrovače. Vložte novou nádobku děrovače. Zavřete dvířka dokončovací schránky. výměna součástí nádobka děrovače nádobka děrovače výměna"},{"UUID":"f08530a8-286a-46ec-aa98-6c97e8e414a9","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna standardního zásobníku Výměna standardního","descFull":"Výměna standardního zásobníku Výměna standardního zásobníku Vyjměte použitý standardní zásobník. Vybalte nový standardní zásobník. Připojte nový standardní zásobník. výměna součástí standardní zásobník standardní zásobník výměna"},{"UUID":"48e3acaa-5181-40c4-9ae2-c845aea5b59d","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna krytu ventilátoru Sejměte použitý","descFull":"Výměna krytu ventilátoru Sejměte použitý kryt ventilátoru. Rozbalte nový kryt ventilátoru. Vložte nový kryt tak, aby se  zajistil  na svém místě. výměna součástí kryt ventilátoru kryt ventilátoru výměna"},{"UUID":"3957ec08-4819-46a2-88ed-e46cef1e2847","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna pravého krytu Sejměte použitý","descFull":"Výměna pravého krytu Sejměte použitý pravý kryt. Rozbalte nový kryt ventilátoru. Vložte nový kryt tak, aby se  zajistil  na svém místě. výměna součástí pravý kryt pravý kryt výměna"},{"UUID":"02ee3dd7-9917-4fdb-a2e2-cec9aa189d84","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna nástroje na čištění skla","descFull":"Výměna nástroje na čištění skla Otevřete kryt skeneru. Vyjměte použitý nástroj na čištění skla. Vybalte nový nástroj na čištění skla. Vložte nový nástroj na čištění skla. Zavřete kryt skeneru. výměna součástí nástroj na čištění skla nástroj na čištění skla výměna"},{"UUID":"f4454daa-5b47-44d8-ae7b-dcec96c85043","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výměna krytu konektoru podávací jednotky","descFull":"Výměna krytu konektoru podávací jednotky Výměna krytu konektoru podávací jednotky Vyjměte standardní zásobník. Vyjměte použitý kryt konektoru podávací jednotky. Vybalte nový kryt konektoru. Připevněte kryt konektoru tak, aby  zacvakl  na svém místě. Připojte standardní zásobník. výměna součástí kryt konektoru podávací jednotky kryt konektoru podávací jednotky výměna"},{"UUID":"1eac087a-a9f8-413a-813a-ce02b0aac3bb","title":"Výměna zásobníku svorek","link":"replacing-toner-cartridge-topic.html","desc":"Výměna kazety se svorkami v sešívacím","descFull":"Výměna kazety se svorkami v sešívacím finišeru Uchopte držadlo F a posuňte sešívací finišer doleva. Vyjměte držák zásobníku se svorkami. Vyjměte prázdný zásobník svorek. Vložte nový zásobník svorek tak, dokud  nezaklapne  na místo. Vložte držák zásobníku se svorkami, dokud  nezaklapne  na místo. Posuňte sešívací finišer doprava. výměna spotřebního materiálu kazeta se svorkami kazeta se svorkami výměna"},{"UUID":"145d900a-8ca3-4cf6-ad81-91d714c9053d","title":"Výměna zásobníku svorek","link":"replacing-toner-cartridge-topic.html","desc":"Výměna zásobníku se svorkami v sešívacím","descFull":"Výměna zásobníku se svorkami v sešívacím děrovacím finišeru Otevřete dvířka H. Vytáhněte zelené držadlo a poté vyjměte držák kazety se svorkami. Vyjměte prázdný zásobník svorek. Rozbalte nový zásobník svorek. Vložte nový zásobník svorek tak, dokud  nezaklapne  na místo. Vložte držák zásobníku se svorkami, dokud  nezaklapne  na místo. Zavřete dvířka H. výměna spotřebního materiálu kazeta se svorkami kazeta se svorkami výměna"},{"UUID":"4770cf4f-35fa-4eca-9d44-0d53d804ad8b","title":"Výměna zásobníku svorek","link":"replacing-toner-cartridge-topic.html","desc":"výměna zásobníku se svorkami v brožovací","descFull":"výměna zásobníku se svorkami v brožovací schránce Otevřete dvířka H. Vytáhněte zelené držadlo a poté vyjměte držák kazety se svorkami. Vyjměte prázdný zásobník svorek. Rozbalte nový zásobník svorek. Vložte nový zásobník svorek tak, dokud  nezaklapne  na místo. Vložte držák zásobníku se svorkami, dokud  nezaklapne  na místo. Zavřete dvířka H. výměna spotřebního materiálu kazeta se svorkami kazeta se svorkami výměna"},{"UUID":"08556de6-9d65-4b67-b98c-1816eaf5a26c","title":"Výměna zásobníku svorek","link":"replacing-toner-cartridge-topic.html","desc":"Výměna držáků kazety se svorkami","descFull":"Výměna držáků kazety se svorkami v dokončovací schránce - vazači knih Otevřete dvířka finišeru. Vytáhněte vazač knih a poté vyjměte použité držáky kazet se svorkami. Rozbalte nové držáky zásobníku se svorkami. Vložte nové držáky kazety se svorkami. Vložte brožovací jednotku a zavřete dvířka finišeru. výměna součástí Držák zásobníku na svorky Držák zásobníku na svorky výměna"},{"UUID":"e282bb80-d3b5-4868-9689-1813649947eb","title":"Výměna částí a spotřebního materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Resetování počitadel spotřeby materiálu Resetování","descFull":"Resetování počitadel spotřeby materiálu Resetování počitadel spotřeby materiálu Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Údržba Nabídka konfigurace Počitadla a využití spotřebovaného materiálu . Vyberte počítadlo, které chcete vynulovat. Resetovat a repasovat lze pouze spotřební materiál a díly, na které se nevztahují smluvní podmínky vratného programu. Záruka výrobce se ale nevztahuje na jakékoliv poškození způsobené neoriginálním spotřebním materiálem nebo neoriginálními díly. Vynulování počítadel spotřebního materiálu nebo dílu bez řádného provedení repase může způsobit poškození tiskárny. Po vynulování počítadel spotřebního materiálu nebo dílů může tiskárna zobrazit chybu indikující přítomnost resetované položky. Resetovat a repasovat lze pouze spotřební materiál a díly, na které se nevztahují smluvní podmínky programu vrácení po použití. Záruka výrobce se ale nevztahuje na jakékoliv poškození způsobené neoriginálním spotřebním materiálem nebo neoriginálními díly. Vynulování počítadel spotřebního materiálu nebo dílu bez řádného provedení repase může způsobit poškození tiskárny. Po vynulování počítadel spotřebního materiálu nebo dílů může tiskárna zobrazit chybu indikující přítomnost resetované položky. počitadla spotřebního materiálu obnovení resetování počitadel spotřeby materiálu"},{"UUID":"b78cabb1-a06a-41f7-a482-7c6744d7f6e3","title":"Čištění částí tiskárny","link":"cleaning-printer-topic.html","desc":"Čištění tiskárny Čištění tiskárny K eliminaci","descFull":"Čištění tiskárny Čištění tiskárny K eliminaci nebezpečí úrazu elektrickým proudem při čištění vnějšku tiskárny odpojte napájecí kabel od elektrické zásuvky a odpojte z tiskárny všechny kabely. Tuto úlohu proveďte vždy po několika měsících. Poškození tiskárny způsobené nesprávnou manipulací není kryto zárukou. Vypněte tiskárnu a vytáhněte napájecí kabel z elektrické zásuvky. Vyjměte papír ze standardního zásobníku a z univerzálního podavače. Jemným kartáčkem nebo vysavačem odstraňte veškerý prach, nečistoty a kousky papíru z okolí tiskárny.   Navlhčeným měkkým hadříkem, který nepouští vlákna, otřete vnějšek tiskárny. Nepoužívejte domácí čisticí prostředky a saponáty, protože by mohly poškodit povrchovou úpravu tiskárny. Po čištění se ujistěte, že jsou všechny plochy tiskárny suché. Zapojte napájecí kabel do zásuvky a poté tiskárnu zapněte. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. čištění tiskárny tiskárna, čištění"},{"UUID":"263c045f-8aa3-447d-a7b5-290f4bad186c","title":"Čištění částí tiskárny","link":"cleaning-printer-topic.html","desc":"Čištění dotykového displeje Čištění dotykového","descFull":"Čištění dotykového displeje Čištění dotykového displeje Pokud chcete při čištění vnějšku tiskárny předejít nebezpečí úrazu elektrickým proudem, odpojte napájecí kabel od elektrické zásuvky a odpojte z tiskárny všechny kabely. Vypněte tiskárnu a vytáhněte napájecí kabel z elektrické zásuvky. Dotykový displej otřete vlhkým, měkkým netřepivým hadříkem. Nepoužívejte domácí čisticí prostředky a saponáty, protože by mohly dotykový displej poškodit. Po čištění se ujistěte, že je dotykový displej suchý. Zapojte napájecí kabel do zásuvky a poté tiskárnu zapněte. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. dotyková obrazovka, čištění čištění dotykové obrazovky"},{"UUID":"6c719df2-b2d6-408e-baf7-ab1689c7c361","title":"Čištění částí tiskárny","link":"cleaning-printer-topic.html","desc":"Čištění skeneru Otevřete kryt skeneru.","descFull":"Čištění skeneru Otevřete kryt skeneru. Vyjměte nástroj na čištění skla. Otevřete dvířka A1. Nástrojem otřete sklo automatického podavače dokumentů. Zavřete dvířka A1. Otřete následující oblasti vlhkým, měkkým netřepivým hadříkem. Skleněná podložka ADF Skleněná podložka skeneru Skleněná plocha skeneru Nástrojem otřete sklo automatického podavače dokumentů. Vraťte nástroj na místo. Zavřete kryt skeneru. skener čištění kvalita tisku čištění skeneru čištění skeneru"},{"UUID":"da34b3bb-e1cf-462b-84d4-ac6bbccf5c23","title":"Čištění částí tiskárny","link":"cleaning-printer-topic.html","desc":"Čištění čoček tiskové hlavy Otevřete","descFull":"Čištění čoček tiskové hlavy Otevřete přední dvířka. Vyjměte tonerové kazety. Opatrně vytáhněte stěrač až na doraz. Stěrač se neodpojuje od tiskárny. Zatlačte stěrač zpět do tiskové hlavy, dokud se nezastaví. Zopakujte  krok 3  a  krok 4  třikrát pro každou tiskovou hlavu. Vložte tonerové kazety. Zavřete přední dvířka. čočky tiskové hlavy čištění čištění čoček tiskové hlavy"},{"UUID":"5e780dd4-a3e8-47ca-b2d2-fe4ba56136ea","title":"Čištění částí tiskárny","link":"cleaning-printer-topic.html","desc":"Vyprázdnění nádobky děrovače V závislosti","descFull":"Vyprázdnění nádobky děrovače V závislosti na nainstalované dokončovací schránce se může vzhled nádobky děrovačky lišit. Otevřete dvířka finišeru. Vyjměte a poté vyprázdněte krabici děrovače. Vložte nádobku děrovače. Zavřete dvířka dokončovací schránky. nádobka děrovače vyprázdnění vyprázdnění nádobky děrovače"},{"UUID":"98778431-be40-4918-b981-40d801e0826b","title":"Úspora energie a papíru","link":"configuring-power-save-mode-settings-topic.html","desc":"Konfigurace nastavení energetického úsporného režimu","descFull":"Konfigurace nastavení energetického úsporného režimu Konfigurace nastavení energetického úsporného režimu Režim spánku Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zařízení Správa napájení Časové limity Režim spánku . Nastavte dobu, po kterou má tiskárna setrvat v nečinnosti, než přejde do  režimu spánku . Režim hibernace Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zařízení Správa napájení Časové limity Časový limit hibernace . Nastavte dobu, po kterou má tiskárna setrvat v nečinnosti, než přejde do režimu hibernace. Aby  doba hibernace  fungovala, nastavte  dobu hibernace při připojení  na  hibernovat . V režimu hibernace je server Embedded Web Server vypnutý. Režim spánku konfigurace Režim hibernace konfigurace energeticky úsporné režimy konfigurace"},{"UUID":"63b2f662-9981-4ceb-b452-83cb7f4570ea","title":"Úspora energie a papíru","link":"configuring-power-save-mode-settings-topic.html","desc":"Úprava jasu displeje Úprava jasu","descFull":"Úprava jasu displeje Úprava jasu displeje Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zařízení Předvolby . V nabídce  Jas obrazovky  upravte nastavení. jas displeje nastavení úprava jasu"},{"UUID":"b7056110-88fd-484e-aca0-d5f4cf4da414","title":"Úspora energie a papíru","link":"configuring-power-save-mode-settings-topic.html","desc":"Úspora spotřebního materiálu Tiskněte na","descFull":"Úspora spotřebního materiálu Tiskněte na obě strany papíru. Oboustranný tisk je výchozím nastavením tiskárny. Tiskněte více stránek na jeden list papíru. Funkce náhledu slouží k zobrazení vzhledu dokumentu před jeho vytisknutím. Vytiskněte jednu kopii dokumentu a zkontrolujte její obsah a formátování. úspora spotřebního materiálu spotřební materiál, úspora"},{"UUID":"81f62831-7da9-4d00-9a5c-de6e6243a0ce","title":"Údržba tiskárny","link":"moving-printer-topic.html","desc":"Přemístění tiskárny Přemístění tiskárny Přesahuje-li","descFull":"Přemístění tiskárny Přemístění tiskárny Přesahuje-li hmotnost tiskárny 20 kg (44 liber), může být k jejímu bezpečnému zdvižení třeba nejméně dvou osob. Abyste zabránili nebezpečí požáru nebo úrazu elektrickým proudem, používejte pouze napájecí kabel dodaný s výrobkem nebo odpovídající náhradní napájecí kabel schválený výrobcem. Při přemisťování tiskárny dodržte tyto pokyny, aby nedošlo ke zranění osob nebo poškození tiskárny: Přesvědčte se, že jsou zavřeny všechny zásobníky a dvířka. Vypněte tiskárnu a vytáhněte napájecí kabel z elektrické zásuvky. Od tiskárny odpojte veškeré šňůry a kabely. Pokud jsou k tiskárně připojeny samostatné stojanové přídavné zásobníky nebo možnosti výstupu, před přesouváním tiskárny je odpojte. Má-li tiskárna kolečkový podstavec, opatrně s ní přejeďte na nové místo. Dbejte zvláštní opatrnosti při překonávání prahů a předělů v podlaze. Není-li tiskárna vybavena kolečkovým podstavcem, ale je nakonfigurována s volitelnými zásobníky nebo možnosti výstupu, odstraňte možnosti výstupu a zvedněte tiskárnu ze zásobníků. Nezvedejte tiskárnu a volitelné doplňky současně. Tiskárnu zvedejte vždy pomocí úchytů. Pokud bude k přesouvání tiskárny použit vozík, musí disponovat dostatečně velkým povrchem, na který se vejde celá spodní část tiskárny. Pokud bude k přesouvání hardwarových doplňků použit vozík, musí disponovat dostatečně velkým povrchem, na který se doplňky vejdou. Držte tiskárnu ve vzpřímené pozici. Zabraňte prudkým otřesům a nárazům. Při pokládání tiskárny dejte pozor, abyste pod ní neměli prsty. Zkontrolujte, zda je kolem tiskárny dostatek místa. Poškození tiskárny způsobené nesprávným postupem při přesouvání není kryto zárukou. přemisťování tiskárny"},{"UUID":"827404d7-6bce-4e9d-81d8-3cfa7f8a8250","title":"Řešení problémů","link":"print-quality-problems-topic.html","desc":"Problémy s kvalitou tisku Zvolte obrázek,","descFull":"Problémy s kvalitou tisku Zvolte obrázek, který připomíná váš problém s kvalitou tisku, a poté klepněte na odkaz pod ním. Dozvíte se tak kroky, které vám pomohou problém vyřešit."},{"UUID":"d87796d0-5dc6-4a05-ab8e-fec88424d7c5","title":"Řešení problémů","link":"printer-error-codes-topic.html","desc":"Chybové kódy tiskárny Chybové kódy","descFull":"Chybové kódy tiskárny Chybové kódy a jejich řešení Chybové kódy Chybová zpráva Řešení 2.01 Je vyžadován spotřební materiál. Vyberte možnost  Zrušit úlohu  a objednejte potřebný spotřební materiál. Další informace najdete v tématu  . 3.01 Standardní výstupní zásobník je plný. Odeberte papír ze zásobníku a vyberte možnost  Pokračovat . 3.02, 3.03, 3.04 Odeberte papír ze zásobníku [x]. Odeberte papír ze zásobníku a vyberte možnost  Pokračovat . 7.13, 7.23, 7.33,7.43 Vložte zásobník [x]. Vložte označený zásobník. 8.01 Zavřete přední dvířka. Pokud zrovna neprovádíte údržbu, nechte přední dvířka zavřená. 8.02, 8.03, 8.04, 8.05, 8.08, 8.10, 8.11 Zavřete dvířka [x]. Pokud zrovna neprovádíte údržbu, nechte označená dvířka zavřená. 8.06 Znovu připojte zásobník na 1500 listů. Zkontrolujte, zda je zásobník správně připevněn k tiskárně. 8.07 Znovu připevněte sešívací finišer. Zkontrolujte, zda je dokončovací schránka správně připevněna k tiskárně. 8.08 Zavřete kryt F podávací jednotky. Pokud zrovna neprovádíte údržbu, ponechte kryt zavřený. 8.09 Zavřete kryt podávací jednotky G. 9 Tiskárna se musela restartovat. Poslední úloha pravděpodobně nebyla dokončena. Výběrem možnosti  Pokračovat  smažete zprávu a můžete pokračovat v tisku. 11.11, 11.21, 11.31, 11.41, 11.51, 11.81, 11.91 Vložte do <zdroj/> papír <typ/> <formát/>. Vložte do označeného zásobníku papír. Další informace najdete v tématu  . 11.12, 11.22, 11.32, 11.42, 11.82, 11.92 Vložte do <zdroj/> papír <typ/> <formát/> <orientace/>. 12.11, 12.21, 12.31, 12.41, 12.51, 12.91 Změňte <zdroj/> na <typ/> <formát/>.  Vytáhněte označený zásobník, vyjměte papír a vložte správný typ a formát papíru. Další informace najdete v tématu  . 12.12, 12.22, 12.32, 12.4212.92 Změňte <zdroj/> na <typ/> <formát/> <orientace/>.  31.00 Nádobka děrovače chybí nebo je plná. Otevřete dvířka H. Odstraňte nádobku děrovače. Je-li nádobka děrovače plná, vyprázdněte ji. Vložte nádobku děrovače. Zavřete dvířka H. 31.35, 31.35A, 31.35B Znovu nainstalujte chybějící nebo nereagující nádobku na odpadní toner. Otevřete přední dvířka. Vyjměte nádobku na odpadní toner. Abyste zamezili vylití toneru, umístěte láhev do vzpřímené polohy. Vložte nádobku na odpadní toner. Zavřete přední dvířka. 31.40z, 31.41z, 31.42z, 31.43z Znovu nainstalujte chybějící nebo nereagující [barva] tonerovou kazetu. Otevřete přední dvířka. Vyjměte kazetu. Vložte kazetu. Zavřete přední dvířka. 31.60z Přeinstalujte chybějící nebo nereagující černou zobrazovací jednotku. Otevřete přední dvířka. Vyjměte tonerové kazety. Vyjměte nádobku na odpadní toner. Abyste zamezili vylití toneru, umístěte láhev do vzpřímené polohy. Vyjměte zobrazovací sadu. Nevystavujte zobrazovací sadu přímému světlu. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Odjistěte a vyjměte černou zobrazovací jednotku. Vložte černou zobrazovací jednotku a zajistěte ji. Vložte zobrazovací sadu, aby zapadla na své místo. Vložte nádobku na odpadní toner. Vložte tonerové kazety. Zavřete přední dvířka. 31.64z Nainstalujte chybějící, odpojenou, nebo nereagující zobrazovací sadu. Otevřete přední dvířka. Vyjměte tonerové kazety. Vyjměte nádobku na odpadní toner. Abyste zamezili vylití toneru, umístěte láhev do vzpřímené polohy. Vyjměte zobrazovací sadu. Nevystavujte zobrazovací sadu přímému světlu. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte zobrazovací sadu, aby zapadla na své místo. Vložte nádobku na odpadní toner. Vložte tonerové kazety. Zavřete přední dvířka. 31.80z Znovu nainstalujte chybějící nebo nereagující zapékač. Otevřete dvířka B. Vnitřek tiskárny může být horký. Abyste omezili riziko zranění způsobeného horkou součástí, nedotýkejte se povrchu, dokud nevychladne. Odjistěte a vyjměte zapékač. Vložte zapékač a zajistěte jej. Zavřete dvířka B. 32.40z, 32.41z, 32.42z, 32.43z Vyměňte nepodporovanou [barva] tonerovou kazetu. Další informace najdete v tématu  . 32.60z Vyměňte nepodporovanou černou zobrazovací jednotku. Další informace najdete v tématu  . 32.65z Vyměňte nepodporovanou barevnou obrazovou sadu. Další informace najdete v tématu  . 33.40z, 33.41z, 33.42z, 33.43z Doplněná běžná [barevná] kazeta Další informace najdete v tématu  . 33.60z Neoriginální černá zobrazovací jednotka, viz Uživatelská příručka. Další informace najdete v tématu  . 33.64z Neoriginální barevná zobrazovací sada, viz Uživatelská příručka. 34.00 Krátký papír. Nastavte formát papíru podle papíru vloženého do zásobníku. Na ovládacím panelu přejděte do nabídky  Nastavení Papír Zásobník Konfigurace Formát/typ papíru . 34.10, 34.20, 34.30, 34.40, 34.50 Zkontrolujte [zdroj], nastavte vodicí lišty a orientaci. Vytáhněte označený zásobník a ujistěte se, že je papír správně vložený. Další informace najdete v tématu  . 34.90 Zkontrolujte univerzální podavač, nastavte vodicí lišty a orientaci. Ujistěte se, že je papír správně vložený. Další informace najdete v tématu  . 37.1 Nedostatek paměti ke kompletaci úlohy. Vyzkoušejte jeden z následujících kroků: Chcete-li vytisknout část úlohy, která je již uložena, a začít skládat kopie zbytku, vyberte možnost  Pokračovat . Zrušte aktuální tiskovou úlohu. 37.3 Nedostatek paměti, došlo k vymazání některých pozdržených úloh. Výběrem možnosti  Pokračovat  smažete zprávu a můžete pokračovat v tisku. 38.1 Paměť je plná. Vyzkoušejte jeden či více následujících kroků: Výběrem možnosti  Pokračovat  smažete zprávu a můžete pokračovat v tisku. Zrušte aktuální tiskovou úlohu. Nainstalujte do tiskárny další paměť. Snižte počet stránek v tiskové úloze. 39.1 Složitá strana, některá data možná nebyla vytištěna. Vyzkoušejte jeden či více následujících kroků: Výběrem možnosti  Pokračovat  smažete zprávu a můžete pokračovat v tisku. Zrušte aktuální tiskovou úlohu. Nainstalujte do tiskárny další paměť. Před opětovným odesláním tiskové úlohy k tisku snižte složitost a velikost tiskové úlohy. Snižte počet stránek v tiskové úloze. Snižte počet a velikost všech stažených písem. Odstraňte z tiskové úlohy všechna nepotřebná písma nebo makra. Snižte počet grafických prvků v tiskové úloze. 42.yyC, 42.yyK, 42.yyM, 42.yyY Vyměňte [barva] tonerovou kazetu, neshoda oblasti tiskárny. Další informace najdete v tématu  . 43.40Y, 43.41Y, 43.42Y, 43.43Y Znovu vložte [barva] tonerovou kazetu. Otevřete přední dvířka. Vyjměte kazetu. Vložte kazetu. Zavřete přední dvířka. 43.40Z, 43.41Z, 43.42Z, 43.43Z Vyměňte [barva] tonerovou kazetu. Další informace najdete v tématu  . 50 Chyba v písmu PPDS. Nainstalujte písmo PPDS uvedené v tiskové úloze a výběrem možnosti  Pokračovat  nechte tiskárnu vyhledat náhradní písmo. 51 Zjištěna vadná paměť flash. Vyzkoušejte jeden či více následujících kroků: Vyměňte vadnou paměť flash. Výběrem možnosti  Pokračovat  smažete zprávu a můžete pokračovat v tisku. Zrušte aktuální tiskovou úlohu. 52 Nedostatek volného místa v paměti flash pro zdroje. Vyzkoušejte jeden či více následujících kroků: Výběrem možnosti  Pokračovat  smažete zprávu a můžete pokračovat v tisku. Odstraňte písma, makra a další data uložená v paměti flash. Nainstalujte paměťovou jednotku. Stažená písma a makra, která nebyla dříve uložena do paměti flash, budou odstraněna. 58.4 Nesprávná konfigurace možností výstupu. Vypněte tiskárnu a nainstalujte správnou přihrádku nebo finišer. 61 Vyjměte vadný disk. Vyměňte vadnou paměťovou jednotku. 62 Disk plný. Vyzkoušejte jeden či více následujících kroků: Výběrem možnosti  Pokračovat  smažete zprávu a můžete pokračovat v tisku. Odstraňte písma, makra a další data uložená na paměťové jednotce. Nainstalujte paměťovou jednotku. 63 Naformátujte disk. Formátování nyní vymaže všechny informace z jednotky úložiště. Disk zformátujete takto: Na ovládacím panelu přejděte do části  Nastavení Zařízení Údržba Vymazání při vyřazení z provozu . Vyberte možnost  Ošetřit všechny informace na pevném disku  a poté vyberte možnost  VYMAZAT . 71.01 Nebyl nastaven název Faxování stanice. Obraťte se na správce systému. Další informace najdete v tématu  . 71.02 Nebylo nastaveno číslo Faxování stanice. Obraťte se na správce systému. 71.03 K modemu není připojena žádná analogová telefonní linka, fax je neaktivní Zkontrolujte připojení, a zda má linka signál. Další informace najdete v tématu  . 71.04 Analogová telefonní linka je připojena k nesprávnému portu. Odpojte telefonní linku a poté ji připojte k portu LINE. 71.06 Nelze navázat připojení k faxovému serveru HTTPS. Připojení k faxovému serveru HTTPS se přerušilo. Zkontrolujte připojení tiskárny k internetu. 71.07 Tiskárna není zaregistrována na faxovém serveru HTTPS. Zkontrolujte, zda je tiskárna přidaná do seznamu zařízení na portálu faxového serveru HTTPS. Kontaktujte správce systému. 71.11 Oddíl faxu. Oddíl faxování nefunguje. Kontaktujte správce systému. 71.12 Paměť je plná, nelze tisknout faxy. Pokud chcete vytisknout plný počet uložených faxů, vyberte možnost  Vytisknout vše . 71.13 Paměť je plná. Nelze odesílat faxy. Vyzkoušejte jeden z následujících kroků: Pokračujte a zkuste znovu odeslat fax. Naskenujte originální dokument po jednotlivých stránkách, vytočte faxové číslo a poté odešlete dokument faxem. 71.4 Čas tiskárny není správný. Konfigurace času tiskárny. Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Předvolby Datum a čas Konfigurovat . 72.01 E-mailový server SMTP není momentálně nastaven. Obraťte se na správce systému.  Vyzkoušejte jeden z následujících kroků: Nastavte funkci e-mailu. Další informace najdete v tématu  . Vypněte chybovou zprávu. Další informace najdete v tématu  . 72.02 Server webového odkazu není nastaven. Obraťte se na správce systému. Kontaktujte svého správce systému. 72.04 Faxový server Na formát není nastaven. Obraťte se na správce systému. Vyzkoušejte jeden z následujících kroků:  Konfigurace nastavení  Na formát . Na ovládacím panelu přejděte k položkám  Nastavení Faxování Nastavení faxového serveru Obecná nastavení faxu . Kontaktujte svého správce systému. 75.01 Detekován bezpečnostní prvek. Postupujte jedním z následujících způsobů: Použijte instalovaný bezpečnostní prvek. Tiskárna vymaže všechny stávající certifikáty a může také vymazat a znovu naformátovat paměťovou jednotku. Vypněte tiskárnu a poté bezpečnostní prvek odeberte. 75.02 Bezpečnostní prvek nebyl rozpoznán. 75.03 Chyba při komunikaci s bezpečnostním prvkem.  Postupujte jedním z následujících způsobů: Přestaňte používat bezpečnostní prvek. Tiskárna vymaže všechny stávající certifikáty a může také vymazat a znovu naformátovat paměťovou jednotku. Vypněte tiskárnu a bezpečnostní prvek odeberte a poté jej znovu nainstalujte. 75.11 Bezpečnostní prvek se nepodařilo aktualizovat. Postupujte jedním z následujících způsobů: Zkuste aktualizaci zopakovat. Zrušte aktualizaci. Tiskárna může vymazat všechny stávající certifikáty a obsah paměťové jednotky. 75.12 Aktualizace bezpečnostního prvku není dokončena. Postupujte jedním z následujících způsobů: Restartujte tiskárnu. Počkejte 10 sekund na dokončení aktualizace. Zrušte aktualizaci. Tiskárna může vymazat všechny stávající certifikáty a obsah paměťové jednotky. 80.01, 80.09 Sada pro údržbu – téměř nízká životnost. Smažte zprávu výběrem možnosti  Pokračovat . 80.11, 80.19 Sada pro údržbu – nízká životnost. 80.21, 80.29 Sada pro údržbu – velmi nízká životnost. 80.31 Vyměňte sadu pro údržbu a pokračujte v tisku. Další informace najdete v tématu  . 80.31 Vyměňte sadu pro údržbu, byla překročena doporučená životnost. 81.11 Životnost sady válců pro zásobník na 1500 listů je prakticky u konce. Smažte zprávu výběrem možnosti  Pokračovat . 81.31 Vyměňte sadu válců pro zásobník na 1500 listů, byla překročena jeho doporučená životnost. Chcete-li získat další informace, obraťte se na  zákaznická podpora . 82.00, 82.02, 82.09 Nádobka na odpadní toner je téměř plná. Další informace najdete v tématu  . 82.3, 82.32, 82.33, 82.39 Vyměňte nádobku na odpadní toner. 83.1y Dochází přenosový modul. Smažte zprávu výběrem možnosti  Pokračovat . 83.3y Vyměňte přenosový modul, překročena doporučená životnost. Chcete-li získat další informace, obraťte se na  zákaznická podpora . 83.4y Vyměňte přenosový modul. 83.20 V kazetě se svorkami docházejí svorky. Smažte zprávu výběrem možnosti  Pokračovat . 83.20 Dochází vnitřní svorky S2. 83.20 Dochází vnější svorky S2. 83.30 Kazeta se svorkami je prázdná nebo chybí. Vyzkoušejte jeden z následujících kroků: Vyjměte a poté vložte kazetu se svorkami. Vyměňte zásobník svorek. Další informace naleznete v části   nebo  . 83.30 Kazeta se svorkami S1 je prázdná nebo chybí. Vyzkoušejte jeden z následujících kroků: Vyjměte a poté vložte kazetu se svorkami. Vyměňte zásobník svorek. Další informace najdete v tématu  . 83.30 Kazeta s vnitřními svorkami S2 je prázdná nebo chybí. Vyzkoušejte jeden z následujících kroků: Vyjměte a poté vložte kazetu se svorkami. Vyměňte zásobník svorek. Další informace najdete v tématu  . 83.30 Kazeta s vnějšími svorkami S2 je prázdná nebo chybí. 84.01K, 84.03K, 84.09K Černá zobrazovací jednotka je téměř prázdná. Smažte zprávu výběrem možnosti  Pokračovat . 84.11K, 84.13K, 84.19K Černá zobrazovací jednotka je prázdná. 84.21C, 84.03C, 84.09C Černá zobrazovací jednotka je úplně prázdná. 84.01C, 84.03C, 84.09C Barevná zobrazovací sada je téměř prázdná. 84.11C, 84.13C, 84.19C Barevná zobrazovací sada je prázdná. 84.21C, 84.23C, 84.29C Téměř dochází barevná zobrazovací sada. 84.31, 84.33 Vyměňte černou zobrazovací jednotku, byla překročena doporučená životnost. Další informace najdete v tématu  . 84.31, 84.33 Vyměňte barevnou zobrazovací sadu, byla překročena doporučená životnost. Další informace najdete v tématu  . 84.41, 84.43, 84.48 Chcete-li pokračovat v tisku, vyměňte černou zobrazovací jednotku. Další informace najdete v tématu  . 84.41, 84.43, 84.48 Chcete-li pokračovat v tisku, vyměňte barevnou zobrazovací sadu. Další informace najdete v tématu  . 86.23 Nutná brzká údržba skeneru. Smažte zprávu výběrem možnosti  Pokračovat . 86.33 Vyměňte sadu podavače ADF, byla překročena doporučená životnost. Chcete-li získat další informace, obraťte se na  zákaznická podpora . 88.00[x], 88.07[x], 88.08[x], 88.09[x] [Barva] tonerová kazeta je téměř prázdná. Smažte zprávu výběrem možnosti  Pokračovat . 88.10[x], 88.17[x], 88.18[x], 88.19[x] [Barva] tonerová kazeta je prázdná. 88.20[x], 88.27[x], 88.28[x], 88.29[x] [Barva] tonerová kazeta je úplně prázdná. 88.30[x], 88.37[x], 88.38[x] Vyměňte [barva] tonerovou kazet, odhadovaný počet zbývajících stran: <NUM/>. Další informace najdete v tématu  . 88.30[x], 88.37[x], 88.38[x] Vyměňte [barva] tonerovou kazetu. 88.40[x], 88.47[x], 88.48[x] Vyměňte [barevnou] tonerovou kazetu, zbývá 0 stran. 88.40[x], 88.47[x], 88.48[x] Vyměňte [barva] tonerovou kazetu. 200.03, 200.05, 200.12, 200.13, 200.14, 200.15, 200.22, 200.23, 200.24, 200.25, 200.26, 200.32, 200.33, 200.34, 200.35, 200.36, 200.42, 200.43, 200.44, 200.45, 200.46, 200.52, 200.53, 200.54, 200.55, 200.56, 200.91, 201.91, 202.02, 202.03, 202.04, 202.05, 202.12, 202.13, 202.14, 202.15, 202.22, 202.23, 202.24, 202.25, 202.32, 202.33, 202.34, 202.35, 202.42, 202.43, 202.44, 202.45, 202.52, 202.53, 202.54, 202.55, 202.91, 202.93, 202.95, 231.03, 231.05, 231.13, 231.15, 231.23, 231.25, 231.33, 231.35, 231.43, 231.45, 231.53, 231.55, 231.91, 232.03, 232.05, 232.13, 232.15, 232.23, 232.25, 232.33, 232.35, 232.43, 232.45, 232.53, 232.55, 232.93, 232.94, 232.95, 240.05, 240.25, 240.35, 240.45, 240.55, 240.91, 240.95, 241.12, 241.14, 241.15, 241.91 Uvíznutí papíru v [MÍSTO/]. Další informace najdete v tématu  . 240.06 Uvíznutí papíru v [MÍSTO/]. Další informace najdete v tématu  . 241.16, 241.82, 241.83, 241.84, 661.13, 661.84 Chyba zavedení papíru do [MÍSTO/]. Otevřete zásobník 1. Vyjměte a znovu zarovnejte stoh papíru. V případě potřeby nastavte vodicí lišty. Znovu vložte zásobník 1. Zavřete zásobník 1. 242.23, 242.25, 242.35, 242.45, 242.55, 242.91 Uvíznutí papíru v [MÍSTO/]. Další informace najdete v tématu  . 242.33, 242.43, 243.33, 243.35, 243.36, 243.43, 243.35, 243.45, 243.45, 243.55, 243.91, 244.43, 244.45, 244.91 Uvíznutí papíru v [MÍSTO/]. Další informace naleznete v těchto částech: 243.43, 243.53, 244.43, 244.45, 244.46, 244.91, 245.53, 245.56, 245.55, 245.91, 602.59, 664.43, 665.53 Uvíznutí papíru v [MÍSTO/]. Další informace najdete v tématu  . 28X.13K, 28X.93K, 28X.15K, 28X.95K, 281.16K, 281.96K, 680.20K, 680.40K Při restartování úlohy znovu vložte všechny originální dokumenty. Vyzkoušejte jeden z následujících kroků: Restartujte úlohu. Zrušte úlohu. 28X.13Q, 28X.93Q, 28X.15Q, 28X.95Q, 281.16Q, 281.96Q, 680.20Q Před pokračováním v úloze vyměňte uvíznuté předlohy. Postupujte jedním z následujících způsobů: Skenování ze skleněné plochy skeneru. Proveďte skenování z automatického podavače dokumentů. Dokončete úlohu bez dalšího skenování. Zrušte úlohu. 280.06 Znovu založte předlohy do ADF a restartujte úlohu. 280.06, 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95, 281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13, 283.91, 283.15, 283.93, 284.11, 284.13, 284.15, 284.91, 284.93, 284.95, 295.01 Uvíznutí skeneru. Další informace najdete v tématu  . 291.06 Při restartu úlohy zavřete kryt plochy a vložte originály. Postupujte jedním z následujících způsobů: Skenování ze skleněné plochy skeneru. Proveďte skenování z automatického podavače dokumentů. Dokončete úlohu bez dalšího skenování. Zrušte úlohu. 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 444.66, 450.21, 450.23, 450.25, 450.98, 450.99, 451.21, 451.23, 451.25, 452.66, 453.21, 453.23, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 460.66, 461.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 472.66, 477.66, 480.66, 483.66, 486.29, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 Uvíznutí papíru v [MÍSTO/]. Další informace najdete v tématu  . 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 442.66, 444.66, 445.66, 450.21, 450.23, 450.25, 451.21, 451.23, 451.25, 451.98, 451.99, 452.66, 453.21, 453.23, 453.25, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 459.66, 460.66, 461.66, 462.66, 463.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 470.66, 472.66, 473.66, 476.66, 477.66, 480.66, 483.66, 486.29, 490.66, 491.21, 491.25, 491.66, 493.21, 494.21, 492.66, 494.66, 495.66, 496.66, 497.66, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 Uvíznutí papíru v [MÍSTO/]. Další informace najdete v tématu  . 420.11, 420.13, 420.15, 420.99, 421.56, 422.56, 423.56, 424.56, 425.13, 425.15, 425.11, 426.11, 426.15, 428.56A, 428.56B, 431.56, 435.56, 438.11, 439.19, 461.56, 698.19 Uvíznutí papíru v [MÍSTO/]. Další informace najdete v tématu  . 438.11, 500.11, 500.13, 500.15, 500.99, 502.11, 502.13, 502.15, 504.11, 504.13, 504.15, 505.13, 506.11, 506.13, 506.15, 507.11, 507.13, 507.15,  508.56, 509.56, 510.56, 511.56, 512.56, 513.56, 514.19, 698.19, 698.29 Uvíznutí papíru v [MÍSTO/]. Další informace najdete v tématu  . 602.29, 662.23 Chyba vložení papíru do zásobníku 2. Další informace najdete v tématu  . 602.39, 663.33 Chyba vložení papíru do zásobníku 3. Další informace naleznete v těchto částech: 602.49, 664.43 Chyba vložení papíru do zásobníku 4. Další informace najdete v tématu  . chybové kódy tiskárny chybové kódy zprávy tiskárny chybové zprávy"},{"UUID":"d71c7934-52fc-4e49-9402-c30eb86b31dd","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Prázdné nebo bílé stránky Před","descFull":"Prázdné nebo bílé stránky Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Ujistěte se, že je ze zobrazovací sady, zobrazovací jednotky a tonerových kazet odstraněn veškerý obalový materiál. Zkontrolujte, jestli tiskárna používá originální podporovanou tonerovou kazetu Lexmark. Zkontrolujte, jestli tiskárna používá originální podporovanou tonerovou kazetu. Pokud není kazeta podporována, nainstalujte podporovanou kazetu. Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku bílé stránky problém s kvalitou tisku prázdné strany prázdné strany bílé stránky"},{"UUID":"6d9c9aec-e42b-4407-979d-d7e730171191","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Tmavý tisk Před odstraňováním problému","descFull":"Tmavý tisk Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Na ovládacím panelu přejděte k položkám  Nastavení Tisk Kvalita Pokročilé zobrazování  a poté vyberte možnost  Barevná úprava . Snižte sytost toneru v dialogovém okně Předvolby tisku nebo Tisk (podle operačního systému). Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Tisk Kvalita Sytost toneru . Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá papíru založenému v zásobníku.  Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Zkontrolujte, zda papír nemá texturu nebo drsný povrch. Vložte papír z čerstvého balení. Papír zvlhnul kvůli vysoké vlhkosti prostředí. Ponechte papír v originálním balení, dokud se jej nebudete chystat použít. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku tmavý tisk tmavý tisk"},{"UUID":"6acb5926-1354-4eba-9b05-c8e7bc51d6a7","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Stíny Před odstraňováním problému vytiskněte","descFull":"Stíny Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Vložte do zásobníku papír správného typu a gramáže. Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá papíru založenému v zásobníku.  Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Na ovládacím panelu přejděte k položkám  Nastavení Tisk Kvalita Pokročilé zobrazování  a poté vyberte možnost  Barevná úprava . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku stíny stíny"},{"UUID":"91e8a097-dfc3-4bd3-935d-d1503921787f","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Šedé nebo barevné pozadí Před","descFull":"Šedé nebo barevné pozadí Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Zvyšte sytost toneru v dialogovém okně Předvolby tisku nebo Tisk (podle operačního systému). Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Tisk Kvalita Sytost toneru . Na ovládacím panelu přejděte k položkám  Nastavení Tisk Kvalita Pokročilé zobrazování  a poté vyberte možnost  Barevná úprava . Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku šedé nebo barevné pozadí na výtisku se objevuje šedé pozadí na výtisku se objevuje barevné pozadí"},{"UUID":"5b6a23e6-974e-48be-9845-cdd03f08a8b3","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Nesprávné okraje Vyzkoušejte jeden či","descFull":"Nesprávné okraje Vyzkoušejte jeden či více následujících kroků: Nastavte vodicí lišty papíru v zásobníku do správné polohy pro vloženou velikost papíru. Zadejte formát papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá založenému papíru.  Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku nesprávné okraje nesprávné okraje"},{"UUID":"cb117a2c-8769-4f74-9e2b-c701424c1bef","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Světlý tisk Před odstraňováním problému","descFull":"Světlý tisk Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Ujistěte se, že je ze zobrazovací sady, zobrazovací jednotky a tonerových kazet odstraněn veškerý obalový materiál. Na ovládacím panelu přejděte k položkám  Nastavení Tisk Kvalita Pokročilé zobrazování  a poté vyberte možnost  Barevná úprava . Zvyšte sytost toneru v dialogovém okně Předvolby tisku nebo Tisk (podle operačního systému).  Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Tisk Kvalita Sytost toneru . Na ovládacím panelu přejděte k položkám  Nastavení Tisk Kvalita  a vypněte možnost  Šetřič barev . Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá založenému papíru.  Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Zkontrolujte, zda papír nemá texturu nebo drsný povrch. Vložte papír z čerstvého balení. Papír zvlhnul kvůli vysoké vlhkosti prostředí. Ponechte papír v originálním balení, dokud se jej nebudete chystat použít. Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku světlý tisk světlý tisk"},{"UUID":"a03aeebc-889b-4f4f-bfbd-0a4eef3a97ac","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Chybějící barvy Před odstraňováním problému","descFull":"Chybějící barvy Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Ujistěte se, že je ze zobrazovací sady, zobrazovací jednotky a tonerových kazet odstraněn veškerý obalový materiál. Vyjměte vývojovou jednotku chybějící barvy. Vyjměte zobrazovací sadu. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vyjměte a poté vložte vývojovou jednotku chybějící barvy. Vložte zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku chybějící barvy chybějící barvy"},{"UUID":"772dc108-4e81-4b15-826e-0efb2c3cd143","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Tisk se skvrnami a tečkami Tisk","descFull":"Tisk se skvrnami a tečkami Tisk se skvrnami a tečkami Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Zkontrolujte, zda není tiskárna kontaminována vyteklým tonerem. Ujistěte se, že nastavení formátu a typu papíru odpovídají vloženému papíru. Na ovládacím panelu přejděte do nabídky  Nastavení Papír Konfigurace zásobníku Formát/Typ papíru . Zkontrolujte, zda papír nemá texturu nebo drsný povrch. Zadejte formát a typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá papíru založenému v zásobníku. Vložte papír z čerstvého balení. Papír zvlhnul kvůli vysoké vlhkosti prostředí. Ponechte papír v originálním balení, dokud se jej nebudete chystat použít. Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku tisk se skvrnami a tečkami tisk se skvrnami a tečkami tečky na vytištěné stránce"},{"UUID":"0c63f517-a7b4-43f2-a486-5ef9d1dc4d06","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Výtisk je křivý nebo zkosený","descFull":"Výtisk je křivý nebo zkosený Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Vložte papír z čerstvého balení. Otevřete zásobník a vyjměte papír. Vložte papír z čerstvého balení. Papír zvlhnul kvůli vysoké vlhkosti prostředí. Ponechte papír v originálním balení, dokud se jej nebudete chystat použít. Nastavte vodicí lišty papíru v zásobníku do správné polohy pro vloženou velikost papíru. Zkontrolujte, zda tisknete na podporovaný papír. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku šikmý tisk problém s kvalitou tisku křivý tisk křivý tisk šikmý tisk"},{"UUID":"16a8e14d-f5a8-4334-83c6-64fa8f0ce0cb","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Obrázky vytištěné jednou barvou nebo","descFull":"Obrázky vytištěné jednou barvou nebo celé černé Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku obrázky vytištěné jednou barvou nebo celé černé plná barva černé obrázky"},{"UUID":"23acc661-f624-49fe-814d-97b1f513415c","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Oříznutý text nebo obrázky Před","descFull":"Oříznutý text nebo obrázky Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Ujistěte se, že je ze zobrazovací sady, zobrazovací jednotky a tonerových kazet odstraněn veškerý obalový materiál. Nastavte vodicí lišty papíru v zásobníku do správné polohy pro vloženou velikost papíru. Zadejte formát papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá papíru založenému v zásobníku.  Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku oříznutý text nebo obrázky oříznutý text na výtisku oříznuté obrázky na výtisku"},{"UUID":"914f0545-5735-4675-b9a5-48430b0fee62","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Toner se snadno smazává Před","descFull":"Toner se snadno smazává Před odstraňováním problému vytiskněte zkušební stránku. Na ovládacím panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Zkuste provést následující: Zkontrolujte, zda je napájecí kabel tiskárny připojen k řádně uzemněné elektrické zásuvce vhodných parametrů. Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá založenému papíru. Na ovládacím panelu nastavte typ papíru. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku toner se snadno smazává toner se snadno smazává"},{"UUID":"10a7380b-37fa-4f8f-97aa-a0580e97fcaa","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Nerovnoměrný tisk Před odstraňováním problému","descFull":"Nerovnoměrný tisk Před odstraňováním problému vytiskněte zkušební stránku. Z kontrolního panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Otevřete dvířka B a zkontrolujte, že druhý nanášecí válec je zajištěn na svém místě. Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku nerovnoměrný tisk nerovnoměrný tisk"},{"UUID":"2d753e3e-1d85-48bc-a15c-e2b981ceadcb","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Vodorovné tmavé čáry Před odstraňováním","descFull":"Vodorovné tmavé čáry Před odstraňováním problému vytiskněte zkušební stránku. Z kontrolního panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Pokud se ve výtiscích stále zobrazují vodorovné tmavé čáry, nahlédněte do části  . Vyzkoušejte jeden či více následujících kroků: Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá založenému papíru. Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Zkontrolujte, zda papír nemá texturu nebo drsný povrch. Vložte papír z čerstvého balení. Papír zvlhnul kvůli vysoké vlhkosti prostředí. Ponechte papír v originálním balení, dokud se jej nebudete chystat použít. Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku vodorovné tmavé čáry vodorovné tmavé čáry"},{"UUID":"f3afc7c7-2363-4c6f-8b53-50b0cbc27ebe","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Svislé tmavé čáry Před odstraňováním","descFull":"Svislé tmavé čáry Před odstraňováním problému vytiskněte zkušební stránku. Z kontrolního panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá papíru založenému v zásobníku. Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Zkontrolujte, zda papír nemá texturu nebo drsný povrch. Vložte papír z čerstvého balení. Papír zvlhnul kvůli vysoké vlhkosti prostředí. Ponechte papír v originálním balení, dokud se jej nebudete chystat použít. Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku na výtiscích se objevují svislé tmavé čáry svislé tmavé čáry na výtiscích"},{"UUID":"bd46b905-f224-4723-aacc-48a828b10974","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Vodorovné bílé čáry Před odstraňováním","descFull":"Vodorovné bílé čáry Před odstraňováním problému vytiskněte zkušební stránku. Z kontrolního panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Pokud se ve výtiscích stále zobrazují vodorovné bílé čáry, nahlédněte do části  . Vyzkoušejte jeden či více následujících kroků: Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá papíru založenému v zásobníku. Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Vložte zvolený zdroj papíru s doporučeným typem papíru. Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte fotoválec přímému světlu. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnů fotoválců. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku vodorovné bílé čáry vodorovné bílé čáry"},{"UUID":"da6843e3-5ffc-43f8-a903-266399b94302","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Svislé bílé čáry Před odstraňováním","descFull":"Svislé bílé čáry Před odstraňováním problému vytiskněte zkušební stránku. Z kontrolního panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Vyzkoušejte jeden či více následujících kroků: Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá papíru založenému v zásobníku. Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Zkontrolujte, zda používáte doporučený typ papíru. Do zvoleného zdroje papíru nezapomeňte vložit doporučený typ papíru. Ověřte, že jsou zobrazovací sada a černá zobrazovací jednotka správně nainstalovány. Vyjměte zobrazovací sadu a poté černou zobrazovací jednotku. Nevystavujte zobrazovací sadu ani černou zobrazovací jednotku přímému světlu na více než 10 minut. Delší vystavení přímému světlu může způsobit problémy s kvalitou tisku. Nedotýkejte se bubnu fotoválce pod zobrazovací jednotkou nebo černou zobrazovací sadou. Učiníte-li tak, můžete negativně ovlivnit kvalitu budoucích tiskových úloh. Vložte černou zobrazovací jednotku a poté zobrazovací sadu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku svislé bílé čáry svislé bílé čáry"},{"UUID":"1f579e9d-a18f-49e3-b90b-b482e6141dda","title":"Kvalita tisku je špatná","link":"solving-printing-problems.html","desc":"Opakované chyby Před odstraňováním problému","descFull":"Opakované chyby Před odstraňováním problému vytiskněte zkušební stránku. Z kontrolního panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Ze zásobníku 1 vytiskněte vzorové stránky a ověřte, že je papír vložen s orientací na výšku. Určete, kolik barev má vady. Změřte vzdálenost mezi opakujícími se vadami na dotčené barevné stránce. Pomocí stránky Pravítko určení defektu změřte vzdálenost mezi opakujícími se vadami na dotčené barevné stránce. Vyměňte spotřební materiál nebo díl, která odpovídá výsledku měření na dotčené barevné stránce. Barevná zobrazovací sada nebo černá zobrazovací jednotka 94,5 mm (3,72 palce) 19,9 mm (1,18 palce) 23,2 mm (0,19 palce) Vývojová jednotka 43,6 mm (1,72 palce) 45,0 mm (1,77 palce) Zapékač 95 mm (3,74 palce) 110 mm (4,33 palce) Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku opakované vady tisku opakované vady tisku"},{"UUID":"c94643a5-bee9-42cb-8a56-9a9be905ff68","title":"Potíže s tiskem","link":"solving-printing-problems.html","desc":"Tiskové úlohy se netisknou Vyzkoušejte","descFull":"Tiskové úlohy se netisknou Vyzkoušejte jeden či více následujících kroků: V dokumentu, který se chystáte vytisknout, otevřete dialogové okno Předvolby tisku nebo Tisk a zkontrolujte, zda jste vybrali správnou tiskárnu. Zkontrolujte, zda je tiskárna zapnutá, a vyřešte všechny chybové zprávy zobrazené na displeji. Zkontrolujte, zda jsou porty funkční a zda jsou kabely bezpečně připojeny k počítači a k tiskárně. Další informace vyhledejte v dokumentaci k nastavení dodané s tiskárnou. Vypněte tiskárnu, vyčkejte přibližně 10 sekund a pak ji znovu zapněte. Odinstalujte a znovu nainstalujte ovladač tisku. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s tiskem tiskové úlohy se netisknou tiskové úlohy se nevytiskly tiskové úlohy se netisknou"},{"UUID":"ba5be9b7-f45c-4dfd-9c74-d2db848eae5f","title":"Potíže s tiskem","link":"solving-printing-problems.html","desc":"Důvěrné a jiné pozdržené dokumenty se","descFull":"Důvěrné a jiné pozdržené dokumenty se netisknou Vyzkoušejte jeden či více následujících kroků: Z ovládacího panelu zkontrolujte, zda se dokumenty zobrazují v seznamu  Pozdržené úlohy . Pokud se dokumenty v seznamu nezobrazují, vytiskněte je pomocí možností Vytisknout a pozdržet. Vyřešte případné chyby formátování nebo neplatná data v tiskové úloze. Odstraňte tiskovou úlohu a poté ji znovu odešlete. V případě souborů PDF vygenerujte nový soubor a poté dokument vytiskněte. Pokud tisknete z Internetu, tiskárna může číst úlohy více názvů úloh jako duplicitní položky. Uživatelé systému Windows: V dialogovém okně Předvolby tisku nebo Tisk vyberte možnost  Zachovat duplicitní dokumenty . Uživatelé systému Macintosh: Pojmenujte každou úlohu jinak. Odstraňte některé pozdržené úlohy a uvolněte tak paměť tiskárny. Nainstalujte do tiskárny další paměť. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku důvěrné a jiné pozdržené dokumenty se netisknou důvěrné dokumenty se netisknou pozdržené dokumenty se netisknou"},{"UUID":"2ceabd87-3cea-4c3b-ad60-8537f696bea0","title":"Potíže s tiskem","link":"solving-printing-problems.html","desc":"Úloha se tiskne z nesprávného zásobníku","descFull":"Úloha se tiskne z nesprávného zásobníku nebo na nesprávný papír Vyzkoušejte jeden či více následujících kroků: Ujistěte se, že tisknete na správný papír. Zadejte formát a typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá papíru založenému v zásobníku. Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Zkontrolujte, zda nejsou zásobníky propojeny. Další informace najdete v tématu  . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s tiskem úlohy se tisknou z nesprávného zásobníku problém s tiskem úlohy se tisknou na nesprávný papír úlohy se tisknou z nesprávného zásobníku úlohy se tisknou na nesprávný papír"},{"UUID":"305b4c1b-d0bb-4fe9-a73a-b9c3e7f1a047","title":"Potíže s tiskem","link":"solving-printing-problems.html","desc":"Pomalý tisk Vyzkoušejte jeden či","descFull":"Pomalý tisk Vyzkoušejte jeden či více následujících kroků: Zkontrolujte, zda je kabel tiskárny řádně připojený k tiskárně, počítači, tiskovému serveru, volitelnému doplňku nebo jinému síťovému zařízení. Ujistěte se, že tiskárna není v  tichém režimu . Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Údržba Nabídka Konfigurace Provoz zařízení Tichý režim . Určete rozlišení dokumentu, který chcete vytisknout. V závislosti na operačním systému přejděte do dialogového okna Předvolby tisku nebo Tisk. Nastavte rozlišení na  4800 CQ . Nastavení můžete změnit také pomocí ovládacího panelu. Přejděte k položkám  Nastavení Tisk Kvalita Rozlišení tisku . Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Nastavení můžete změnit také pomocí ovládacího panelu. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Tisk na těžší papír probíhá pomaleji. Tisk na papír užší než letter, A4 a legal může probíhat pomaleji. Zkontrolujte, zda nastavení tiskárny pro texturu a hmotnost odpovídají zakládanému papíru. Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Papír Konfigurace médií Typy médií .  Drsný povrch papíru a vysoká hmotnost papíru mohou způsobit pomalejší tisk. Odeberte pozastavené úlohy. Ujistěte se, že se tiskárna nepřehřívá. Po dokončení dlouhé tiskové úlohy nechte tiskárnu vychladnout. Sledujte doporučenou okolní teplotu pro tiskárnu. Další informace najdete v tématu  . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s tiskem pomalý tisk pomalý tisk"},{"UUID":"13234ed5-727d-45d5-afd2-cedfb9ff3545","title":"Řešení problémů","link":"trb-printer-not-responding-topic.html","desc":"Tiskárna nereaguje. Vyzkoušejte jeden či","descFull":"Tiskárna nereaguje. Vyzkoušejte jeden či více následujících kroků: Zkontrolujte, zda je napájecí kabel připojen k elektrické zásuvce. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zkontrolujte, zda elektrická zásuvka není vypnuta pomocí spínače nebo jističe. Zkontrolujte, zda je tiskárna zapnuta. Ujistěte se, že tiskárna není v režimu spánku nebo hibernace. Zkontrolujte, zda jsou kabely spojující tiskárnu a počítač připojeny ke správným portům. Vypněte tiskárnu, nainstalujte hardwarové doplňky, a poté ji znovu zapněte. Další informace vyhledejte v dokumentaci dodané společně s doplňkem. Nainstalujte správný ovladač tiskárny. Vypněte tiskárnu, vyčkejte přibližně 10 sekund a pak ji znovu zapněte. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s tiskem tiskárna nereaguje tiskárna nereaguje"},{"UUID":"b065735b-52c2-43f6-9bc2-e1425bf14b85","title":"Řešení problémů","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Jednotku paměti flash nelze přečíst","descFull":"Jednotku paměti flash nelze přečíst Vyzkoušejte jeden či více následujících kroků: Ověřte, že tiskárna není zaneprázdněna zpracováním více úloh. Ujistěte se, že je jednotka paměti flash zasunuta do předního portu USB. Jednotka paměti flash nebude funkční, pokud je zasunuta do zadního portu USB. Ujistěte se, že jednotka paměti flash je podporována. Další informace najdete v tématu  . Vyjměte a poté vložte jednotku paměti flash. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . jednotku paměti flash nelze přečíst problém s tiskem jednotku paměti flash nelze přečíst"},{"UUID":"19d17f59-90d6-41ea-a20a-6554b749b151","title":"Řešení problémů","link":"enabling-usb-port-topic.html","desc":"Povolení portu USB Na ovládacím","descFull":"Povolení portu USB Na ovládacím panelu přejděte k položkám  Nastavení Síť/porty USB . Vyberte možnost  Povolit port USB . port USB povolení povolení portu USB nastavení portu USB"},{"UUID":"d59565a2-0689-42fa-a0e7-85f0670385f5","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Prevence uvíznutí Vložte správně papír.","descFull":"Prevence uvíznutí Vložte správně papír. Ujistěte se, že papír leží v zásobníku rovně. Správné a nesprávné vložení papíru Správné vložení papíru Nesprávné vložení papíru Při probíhajícím tisku neplňte ani nevyjímejte zásobník. Nezakládejte příliš mnoho papíru. Ujistěte se, že výška stohu papíru nepřesahuje indikátor značky maximálního množství papíru. Nezasouvejte papír do zásobníku. Vložte papíru podle obrázku. Ujistěte se, že jsou správně umístěná vodítka papíru a že příliš netlačí na papír či obálky. Po založení papíru zásobník přiměřenou silou zatlačte do tiskárny. Používejte doporučený papír. Používejte pouze doporučený papír a speciální média. Nevkládejte pomačkaný, zohýbaný, vlhký, ohnutý nebo zprohýbaný papír. Papír před vložením ohněte, promněte a vyrovnejte hrany. Nepoužívejte papír, který je nastříhaný nebo nařezaný ručně. Nepoužívejte více formátů, gramáží a typů papíru v jednom zásobníku. Ujistěte se, že je v počítači nebo na ovládacím panelu tiskárny správně zadán formát a typ papíru. Papír skladujte v souladu s doporučeními výrobce. uvíznutí papíru prevence uvíznutí, papír prevence prevence uvíznutí papíru"},{"UUID":"4aaa3aef-c048-4976-92ea-8b71c8d3fb34","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Identifikace míst zaseknutí Pokud je","descFull":"Identifikace míst zaseknutí Pokud je možnost  Pomocník při uvíznutí  nastavena na hodnotu  Zapnuto , tiskárna po odstranění zaseknuté stránky vysune prázdné nebo částečně potištěné stránky. Vyhledejte ve výstupu tisku prázdné stránky. Pokud je možnost  Napravit uvíznutí  nastavena na hodnotu  Zapnuto  nebo  Automaticky , vytiskne tiskárna uvíznuté stránky znovu. Místa uvíznutí Místa uvíznutí 1 Dvířka B 2 Univerzální podavač 3 Standardní zásobník 4 Standardní zásobník 5 Automatický podavač dokumentů 6 Sešívací finišer 7 Volitelný zásobník na 550 listů 8 Zásobník na 2 x 550 listů 9 Zásobník na 1500 listů 10 Sešívací, děrovací finišer 11 Podávací jednotka s možností skládání 12 dvojitý zásobník na 2000 listů 13 Brožovací finišer uvíznutí papíru vyhledání místa uvíznutí identifikace"},{"UUID":"2bafac1b-ac90-42d1-a428-cf4aab011224","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Zaseknutí papíru ve standardním zásobníku","descFull":"Zaseknutí papíru ve standardním zásobníku Zaseknutí papíru ve standardním zásobníku Vytáhněte standardní zásobník. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Vložte zásobník. odstraňování uvíznutého papíru ve standardním zásobníku vyjmutí uvíznutého papíru ve standardním zásobníku zaseknutí papíru ve standardním zásobníku"},{"UUID":"39bdab59-36e4-47c0-82b1-c11b8542df15","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutý papír ve volitelném zásobníku","descFull":"Uvíznutý papír ve volitelném zásobníku na 550 listů Otevřete dvířka D. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka. Vytáhněte volitelný zásobník na 550 listů. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Vložte zásobník. odstraňování uvíznutého papíru v zásobníku na 550 listů vyjmutí uvíznutého papíru v zásobníku na 550 listů uvíznutí papíru v zásobníku na 550 listů"},{"UUID":"7711fca2-1634-4095-949b-1d8292d54c1b","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutí papíru v podavači ADF Zaseknutí","descFull":"Uvíznutí papíru v podavači ADF Zaseknutí papíru ve dvířkách A Otevřete dvířka A. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka A. Zaseknutí papíru ve dvířkách A1 Otevřete kryt skeneru. Stlačením zelené západky otevřete dvířka A1. Otočte zeleným knoflíkem u dvířek A1 doprava a vyjměte zaseknutý papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka A1 a poté zavřete i kryt skeneru. Zaseknutí papíru v přihrádce automatického podavače dokumentů Vyjměte všechny papíry z přihrádky automatického podavače dokumentů. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. odstraňování uvíznutého papíru v automatickém podavači dokumentů uvíznutý papír v automatickém podavači dokumentů vyjmutí uvíznutého papíru v automatickém podavači dokumentů"},{"UUID":"f7734568-96a9-4583-9261-80853cc2405c","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutí papíru v univerzálním podavači Vyjměte","descFull":"Uvíznutí papíru v univerzálním podavači Vyjměte všechen papír z univerzálního podavače. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. odstraňování uvíznutého papíru do univerzálního podavače vyjmutí uvíznutého papíru do univerzálního podavače zaseknutí papíru v univerzálním podavači"},{"UUID":"b5d42458-5e1c-431a-963a-60d824e4ff52","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutí papíru v zásobníku na 2x","descFull":"Uvíznutí papíru v zásobníku na 2x 550 listů Otevřete dvířka E. Vyjměte zaseknutý papír uvnitř dvířek E. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka E. Vytáhněte zásobník 3. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Vložte zásobník 3. Zopakujte  krok 4  až  krok 6  pro zásobník 4. odstraňování uvíznutého papíru Zásobník na 2 x 550 listů vyjmutí uvíznutého papíru Zásobník na 2 x 550 listů uvíznutý papír Zásobník na 2 x 550 listů"},{"UUID":"e1b04d04-1d52-42a0-8849-2cd0f0f773a0","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutý papír v zásobníku na 2000 listů","descFull":"Uvíznutý papír v zásobníku na 2000 listů Otevřete dvířka E. Vyjměte zaseknutý papír uvnitř dvířek E. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka E. odstraňování uvíznutého papíru ve dvojitém zásobníku na 2000 listů vyjmutí uvíznutého papíru ve dvojitém zásobníku na 2000 listů uvíznutý papír v zásobníku na 2000 listů"},{"UUID":"03db268f-b5c7-4504-a03b-8f7f81410216","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutý papír v zásobníku na 1500 listů","descFull":"Uvíznutý papír v zásobníku na 1500 listů Otevřete dvířka K. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka K. Uchopte držadlo J a posuňte zásobník doprava. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zasuňte zásobník zpět na místo. odstraňování uvíznutého papíru v zásobníku na 1500 listů vyjmutí uvíznutého papíru v zásobníku na 1500 listů uvíznutý papír v zásobníku na 1500 listů"},{"UUID":"1211c60a-fe7f-47fa-81aa-04f910bb6476","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutí papíru ve dvířkách B Otevřete","descFull":"Uvíznutí papíru ve dvířkách B Otevřete dvířka B. Vnitřek tiskárny může být horký. Abyste omezili riziko zranění způsobeného horkou součástí, nedotýkejte se povrchu, dokud nevychladne. Aby nedošlo k poškození elektrostatickým výbojem, dotkněte se jakéhokoliv nekrytého kovového povrchu tiskárny před přístupem k vnitřním částem tiskárny, nebo než se těchto částí dotknete. Vyjměte zaseknutý papír ze všech následujících míst: Ujistěte se, že jsou vyjmuty všechny útržky papíru. Nad zapékačem V zapékači Pod zapékačem Pod výstupním válcem standardního zásobníku V jednotce pro oboustranný tisk Zavřete dvířka B. Uvíznutí papíru ve dvířkách B zaseknutí papíru v zapékači zablokování papíru v jednotce pro oboustranný tisk odstraňování uvíznutého papíru v zapékači odstraňování uvíznutého papíru v jednotce pro oboustranný tisk vyjmutí uvíznutého papíru v zapékači vyjmutí uvíznutého papíru v jednotce pro oboustranný tisk"},{"UUID":"f993b29f-dc17-461d-9bd7-a231dc71fc49","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutí papíru ve standardním odkladači","descFull":"Uvíznutí papíru ve standardním odkladači Vyjměte veškerý papír ze standardního zásobníku. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. odstraňování uvíznutého papíru standardní zásobník vyjmutí uvíznutého papíru ve standardním odkladači zaseknutý papír ve standardním zásobníku"},{"UUID":"23e91096-de5c-442a-936b-8cbdc8f07410","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutí papíru v sešívacím finišeru Vyjměte","descFull":"Uvíznutí papíru v sešívacím finišeru Vyjměte zaseknutý papír z přihrádky sešívacího finišeru. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Uchopte držadlo F a posuňte sešívací finišer doleva. Otevřete dvířka R1 a otočte kolečkem R2 po směru hodinových ručiček. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka R1. Vyjměte uvíznutý papír z výstupního válce standardního zásobníku. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zasuňte sešívací finišer zpět na místo. odstraňování uvíznutého papíru v sešívacím finišeru vyjmutí uvíznutého papíru v sešívacím finišeru uvíznutý papír v sešívacím finišeru"},{"UUID":"0bca09e0-05a3-41bd-be9f-a479f6d5be89","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutí papíru v podávací jednotce s","descFull":"Uvíznutí papíru v podávací jednotce s možností skládání Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otevřete dvířka F. Zvedací držadlo N4. Zvedací držadlo N5. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete držadlo N5 a poté zavřete držadlo N4. Zatlačte držadlo N1 dolů. Otočte kolečkem N2 proti směru hodinových ručiček. Vyjměte zablokovaný papír. Abyste předešli poškození tiskárny, odstraňte si před vyjmutím uvíznutého papíru z rukou veškeré šperky. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Držadlo N1 vraťte zpět na místo. Zavřete dvířka F. odstraňování uvíznutého papíru v podávací jednotce s možností skládání vyjmutí uvíznutého papíru v podávací jednotce s možností skládání uvíznutý papír v podávací jednotce s možností skládání"},{"UUID":"48d557e8-1c00-4195-ac6d-b1d5bb3d30e8","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"uvíznutí papíru v sešívacím, děrovacím finišeru","descFull":"uvíznutí papíru v sešívacím, děrovacím finišeru Pokud je tiskárna nakonfigurována s podávací jednotkou, postupujte takto: Vyjměte uvíznutý papír v přihrádce 1. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Neodstraňujte vytištěné stránky, které jsou v přihrádce na sešívané stránky, aby poté nechyběly. Vyjměte zaseknutý papír ze standardního zásobníku dokončovací schránky. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Vyjměte uvíznutý papír v přihrádce 2. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otevřete kryt G podávací jednotky a vyjměte uvíznutý papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete kryt podávací jednotky G. Otevřete dvířka I, otevřete dvířka R1 a poté vyjměte uvíznutý papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka R1 a poté dvířka I. Otevřete kryt podávací jednotky F. Otevřete dvířka H. Zvedací držadlo R4. Otočte kolečkem R3 proti směru hodinových ručiček a vyjměte uvíznutý papír z přihrádky 1. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otočte kolečkem R2 proti směru hodinových ručiček a vyjměte uvíznutý papír z krytu F podávací jednotky. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete kryt F podávací jednotky. Vraťte držadlo R4 do původní polohy. Zavřete dvířka H. Pokud je tiskárna nakonfigurována s podávací jednotkou s možností skládání, postupujte takto: Vyjměte uvíznutý papír v přihrádce 1. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Neodstraňujte vytištěné stránky, které jsou v přihrádce na sešívané stránky, aby poté nechyběly. Vyjměte zaseknutý papír ze standardního zásobníku dokončovací schránky. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Vyjměte uvíznutý papír v přihrádce 2. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otevřete dvířka F. Otevřete dvířka N4. Otevřete dvířka N5. Otevřete dvířka H. Zvedací držadlo R4. Otočte kolečkem R3 proti směru hodinových ručiček a vyjměte uvíznutý papír z přihrádky 1. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otočte kolečkem R2 proti směru hodinových ručiček a poté vyjměte papír uvíznutý mezi dvířky N4 a N5. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otevřete dvířka B. Vnitřek tiskárny může být horký. Abyste omezili riziko zranění způsobeného horkou součástí, nedotýkejte se povrchu, dokud nevychladne. Aby nedošlo k poškození elektrostatickým výbojem, dotkněte se jakéhokoliv nekrytého kovového povrchu tiskárny před přístupem k vnitřním částem tiskárny, nebo než se těchto částí dotknete. Vyjměte uvíznutý papír zpod výstupního válce standardního zásobníku. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka B. Zatlačte držadlo N1 dolů. Otočte kolečkem N2 proti směru hodinových ručiček. Vyjměte zablokovaný papír. Abyste předešli poškození tiskárny, odstraňte si před vyjmutím uvíznutého papíru z rukou veškeré šperky. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Držadlo N1 vraťte zpět na místo. Zavřete držadlo N5 a poté zavřete držadlo N4. Zavřete dvířka F. Vraťte držadlo R4 do původní polohy. Zavřete dvířka H. odstraňování uvíznutého papíru v sešívacím děrovacím finišeru vyjmutí uvíznutého papíru v sešívacím děrovacím finišeru zaseknutí papíru v sešívacím, děrovacím finišeru"},{"UUID":"7fe30c00-06db-46d6-bb2e-32532f10e3d8","title":"Odstranění zaseknutého papíru","link":"clearing-jams.html","desc":"Uvíznutí papíru v brožovací schránce Pokud","descFull":"Uvíznutí papíru v brožovací schránce Pokud je tiskárna nakonfigurována s podávací jednotkou, postupujte takto: Vyjměte zaseknutý papír ze standardního zásobníku dokončovací schránky. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Vyjměte uvíznutý papír v přihrádce 1. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Vyjměte uvíznutý papír v přihrádce 1. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Neodstraňujte vytištěné stránky, které jsou v přihrádce na sešívané stránky, aby poté nechyběly. Vyjměte uvíznutý papír v přihrádce 3. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otevřete kryt G podávací jednotky a vyjměte uvíznutý papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete kryt podávací jednotky G. Otevřete kryt podávací jednotky F. Otevřete dvířka H. Přesuňte držadlo R3 doprava a odstraňte uvíznutý papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Posuňte držadlo R1 doleva, otočte kolečko R2 proti směru hodinových ručiček a vyjměte uvíznutý papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otočte kolečko R5 proti směru hodinových ručiček a poté vyjměte papír uvíznutý ve standardního zásobníku dokončovací schránky. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zvedněte držadlo R4, otočte kolečko R2 po směru hodinových ručiček a poté vyjměte uvíznutý papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete kryt F podávací jednotky. Vraťte držadla R1, R3 a R4 do původní polohy. Zavřete dvířka H. Pokud je tiskárna nakonfigurována s podávací jednotkou s možností skládání, postupujte takto: Vyjměte zaseknutý papír ze standardního zásobníku dokončovací schránky. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Vyjměte uvíznutý papír v přihrádce 1. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Vyjměte uvíznutý papír v přihrádce 1. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Neodstraňujte vytištěné stránky, které jsou v přihrádce na sešívané stránky, aby poté nechyběly. Vyjměte uvíznutý papír v přihrádce 3. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otevřete dvířka F. Otevřete dvířka H. Otevřete dvířka N4. Otevřete dvířka N5. Zvedací držadlo R4. Otočte kolečko R2 po směru hodinových ručiček a poté vyjměte uvíznutý papír v držadle R4. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Posuňte držadlo R1 doleva, otočte kolečko R2 proti směru hodinových ručiček a vyjměte papír uvíznutý mezi dvířky N4 a N5. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otevřete dvířka B. Vnitřek tiskárny může být horký. Abyste omezili riziko zranění způsobeného horkou součástí, nedotýkejte se povrchu, dokud nevychladne. Aby nedošlo k poškození elektrostatickým výbojem, dotkněte se jakéhokoliv nekrytého kovového povrchu tiskárny před přístupem k vnitřním částem tiskárny, nebo než se těchto částí dotknete. Vyjměte uvíznutý papír zpod výstupního válce standardního zásobníku. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka B. Zatlačte držadlo N1 dolů. Otočte kolečkem N2 proti směru hodinových ručiček. Vyjměte zablokovaný papír. Abyste předešli poškození tiskárny, odstraňte si před vyjmutím uvíznutého papíru z rukou veškeré šperky. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Držadlo N1 vraťte zpět na místo. Zavřete dvířka N5 a poté dvířka N4. Zavřete dvířka F. Vraťte držadla R1 a R4 zpět do původní polohy. Zavřete dvířka H. Uvíznutí papíru ve vazači knih Vyjměte uvíznutý papír v přihrádce 2. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otevřete dvířka H. Otočte kolečka R6, R11 a R10 po směru hodinových ručiček. Vytáhněte brožovací jednotku. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Otáčejte kolečkem R9 proti směru hodinových ručiček, dokud se nezastaví. Otevřete dvířka R8. Vyjměte zablokovaný papír. Ujistěte se, že jsou vyjmuty všechny útržky papíru. Zavřete dvířka R8. Vraťte vazač knih do dokončovací schránky – vazače knih. Zavřete dvířka H. odstraňování uvíznutého papíru v dokončovací schránce – vazači knih vyjmutí uvíznutého papíru v dokončovací schránce – vazači knih uvíznutí papíru v dokončovací schránce – vazači knih"},{"UUID":"bb28df9d-94ff-4bba-a498-da976d0e21db","title":"Problémy se síťovým připojením","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Embedded Web Server nelze spustit","descFull":"Embedded Web Server nelze spustit Embedded Web Server nelze spustit Vyzkoušejte jeden či více následujících kroků: Zkontrolujte, že je tiskárna zapnutá. Ujistěte se, že je adresa IP tiskárny správná. Na ovládacím panelu zobrazte IP adresu. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Ujistěte se, že jste nainstalovali podporovaný prohlížeč. Internet Explorer verze 11 nebo novější Microsoft Edge Safari verze 6 nebo novější Google Chrome  verze 32 nebo novější Mozilla Firefox verze 24 nebo novější Zkontrolujte, zda funguje připojení k síti. Pokud připojení nefunguje, obraťte se na správce. Ujistěte se, že jsou kabely řádně připojené k tiskárně a tiskovému serveru. Další informace vyhledejte v dokumentaci dodané s tiskovým serverem. Zkontrolujte, zda jsou webové servery proxy zakázány. Pokud jsou servery zakázány, obraťte se na správce. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . Embedded Web Server nelze spustit řešení problémů Embedded Web Server nelze spustit"},{"UUID":"078efa66-1390-430a-9ca6-f710e4ba08ab","title":"Problémy se síťovým připojením","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Tiskárnu nelze připojit k síti Wi-Fi","descFull":"Tiskárnu nelze připojit k síti Wi-Fi Tiskárnu nelze připojit k síti Wi-Fi Vyzkoušejte jeden či více následujících kroků: Na ovládacím panelu přejděte k položkám  Nastavení Síť/porty Přehled sítě Aktivní adaptér  a poté vyberte možnost  Automaticky . Ujistěte se, zda je počítač připojen ke správné síti Wi-Fi. Další informace najdete v tématu  . Některé směrovače mohou mít stejný výchozí název sítě Wi-Fi. Ujistěte se, že jste zadali správné heslo sítě. Při zadávání hesla si dejte pozor na mezery, čísla a velká písmena. Ověřte, že jste vybrali správný režim zabezpečení bezdrátové sítě. Na ovládacím panelu přejděte k položkám  Nastavení Sítě/porty Bezdrátová síť Režim zabezpečení bezdrátové sítě . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . tiskárnu nelze připojit k síti Wi-Fi řešení problémů tiskárnu nelze připojit k síti Wi-Fi"},{"UUID":"2c6209ed-3f1a-4735-a021-5a7039bf2821","title":"Problémy s hardwarovými doplňky","link":"trb-cannot-detect-internal-option-topic.html","desc":"Nelze rozpoznat interní volitelný doplněk","descFull":"Nelze rozpoznat interní volitelný doplněk Nelze rozpoznat interní volitelný doplněk Vyzkoušejte jeden či více následujících kroků: Vypněte tiskárnu, vyčkejte přibližně 10 sekund a pak ji znovu zapněte. Vytiskněte  stránku s nastavením  a zkontrolujte, jestli je interní doplněk uveden v seznamu Instalované funkce. Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zprávy Stránka s nastavením . Ověřte, zda je interní volitelný doplněk správně nainstalován na desce řadiče. Vypněte tiskárnu a vytáhněte napájecí kabel z elektrické zásuvky. Zkontrolujte, zda je interní doplněk nainstalován do správného konektoru na desce řadiče. Zapojte napájecí kabel do zásuvky a poté tiskárnu zapněte. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Ujistěte se, že je interní volitelný doplněk k dispozici v ovladači tiskárny. V případě potřeby přidejte interní volitelný doplněk do ovladače tiskárny ručně, aby byl k dispozici pro tiskové úlohy. Další informace najdete v tématu  . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problémy s hardwarovými doplňky nelze rozpoznat interní volitelný doplněk volitelný interní doplněk nebyl zjištěn nelze rozpoznat interní volitelný doplněk"},{"UUID":"0770b64d-8474-4c3c-addc-accd70600f4e","title":"Problémy s hardwarovými doplňky","link":"trb-cannot-detect-internal-option-topic.html","desc":"Internal Solutions Port nefunguje správně","descFull":"Internal Solutions Port nefunguje správně Internal Solutions Port nefunguje správně Vyzkoušejte jeden či více následujících kroků: Vytiskněte  stránku s nastavením nabídek  a zkontrolujte, jestli je port Internal Solutions Port (ISP) uveden v seznamu instalovaných funkcí. Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zprávy Stránka s nastavením . Vyjměte a znovu nainstalujte port ISP. Další informace najdete v tématu  . Zkontrolujte kabel a připojení ISP. Použijte správný kabel a zkontrolujte, zda je bezpečně připojen k portu ISP. Zkontrolujte, zda je kabel rozhraní řešení ISP řádně připojen k příslušné zásuvce na desce řadiče. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . řešení problémů internal solutions port problém s volitelnými doplňky tiskárny internal solutions port Internal Solutions Port nefunguje správně"},{"UUID":"5eb9abee-b89a-49fb-bcc5-db16c97c7a70","title":"Problémy s hardwarovými doplňky","link":"trb-cannot-detect-internal-option-topic.html","desc":"Karta paralelního nebo sériového rozhraní","descFull":"Karta paralelního nebo sériového rozhraní nefunguje správně Karta paralelního nebo sériového rozhraní nefunguje správně Vyzkoušejte jeden či více následujících kroků: Vytiskněte  stránku s nastavením  a zkontrolujte, jestli je karta paralelního nebo sériového rozhraní uvedena v seznamu instalovaných funkcí. Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zprávy Stránka s nastavením . Odeberte a poté nainstalujte kartu paralelního nebo sériového rozhraní. Další informace najdete v tématu  . Zkontrolujte připojení mezi kabelem a kartou paralelního nebo sériového rozhraní. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s volitelnými doplňky tiskárny karta paralelního rozhraní problém s volitelnými doplňky tiskárny karta sériového rozhraní řešení problémů karta paralelního rozhraní řešení problémů karta sériového rozhraní"},{"UUID":"8bf7d742-7b94-4980-be06-2799eba71a22","title":"Problémy s hardwarovými doplňky","link":"trb-cannot-detect-internal-option-topic.html","desc":"Zjištěna vadná paměť flash Zjištěna","descFull":"Zjištěna vadná paměť flash Zjištěna vadná paměť flash Vyzkoušejte jeden či více následujících kroků: Vadnou paměť flash vyměňte. Stisknutím tlačítka  Pokračovat  ignorujte zprávu a pokračujte v tisku. Zrušte aktuální tiskovou úlohu. zprávy tiskárny zjištěna vadná paměť flash vadná paměť flash řešení problémů vadná paměť flash"},{"UUID":"92211f75-35dc-40d5-84f0-cd1e62a3b145","title":"Problémy s hardwarovými doplňky","link":"trb-cannot-detect-internal-option-topic.html","desc":"Nedostatek volného místa v paměti flash","descFull":"Nedostatek volného místa v paměti flash pro zdroje Nedostatek volného místa v paměti flash pro zdroje Vyzkoušejte jeden či více následujících kroků: Výběrem možnosti  Pokračovat  smažete zprávu a můžete pokračovat v tisku. Odstraňte písma, makra a další data uložená v paměti flash. Nainstalujte paměťovou jednotku. Stažená písma a makra, která nebyla dříve uložena do paměti flash, budou odstraněna. zprávy tiskárny Nedostatek volného místa v paměti flash pro zdroje Nedostatek volného místa v paměti flash pro zdroje"},{"UUID":"28a3e80c-948e-4bf9-aa92-831f4a9c2f13","title":"Problémy se spotřebním materiálem","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Vyměňte kazetu, neshoda regionu tiskárny","descFull":"Vyměňte kazetu, neshoda regionu tiskárny Tento problém opravíte zakoupením kazety se správným regionem, který se shoduje s regionem tiskárny nebo zakoupením celosvětové kazety. První číslo ve zprávě za číslem 42 označuje region tiskárny. Druhé číslo ve zprávě za číslem 42 označuje region kazety. Nainstalujte správnou tonerovou kazetu. Regiony tiskáren a tonerových kazet Oblast Číselný kód Celosvětově nebo Nedefinovaný region 0 Severní Amerika (Spojené státy, Kanada) 1 Evropský hospodářský prostor, Západní Evropa, severské země, Švýcarsko 2 Asie a Tichomoří 3 Latinská Amerika 4 Zbývající část Evropy, Střední východ, Afrika 5 Austrálie, Nový Zéland 6 Neplatný region 9 Chcete-li zjistit nastavení regionu tiskárny a tonerové kazety, vytiskněte  zkušební stránky kvality tisku . Z kontrolního panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . zprávy tiskárny Vyměňte kazetu, neshoda regionu tiskárny Vyměňte kazetu, neshoda regionu tiskárny kazeta, neshoda regionu tiskárny"},{"UUID":"073485cf-0495-4e05-a1cf-5286d8af77cb","title":"Problémy se spotřebním materiálem","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Doplněná běžná [barevná] kazeta Tiskárna","descFull":"Doplněná běžná [barevná] kazeta Tiskárna zjistila běžnou kazetu Lexmark, která byla doplněna neoriginálním tonerem od jiného výrobce než od společností Lexmark. Tiskárna zjistila běžnou kazetu, která byla doplněna neoriginálním tonerem od jiného výrobce než od výrobce vaší tiskárny. Pokračujte výběrem možnosti  OK . Všechny indikátory životnosti součástí tiskárny jsou navrženy tak, aby fungovaly se spotřebním materiálem a díly značky Lexmark, a když repasi provedou jiné strany než společnost Lexmark, může použití takovéhoto spotřebního materiálu a dílů v tiskárně Lexmark přinést nepředvídatelné výsledky. Všechny indikátory životnosti součástí tiskárny jsou navrženy tak, aby fungovaly se spotřebním materiálem a díly od daného výrobce, a když repasi provedou jiné strany než daný výrobce, může použití takovéhoto spotřebního materiálu a dílů v tiskárně přinést nepředvídatelné výsledky. Více informací naleznete v prohlášení o omezené záruce na tiskárnu. zprávy tiskárny doplněná běžná kazeta neoriginální toner spotřební materiál jiných výrobců"},{"UUID":"5d2e5332-3906-4b1c-bf2c-987d7bc13712","title":"Problémy se spotřebním materiálem","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Spotřební materiál od jiného výrobce","descFull":"Spotřební materiál od jiného výrobce než Lexmark Spotřební materiál od jiného výrobce než Dell Spotřební materiál od jiného výrobce než výrobce tiskárny Tiskárna zjistila, že je v tiskárně nainstalován spotřební materiál nebo díl od jiného výrobce. Tiskárna zjistila, že je v tiskárně nainstalován spotřební materiál nebo díl od jiného výrobce než Dell. Tiskárna zjistila, že je v tiskárně nainstalován nerozpoznaný spotřební materiál nebo díl. Tiskárna Lexmark je navržena tak, aby fungovala nejlépe s pravým spotřebním materiálem a díly Lexmark. Použití spotřebních materiálů či dílů jiných výrobců můžete ovlivnit výkon, spolehlivost či životnost tiskárny a jejích zobrazovacích součástí. Tiskárna Dell je navržena tak, aby fungovala nejlépe s originálním spotřebním materiálem a díly Dell. Použití spotřebních materiálů či dílů jiných výrobců můžete ovlivnit výkon, spolehlivost či životnost tiskárny a jejích zobrazovacích součástí. Tiskárna je navržena tak, aby fungovala nejlépe s originálním spotřebním materiálem a díly vyrobenými výrobcem tiskárny. Použití spotřebních materiálů či dílů jiných výrobců můžete ovlivnit výkon, spolehlivost či životnost tiskárny a jejích zobrazovacích součástí. Všechny ukazatele životnosti jsou navrženy pro používání spotřebního materiálu a dílů Lexmark a mohou přivodit nepředvídatelné důsledky, pokud se použije spotřební materiál či díly jiného výrobce. Používání zobrazovacích součástí po uplynutí zamýšlené životnosti může tiskárnu Lexmark nebo související součásti poškodit. Všechny ukazatele životnosti jsou navrženy pro používání spotřebního materiálu a dílů Dell a mohou přivodit nepředvídatelné důsledky při použití spotřebního materiálu či dílů od jiného výrobce. Používání zobrazovacích součástí po uplynutí zamýšlené životnosti může tiskárnu Dell nebo související součásti poškodit. Všechny ukazatele životnosti jsou navrženy pro používání spotřebního materiálu a dílů od výrobce tiskárny a mohou přivodit nepředvídatelné důsledky, pokud se použije spotřební materiál či díly jiného výrobce. Používání zobrazovacích součástí po uplynutí zamýšlené životnosti může tiskárnu nebo související součásti poškodit.  Použití spotřebních materiálů nebo dílů jiných výrobců může ovlivnit pokrytí zárukou. Poškození způsobené použitím spotřebního materiálu či dílů jiného výrobce nemusí být zárukou pokryto. Pokud přijímáte všechna tato rizika a chcete pokračovat s použitím neoriginálního spotřebního materiálu nebo dílů ve vaší tiskárně, dvěma prsty stiskněte a přidržte chybovou zprávu na displeji po dobu 15 sekund. Po zobrazení potvrzovacího dialogového okna stiskněte tlačítko  Pokračovat . Pokud tato rizika nechcete přijmout, vyjměte spotřební materiál či díl od jiného výrobce z tiskárny a nainstalujte originální spotřební materiál či díl Lexmark. Další informace najdete v tématu  . Pokud tato rizika nechcete přijmout, vyjměte spotřební materiál či díl od jiného výrobce z tiskárny a nainstalujte originální spotřební materiál či díl Dell. Pokud tato rizika nechcete přijmout, vyjměte spotřební materiál či díl od jiného výrobce z tiskárny a poté nainstalujte originální spotřební materiál či díl od výrobce tiskárny. Pokud po vymazání chybové zprávy tiskárna netiskne, vynulujte počitadlo využití spotřebního materiálu. Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Údržba Nabídka konfigurace Počitadla a využití spotřebovaného materiálu . Vyberte díl nebo spotřební materiál, který chcete resetovat, a poté vyberte položku  Spustit . Přečtěte si varovnou zprávu, a poté vyberte možnost  Pokračovat . Stisknutím dvou prstů na displeji po dobu 15 sekund zprávu vymažete. Pokud se vám nepodaří resetovat počitadla spotřeby materiálu, vraťte položku v místě nákupu. zprávy tiskárny Spotřební materiál od jiného výrobce než Lexmark Spotřební materiál od jiného výrobce než Lexmark zprávy tiskárny Spotřební materiál od jiného výrobce než Dell Spotřební materiál od jiného výrobce než Dell zprávy tiskárny Spotřební materiál od jiného výrobce než výrobce tiskárny Spotřební materiál od jiného výrobce než výrobce tiskárny obnovení počitadla spotřebního materiálu počitadla spotřebního materiálu obnovení resetování počitadel spotřeby materiálu"},{"UUID":"271b3142-8e33-4261-821a-0e3aceba4386","title":"Potíže s podáváním papíru","link":"trb-paper-curl-topic.html","desc":"Zvlněný papír Vyzkoušejte jeden či","descFull":"Zvlněný papír Vyzkoušejte jeden či více následujících kroků: Nastavte vodicí lišty v zásobníku do správné polohy pro vloženou velikost papíru. Zadejte typ papíru z dialogového okna Předvolby tisku nebo Tisk (podle operačního systému). Ujistěte se, že nastavení odpovídá založenému papíru. Nastavení můžete změnit také pomocí ovládacího panelu tiskárny. Přejděte na položku  Nastavení Papír Konfigurace zásobníku Formát/typ papíru . Vyjměte papír, otočte jej a znovu vložte. Vložte papír z čerstvého balení. Papír zvlhnul kvůli vysoké vlhkosti prostředí. Ponechte papír v originálním balení, dokud se jej nebudete chystat použít. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou tisku zvlněný papír zvlněný papír"},{"UUID":"d36d2d1e-59af-4988-8584-f99ea4a22327","title":"Potíže s podáváním papíru","link":"trb-paper-curl-topic.html","desc":"Obálka se při tisku zalepí","descFull":"Obálka se při tisku zalepí Vyzkoušejte jeden či více následujících kroků: Použijte obálku, které byla uložena v suchém prostředí. Při tisku na obálky s vysokým obsahem vlhkosti se mohou obálky zalepit. Nastavte typ papíru na možnost  Obálka . Na ovládacím panelu přejděte do nabídky  Nastavení Papír Konfigurace zásobníku Formát/Typ papíru . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s podáváním papíru obálka se při tisku zalepí obálka se při tisku zalepí"},{"UUID":"c8fd8a81-15df-4043-89af-b0d7641a31b9","title":"Potíže s podáváním papíru","link":"trb-paper-curl-topic.html","desc":"Tisk se skládáním kopií nefunguje","descFull":"Tisk se skládáním kopií nefunguje Vyzkoušejte jeden či více následujících kroků: Na ovládacím panelu přejděte k položkám  Nastavení  Tisk Rozvržení Skládání  a poté vyberte možnost  Zapnuto [1,2,1,2,1,2] . V dokumentu, který se chystáte vytisknout, otevřete dialogové okno Předvolby tisku nebo Tisk a poté zvolte možnost  Skládání . Snižte počet stran určených k tisku. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s podáváním papíru tisk se skládáním kopií nefunguje tisk se skládáním kopií nefunguje"},{"UUID":"cecd01ca-fa32-49b3-ba39-44c5906dc9bd","title":"Potíže s podáváním papíru","link":"trb-paper-curl-topic.html","desc":"Spojování zásobníků nefunguje Vyzkoušejte jeden","descFull":"Spojování zásobníků nefunguje Vyzkoušejte jeden či více následujících kroků: Zkontrolujte, zda propojené zásobníky obsahují papír stejného formátu, orientace a typu. Ujistěte se, že jsou správně nastavena vodítka papíru. Nastavte formát a typ papíru podle papíru vloženého do propojených zásobníků. Na ovládacím panelu přejděte do nabídky  Nastavení Papír Konfigurace zásobníku Formát/Typ papíru . Zkontrolujte, zda je  Spojování zásobníků  nastaveno na možnost  Automaticky . Další informace najdete v tématu  . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s podáváním papíru spojování zásobníků nefunguje spojování zásobníků nefunguje"},{"UUID":"dcdf5dbe-6015-4688-aeb7-9a4d36a4ca92","title":"Potíže s podáváním papíru","link":"trb-paper-curl-topic.html","desc":"Časté uvíznutí papíru Vyzkoušejte jeden","descFull":"Časté uvíznutí papíru Vyzkoušejte jeden či více následujících kroků: Zkontrolujte, zda je papír správně vložený. Ujistěte se, že jsou správně nastavena vodítka papíru. Ujistěte se, že výška stohu papíru nepřesahuje indikátor značky maximálního množství papíru. Ujistěte se, že tisknete na papír doporučeného formátu a typu. Nastavení správný formát a typ papíru. Na ovládacím panelu přejděte do nabídky  Nastavení Papír Konfigurace zásobníku Formát/Typ papíru . Vložte papír z čerstvého balení. Papír zvlhnul kvůli vysoké vlhkosti prostředí. Ponechte papír v originálním balení, dokud se jej nebudete chystat použít. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s podáváním papíru časté uvíznutí papíru časté uvíznutí papíru"},{"UUID":"920995e2-192b-4c20-ad02-3900f62beb88","title":"Potíže s podáváním papíru","link":"trb-paper-curl-topic.html","desc":"Uvíznuté stránky se nevytisknou znovu","descFull":"Uvíznuté stránky se nevytisknou znovu Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Oznámení Obnova obsahu po uvíznutí . V nabídce  Obnovení po zablokování  vyberte možnost  Zapnuto  nebo  Automaticky . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s tiskem uvíznuté stránky se nevytisknou znovu uvíznuté stránky se nevytisknou znovu"},{"UUID":"08d51fc9-8152-4f94-ae4f-a60b2d77286b","title":"Problémy s e-mailem","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Zakázání chybové zprávy „Není nastaven","descFull":"Zakázání chybové zprávy „Není nastaven server SMTP“ Na ovládacím panelu tiskárny přejděte na položku  Nastavení E-mail Nastavení e-mailu . Parametr  Zakázat chybu „Není nastaven server SMTP“  nastavte na  Zapnuto . Chcete-li zabránit opakování chyby, proveďte jeden nebo více z následujících kroků: Aktualizujte firmware tiskárny. Podrobnější informace najdete v části „Aktualizace firmwaru“. Nakonfigurujte nastavení e-mailového serveru SMTP. Další informace najdete v tématu  . chyba nenastaveného serveru SMTP vypnutí řešení problémů chyba nenastaveného serveru SMTP zakázání chyby nenastaveného serveru SMTP"},{"UUID":"eacf9aa9-7449-4b95-bc01-072b1d62e732","title":"Problémy s e-mailem","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Nelze odeslat e-mail Zkuste některé","descFull":"Nelze odeslat e-mail Zkuste některé z následujících postupů: Ujistěte se, že jsou správně nakonfigurována e-mailová nastavení SMTP. Další informace najdete v tématu  . Ujistěte se, že je tiskárna připojena k síti a síť je připojena k internetu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s e-mailem nelze odeslat e-mail nelze odeslat e-mail"},{"UUID":"674fec46-5b6c-4bc4-a258-cbe34803490d","title":"Problémy s faxováním","link":"trb-caller-id-not-shown-topic.html","desc":"Nezobrazuje se ID volajícího Nezobrazuje","descFull":"Nezobrazuje se ID volajícího Nezobrazuje se ID volajícího Tyto pokyny platí pouze pro tiskárny s nainstalovanou faxovou kartou. Na ovládacím panelu přejděte k položkám  Nastavení Fax Nastavení faxu  Nastavení příjmu faxů Ovládací prvky správy . Parametr  Povolit ID volajícího  nastavte na hodnotu  Zapnuto . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s faxováním nezobrazuje se ID volajícího nezobrazuje se ID volajícího"},{"UUID":"524382e0-d2e9-4975-af83-3c6ef42f8248","title":"Problémy s faxováním","link":"trb-caller-id-not-shown-topic.html","desc":"Nelze odesílat ani přijímat faxy","descFull":"Nelze odesílat ani přijímat faxy pomocí analogového faxu Nelze odesílat ani přijímat faxy pomocí analogového faxu Vyzkoušejte jeden či více následujících kroků: Vyřešte veškerá chybová hlášení, která se zobrazují na displeji. Zkontrolujte, zda jsou řádně připojeny kabely telefonu, sluchátka nebo záznamníku. Zkontrolujte oznamovací tón. Zavolejte na faxové číslo, abyste se ujistili, zda je řádně funkční. Používáte-li funkci Vytáčení v zavěšeném stavu, zvyšte hlasitost a zkontrolujte, zda je slyšet oznamovací tón. Zkontrolujte konektor telefonního kabelu. Zapojte analogový telefon přímo do zásuvky ve zdi. Počkejte na oznamovací tón. Pokud neuslyšíte oznamovací tón, použijte jiný telefonní kabel. Pokud stále neslyšíte oznamovací tón, připojte analogový telefon do jiné telefonní zásuvky ve zdi. Uslyšíte-li oznamovací tón, připojte tiskárnu k této telefonní zásuvce. Zkontrolujte, zda je tiskárna připojena k lince analogové telefonní služby nebo ke správnému digitálnímu konektoru. Používáte-li telefonní službu ISDN (Integrated Services for Digital Network), proveďte připojení k analogovému telefonnímu portu adaptéru terminálu ISDN. Další informace získáte od svého poskytovatele služby ISDN. Používáte-li DSL, proveďte připojení k filtru DSL nebo k routeru podporujícímu použití analogových zařízení. Další informace získáte od svého poskytovatele DSL. Používáte-li telefonní službu pobočkové ústředny (PBX), přesvědčte se, zda se připojujete k analogovému konektoru na PBX. Není-li k dispozici žádná z těchto možností, pak zvažte instalaci analogové telefonní linky pro faxový přístroj. Dočasně odpojte ostatní zařízení a deaktivujte ostatní telefonní služby. Odpojte ostatní zařízení (například záznamníky, počítače, modemy nebo rozdělovače telefonních linek) mezi tiskárnou a telefonní linkou. Deaktivujte službu čekajících hovorů a hlasovou schránku. Další informace získáte od své telefonní společnosti. Odesílejte originální dokument po jednotlivých stránkách. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s faxováním nelze odesílat ani přijímat faxy pomocí analogového faxu nelze odesílat ani přijímat faxy pomocí analogového faxu"},{"UUID":"c2d3cd64-ea97-43f2-87b8-c4396af51216","title":"Problémy s faxováním","link":"trb-caller-id-not-shown-topic.html","desc":"Lze přijímat, ale nikoli odesílat","descFull":"Lze přijímat, ale nikoli odesílat faxy pomocí analogového faxu Lze přijímat, ale nikoli odesílat faxy pomocí analogového faxu Vyzkoušejte jeden či více následujících kroků: Položte originální dokument do zásobníku automatického podavače dokumentů (ADF) nebo na skleněnou plochu skeneru. Nastavte řádně číslo zástupce. Zkontrolujte, zda je nastaveno číslo zástupce pro telefonní číslo, které chcete vytočit. Vytočte telefonní číslo ručně. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s faxováním nelze odesílat faxy pomocí analogového faxu nelze odesílat faxy pomocí analogového faxu"},{"UUID":"356a9c8b-58ad-4e77-83d0-a9174da9b7e8","title":"Problémy s faxováním","link":"trb-caller-id-not-shown-topic.html","desc":"Lze odesílat, ale nikoli přijímat","descFull":"Lze odesílat, ale nikoli přijímat faxy pomocí analogového faxu Lze odesílat, ale nikoli přijímat faxy pomocí analogového faxu Vyzkoušejte jeden či více následujících kroků: Zkontrolujte, zda je zdroj papíru plný. Zkontrolujte nastavení zpoždění určené počtem zvonění. Na ovládacím panelu přejděte do části  Nastavení Fax Nastavení faxu Nastavení příjmu faxů Počet zvonění před přijetím . Pokud tiskárna tiskne prázdné stránky, podívejte se do tématu  . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s faxováním lze odesílat, ale nikoli přijímat faxy pomocí analogového faxu nelze přijímat faxy pomocí analogového faxu"},{"UUID":"84ff5d7a-b7b8-4827-8fde-0e1db26a81f0","title":"Problémy s faxováním","link":"trb-caller-id-not-shown-topic.html","desc":"Nelze nastavit službu etherFAX Nelze","descFull":"Nelze nastavit službu etherFAX Nelze nastavit službu etherFAX Vyzkoušejte jeden či více následujících kroků: Zkontrolujte připojení tiskárny. Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zprávy Síť Stránka nastavení sítě . Na vytištěné stránce zkontrolujte stav sítě. Ujistěte se, že je tiskárna připojena k síti a síť je připojena k internetu. Zkontrolujte, zda je služba etherFAX správně nastavena. Další informace najdete v tématu  . Pokud problém přetrvává, přejděte na stránku   https://www.etherfax.net/lexmark . problém s faxováním nelze nastavit službu etherFAX nelze nastavit službu etherFAX"},{"UUID":"59c09387-aefc-42b7-8e74-58e8b674185a","title":"Problémy s faxováním","link":"trb-caller-id-not-shown-topic.html","desc":"Nelze odesílat ani přijímat faxy","descFull":"Nelze odesílat ani přijímat faxy pomocí služby etherFAX Nelze odesílat ani přijímat faxy pomocí služby etherFAX Vyzkoušejte jeden či více následujících kroků: Ujistěte se, že je tiskárna připojena k síti a síť je připojena k internetu. Zkontrolujte, zda je služba etherFAX správně nastavena. Další informace najdete v tématu  . Rozdělte velké dokumenty na menší soubory. Pokud problém přetrvává, přejděte na stránku   https://www.etherfax.net/lexmark . problém s faxováním nelze odesílat ani přijímat faxy pomocí služby etherFAX nelze odesílat ani přijímat faxy pomocí služby etherFAX"},{"UUID":"697ff595-5347-4dbb-9a26-d225a6b5337b","title":"Problémy s faxováním","link":"trb-caller-id-not-shown-topic.html","desc":"Špatná kvalita tisku faxu Špatná","descFull":"Špatná kvalita tisku faxu Špatná kvalita tisku faxu Vyzkoušejte jeden či více následujících kroků: Vyřešte veškeré vady v kvalitě tisku. Vytiskněte  zkušební stránky kvality tisku . Z kontrolního panelu přejděte do nabídky  Nastavení Řešení problémů Vytisknout zkušební stránku . Opravte veškeré vady v kvalitě tisku. Další informace najdete v tématu  . Pokud používáte analogový fax, snižte přenosovou rychlost příchozích faxů. Na ovládacím panelu přejděte k položkám  Nastavení Fax Nastavení faxu Nastavení příjmu faxů Ovládací prvky správy . V nabídce  Maximální rychlost  vyberte nižší přenosovou rychlost. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s faxováním nízká kvalita tisku špatná kvalita tisku faxu"},{"UUID":"2ee62371-2dd8-4b11-a51c-58550bbd870f","title":"Problémy s faxováním","link":"trb-caller-id-not-shown-topic.html","desc":"Chybí informace na úvodní stránce","descFull":"Chybí informace na úvodní stránce faxu Chybí informace na úvodní stránce faxu Vypněte tiskárnu, vyčkejte přibližně 10 sekund a pak ji znovu zapněte. Odešlete nebo načtěte fax. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s faxováním chybí informace na úvodní stránce faxu chybí informace na úvodní stránce faxu"},{"UUID":"f58c9a19-47da-4a52-967a-dcd1619253e2","title":"Problémy s faxováním","link":"trb-caller-id-not-shown-topic.html","desc":"Nelze odeslat úvodní stránku faxu","descFull":"Nelze odeslat úvodní stránku faxu z počítače Nelze odeslat úvodní stránku faxu z počítače Vyzkoušejte jeden či více následujících kroků: Ujistěte se, že je aktualizován tiskový ovladač. Další informace naleznete na stránce  www.lexmark.com/downloads . Ujistěte se, že je aktualizován tiskový ovladač. Další informace získáte na místě, kde jste tiskárnu zakoupili. Zkontrolujte, zda je ovladač tiskárny aktualizován na nejnovější verzi, a odešlete fax. Chcete-li získat další informace, obraťte se na  svého prodejce . Zrušte nastavení  Před faxováním vždy zobrazit nastavení . V dokumentu, který se chystáte faxovat, otevřete dialogové okno  Tisk . Vyberte tiskárnu a potom klepněte na možnost  Vlastnosti ,  Předvolby ,  Možnosti  nebo  Nastavení . Klepněte na položku  Fax  a poté zrušte zaškrtnutí políčka  Před faxováním vždy zobrazit nastavení . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s faxováním nelze odeslat úvodní stránku faxu z počítače nelze odeslat úvodní stránku faxu z počítače"},{"UUID":"3a7c3c5e-239f-4f0d-8609-a36589b39051","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nelze skenovat do počítače Vyzkoušejte","descFull":"Nelze skenovat do počítače Vyzkoušejte jeden či více následujících kroků: Proveďte úlohu kopírování. Pokud úloha selže, vypněte tiskárnu, vyčkejte přibližně 10 sekund a poté tiskárnu znovu zapněte. Zkontrolujte připojení tiskárny. Vytiskněte  stránky Nastavení sítě . Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Zprávy Síť  a poté vyberte možnost  Stránka nastavení sítě . Zkontrolujte první část stránky a ověřte, že stav je Připojeno. Ujistěte se, že jsou tiskárna i počítač připojeny ke stejné síti. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém se skenováním nelze skenovat do počítače nelze skenovat do počítače"},{"UUID":"b45f9fba-9593-4a2e-aa39-85f04a62d311","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nelze skenovat do síťové složky","descFull":"Nelze skenovat do síťové složky Vyzkoušejte jeden či více následujících kroků: Vytvořte zástupce síťové složky a poté dokument naskenujte pomocí tohoto zástupce. Další informace najdete v tématu  . Ujistěte se, že cesta a formát síťové složky jsou správné. Například  // název_hostitele_serveru /název_složky/cesta , kde  název_hostitele_serveru  je plně kvalifikovaná doména (FQDN) nebo IP adresa. Ujistěte se, že máte oprávnění k zápisu do síťové složky. Aktualizujte zástupce síťové složky. Otevřete webový prohlížeč a zadejte do pole adresy IP adresu tiskárny. Zobrazte adresu IP tiskárny na domovské obrazovce tiskárny. IP adresa se zobrazí jako čtyři sady čísel oddělených tečkou, například 123.123.123.123. Pokud používáte server proxy, dočasně jej zakažte, aby se správně načetla webová stránka. Klepněte na možnost  Zástupci  a vyberte zástupce. Máte-li více typů zástupců, vyberte  Síťová složka . Do pole Cesta pro sdílení zadejte cestu k síťové složce. Například  \\\\nazev_hostitele_serveru\\nazev_slozky\\cesta . Při zadávání cesty ke sdílení vždy používejte klasická lomítka. V nabídce  Ověření  vyberte metodu ověřování. Je-li možnost  Ověření  nastavena na hodnotu „ Použít přiřazené uživatelské jméno a heslo “, do polí Uživatelské jméno a Heslo vyplňte své přihlašovací údaje. Klepněte na tlačítko  Uložit . Ujistěte se, že jsou tiskárna a síťová složka připojeny ke stejné síti. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . nelze skenovat do síťové složky problém se skenováním nelze skenovat do síťové složky"},{"UUID":"93a7021c-0715-4047-b007-901b18b4699d","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Dokument nebo fotografie se kopírují","descFull":"Dokument nebo fotografie se kopírují jen zčásti Vyzkoušejte jeden či více následujících kroků: Dbejte na to, aby byly dokument nebo fotografie položeny lícem dolů, v levém horním rohu skleněné plochy skeneru. Nastavte formát papíru podle papíru vloženého do zásobníku. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kopírováním dokumenty se kopírují jen zčásti problém s kopírováním fotografie se kopírují jen zčásti dokument nebo fotografie se kopírují jen zčásti problém se skenováním dokumenty se kopírují jen zčásti problém se skenováním fotografie se kopírují jen zčásti"},{"UUID":"97440825-1489-435e-94ef-b8a208a561c2","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Špatná kvalita kopie Vyzkoušejte jeden","descFull":"Špatná kvalita kopie Vyzkoušejte jeden či více následujících kroků: Vyčistěte skleněnou plochu skeneru a sklo podavače ADF navlhčeným měkkým hadříkem, který nepouští vlákna. Pokud je vaše tiskárna vybavena uvnitř podavače ADF druhou skleněnou plochou podavače ADF, vyčistěte také tuto skleněnou plochu. Další informace najdete v tématu  . Dbejte na to, aby byly dokument nebo fotografie položeny lícem dolů, v levém horním rohu skleněné plochy skeneru. Zkontrolujte kvalitu originálního dokumentu nebo fotografie a odpovídajícím způsobem upravte nastavení kvality skenování. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kopírováním špatná kvalita kopie špatná kvalita kopie problém se skenováním špatná kvalita kopie nízká kvalita skenování"},{"UUID":"09e12d3f-d36a-4d80-b7a9-9b01307dcaf1","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Svislé tmavé šmouhy při skenování","descFull":"Svislé tmavé šmouhy při skenování z podavače ADF Zvedněte kryt skeneru a poté vyjměte nástroj na čištění skla. Otřete sklo automatického podavače dokumentů vedle skleněné plochy skeneru. Otevřete dvířka A1 a vyčistěte sklo automatického podavače dokumentů. Vraťte nástroj na původní místo. Zavřete kryt skeneru. Další informace očištění skeneru najdete v části  . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém se skenováním při skenování z podavače ADF se na výstupu objevují vertikální tmavé pruhy při skenování z podavače ADF se na výstupu objevují vertikální tmavé pruhy problém s kvalitou skenování"},{"UUID":"836b1917-46a4-4323-ae9b-0757d6b98901","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Zubatý obrázek nebo text při","descFull":"Zubatý obrázek nebo text při skenování z podavače ADF Zubatý obrázek nebo text při skenování z podavače ADF Vložte 50 listů čistého obyčejného papíru do podavače ADF. Obyčejný papír pomáhá vyčistit nebo odstranit prach a jiné povlaky z válečků podavače ADF. Na ovládacím panelu posunutím prstu doprava přejděte do řídicího centra a poté vyberte možnost  . Vložte originál dokumentu do podavače ADF. Naskenujte dokument. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém se skenováním zubatý obrázek problém se skenováním zubatý text řešení problémů zubatý obrázek při skenování z automatického podavače dokumentů řešení problémů zubatý text při skenování z automatického podavače dokumentů zubatý obrázek při skenování z automatického podavače dokumentů zubatý text při skenování z automatického podavače dokumentů"},{"UUID":"740fc2a6-0f52-4950-92a6-edf431253473","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skenování se nezdařilo Skenování se","descFull":"Skenování se nezdařilo Skenování se nezdařilo Vyzkoušejte jeden či více následujících kroků: Zkontrolujte, zda je kabel Ethernet nebo kabel USB pevně připojen k počítači a tiskárně. Zkontrolujte soubor, který chcete naskenovat, a ujistěte se, že: Název souboru není v cílové složce již použit. Dokument nebo fotografie, který chcete skenovat, nejsou otevřeny v jiné aplikaci. Ujistěte se, že není v nastavení konfigurace cílů zaškrtnuté políčko  Připojit časové razítko  nebo  Přepsat stávající soubor . Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém se skenováním skenování se nezdařilo skenování se nezdařilo řešení problémů skenování se nezdařilo"},{"UUID":"cab5fafa-a646-47a5-a1b2-3d3e52dc1e98","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skener nelze zavřít Skener nelze","descFull":"Skener nelze zavřít Skener nelze zavřít Odstraňte veškeré překážky, které brání zavření krytu skeneru. Zavřete skener. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém se skenováním skener nelze zavřít skener nelze zavřít"},{"UUID":"c0e58f08-3edd-4d1e-a76b-8e8957aabc07","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skenování trvá příliš dlouho nebo","descFull":"Skenování trvá příliš dlouho nebo dojde k zamrznutí počítače Skenování trvá příliš dlouho nebo dojde k zamrznutí počítače Zavřete aplikace, které ruší skenování. Naskenujte dokument znovu. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém se skenováním skenování trvá příliš dlouho problém se skenováním skenování způsobuje zamrznutí počítače skenování trvá dlouho nebo dojde k zamrznutí počítače"},{"UUID":"a56c57e9-b8a6-4389-bffc-8a49e800a90f","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skener nereaguje Skener nereaguje Vyzkoušejte","descFull":"Skener nereaguje Skener nereaguje Vyzkoušejte jeden či více následujících kroků: Zkontrolujte, zda je napájecí kabel připojen k tiskárně a k elektrické zásuvce. Abyste předešli riziku požáru nebo úrazu el. proudem, připojte napájecí kabel do řádně uzemněné elektrické zásuvky s odpovídajícími parametry, která se nachází v blízkosti výrobku a je snadno přístupná. Zkontrolujte, zda je tiskárna zapnutá, a vyřešte všechny chybové zprávy zobrazené na displeji. Vypněte tiskárnu, vyčkejte přibližně 10 sekund a pak ji znovu zapněte. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kopírováním skener nereaguje problém se skenováním skener nereaguje skener nereaguje"},{"UUID":"1eda1c6b-f400-426b-92a4-644f01e11851","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Úprava registrace skeneru Úprava registrace","descFull":"Úprava registrace skeneru Úprava registrace skeneru Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Údržba Nabídka konfigurace Konfigurace skeneru Ruční registrace skeneru . V nabídce  Rychlý test tisku  vyberte možnost  Start . Testovací stránku položte na skleněnou plochu skeneru a vyberte možnost  Registrace plochého skeneru . V nabídce  Rychlý test kopírování  vyberte možnost  Start . Porovnejte testovací stránku s originálním dokumentem. Pokud se okraje stránky testu liší od originálního dokumentu, upravte nastavení  Levý okraj  a  Horní okraj . Opakujte   a  , dokud nebudou okraje stránky  Rychlý test kopírování  téměř shodné s originálním dokumentem. nastavení registrace skeneru"},{"UUID":"658ee5c4-5324-4eaa-8a1f-d67f3bb46aaf","title":"Problémy se skenováním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Úprava registrace ADF Na ovládacím","descFull":"Úprava registrace ADF Na ovládacím panelu přejděte k položkám  Nastavení Zařízení Údržba Nabídka konfigurace Konfigurace skeneru Ruční registrace skeneru . V nabídce  Rychlý test tisku  vyberte možnost  Start . Položte testovací stránku do automatického podavače dokumentů. Vyberte možnost  Registrace předního ADF  nebo  Registrace zadního ADF . K zarovnání  Registrace předního ADF  vložte testovací stránku potištěnou stranou nahoru a krátkou hranou napřed. K zarovnání  Registrace zadního ADF  vložte testovací stránku do automatického podavače dokumentů potištěnou stranou dolů a krátkou hranou napřed. V nabídce  Rychlý test kopírování  vyberte možnost  Start . Porovnejte testovací stránku s originálním dokumentem. Pokud se okraje stránky testu liší od originálního dokumentu, upravte nastavení  Horizontální nastavení  a  Horní okraj . Opakujte   a  , dokud nebudou okraje stránky  Rychlý test kopírování  téměř shodné s originálním dokumentem. registrace ADF nastavení úprava registrace ADF"},{"UUID":"7c0493b4-b98e-45ce-b4d2-47629ed0e1af","title":"Potíže s kvalitou barev","link":"modifying-colors-in-printed-output-topic.html","desc":"Úprava barev na tištěném výstupu","descFull":"Úprava barev na tištěném výstupu Na ovládacím panelu tiskárny přejděte k položkám  Nastavení Tisk Kvalita Pokročilé zobrazování Korekce barev . V nabídce  Korekce barev  vyberte možnost  Ručně . V nabídce  Obsah korekce barev  vyberte příslušné nastavení pro převod barev. Typy objektů Ruční barva a jejich konverzní tabulky Typ objektu Barevné konverzní tabulky Obrázek RGB Text RGB Grafika RGB Živé  – Produkuje jasnější, nasycenější barvy a může být použita na všechny vstupní barevné formáty. Displej sRGB  – Produkuje výstup, který aproximuje barvy zobrazené na počítačové obrazovce. Pro tisk fotografií je optimalizováno použití černého toneru. Displej – True Black  – Produkuje výstup, který aproximuje barvy zobrazené na počítačové obrazovce. Toto nastavení používá pouze černý toner pro vytvoření všech stupňů neutrální šedi. sRGB Živé  – Zvyšuje sytost barev pro barevnou korekci  Displej sRGB . Použití černého toneru je optimalizováno pro tisk obchodní grafiky. Vypnuto Obrázek CMYK Text CMYK Grafika CMYK US CMYK  – Použije barevnou korekci pro aproximaci barevného výstupu SWOP (Specifications for Web Offset Publishing). Euro CMYK  – Použije korekci barev pro aproximovaný EuroScale barevný výstup. Živé CMYK  – Zvyšuje sytost barev pro nastavení barevné korekce  US CMYK . Vypnuto úprava barevného výstupu ruční korekce barev korekce barev"},{"UUID":"454756e3-3289-4058-a6e4-ec4be551544d","title":"Potíže s kvalitou barev","link":"modifying-colors-in-printed-output-topic.html","desc":"časté dotazy o barevném tisku","descFull":"časté dotazy o barevném tisku Co je to barva RGB? RGB barva je způsob popisu barev pomocí určení množství červené, zelené a modré barvy, které jsou použité k vytvoření určité barvy. Červené, zelené a modré světlo lze přidávat v různých poměrech a vytvářet tak velikou škálu barev pozorovaných v přírodě. Počítačové obrazovky, skenery a digitální fotoaparáty používají tuto metodu k zobrazování barev. Co je to barva CMYK? Barva CMYK je způsob popisu barvy pomocí určení množství azurové, purpurové, žluté a černé, použitého k vytvoření určité barvy. Inkousty nebo tonery CMYK lze při tisku použít v různých množstvích pro reprodukci mnoha barev vyskytujících se v přírodě. Tiskařské lisy, inkoustové tiskárny a barevné laserové tiskárny vytvářejí barvy tímto způsobem.  Jak je barva definována v dokumentu, který je určen k tisku? Programy jsou používány k definování a úpravě barev v dokumentu pomocí barevných kombinací RGB či CMYK. Více informací naleznete v tématech nápovědy programu. Jak tiskárna zjistí, jakou barvu má tisknout? Při tisku dokumentu jsou informace popisující typ a barvu všech objektů zaslány tiskárně. Informace poté procházejí barevnými konverzními tabulkami. Barva se převede na odpovídající množství tonerů CMYK, které se použijí k dosažení požadované barvy. Informace o objektu určují použití barevných konverzních tabulek. Například je možné použít jeden typ barevné konverzní tabulky na text, zatímco na fotografie je používán jiný typ barevné konverzní tabulky. Co je to ruční korekce barev? Když je povolena ruční korekce barev, používá tiskárna ke zpracování objektů uživatelem zvolené barevné konverzní tabulky. Ruční nastavení korekce barev jsou specifická pro každý typ tištěného objektu (text, grafika nebo obrázky). To je také specifické pro různý způsob, jakým je definována barva v programu (kombinace RGB nebo CMYK). Pro ruční použití jiné barevné konverzní tabulky viz část  . Pokud program nedefinuje barvy pomocí kombinací RGB nebo CMYK, ruční korekce barev nemá význam. Také nemá vliv, když program či operační systém počítače ovládá úpravu barev. Ve většině případů je nastavením korekce barev na režim Automaticky dosaženo výběru ideálních barev pro dokumenty. Jak mohu dosáhnout věrnosti podání určité barvy (například firemního loga)? V nabídce  Kvalita  je k dispozici devět typů sad  Ukázka barev . Tyto sady jsou také dostupné ze stránky  Ukázka barev  ve vestavěném webovém serveru. Výběrem jakékoliv vzorové sady vytisknete několikastránkový dokument sestávající ze stovek barevných čtverců. Každý čtverec obsahuje kombinaci CMYK nebo RGB v závislosti na zvolené tabulce. Barva každého čtverce je dána průchodem CMYK či RGB kombinace označené na čtverci. Při zkoumání sad  Ukázka barev  můžete vybrat čtverec, jehož barva se nejvíce blíží hledané barvě. Barevná kombinace označená na čtverci potom může být použita k úpravě barvy objektu v programu. Více informací naleznete v tématech nápovědy programu. K použití vybrané barevné konverzní tabulky pro určitý objekt může být nezbytná ruční barevná korekce. Výběr správné sady  Ukázka barev  pro řešení konkrétního problému s hledáním odpovídající barvy závisí na: použitém nastavení  Korekce barev  ( Automaticky ,  Vypnuto  nebo  Ruční ), typu tištěného objektu (text, grafika nebo obrázky), tom, jakým způsobem je definována barva v programu (kombinace RGB nebo CMYK). Pokud program nedefinuje barvy pomocí kombinací RGB nebo CMYK, stránky  Ukázka barev  nelze použít. Některé programy upravují kombinace RGB nebo CMYK definované v programu pomocí správy barev. V těchto případech nemusí výsledná vytištěná barva zcela odpovídat barvě na stránkách  Ukázka barev . problém s kvalitou barev časté dotazy o barevném tisku barevný tisk korekce barev ukázka barev"},{"UUID":"b74dcc27-75ee-4886-bdaa-71105cbf5b9f","title":"Potíže s kvalitou barev","link":"modifying-colors-in-printed-output-topic.html","desc":"Výtisk vypadá zabarveně Výtisk vypadá","descFull":"Výtisk vypadá zabarveně Výtisk vypadá zabarveně Vyzkoušejte jeden či více následujících kroků: Na ovládacím panelu přejděte k položkám  Nastavení Tisk Kvalita Pokročilé zobrazování  a poté vyberte možnost  Barevná úprava . Na ovládacím panelu přejděte k položkám  Nastavení Tisk Kvalita Pokročilé zobrazování , vyberte možnost  Vyvážení barev  a upravte nastavení. Pokud problém přetrvá, kontaktujte  zákaznická podpora . Pokud problém přetrvá, kontaktujte  svého prodejce . problém s kvalitou barev výtisk vypadá zabarveně výtisk vypadá zabarveně řešení problémů výtisk vypadá zabarveně"},{"UUID":"08b2aa08-f76b-4e4a-848a-28378e729934","title":"Řešení problémů","link":"trb-contacting-customer-support-topic.html","desc":"Kontaktování zákaznické podpory Kontaktování zákaznické","descFull":"Kontaktování zákaznické podpory Kontaktování zákaznické podpory Než se obrátíte na zákaznickou podporu, mějte k dispozici následující informace: Popis problému s tiskárnou Chybová zpráva Typ modelu tiskárny a sériové číslo Přejděte na stránku  https://support.lexmark.com  ohledně podpory e-mailem nebo prostřednictvím chatu, případně si projděte knihovnu příruček, pomocné dokumentace, ovladačů a dalších souborů ke stažení. K dispozici je také technická podpora po telefonu. V USA nebo Kanadě volejte na číslo 1-800-539-6275. V případě ostatních zemí nebo oblastí přejděte do  adresáře kontaktů mezinárodní podpory . Případně se obraťte na prodejce tiskárny. kontaktování zákaznické podpory zákaznická podpora"},{"UUID":"f35ea63e-1939-40c5-9ba0-abf378663677","title":"Řešení problémů","link":"troubleshooting-chapter.html","desc":"Kontaktování prodejce Než se obrátíte","descFull":"Kontaktování prodejce Než se obrátíte na prodejce, připravte si následující informace: Popis problému s tiskárnou Chybová zpráva Typ modelu tiskárny a sériové číslo kontaktování prodejce prodejce tiskáren"},{"UUID":"944045e7-2578-4f33-be68-b64a9bce4a27","title":"Řešení problémů","link":"troubleshooting-chapter.html","desc":"Kontaktování technické podpory Pokud budete","descFull":"Kontaktování technické podpory Pokud budete telefonovat do oddělení technické podpory, popište problém, zprávu na displeji tiskárny a kroky, které jste při řešení potíží při hledání řešení již podnikli. Podívejte se na štítek uvnitř horního krytu nebo na zadní straně tiskárny a poznamenejte si tyto údaje: Model tiskárny Číslo servisního štítku nebo kód expresního servisu Další informace naleznete na webové stránce  www.dell.com/support . řešení problémů kontaktování technické podpory kontaktování technické podpory"},{"UUID":"d22d5de4-8aed-465b-9844-7e172f9dc12f","title":"Recyklace a likvidace","link":"recycling-lexmark-products-topic.html","desc":"Recyklace produktů společnosti Lexmark Recyklace","descFull":"Recyklace produktů společnosti Lexmark Recyklace produktů společnosti Lexmark Přejděte na stránku  www.lexmark.com/recycle . V seznamu vyberte svou zemi. Vyberte recyklační program. recyklace produktů"},{"UUID":"bbdb5751-dd82-4c01-bb4c-31fab28e237d","title":"Recyklace a likvidace","link":"recycling-lexmark-packaging-topic.html","desc":"Recyklace obalů od produktů Lexmark","descFull":"Recyklace obalů od produktů Lexmark Recyklace obalů od produktů Lexmark Společnost Lexmark se nepřetržitě snaží minimalizovat obaly. Menší obaly pomáhají, aby byly tiskárny Lexmark transportovány co nejefektivnějším a nejekologičtějším způsobem, a aby bylo nutné likvidovat menší objem obalů. Toto zefektivnění má za následek snížení emisí skleníkových plynů, úspory energie a šetření přírodních zdrojů. Společnost Lexmark také nabízí v některých zemích nebo oblastech recyklaci komponent obalů. Další informace naleznete na  www.lexmark.com/recycle . Kartóny Lexmark jsou 100% recyklovatelné, jestliže jsou k dispozici recyklační střediska. Takováto zařízení ovšem nemusí ve vaší oblasti existovat. Pěna použitá v obalech Lexmark je recyklovatelná, jestliže jsou k dispozici recyklační střediska na recyklaci pěny. Takováto zařízení ovšem nemusí ve vaší oblasti existovat.  Když vracíte kazetu společnosti Lexmark, můžete znovu využít krabici, ve které jste kazetu koupili. Společnost Lexmark krabici recykluje. recyklace produktů obalový materiál"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"Multifunkčn&iacute; tisk&aacute;rny CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655"}},[_vm._v("\n    Multifunkční tiskárny CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_cs","title":"Informace o&nbsp;bezpečnosti"}},[_vm._v("\n    Informace o bezpečnosti\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e20"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e25","title":"Konvence"}},[_vm._v("\n     Konvence\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e45","title":"Upozorněn&iacute; t&yacute;kaj&iacute;c&iacute; se produktu"}},[_vm._v("\n     Upozornění týkající se produktu\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_cs","title":"Informace o&nbsp;tisk&aacute;rně"}},[_vm._v("\n    Informace o tiskárně\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e223"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_cs","title":"Vyhled&aacute;n&iacute; informac&iacute; o tisk&aacute;rně"}},[_vm._v("\n     Vyhledání informací o tiskárně\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_cs","title":"Zji&scaron;těn&iacute; s&eacute;riov&eacute;ho č&iacute;sla tisk&aacute;rny"}},[_vm._v("\n     Zjištění sériového čísla tiskárny\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_cs","title":"Konfigurace tisk&aacute;rny"}},[_vm._v("\n     Konfigurace tiskárny\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_cs","title":"Použit&iacute; ovl&aacute;dac&iacute;ho panelu"}},[_vm._v("\n     Použití ovládacího panelu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#using-home-screen_cs","title":"Ikony domovsk&eacute; obrazovky"}},[_vm._v("\n     Ikony domovské obrazovky\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"colors-of-indicator-light-topic.html#colors-of-indicator-light_cs","title":"Barvy kontrolky"}},[_vm._v("\n     Barvy kontrolky\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_cs","title":"Použ&iacute;v&aacute;n&iacute; automatick&eacute;ho podavače dokumentů a&nbsp;skleněn&eacute; plochy skeneru"}},[_vm._v("\n     Používání automatického podavače dokumentů a skleněné plochy skeneru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_cs","title":"Vyhled&aacute;n&iacute; slotu zabezpečen&iacute;"}},[_vm._v("\n     Vyhledání slotu zabezpečení\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-guidelines-topic.html#d0e771","title":"V&yacute;běr pap&iacute;ru"}},[_vm._v("\n     Výběr papíru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-applications-topic.html#d0e10637","title":"Dal&scaron;&iacute; funkce a podpora tisk&aacute;rny"}},[_vm._v("\n     Další funkce a podpora tiskárny\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_cs","title":"Nastaven&iacute;, instalace a&nbsp;konfigurace"}},[_vm._v("\n    Nastavení, instalace a konfigurace\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10764"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_cs","title":"V&yacute;běr um&iacute;stěn&iacute; tisk&aacute;rny"}},[_vm._v("\n     Výběr umístění tiskárny\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-ports-topic.html#printer-ports_cs","title":"Porty tisk&aacute;rny"}},[_vm._v("\n     Porty tiskárny\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-scan-center-topic.html#d0e10970","title":"Konfigurace aplikac&iacute; a ře&scaron;en&iacute;"}},[_vm._v("\n     Konfigurace aplikací a řešení\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e11147","title":"Instalace a použ&iacute;v&aacute;n&iacute; funkc&iacute; usnadněn&iacute;"}},[_vm._v("\n     Instalace a používání funkcí usnadnění\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e11452","title":"Nastaven&iacute; tisk&aacute;rny pro faxov&aacute;n&iacute;"}},[_vm._v("\n     Nastavení tiskárny pro faxování\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#loading-trays-group_cs","title":"Založen&iacute; pap&iacute;ru a speci&aacute;ln&iacute;ch m&eacute;di&iacute;"}},[_vm._v("\n     Založení papíru a speciálních médií\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e12248","title":"Instalace a&nbsp;aktualizace softwaru, ovladačů a&nbsp;firmwaru"}},[_vm._v("\n     Instalace a aktualizace softwaru, ovladačů a firmwaru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-optional-550-sheet-tray-topic.html#d0e12574","title":"Instalace hardwarov&yacute;ch doplňků"}},[_vm._v("\n     Instalace hardwarových doplňků\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"connecting-printer-to-wireless-network-topic.html#d0e14105","title":"Pr&aacute;ce v&nbsp;s&iacute;ti"}},[_vm._v("\n     Práce v síti\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_cs","title":"Zabezpečen&iacute; tisk&aacute;rny"}},[_vm._v("\n    Zabezpečení tiskárny\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14457"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_cs","title":"Vymaz&aacute;n&iacute; paměti tisk&aacute;rny"}},[_vm._v("\n     Vymazání paměti tiskárny\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_cs","title":"Maz&aacute;n&iacute; paměťov&eacute; jednotky tisk&aacute;rny"}},[_vm._v("\n     Mazání paměťové jednotky tiskárny\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_cs","title":"Obnoven&iacute; v&yacute;choz&iacute;ch tov&aacute;rn&iacute;ch nastaven&iacute;"}},[_vm._v("\n     Obnovení výchozích továrních nastavení\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_cs","title":"Prohl&aacute;&scaron;en&iacute; o nest&aacute;losti"}},[_vm._v("\n     Prohlášení o nestálosti\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_cs","title":"Tisk"}},[_vm._v("\n    Tisk\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14649"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-topic.html#printing-from-computer_cs","title":"Tisk z&nbsp;poč&iacute;tače"}},[_vm._v("\n     Tisk z počítače\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14700","title":"Tisk pomoc&iacute; mobiln&iacute;ho zař&iacute;zen&iacute;"}},[_vm._v("\n     Tisk pomocí mobilního zařízení\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_cs","title":"Tisk z&nbsp;jednotky flash"}},[_vm._v("\n     Tisk z jednotky flash\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_cs","title":"Konfigurace důvěrn&yacute;ch &uacute;loh"}},[_vm._v("\n     Konfigurace důvěrných úloh\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_cs","title":"Tisk důvěrn&yacute;ch a&nbsp;jin&yacute;ch pozdržen&yacute;ch &uacute;loh"}},[_vm._v("\n     Tisk důvěrných a jiných pozdržených úloh\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-topic.html#printing-font-sample-list_cs","title":"Tisk seznamu uk&aacute;zek p&iacute;sma"}},[_vm._v("\n     Tisk seznamu ukázek písma\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-topic.html#printing-directory-list_cs","title":"Tisk seznamu adres&aacute;řů"}},[_vm._v("\n     Tisk seznamu adresářů\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_cs","title":"Um&iacute;stěn&iacute; oddělovac&iacute;ch listů do tiskov&yacute;ch &uacute;loh"}},[_vm._v("\n     Umístění oddělovacích listů do tiskových úloh\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_cs","title":"Ru&scaron;en&iacute; tiskov&eacute; &uacute;lohy"}},[_vm._v("\n     Rušení tiskové úlohy\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_cs","title":"&Uacute;prava sytosti toneru"}},[_vm._v("\n     Úprava sytosti toneru\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_cs","title":"Kop&iacute;rov&aacute;n&iacute;"}},[_vm._v("\n    Kopírování\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15195"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_cs","title":"Kop&iacute;rov&aacute;n&iacute;"}},[_vm._v("\n     Kopírování\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_cs","title":"Kop&iacute;rov&aacute;n&iacute; fotografi&iacute;"}},[_vm._v("\n     Kopírování fotografií\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-letterhead-topic.html#copying-on-letterhead_cs","title":"Kop&iacute;rov&aacute;n&iacute; na&nbsp;hlavičkov&yacute; pap&iacute;r"}},[_vm._v("\n     Kopírování na hlavičkový papír\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_cs","title":"Kop&iacute;rov&aacute;n&iacute; na obě strany pap&iacute;ru"}},[_vm._v("\n     Kopírování na obě strany papíru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_cs","title":"Zmen&scaron;en&iacute; nebo zvět&scaron;en&iacute; kopi&iacute;"}},[_vm._v("\n     Zmenšení nebo zvětšení kopií\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_cs","title":"Skl&aacute;d&aacute;n&iacute; kopi&iacute;"}},[_vm._v("\n     Skládání kopií\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_cs","title":"Um&iacute;stěn&iacute; oddělovac&iacute;ch listů mezi kopie"}},[_vm._v("\n     Umístění oddělovacích listů mezi kopie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_cs","title":"Kop&iacute;rov&aacute;n&iacute; v&iacute;ce str&aacute;nek na jeden list"}},[_vm._v("\n     Kopírování více stránek na jeden list\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_cs","title":"Kop&iacute;rov&aacute;n&iacute; karet"}},[_vm._v("\n     Kopírování karet\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_cs","title":"Vytvořen&iacute; zkratky pro kop&iacute;rov&aacute;n&iacute;"}},[_vm._v("\n     Vytvoření zkratky pro kopírování\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_cs","title":"E-mail"}},[_vm._v("\n    E-mail\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15468"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-settings-topic.html#configuring-smtp-settings_cs","title":"Konfigurace nastaven&iacute; protokolu SMTP"}},[_vm._v("\n     Konfigurace nastavení protokolu SMTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_cs","title":"zas&iacute;l&aacute;n&iacute; emailem"}},[_vm._v("\n     zasílání emailem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_cs","title":"Vytvořen&iacute; z&aacute;stupce e-mailu"}},[_vm._v("\n     Vytvoření zástupce e-mailu\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_cs","title":"Faxov&aacute;n&iacute;"}},[_vm._v("\n    Faxování\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e16917"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_cs","title":"Odesl&aacute;n&iacute; Faxov&aacute;n&iacute;"}},[_vm._v("\n     Odeslání Faxování\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_cs","title":"Napl&aacute;nov&aacute;n&iacute; faxu"}},[_vm._v("\n     Naplánování faxu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_cs","title":"Vytvořen&iacute; z&aacute;stupce c&iacute;le faxov&aacute;n&iacute;"}},[_vm._v("\n     Vytvoření zástupce cíle faxování\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_cs","title":"Změna rozli&scaron;en&iacute; faxu"}},[_vm._v("\n     Změna rozlišení faxu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_cs","title":"&Uacute;prava sytosti faxu"}},[_vm._v("\n     Úprava sytosti faxu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_cs","title":"Tisk faxov&eacute;ho protokolu"}},[_vm._v("\n     Tisk faxového protokolu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_cs","title":"Blokov&aacute;n&iacute; nevyž&aacute;dan&yacute;ch faxů"}},[_vm._v("\n     Blokování nevyžádaných faxů\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_cs","title":"Pozdržen&iacute; faxů"}},[_vm._v("\n     Pozdržení faxů\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_cs","title":"Přeposl&aacute;n&iacute; faxu"}},[_vm._v("\n     Přeposlání faxu\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_cs","title":"Skenov&aacute;n&iacute;"}},[_vm._v("\n    Skenování\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17213"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_cs","title":"Skenov&aacute;n&iacute; do poč&iacute;tače"}},[_vm._v("\n     Skenování do počítače\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_cs","title":"Skenov&aacute;n&iacute; na server FTP"}},[_vm._v("\n     Skenování na server FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_cs","title":"Vytvořen&iacute; z&aacute;stupce serveru FTP"}},[_vm._v("\n     Vytvoření zástupce serveru FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-network-folder-topic.html#scanning-to-network-folder_cs","title":"Skenov&aacute;n&iacute; do s&iacute;ťov&eacute; složky"}},[_vm._v("\n     Skenování do síťové složky\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-network-folder-destination-topic.html#configuring-network-folder-destination_cs","title":"Konfigurace c&iacute;lov&eacute; s&iacute;ťov&eacute; složky"}},[_vm._v("\n     Konfigurace cílové síťové složky\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_cs","title":"Přid&aacute;n&iacute; z&aacute;stupce s&iacute;ťov&eacute; složky"}},[_vm._v("\n     Přidání zástupce síťové složky\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_cs","title":"Skenov&aacute;n&iacute; na jednotku paměti flash"}},[_vm._v("\n     Skenování na jednotku paměti flash\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printer-menus-chapter.html#printer-menus-chapter_cs","title":"Nab&iacute;dky tisk&aacute;rny"}},[_vm._v("\n    Nabídky tiskárny\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17502"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-topic.html#menu-map_cs","title":"Sch&eacute;ma nab&iacute;dek"}},[_vm._v("\n     Schéma nabídek\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e17816","title":"Zař&iacute;zen&iacute;"}},[_vm._v("\n     Zařízení\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e20050","title":"Tisk"}},[_vm._v("\n     Tisk\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e21332","title":"Pap&iacute;r"}},[_vm._v("\n     Papír\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e21664","title":"Kop&iacute;rov&aacute;n&iacute;"}},[_vm._v("\n     Kopírování\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e22223","title":"Faxov&aacute;n&iacute;"}},[_vm._v("\n     Faxování\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e24090","title":"E-mail"}},[_vm._v("\n     E-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e25187","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e25893","title":"Jednotka USB"}},[_vm._v("\n     Jednotka USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e26739","title":"S&iacute;ť/Porty"}},[_vm._v("\n     Síť/Porty\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e28890","title":"Zabezpečen&iacute;"}},[_vm._v("\n     Zabezpečení\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e29987","title":"Cloudov&eacute; služby"}},[_vm._v("\n     Cloudové služby\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e30044","title":"Zpr&aacute;vy"}},[_vm._v("\n     Zprávy\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_cs","title":"Ře&scaron;en&iacute; probl&eacute;mů"}},[_c('strong',[_vm._v("\n      Řešení problémů\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_cs","title":"Forms Merge"}},[_c('strong',[_vm._v("\n      Forms Merge\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_cs","title":"Tisk str&aacute;nky s&nbsp;nastaven&iacute;m"}},[_vm._v("\n     Tisk\n     "),_c('strong',[_vm._v("\n      stránky s nastavením\n     ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_cs","title":"Možnosti dokončovac&iacute; schr&aacute;nky tisk&aacute;rny"}},[_vm._v("\n    Možnosti dokončovací schránky tiskárny\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30527"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-finisher-topic.html#using-staple-finisher_cs","title":"Použ&iacute;v&aacute;n&iacute; se&scaron;&iacute;vac&iacute;ho fini&scaron;eru"}},[_vm._v("\n     Používání sešívacího finišeru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_cs","title":"Použ&iacute;v&aacute;n&iacute; se&scaron;&iacute;vac&iacute;ho děrovac&iacute;ho fini&scaron;eru"}},[_vm._v("\n     Používání sešívacího děrovacího finišeru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacker-topic.html#using-offset-stacker_cs","title":"Použ&iacute;v&aacute;n&iacute; odsazovac&iacute;ho odkl&aacute;dac&iacute;ho z&aacute;sobn&iacute;ku"}},[_vm._v("\n     Používání odsazovacího odkládacího zásobníku\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-booklet-finisher-topic.html#using-booklet-finisher_cs","title":"Použ&iacute;v&aacute;n&iacute; dokončovac&iacute; schr&aacute;nky na knihy"}},[_vm._v("\n     Používání dokončovací schránky na knihy\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-hptfu-topic.html#using-hptfu_cs","title":"Použ&iacute;v&aacute;n&iacute; pod&aacute;vac&iacute; jednotky s možnost&iacute; skl&aacute;d&aacute;n&iacute;"}},[_vm._v("\n     Používání podávací jednotky s možností skládání\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_cs","title":"&Uacute;držba tisk&aacute;rny"}},[_vm._v("\n    Údržba tiskárny\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30937"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-supplies-status-topic.html#checking-supplies-status_cs","title":"Kontrola stavu č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu"}},[_vm._v("\n     Kontrola stavu částí a spotřebního materiálu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_cs","title":"Konfigurace upozorňov&aacute;n&iacute; na spotřebn&iacute; materi&aacute;l"}},[_vm._v("\n     Konfigurace upozorňování na spotřební materiál\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-email-alert-topic.html#setting-up-email-alert_cs","title":"Nastaven&iacute; e-mailov&yacute;ch upozorněn&iacute;"}},[_vm._v("\n     Nastavení e-mailových upozornění\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-reports-and-logs-topic.html#generating-reports-and-logs_cs","title":"Vytv&aacute;řen&iacute; zpr&aacute;v a protokolů"}},[_vm._v("\n     Vytváření zpráv a protokolů\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_cs","title":"Objedn&aacute;n&iacute; č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu"}},[_vm._v("\n     Objednání částí a spotřebního materiálu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e31792","title":"V&yacute;měna č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu"}},[_vm._v("\n     Výměna částí a spotřebního materiálu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e32416","title":"Či&scaron;těn&iacute; č&aacute;st&iacute; tisk&aacute;rny"}},[_vm._v("\n     Čištění částí tiskárny\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e32580","title":"&Uacute;spora energie a&nbsp;pap&iacute;ru"}},[_vm._v("\n     Úspora energie a papíru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_cs","title":"Přem&iacute;stěn&iacute; tisk&aacute;rny"}},[_vm._v("\n     Přemístění tiskárny\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_cs","title":"Ře&scaron;en&iacute; probl&eacute;mů"}},[_vm._v("\n    Řešení problémů\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32718"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_cs","title":"Probl&eacute;my s&nbsp;kvalitou tisku"}},[_vm._v("\n     Problémy s kvalitou tisku\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_cs","title":"Chybov&eacute; k&oacute;dy tisk&aacute;rny"}},[_vm._v("\n     Chybové kódy tiskárny\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_cs","title":"Pot&iacute;že s tiskem"}},[_vm._v("\n     Potíže s tiskem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_cs","title":"Tisk&aacute;rna nereaguje."}},[_vm._v("\n     Tiskárna nereaguje.\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_cs","title":"Jednotku paměti flash nelze přeč&iacute;st"}},[_vm._v("\n     Jednotku paměti flash nelze přečíst\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_cs","title":"Povolen&iacute; portu USB"}},[_vm._v("\n     Povolení portu USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_cs","title":"Odstraněn&iacute; zaseknut&eacute;ho pap&iacute;ru"}},[_vm._v("\n     Odstranění zaseknutého papíru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e36142","title":"Probl&eacute;my se s&iacute;ťov&yacute;m připojen&iacute;m"}},[_vm._v("\n     Problémy se síťovým připojením\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e36235","title":"Probl&eacute;my s&nbsp;hardwarov&yacute;mi doplňky"}},[_vm._v("\n     Problémy s hardwarovými doplňky\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e36408","title":"Probl&eacute;my se spotřebn&iacute;m materi&aacute;lem"}},[_vm._v("\n     Problémy se spotřebním materiálem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-paper-curl-topic.html#d0e36556","title":"Pot&iacute;že s&nbsp;pod&aacute;v&aacute;n&iacute;m pap&iacute;ru"}},[_vm._v("\n     Potíže s podáváním papíru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e36750","title":"Probl&eacute;my s&nbsp;e-mailem"}},[_vm._v("\n     Problémy s e-mailem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e36805","title":"Probl&eacute;my s&nbsp;faxov&aacute;n&iacute;m"}},[_vm._v("\n     Problémy s faxováním\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e37127","title":"Probl&eacute;my se skenov&aacute;n&iacute;m"}},[_vm._v("\n     Problémy se skenováním\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"modifying-colors-in-printed-output-topic.html#d0e37545","title":"Pot&iacute;že s&nbsp;kvalitou barev"}},[_vm._v("\n     Potíže s kvalitou barev\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_cs","title":"Kontaktov&aacute;n&iacute; z&aacute;kaznick&eacute; podpory"}},[_vm._v("\n     Kontaktování zákaznické podpory\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_cs","title":"Recyklace a likvidace"}},[_vm._v("\n    Recyklace a likvidace\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37771"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_cs","title":"Recyklace produktů společnosti Lexmark"}},[_vm._v("\n     Recyklace produktů společnosti Lexmark\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_cs","title":"Recyklace obalů od produktů Lexmark"}},[_vm._v("\n     Recyklace obalů od produktů Lexmark\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_cs","title":"Pozn&aacute;mky"}},[_vm._v("\n    Poznámky\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37807"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37810","title":"Informace o produktu"}},[_vm._v("\n     Informace o produktu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37830","title":"Pozn&aacute;mky k&nbsp;vyd&aacute;n&iacute;"}},[_vm._v("\n     Poznámky k vydání\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_cs","title":"Ochrann&eacute; zn&aacute;mky"}},[_vm._v("\n     Ochranné známky\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_cs","title":"Licenčn&iacute; informace"}},[_vm._v("\n     Licenční informace\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_cs","title":"&Uacute;rovně hluku"}},[_vm._v("\n     Úrovně hluku\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_cs","title":"Směrnice OEEZ (o odpadn&iacute;ch elektrick&yacute;ch a elektronick&yacute;ch zař&iacute;zen&iacute;ch)"}},[_vm._v("\n     Směrnice OEEZ (o odpadních elektrických a elektronických zařízeních)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37943","title":"Lithium-iontov&aacute; nab&iacute;jec&iacute; baterie"}},[_vm._v("\n     Lithium-iontová nabíjecí baterie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_cs","title":"Nař&iacute;zen&iacute; (EU) 2023/1542"}},[_vm._v("\n     Nařízení (EU) 2023/1542\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37981","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_cs","title":"Likvidace produktu"}},[_vm._v("\n     Likvidace produktu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_cs","title":"Vr&aacute;cen&iacute; kazet Lexmark za &uacute;čelem opětovn&eacute;ho použit&iacute; nebo recyklace"}},[_vm._v("\n     Vrácení kazet Lexmark za účelem opětovného použití nebo recyklace\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_cs","title":"Upozorněn&iacute; na citlivost vůči statick&eacute; elektřině"}},[_vm._v("\n     Upozornění na citlivost vůči statické elektřině\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_cs","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_cs","title":"Informace o teplotě"}},[_vm._v("\n     Informace o teplotě\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_cs","title":"Upozorněn&iacute; ohledně laseru"}},[_vm._v("\n     Upozornění ohledně laseru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_cs","title":"Spotřeba energie"}},[_vm._v("\n     Spotřeba energie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38255","title":"Z&aacute;konn&eacute; požadavky t&yacute;kaj&iacute;c&iacute; se bezdr&aacute;tov&yacute;ch v&yacute;robků"}},[_vm._v("\n     Zákonné požadavky týkající se bezdrátových výrobků\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_cs","title":"Pozn&aacute;mka k modul&aacute;rn&iacute;m komponent&aacute;m"}},[_vm._v("\n     Poznámka k modulárním komponentám\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_cs","title":"Vystaven&iacute; z&aacute;řen&iacute; r&aacute;diov&yacute;ch vln"}},[_vm._v("\n     Vystavení záření rádiových vln\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38281","title":"Prohl&aacute;&scaron;en&iacute; o&nbsp;dodržen&iacute; směrnic EU"}},[_vm._v("\n     Prohlášení o dodržení směrnic EU\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_cs","title":"Prohl&aacute;&scaron;en&iacute; o&nbsp;dodržen&iacute; směrnic EU"}},[_vm._v("\n     Prohlášení o dodržení směrnic EU\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_cs","title":"Pozn&aacute;mka t&yacute;kaj&iacute;c&iacute; se r&aacute;diov&eacute;ho ru&scaron;en&iacute;"}},[_vm._v("\n     Poznámka týkající se rádiového rušení\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js